// Page-specific strings, namespaced as 'pages.<pageName>.<key>'.
export default {
  'pages.chat.promptLibrary.purposeRequired': 'กรอกวัตถุประสงค์ของพรอมต์นี้',
  'pages.chat.promptLibrary.metadataUnavailable':
    'ตัวเลือกพรอมต์บางรายการไม่พร้อมใช้งาน ต้องเลือกสาขางานอย่างน้อยหนึ่งรายการจึงจะบันทึกได้',
  'pages.chat.promptLibrary.retryOptions': 'ลองอีกครั้ง',
  'pages.chat.promptLibrary.tags': 'แท็ก',
  'pages.chat.promptLibrary.tagsRequired': 'เพิ่มแท็กอย่างน้อยหนึ่งแท็ก',
  'pages.chat.promptLibrary.tagsPlaceholder': 'เลือกหรือสร้างแท็ก',
  'pages.chat.promptLibrary.practiceAreas': 'สาขางาน',
  'pages.chat.promptLibrary.practiceAreasRequired': 'เลือกสาขางานอย่างน้อยหนึ่งรายการ',
  'pages.chat.promptLibrary.practiceAreasPlaceholder': 'เลือกสาขางาน',
  'pages.chat.promptLibrary.exampleTemplate':
    'งาน: [อธิบายงานที่ต้องการให้พรอมต์นี้ทำ]\n\nข้อมูลนำเข้า: [ระบุเอกสารหรือข้อมูลที่ต้องให้]\n\nข้อกำหนด: [อธิบายโครงสร้าง น้ำเสียง ข้อจำกัด และระดับรายละเอียด]\n\nใช้ข้อความต่อไปนี้เป็นตัวอย่างผลลัพธ์ที่ต้องการ ปรับให้เข้ากับข้อมูลนำเข้าใหม่แทนการทำซ้ำข้อเท็จจริงในตัวอย่าง:\n\n',
  'pages.chat.promptLibrary.discardTitle': 'ทิ้งฉบับร่างของพรอมต์นี้หรือไม่?',
  'pages.chat.promptLibrary.discardDescription': 'การแก้ไขของคุณยังไม่ได้บันทึกลงในคลัง',
  'pages.chat.promptLibrary.discard': 'ทิ้ง',
  'pages.chat.promptLibrary.keepEditing': 'แก้ไขต่อ',
  'pages.chat.promptLibrary.saved': 'บันทึกพรอมต์ลงในคลังส่วนตัวของคุณแล้ว',
  'pages.chat.promptLibrary.viewLibrary': 'ดูคลัง',
  'pages.chat.promptLibrary.saveFailed':
    'บันทึกพรอมต์ไม่สำเร็จ ฉบับร่างของคุณยังอยู่ โปรดลองอีกครั้ง',
  'pages.chat.promptLibrary.create': 'สร้างพรอมต์ที่ใช้ซ้ำได้',
  'pages.chat.promptLibrary.cancel': 'ยกเลิก',
  'pages.chat.promptLibrary.save': 'บันทึกลงในคลังของฉัน',
  'pages.chat.promptLibrary.reviewTitle': 'ปรับให้มีประโยชน์ในการสนทนาใหม่',
  'pages.chat.promptLibrary.reviewDescription':
    'เก็บคำสั่งที่ใช้ซ้ำได้ หรือใช้คำตอบที่มีประโยชน์เป็นตัวอย่าง แทนชื่อและข้อเท็จจริงเฉพาะเรื่องด้วยข้อความแทนค่า เช่น [ข้อตกลง] ระบุให้ชัดเจนว่าข้อความอย่าง “ข้างต้น” หมายถึงอะไร ประวัติแชทและไฟล์แนบจะไม่รวมอยู่ด้วย',
  'pages.chat.promptLibrary.original': 'ข้อความแชทต้นฉบับ',
  'pages.chat.promptLibrary.keepWording': 'เก็บถ้อยคำที่เลือกไว้',
  'pages.chat.promptLibrary.useExample': 'ใช้เป็นตัวอย่างผลลัพธ์',
  'pages.chat.promptLibrary.exampleHelp':
    'กรอกงาน ข้อมูลนำเข้า และข้อกำหนดด้านล่างเพื่ออธิบายวิธีสร้างผลลัพธ์ที่คล้ายกัน',
  'pages.chat.promptLibrary.name': 'ชื่อ',
  'pages.chat.promptLibrary.nameRequired': 'กรอกชื่อพรอมต์นี้',
  'pages.chat.promptLibrary.purpose': 'วัตถุประสงค์',
  'pages.chat.promptLibrary.content': 'พรอมต์',
  'pages.chat.promptLibrary.contentRequired': 'กรอกคำสั่งที่จะบันทึก',
  'pages.adminManagement.groupName': 'ชื่อกลุ่ม',
  'pages.adminManagement.personalTag': 'ส่วนตัว',
  'pages.adminManagement.owner': 'เจ้าของ',
  'pages.adminManagement.deletedUserTag': 'ผู้ใช้ที่ถูกลบ',
  'pages.adminManagement.members': 'สมาชิก',
  'pages.adminManagement.options': 'ตัวเลือก',
  'pages.adminManagement.manageGroupTooltip': 'จัดการกลุ่ม',
  'pages.adminManagement.manageFilesTooltip': 'จัดการไฟล์',
  'pages.adminManagement.removeGroupTooltip': 'ลบกลุ่ม',
  'pages.adminManagement.stats.totalUsers': 'ผู้ใช้ทั้งหมด',
  'pages.adminManagement.stats.totalGroups': 'กลุ่มทั้งหมด',
  'pages.adminManagement.stats.personalGroups': 'กลุ่มส่วนตัว',
  'pages.adminManagement.stats.sharedGroups': 'กลุ่มที่ใช้ร่วมกัน',
  'pages.adminManagement.stats.totalFiles': 'ไฟล์ทั้งหมด',
  'pages.adminManagement.stats.totalFolders': 'โฟลเดอร์ทั้งหมด',
  'pages.adminManagement.sharedTag': 'ใช้ร่วมกัน',
  'pages.adminManagement.moveAll': 'ย้ายทั้งหมด',
  'pages.adminManagement.fileDescription': '{username} · {action} เมื่อ {date}',
  'pages.adminManagement.fileAction.uploaded': 'อัปโหลดแล้ว',
  'pages.adminManagement.fileAction.created': 'สร้างแล้ว',
  'pages.adminManagement.createGroupButton': 'สร้างกลุ่ม',
  'pages.adminManagement.modifyUserGroupTitle': 'แก้ไขกลุ่มผู้ใช้',
  'pages.adminManagement.createUserGroupTitle': 'สร้างกลุ่มผู้ใช้',
  'pages.adminManagement.updateSubmitText': 'อัปเดต',
  'pages.adminManagement.userGroupUpdatedSuccess': 'อัปเดตกลุ่มผู้ใช้สำเร็จแล้ว',
  'pages.adminManagement.userGroupCreatedSuccess': 'สร้างกลุ่มผู้ใช้สำเร็จแล้ว',
  'pages.adminManagement.groupNameRequiredMessage': 'กรุณากรอกชื่อกลุ่ม',
  'pages.adminManagement.ownerRequiredMessage': 'กรุณาเลือกเจ้าของกลุ่ม',
  'pages.adminManagement.membersRequiredMessage': 'กรุณาเลือกสมาชิกกลุ่ม',
  'pages.adminManagement.moveFolderTitle': 'ย้ายโฟลเดอร์',
  'pages.adminManagement.moveFileTitle': 'ย้ายไฟล์',
  'pages.adminManagement.allMovedSuccess': 'ย้ายทั้งหมดสำเร็จแล้ว',
  'pages.adminManagement.folderMovedSuccess': 'ย้ายโฟลเดอร์สำเร็จแล้ว',
  'pages.adminManagement.fileMovedSuccess': 'ย้ายไฟล์สำเร็จแล้ว',
  'pages.adminManagement.destinationGroupLabel': 'กลุ่มปลายทาง',
  'pages.adminManagement.destinationGroupRequiredMessage': 'กรุณาเลือกกลุ่มปลายทาง',
  'pages.adminManagement.destinationFolderPlaceholder': 'เลือกโฟลเดอร์ปลายทาง',
  'pages.adminManagement.renameOptionalLabel': 'เปลี่ยนชื่อ (ไม่บังคับ)',
  'pages.adminManagement.loadFolderDataError': 'ไม่สามารถโหลดข้อมูลโฟลเดอร์ได้',
  'pages.adminManagement.ownerCannotBeRemovedWarning': 'ไม่สามารถลบเจ้าของกลุ่มออกจากสมาชิกได้',
  'pages.aISetting.promptCopied': 'คัดลอกพรอมต์แล้ว!',
  'pages.aISetting.failedToCopyPrompt': 'ไม่สามารถคัดลอกพรอมต์ได้',
  'pages.aISetting.updatedByMeta': 'อัปเดตเมื่อ {date} โดย {user}',
  'pages.aISetting.updateButton': 'อัปเดต',
  'pages.aISetting.systemPromptLabel': 'พรอมต์ระบบ',
  'pages.aISetting.additionalPromptLabel': 'พรอมต์เพิ่มเติม',
  'pages.aISetting.temperatureLabel': 'Temperature',
  'pages.aISetting.updatedBadge': 'อัปเดตแล้ว!!',
  'pages.aISetting.requiredParamsMissing': 'ขาดพารามิเตอร์ที่จำเป็น: {params}',
  'pages.angelInsider.micrositeFrameTitle': 'A&GEL Insider',
  'pages.angelInsider.nav.basics': 'พื้นฐาน',
  'pages.angelInsider.nav.learnMore': 'เรียนรู้เพิ่มเติม',
  'pages.angelInsider.nav.whatsNew': 'มีอะไรใหม่',
  'pages.angelInsider.nav.futureStuff': 'สิ่งที่กำลังจะมา',
  'pages.angelInsider.nav.logoAlt': 'A&GEL Insider',
  'pages.angelInsider.landing.tiles.basics.title': 'พื้นฐาน',
  'pages.angelInsider.landing.tiles.learnMore.title': 'เรียนรู้เพิ่มเติม',
  'pages.angelInsider.landing.tiles.whatsNew.title': 'มีอะไรใหม่',
  'pages.angelInsider.landing.tiles.whatsNew.subtitle': 'ฟีเจอร์และการอัปเดตที่เปิดตัวล่าสุด',
  'pages.angelInsider.landing.tiles.comingUp.title': 'สิ่งที่กำลังจะมา',
  'pages.angelInsider.landing.tiles.comingUp.subtitle': 'สิ่งที่ทีมกำลังพัฒนาในลำดับถัดไป',
  'pages.angelInsider.landing.pills.all': 'ทั้งหมด',
  'pages.angelInsider.landing.pills.chatAndContext': 'แชทและบริบท',
  'pages.angelInsider.landing.pills.filesAndVault': 'ไฟล์และคลังจัดเก็บ',
  'pages.angelInsider.landing.pills.promptLibrary': 'คลังพรอมต์',
  'pages.angelInsider.landing.pills.quickInfo': 'ข้อมูลด่วน',
  'pages.angelInsider.landing.pills.scribe': 'บันทึกเสียง',
  'pages.angelInsider.landing.pills.disputeResolution': 'การระงับข้อพิพาท',
  'pages.angelInsider.landing.pills.sideBySide': 'เปรียบเทียบแบบเคียงข้างกัน',
  'pages.angelInsider.landing.pills.multiStepPrompt': 'พรอมต์หลายขั้นตอน',
  'pages.angelInsider.landing.pills.timeline': 'ไทม์ไลน์',
  'pages.angelInsider.landing.pills.workstudio': 'Workstudio',
  'pages.angelInsider.landing.pills.deepResearch': 'การวิจัยเชิงลึก',
  'pages.angelInsider.landing.pills.scopeSummary': 'สรุปขอบเขตงาน',
  'pages.angelInsider.landing.pills.review': 'ตรวจสอบ',
  'pages.angelInsider.landing.pills.whatsNew': 'มีอะไรใหม่',
  'pages.angelInsider.landing.pills.futureStuff': 'สิ่งที่กำลังจะมา',
  'pages.angelInsider.landing.preferOneFeature': 'ต้องการเรียนรู้ทีละฟีเจอร์ใช่หรือไม่',
  'pages.angelInsider.landing.scrollFeatureList': 'เลื่อนดูรายการฟีเจอร์',
  'pages.angelInsider.basics.habits.habit1.num': 'นิสัยที่ 01',
  'pages.angelInsider.basics.habits.habit1.title': 'ให้ข้อมูลแก่ A&GEL เพื่อเริ่มต้นทำงาน',
  'pages.angelInsider.basics.habits.habit2.num': 'นิสัยที่ 02',
  'pages.angelInsider.basics.habits.habit3.num': 'นิสัยที่ 03',
  'pages.angelInsider.basics.habits.habit3.title': 'อย่าใช้แค่แชท—สำรวจฟีเจอร์อื่น ๆ ด้วย',
  'pages.angelInsider.basics.heading': 'พื้นฐาน',
  'pages.angelInsider.basics.welcome.pacingHeading': 'ก้าวหน้าตามจังหวะของคุณเอง',
  'pages.angelInsider.basics.welcome.togetherHeading': 'ร่วมมือกัน เราไปได้ไกลกว่าเดิม',
  'pages.angelInsider.basics.welcome.signatureName': 'Kok Leong',
  'pages.angelInsider.basics.welcome.signatureTeam': 'ทีมพัฒนา A&GEL',
  'pages.angelInsider.basics.welcome.ctaLetsBegin': 'เริ่มต้นกันเลย →',
  'pages.angelInsider.basics.habitsSection.title': '3 นิสัยง่าย ๆ ที่จะนำทางคุณตลอดเส้นทาง',
  'pages.angelInsider.reader.back': '← กลับ',
  'pages.angelInsider.reader.label': 'A&GEL INSIDER',
  'pages.angelInsider.reader.contents': 'สารบัญ',
  'pages.angelInsider.reader.issueNumber': 'ฉบับที่ {number}',
  'pages.angelInsider.reader.featureGuide': 'คู่มือฟีเจอร์',
  'pages.angelInsider.reader.minRead': 'อ่านใช้เวลา {minutes} นาที',
  'pages.angelInsider.reader.atAGlance': 'ภาพรวมโดยย่อ',
  'pages.angelInsider.blockRenderer.supportedAlt': 'รองรับ',
  'pages.angelInsider.typewriterExample.badLabel': 'แบบนี้ก็พอใช้ได้:',
  'pages.angelInsider.typewriterExample.goodLabel': 'แต่แบบนี้ดีกว่า:',
  'pages.angelInsider.basics.habits.labels.takeaways': 'ประเด็นสำคัญ',
  'pages.angelInsider.basics.habits.labels.examples': 'ตัวอย่าง',
  'pages.angelInsider.basics.habits.labels.benefits': 'ประโยชน์ที่ได้',
  'pages.angelInsider.basics.habits.habit1.tile.patternMatchers':
    'เครื่องมือ AI อย่าง A&GEL อ่านใจไม่ได้ มันคือ<strong>ตัวจับรูปแบบ</strong> หากคุณถามอย่างคลุมเครือ คุณก็จะได้คำตอบกลาง ๆ แต่หากคุณให้บริบทที่มากพอและเฉพาะเจาะจง โอกาสที่จะได้ผลลัพธ์ที่แม่นยำและนำไปใช้ได้จริงก็จะสูงขึ้นมาก',
  'pages.angelInsider.basics.habits.habit1.tile.callItContext':
    'เรียกจุดตั้งต้นนี้ว่า <strong>“บริบท”</strong> กันเถอะ',
  'pages.angelInsider.basics.habits.habit1.tile.rawMaterial':
    'ให้มองบริบทเป็นวัตถุดิบที่ A&GEL ใช้ทำงาน เมื่อร่างบันทึกความเห็นทางกฎหมาย อย่าเพียงบอกว่า “สรุปคดีนี้” แต่ให้อัปโหลดคำพิพากษา ระบุประเด็นข้อเท็จจริงหรือข้อกฎหมายสำคัญที่คุณสนใจ และบอก AI ว่าผู้อ่านคือใคร (หรือจะใช้พรอมต์สำเร็จรูปที่เราพัฒนาไว้สำหรับการสรุป ซึ่งอยู่ในคลังพรอมต์ก็ได้) โดยหลักทั่วไป ยิ่งให้บริบทมากเท่าใด A&GEL ก็ยิ่งทำงานได้ดีขึ้นเท่านั้น',
  'pages.angelInsider.basics.habits.habit1.tile.promptLibraryLink':
    'อ่านเพิ่มเติมเกี่ยวกับคลังพรอมต์',
  'pages.angelInsider.basics.habits.habit1.tile.empowerYou':
    'เครื่องมือ AI อย่าง A&GEL เสริมพลังให้<em>คุณ</em>โดยตรง มันขยายศักยภาพของคุณ แต่ก็ต่อเมื่อคุณเป็นผู้กำหนดทิศทางเท่านั้น หากไม่มีบริบท AI ก็เหมือนทนายความชั้นเยี่ยมที่ยังไม่ได้รับการชี้แจงข้อเท็จจริง หรือเพื่อนร่วมงานที่มีความสามารถแต่ขาดข้อมูลพื้นฐานที่จำเป็นต่อการทำงาน',
  'pages.angelInsider.basics.habits.habit1.tile.vault.title': 'คลังจัดเก็บคือสมองของคุณบน A&GEL',
  'pages.angelInsider.basics.habits.habit1.tile.vault.body':
    'คลังจัดเก็บคือแหล่งบริบทหลักของ A&GEL ซึ่งยึดโยงผลลัพธ์ไว้กับฐานความรู้ที่คุณคัดสรรและเชื่อถือได้ A&GEL ไม่ค้นหาข้อมูลจากอินเทอร์เน็ต – มันทำงานอยู่ในขอบเขตของสิ่งที่คุณอัปโหลดไว้เท่านั้น ลองมองเป็นเพื่อนร่วมงานที่ไม่รู้จักเหน็ดเหนื่อย ถ้าคุณยื่นโต๊ะรกที่กองด้วยเอกสารไม่เกี่ยวข้องให้เขา งานที่ออกมาก็จะแย่ลง แต่ถ้าคุณยื่นแบบอย่างที่ตรงประเด็นเพียงชิ้นเดียว งานของเขาก็จะคมขึ้น จัดไฟล์ลงโฟลเดอร์ย่อยอย่างมีเหตุผล เลือกสรรสิ่งที่จะอัปโหลด และใช้น้ำหนักไฟล์ที่อ้างอิงกับน้ำหนักไฟล์ในเซสชันเพื่อปรับละเอียดว่า A&GEL ควรให้ความสำคัญกับสิ่งใด ดูแลคลังจัดเก็บของคุณเหมือนห้องสมุดที่คัดสรรมาอย่างดี ไม่ใช่กองขยะ',
  'pages.angelInsider.basics.habits.habit1.tile.vault.link':
    'อ่านเพิ่มเติมเกี่ยวกับคลังจัดเก็บของคุณ',
  'pages.angelInsider.basics.habits.habit1.tile.documents.title':
    'ให้เอกสารเฉพาะแก่ A&GEL ก่อนเขียนพรอมต์',
  'pages.angelInsider.basics.habits.habit1.tile.documents.body':
    'หากคุณลากไฟล์มาวางในแชท หรือเลือกไฟล์แล้วสนทนากับไฟล์นั้น ก็เท่ากับคุณป้อนเฉพาะเนื้อหาของเอกสารฉบับนั้นเข้าสู่ความจำระยะสั้นของ A&GEL หลายท่านที่เคยเข้าเวิร์กช็อปของเราคงเคยได้ยินเราเปรียบไฟล์นั้นว่าเป็น ‘ตอนซีรีส์เกาหลีที่คุณเพิ่งดูเมื่อคืน’ (<em>วันนี้คุณอยากพูดถึงแต่เรื่องนั้น</em>) สิ่งนี้ทำให้ A&GEL มีมุมมองที่แคบลง ซึ่งนำมาใช้ให้เกิดผลลัพธ์ที่แม่นยำได้',
  'pages.angelInsider.basics.habits.habit1.tile.documents.link': 'อ่านเพิ่มเติมเกี่ยวกับบริบท',
  'pages.angelInsider.basics.habits.habit1.tile.colleague.title':
    'การทำงานกับ A&GEL ไม่ต่างจากการทำงานกับเพื่อนร่วมงาน',
  'pages.angelInsider.basics.habits.habit1.tile.colleague.body':
    'เช่นเดียวกับที่คุณให้ข้อมูลบางอย่างแก่เพื่อนร่วมทีมเพื่อช่วยให้เขาทำงานต่อได้ กับ A&GEL ก็เช่นกัน',
  'pages.angelInsider.basics.habits.habit1.tile.query.title':
    'แล้วคำถามหรือคำสั่งในพรอมต์ของฉันเองล่ะ นับเป็น ‘การให้สิ่งใดแก่ A&GEL’ ด้วยหรือไม่',
  'pages.angelInsider.basics.habits.habit1.tile.query.body':
    'นับ สำหรับเครื่องมือ AI อย่าง A&GEL พรอมต์ถูกรับเข้าและประมวลผลในฐานะชุดของถ้อยคำเท่านั้น นั่นหมายความว่าพรอมต์ทั้งหมดคือ ‘บริบท’ สำหรับเครื่องมือ AI หรือ A&GEL หากคุณกำลังถามคำถามในพรอมต์ จงถามให้ดีขึ้น แล้วคุณจะได้คำตอบที่ดีขึ้น',
  'pages.angelInsider.basics.habits.habit1.tile.query.link': 'อ่านเพิ่มเติมเกี่ยวกับการเขียนพรอมต์',
  'pages.angelInsider.basics.habits.habit1.tile.benefitsIntro':
    'เมื่อคุณให้บริบทที่มากพอแก่ A&GEL คุณจะได้:',
  'pages.angelInsider.basics.habits.habit1.tile.benefit1':
    '<strong>ผลลัพธ์ที่ดีขึ้น:</strong> บริบทที่เฉพาะเจาะจงให้ผลลัพธ์ที่เฉพาะเจาะจง — A&GEL ที่ได้รับการชี้แจงมาอย่างดีจะทำงานเหมือนเพื่อนร่วมงานที่รู้ข้อเท็จจริงของเรื่องอยู่แล้ว ไม่ใช่คนที่เพิ่งเริ่มจากศูนย์',
  'pages.angelInsider.basics.habits.habit1.tile.benefit2':
    '<strong>วนแก้ไขน้อยลง:</strong> ยิ่งจุดตั้งต้นแม่นยำ คุณก็ยิ่งเสียเวลาเขียนพรอมต์ซ้ำหรือแก้ไขน้อยลง จงทำให้ถูกต้องตั้งแต่ต้นทาง',
  'pages.angelInsider.basics.habits.habit1.tile.benefit3':
    '<strong>มุมมองที่แคบ (ในทางที่ดี):</strong> การอัปโหลดเอกสารเฉพาะก่อนเขียนพรอมต์จะตรึงความสนใจของ A&GEL ไว้ — มันจะทำงานอยู่ในบริบทนั้นเท่านั้น ซึ่งหมายถึงความถูกต้องที่สูงขึ้นและสิ่งรบกวนในผลลัพธ์ที่น้อยลง',
  'pages.angelInsider.basics.habits.habit1.examples.oneOff.bad':
    'มองการสนทนากับ A&GEL แต่ละครั้งเป็นเรื่องครั้งเดียวจบ และเริ่มจากศูนย์ทุกครั้ง',
  'pages.angelInsider.basics.habits.habit1.examples.oneOff.good':
    'ดึง A&GEL เข้ามาเหมือนเพื่อนร่วมงานใหม่ที่เพิ่งเข้าทีม — สรุปสั้น ๆ ถึงเรื่องที่ทำอยู่ คู่กรณี และสิ่งที่คุณต้องการบรรลุ ก่อนจะให้มันลงมือทำงาน',
  'pages.angelInsider.basics.habits.habit1.examples.clause.bad': 'ขอให้ A&GEL “ตรวจข้อสัญญานี้”',
  'pages.angelInsider.basics.habits.habit1.examples.clause.good':
    '“ตรวจข้อสัญญานี้ให้ [ลูกความ] เพื่อ […]” พร้อมระบุว่าการตรวจควรมองหาสิ่งใด (เช่น “ประเด็นใด ๆ ที่เกี่ยวกับค่าธรรมเนียมหรือเรื่องทางการเงิน”)',
  'pages.angelInsider.basics.habits.habit2.tile.intro':
    'LLM ทำได้ดีในการจัดโครงสร้างข้อมูล ระบุรูปแบบ ร่างข้อความ และจัดระเบียบข้อมูลที่ซับซ้อน มันเป็นเครื่องมือสำหรับ<em>การประมวลผล</em> ไม่ใช่สำหรับ<em>การตัดสินใจ</em> คุณยังคงเป็นผู้ตัดสิน เป็นนักวางกลยุทธ์ และเป็นผู้มีอำนาจชี้ขาด AI รับงานหนักด้านการจัดการภาษา — เรียบเรียงใหม่ สรุปความ ดึงข้อสัญญาออกมา — ขณะที่คุณใช้ความเชี่ยวชาญวิชาชีพตรวจสอบผลลัพธ์ ความแตกต่างนี้สำคัญยิ่ง: ไว้ใจให้ AI ประมวลผลได้ แต่อย่ายกวิจารณญาณของคุณให้ใครเด็ดขาด ดังที่คู่มือเตือนไว้ เครื่องมือ AI “อาจไม่แทนที่วิจารณญาณของมนุษย์ แต่ในหลายแง่มุมก็ขยายศักยภาพของคุณ”',
  'pages.angelInsider.basics.habits.habit2.tile.breakItDown.title':
    'แบ่งมันออกเป็นส่วน ๆ (โดยเฉพาะพรอมต์ยาว ๆ)',
  'pages.angelInsider.basics.habits.habit2.tile.breakItDown.body':
    'ผู้ใช้จำนวนมากปฏิบัติกับ A&GEL เหมือนแชทบอทธรรมดา คือพิมพ์พรอมต์ยาว ๆ ครั้งเดียวแล้วหวังผลที่ดีที่สุด นี่ไม่ใช่วิธีที่ดีที่สุดในการใช้เครื่องมือ AI อย่าง A&GEL ผู้ใช้ระดับสูงจะแบ่งงานที่ซับซ้อนออกเป็นส่วนย่อยที่จัดการได้ — แทนที่จะใช้พรอมต์ใหญ่อันเดียว ก็ใช้พรอมต์ย่อยหลายอัน เทคนิคนี้เรียกว่า<em>การแยกส่วน</em> ซึ่งมักนำไปสู่ผลลัพธ์ที่มีคุณภาพสูงกว่า',
  'pages.angelInsider.basics.habits.habit2.tile.breakItDown.imageAlt': 'พรอมต์ยาวอันเดียว',
  'pages.angelInsider.basics.habits.habit2.tile.oneGoExample':
    'รันพรอมต์ขนาดใหญ่ ซับซ้อน และมีหลายส่วนรวดเดียว เช่น “จัดทำรายงานที่รวบรวมประเด็นห่วงกังวลทั้งหมดของฉันจากเอกสาร 1 และเอกสาร 2 แล้วสรุปรายงานนั้นเพื่อสร้างบทสรุปผู้บริหาร จากนั้นรวมรายงานฉบับเต็มกับบทสรุปผู้บริหารเข้าเป็นเอกสารเดียว”',
  'pages.angelInsider.basics.habits.habit2.tile.breakTaskIntro':
    'แบ่งงานออกเป็นขั้นตอนย่อยที่ต่อเนื่องกัน แล้วดำเนินการทีละขั้นด้วยพรอมต์หลายขั้นตอนในแอป',
  'pages.angelInsider.basics.habits.habit2.tile.step1.title': 'ขั้นที่ 1: การดึงข้อมูล',
  'pages.angelInsider.basics.habits.habit2.tile.step1.context':
    'บริบทนำเข้า: [<em>ใส่เนื้อความของเอกสาร 1 และเอกสาร 2</em>]',
  'pages.angelInsider.basics.habits.habit2.tile.step1.prompt':
    'พรอมต์ 1: “สร้างรายการแบบหัวข้อย่อยที่ครอบคลุม ของประเด็นห่วงกังวล ปัญหา หรือความเสี่ยงทั้งหมดที่กล่าวถึงในเอกสารทั้งสองฉบับ”',
  'pages.angelInsider.basics.habits.habit2.tile.step2.title': 'ขั้นที่ 2: ร่างรายงานฉบับเต็ม',
  'pages.angelInsider.basics.habits.habit2.tile.step2.context':
    'บริบทนำเข้า: [<em>ใส่ผลลัพธ์จากขั้นที่ 1</em>]',
  'pages.angelInsider.basics.habits.habit2.tile.step2.prompt':
    'พรอมต์ 2: “จัดทำรายงานอย่างเป็นทางการโดยละเอียดจากรายการหัวข้อย่อยนั้น จัดกลุ่มประเด็นที่คล้ายกันไว้ใต้หัวข้อที่เหมาะสม อย่าใส่บทนำหรือบทสรุปผู้บริหาร”',
  'pages.angelInsider.basics.habits.habit2.tile.step3.title':
    'ขั้นที่ 3: บทสรุปผู้บริหารและการรวมเป็นฉบับสุดท้าย',
  'pages.angelInsider.basics.habits.habit2.tile.step3.context':
    'บริบทนำเข้า: [<em>ใส่ผลลัพธ์จากขั้นที่ 2</em>]',
  'pages.angelInsider.basics.habits.habit2.tile.step3.prompt':
    'พรอมต์ 3: “ขั้นแรก เขียนบทสรุปผู้บริหารกระชับหนึ่งย่อหน้าของรายงานฉบับทางการนั้น จากนั้นแสดงบทสรุปผู้บริหาร เพิ่มเส้นคั่นเชิงภาพ แล้วแสดงรายงานฉบับทางการตามเดิมไว้ด้านล่าง เพื่อสร้างเป็นเอกสารรวมฉบับเดียว”',
  'pages.angelInsider.basics.habits.habit2.tile.multiStepLink':
    'ดูตัวอย่างการใช้งานจริงฉบับเต็มของพรอมต์หลายขั้นตอน',
  'pages.angelInsider.basics.habits.habit2.tile.reshape.title':
    'ใช้ A&GEL ปรับรูป จัดรูปแบบ หรือต่อยอดจากข้อความที่มีอยู่',
  'pages.angelInsider.basics.habits.habit2.tile.reshape.body':
    'แทนที่จะขอให้ A&GEL ร่างเอกสารกฎหมายที่ซับซ้อนขึ้นมาใหม่ทั้งหมดโดยไม่มีเอกสารอ้างอิงใด ๆ ให้จัดหาเอกสารอ้างอิงไว้ แล้ว (i) ใช้ความสามารถทางภาษาของ A&GEL ปรับน้ำเสียง โครงสร้าง หรือรูปแบบของร่างที่คุณมี หรือหลอมรวมหลายร่างเข้าด้วยกัน หรือ (ii) ต่อยอดหาเจตนา ทิศทาง นัยยะ หรือคุณลักษณะระดับรองอื่น ๆ (เช่น สร้างรายการตรวจสอบข้อค้นพบข้ามหลายย่อหน้าหรือหลายเอกสารสำหรับการตรวจทาน)',
  'pages.angelInsider.basics.habits.habit2.tile.benefitsIntro':
    'เมื่อคุณปฏิบัติกับ A&GEL ในฐานะตัวประมวลผลข้อความและแบ่งงานออกเป็นส่วน ๆ คุณจะได้:',
  'pages.angelInsider.basics.habits.habit2.tile.benefit1':
    '<strong>ผลลัพธ์ที่มีคุณภาพสูงขึ้น:</strong> การแยกงานซับซ้อนออกเป็นพรอมต์ย่อยทำให้ A&GEL โฟกัสได้ทีละเรื่อง — แต่ละขั้นต่อยอดจากขั้นก่อนหน้าอย่างเรียบร้อย แทนที่จะพังทลายใต้ภาระของพรอมต์เดียวที่บรรทุกเกินตัว',
  'pages.angelInsider.basics.habits.habit2.tile.benefit2':
    '<strong>ผลลัพธ์ที่คาดเดาได้มากขึ้น:</strong> เมื่อคุณควบคุมทุกขั้นตอน คุณก็ควบคุมผลลัพธ์ คุณตรวจสอบได้ก่อนเดินหน้าต่อ แทนที่จะได้แต่หวังว่าพรอมต์ก้อนใหญ่อันเดียวจะออกมาถูกต้อง',
  'pages.angelInsider.basics.habits.habit2.tile.benefit3':
    '<strong>ใช้ความเชี่ยวชาญของคุณได้คุ้มค่ากว่า:</strong> A&GEL รับงานหนักด้านภาษาไป — เรียบเรียงใหม่ จัดโครงสร้าง ดึงข้อมูล ส่วนคุณคงบทบาทผู้ตรวจทานและนักวางกลยุทธ์ ซึ่งเป็นจุดที่วิจารณญาณของคุณมีค่าที่สุด',
  'pages.angelInsider.basics.habits.habit2.examples.nda.bad':
    'ขอให้ A&GEL “ร่างสัญญาไม่เปิดเผยข้อมูลสำหรับโครงการซอฟต์แวร์”',
  'pages.angelInsider.basics.habits.habit2.examples.nda.good':
    '“นี่คือแบบฟอร์มสัญญาไม่เปิดเผยข้อมูลมาตรฐานของเรา [วาง] แก้ระยะเวลาการรักษาความลับเป็น 5 ปี เพิ่มข้อยกเว้นสำหรับการเปิดเผยตามกฎหมายกำกับดูแล และเปลี่ยนการอ้างอิงถึงกฎหมายสิงคโปร์ทั้งหมดเป็นกฎหมายฮ่องกง”',
  'pages.angelInsider.basics.habits.habit3.tile.intro':
    'การสำรวจฟีเจอร์นอกเหนือจากการแชทธรรมดา — เช่น การอัปโหลดเอกสาร การใช้แอปหรือฟีเจอร์เฉพาะทาง หรือการร้อยเรียงหลายฟีเจอร์เข้าด้วยกันเป็นขั้นตอน — จะทำให้คุณควบคุมผลลัพธ์ได้ละเอียดขึ้น',
  'pages.angelInsider.basics.habits.habit3.tile.experiment.title': 'การลองทำคือหัวใจสำคัญ',
  'pages.angelInsider.basics.habits.habit3.tile.experiment.body':
    'โปรดทดลองและสำรวจฟีเจอร์อื่น ๆ ได้อย่างอิสระ ฟีเจอร์จำนวนมากภายใต้โหมดเฉพาะทางถูกปรับจูนมาเพื่อความถูกต้องและความรอบด้านที่สูงขึ้น ลองค้นหาว่าฟีเจอร์ใดเหมาะกับขั้นตอนการทำงานของคุณที่สุด และอย่ากลัวที่จะผิดพลาด การสั่งสมทักษะก็เหมือนการเดินขึ้นบันได เริ่มจากพื้นฐาน แล้วเมื่อคุณมั่นใจมากขึ้น คุณจะขยับไปสู่เทคนิคที่สูงขึ้นได้เองอย่างเป็นธรรมชาติ',
  'pages.angelInsider.basics.habits.habit3.tile.experiment.closing':
    'เมื่อคุณเชี่ยวชาญเรื่องบริบท เคารพบทบาทของ AI ในฐานะตัวประมวลผลข้อความ (และบทบาทของคุณเองในฐานะผู้เชี่ยวชาญ) และรู้จักแบ่งงานที่ซับซ้อนออกเป็นส่วน ๆ คุณจะเปลี่ยน A&GEL จากของแปลกใหม่ให้กลายเป็นส่วนที่ขาดไม่ได้ในการทำงานประจำวันของคุณ',
  'pages.angelInsider.basics.habits.habit3.tile.swissArmy.title':
    'A&GEL เป็นมีดพกสวิสมากกว่าจะเป็นแชทบอท',
  'pages.angelInsider.basics.habits.habit3.tile.swissArmy.body':
    'นี่คือทางเลือกการออกแบบที่เราตัดสินใจไว้ตั้งแต่ต้น คือนำเสนอชุดเครื่องมือด้านความรู้ที่ใช้งานได้หลากหลาย ออกแบบมาเพื่อตัดผ่านความซับซ้อนอย่างแม่นยำ แทนที่จะยัดทุกความสามารถลงในหน้าต่างแชทเดียว แชทนั้นยอดเยี่ยมสำหรับการระดมสมองและคำถามสั้น ๆ แต่จะอ่อนแรงเมื่อเจอเอกสารขนาดใหญ่มาก (เช่น เอกสารที่เกิน 20,000 คำ) หรืองานหลายขั้นตอนหลายส่วนที่ซับซ้อน แทนที่จะซ่อนเครื่องมือทรงพลังเหล่านี้ไว้ในแชท เราจึงวางไว้อย่างเด่นชัดในแถบด้านซ้าย เป้าหมายของเราคือช่วยให้คุณเชื่อมโยงวัตถุประสงค์ในงานของคุณเข้ากับฟีเจอร์ที่ใช่ — หรือการผสมผสานฟีเจอร์ที่ใช่',
  'pages.angelInsider.basics.habits.habit3.tile.explore.title': 'สำรวจฟีเจอร์อื่นนอกเหนือจากแชท',
  'pages.angelInsider.basics.habits.habit3.tile.explore.review':
    'ตรวจสอบ: เหมาะอย่างยิ่งกับการวิเคราะห์เอกสารหลายฉบับ การตรวจสอบสถานะ และการไล่ดูไฟล์ที่ซับซ้อนด้วยรายการคำถามที่มีโครงสร้าง',
  'pages.angelInsider.basics.habits.habit3.tile.explore.reviewLink':
    'อ่านเพิ่มเติมเกี่ยวกับตรวจสอบ',
  'pages.angelInsider.basics.habits.habit3.tile.explore.workStudio':
    'Workstudio: ทำให้การร่างสัญญาเป็นมาตรฐานเดียวกัน ด้วยการบังคับใช้จุดยืนมาตรฐานโดยอัตโนมัติ',
  'pages.angelInsider.basics.habits.habit3.tile.explore.workStudioLink':
    'อ่านเพิ่มเติมเกี่ยวกับ Workstudio',
  'pages.angelInsider.basics.habits.habit3.tile.explore.scribe':
    'การบันทึกเสียง: ถอดไฟล์เสียงเป็นข้อความอย่างแม่นยำ รวมถึงการถอดความแบบสดและการแปลพร้อมกันสำหรับการสนทนาข้ามประเทศ',
  'pages.angelInsider.basics.habits.habit3.tile.explore.scribeLink':
    'อ่านเพิ่มเติมเกี่ยวกับการบันทึกเสียง',
  'pages.angelInsider.basics.habits.habit3.tile.explore.quickInfo':
    'ข้อมูลด่วน / สรุปแบบมีคำแนะนำ: อ่านเอกสารฉบับเดียวได้อย่างรวดเร็วและตรวจสอบต้นทางได้ ข้อมูลด่วนไว้ดูภาพรวม ส่วนสรุปแบบมีคำแนะนำไว้กำหนดจุดโฟกัสเอง',
  'pages.angelInsider.basics.habits.habit3.tile.explore.quickInfoLink':
    'อ่านเพิ่มเติมเกี่ยวกับข้อมูลด่วนและสรุปแบบมีคำแนะนำ',
  'pages.angelInsider.basics.habits.habit3.tile.explore.translation':
    'การแปล: ให้บริการแปลเฉพาะทางที่แม่นยำระดับย่อหน้าสำหรับเนื้อหาด้านกฎหมายและธุรกิจ',
  'pages.angelInsider.basics.habits.habit3.tile.explore.apps':
    'แอป: ปรับจูนมาเพื่อความถูกต้องและความรอบด้านที่สูงขึ้นในงานเฉพาะ ตัวอย่างเช่น พรอมต์หลายขั้นตอนมีเครื่องมือวิเคราะห์หลากหลายสำหรับแยกแยะเอกสารเพื่อหาประเด็นเฉพาะ ให้ความแม่นยำที่จำเป็นสำหรับงานที่ยาวและซับซ้อนเกินกว่าความสามารถของแชท',
  'pages.angelInsider.basics.habits.habit3.tile.benefitsIntro':
    'เมื่อคุณจับคู่งานของคุณเข้ากับฟีเจอร์ที่เฉพาะเจาะจง คุณจะได้:',
  'pages.angelInsider.basics.habits.habit3.tile.benefit1':
    '<strong>ควบคุมได้มากขึ้น:</strong> ความถูกต้องสูงขึ้นจากการเลือกเครื่องมือให้เหมาะกับงาน แทนที่จะพึ่งพาหน้าต่างแชทเพียงอย่างเดียว',
  'pages.angelInsider.basics.habits.habit3.tile.benefit2':
    '<strong>สั่งสมทักษะ:</strong> การลองทำคือหัวใจสำคัญ เมื่อคุณทดลองฟีเจอร์และการผสมผสานที่ต่างกันไป คุณจะค่อย ๆ สร้างภาพในใจว่า A&GEL ทำอะไรได้บ้าง เรื่องนี้ก็เหมือนการเดินขึ้นบันได: เริ่มจากคำถามพื้นฐานในแชท แล้วค่อยขยับไปสู่การวิเคราะห์หลายขั้นตอนที่ซับซ้อนในแอปหรือตรวจสอบเมื่อทักษะของคุณเติบโตขึ้น',
  'pages.angelInsider.basics.habits.habit3.tile.benefit3':
    '<strong>ประสิทธิภาพ:</strong> การรู้ว่าควรใช้เครื่องมือใดช่วยประหยัดเวลา คุณจะเลิกงัดข้อกับพรอมต์ในแชทสำหรับงานที่ฟีเจอร์เฉพาะทางจัดการได้ดีกว่า เช่น การบันทึกเสียงสำหรับการถอดความ หรือการแปลสำหรับการแปลงภาษาอย่างแม่นยำ',
  'pages.angelInsider.basics.habits.habit3.examples.chatOnly.bad':
    'ใช้แต่แชทอย่างเดียวเสมอ แม้กับสัญญา 90 หน้าหรือการวิเคราะห์หลายขั้นตอน',
  'pages.angelInsider.basics.habits.habit3.examples.chatOnly.good':
    'ลองใช้ตรวจสอบกับสัญญาฉบับยาว หรือใช้พรอมต์หลายขั้นตอนกับงานที่มีหลายช่วง — แล้วจดไว้ว่าฟีเจอร์ใดรู้สึกเร็วกว่าหรือแม่นกว่าสำหรับงานนั้น',
  'pages.angelInsider.basics.habits.habit3.examples.paste.bad':
    'วางสัญญา 90 หน้าลงในแชทแล้วถามว่า “มีความเสี่ยงอะไรบ้าง”',
  'pages.angelInsider.basics.habits.habit3.examples.paste.good':
    'ใช้ ‘ตรวจสอบ’ ร่วมกับรายการคำถามที่มีโครงสร้าง — หรือ ‘พรอมต์หลายขั้นตอน’ ในแอป — เพื่อไล่อ่านเอกสารทีละส่วนและชี้ให้ชัดว่าคุณกำลังมองหาอะไร',
  'pages.angelInsider.seeMore': 'ดูเพิ่มเติม',
  'pages.angelInsider.learnMore.heading': 'เรียนรู้เพิ่มเติม',
  'pages.angelInsider.learnMore.intro':
    'นอกเหนือจากแชท โหมดแอปของ A&GEL ยังครอบคลุมงานเฉพาะทาง ได้แก่ การวิจัยเชิงลึก สรุปแบบมีคำแนะนำ ข้อมูลด่วน ไทม์ไลน์ และการดึงกำหนดเวลา ฟีเจอร์เหล่านี้ให้ผลลัพธ์ที่ดีขึ้นเมื่อคุณระบุอย่างแม่นยำและเตรียมข้อมูลไว้พร้อม',
  'pages.angelInsider.learnMore.featuredBadge': 'แนะนำ',
  'pages.angelInsider.learnMore.cards.usingFiles.title': 'การใช้ไฟล์ของคุณบน A&GEL',
  'pages.angelInsider.learnMore.cards.usingFiles.body':
    'เอกสารที่สแกนมาต้องมีชั้นข้อความก่อน A&GEL จึงจะอ่านได้ ให้ใช้ Kofax แปลง PDF ให้ค้นหาข้อความได้ แล้วจึงอัปโหลด',
  'pages.angelInsider.learnMore.cards.workStudio.title': 'Workstudio',
  'pages.angelInsider.learnMore.cards.workStudio.body':
    'กำหนดจุดยืนมาตรฐานของทีมไว้เพียงครั้งเดียว — A&GEL จะส่งคืนเอกสาร Word พร้อมการติดตามการแก้ไข',
  'pages.angelInsider.learnMore.cards.workStudio.imageAlt': 'Workstudio',
  'pages.angelInsider.learnMore.cards.review.title': 'ตรวจสอบ',
  'pages.angelInsider.learnMore.cards.review.body':
    'ตั้งคำถามหลายข้อกับเอกสารหลายฉบับพร้อมกัน — ผลลัพธ์จะแสดงเป็นตารางพร้อมการอ้างอิงในบรรทัด ใช้มินิแชทเพื่อถามต่อได้โดยไม่ต้องออกจากหน้านี้',
  'pages.angelInsider.learnMore.cards.review.imageAlt': 'โหมดตรวจสอบ',
  'pages.angelInsider.learnMore.cards.dispute.title': 'การระงับข้อพิพาท',
  'pages.angelInsider.learnMore.cards.dispute.body':
    'สรุปคดี วิเคราะห์คำฟ้อง ร่างคำให้การ และติดตามคำคู่ความ ครอบคลุมชุดเอกสารทั้งหมด',
  'pages.angelInsider.learnMore.cards.dispute.imageAlt': 'ตัวติดตามคำคู่ความ',
  'pages.angelInsider.learnMore.cards.sideBySide.title':
    'เปรียบเทียบแบบเคียงข้างกันและการเทียบความต่าง',
  'pages.angelInsider.learnMore.cards.sideBySide.body':
    'ตรวจทานทีละข้อสัญญาพร้อมตรวจสอบย้อนกลับไปยังย่อหน้าต้นทางได้ครบถ้วน การเทียบความต่างรองรับการติดตามการแก้ไขและฉบับแก้ไขเพิ่มเติม',
  'pages.angelInsider.learnMore.cards.sideBySide.imageAlt': 'การวิเคราะห์แบบเคียงข้างกัน',
  'pages.angelInsider.learnMore.cards.multiStep.title': 'พรอมต์หลายขั้นตอน',
  'pages.angelInsider.learnMore.cards.multiStep.body':
    'แบ่งงานกฎหมายที่ซับซ้อนออกเป็นขั้นตอนต่อเนื่อง โดยแต่ละขั้นต่อยอดจากขั้นก่อนหน้า',
  'pages.angelInsider.learnMore.cards.multiStep.imageAlt': 'โหมดแอป',
  'pages.angelInsider.learnMore.cards.timeline.title': 'ไทม์ไลน์',
  'pages.angelInsider.learnMore.cards.timeline.body':
    'รวมลำดับเหตุการณ์จากเอกสารได้สูงสุด 100 ฉบับให้เป็นไทม์ไลน์เดียวที่ตรวจสอบต้นทางได้',
  'pages.angelInsider.learnMore.cards.timeline.imageAlt': 'ไทม์ไลน์',
  'pages.angelInsider.learnMore.cards.deepResearch.title': 'การวิจัยเชิงลึก',
  'pages.angelInsider.learnMore.cards.deepResearch.body':
    'วิเคราะห์ข้ามเอกสารอย่างละเอียดภายใต้พรอมต์การวิจัยที่มีโครงสร้าง ทุกข้อค้นพบเชื่อมกลับไปยังย่อหน้าต้นทางผ่านการอ้างอิงในบรรทัดที่คลิกได้',
  'pages.angelInsider.learnMore.cards.deepResearch.imageAlt': 'การวิจัยเชิงลึก',
  'pages.angelInsider.learnMore.cards.scopeSummary.title': 'สรุปขอบเขตงาน',
  'pages.angelInsider.learnMore.cards.scopeSummary.body':
    'สร้างบทสรุปที่มีโครงสร้างตามขอบเขตที่คุณกำหนดไว้ ทุกประเด็นที่ดึงออกมามีการอ้างอิงในบรรทัดที่คลิกได้เพื่อตรวจสอบกับต้นทาง',
  'pages.angelInsider.learnMore.faq.heading': 'คำถามที่พบบ่อย',
  'pages.angelInsider.learnMore.faq.group1.kicker': 'หลักการทั่วไป',
  'pages.angelInsider.learnMore.faq.experts.question':
    '“ให้ผู้เชี่ยวชาญได้ทำหน้าที่ผู้เชี่ยวชาญเสมอ” หมายความว่าอย่างไร',
  'pages.angelInsider.learnMore.faq.experts.answer':
    'วิจารณญาณ ความเข้าใจเชิงลึก และความซื่อตรงในฐานะผู้เชี่ยวชาญของคุณ ควรอยู่ที่ใจกลางของงานเสมอ A&GEL ไม่ได้มาแทนที่ความเชี่ยวชาญของคุณ — แต่ออกแบบมาเพื่อช่วยให้คุณทำได้มากขึ้นด้วยทรัพยากรที่มากขึ้น',
  'pages.angelInsider.learnMore.faq.unfamiliar.question':
    'หากฉันไม่คุ้นเคยกับเรื่องที่กำลังถาม A&GEL เลย ควรทำอย่างไร',
  'pages.angelInsider.learnMore.faq.unfamiliar.answer':
    'คุณยังใช้ A&GEL ได้ — เพียงแต่ต้องระมัดระวังมากขึ้นและตรวจสอบผลลัพธ์ให้มากขึ้น ลองใช้ A&GEL เป็นประตูสู่องค์ความรู้ที่ทีมของคุณมีอยู่แล้ว เพื่อรับข้อมูลเชิงลึกได้ทันทีและเสริมการเรียนรู้และพัฒนาตนเอง',
  'pages.angelInsider.learnMore.faq.group2.kicker': 'การจัดการไฟล์',
  'pages.angelInsider.learnMore.faq.referenceMaterial.question':
    'ฉันควรอัปโหลดเอกสารอ้างอิงประเภทใดขึ้น A&GEL',
  'pages.angelInsider.learnMore.faq.referenceMaterial.answer':
    'อัปโหลดเฉพาะเอกสารที่เชื่อถือได้และถูกต้องเท่านั้น — แหล่งกฎหมายชั้นต้น (ตัวบทกฎหมาย คำพิพากษา) และเอกสารภายในที่เชื่อถือได้ (องค์ความรู้ขององค์กร เอกสารที่ผ่านการใช้งานจริง) และควรตั้งชื่อไฟล์ตามแนวทางที่ชัดเจน',
  'pages.angelInsider.learnMore.faq.thirdParty.question':
    'ฉันอัปโหลดเอกสารของบุคคลภายนอกได้หรือไม่',
  'pages.angelInsider.learnMore.faq.thirdParty.answer':
    'ได้ — รวมถึงเอกสารจากทนายความฝ่ายตรงข้าม ให้อัปโหลดไว้ในโฟลเดอร์ที่ระบุชื่อชัดเจนเพื่อแยกจากแบบร่างที่คุณเชื่อถือ ทั้งนี้โปรดปฏิบัติตามนโยบายขององค์กรว่าด้วยการใช้ AI และเนื้อหาของบุคคลภายนอก',
  'pages.angelInsider.learnMore.faq.processingTime.question':
    'เหตุใด A&GEL จึงใช้เวลานานในการประมวลผลไฟล์ที่อัปโหลด',
  'pages.angelInsider.learnMore.faq.processingTime.answer':
    'เอกสารต้องถูกแปลงเป็น “เอ็มเบดดิง” ที่ A&GEL ใช้งานได้ — ซึ่งทำเพียงครั้งเดียวตอนอัปโหลด ในแชท คุณสามารถนำเอกสารที่อัปโหลดไว้แล้วมาใช้ซ้ำในเซสชันใหม่ได้โดยเลือกผ่านปุ่มบริบท',
  'pages.angelInsider.learnMore.faq.bulkUpload.question': 'ฉันควรอัปโหลดเอกสารจำนวนมากอย่างไร',
  'pages.angelInsider.learnMore.faq.bulkUpload.answer':
    'ในโหมดไฟล์ ให้คลิกปุ่มอัปโหลดที่มุมขวาบน เลือกไฟล์ของคุณ แล้วกด “เปิด” คุณสามารถใช้งาน A&GEL ต่อได้ระหว่างที่การอัปโหลดกำลังดำเนินอยู่',
  'pages.angelInsider.learnMore.faq.sorting.question':
    'ฉันควรจัดหมวดหมู่และดูแลเอกสารอ้างอิงอย่างไร',
  'pages.angelInsider.learnMore.faq.sorting.answer':
    'อย่าอัปโหลดทุกอย่างไว้ในโฟลเดอร์เดียว ให้จัดกลุ่มเอกสารตาม (i) หัวข้อเรื่อง และ (ii) ขั้นตอนการทำงาน เช่น <code>Home / IP Licensing / Licensor</code> วิธีนี้ช่วยให้ A&GEL ดึงบริบทที่ถูกต้องมาใช้ และทำให้คุณตรวจสอบผลลัพธ์ได้ง่ายขึ้น',
  'pages.angelInsider.learnMore.faq.group3.kicker': 'การเขียนพรอมต์',
  'pages.angelInsider.learnMore.faq.promptTypes.question': 'ฉันใช้พรอมต์ประเภทใดได้บ้าง',
  'pages.angelInsider.learnMore.faq.promptTypes.answer':
    'พรอมต์เพื่อค้นหาข้อมูล (แบบตั้งคำถาม อธิบาย ค้นคว้า) พรอมต์เชิงงาน (สั่งการ หลายขั้นตอน อิงเทมเพลต) พรอมต์เชิงวิเคราะห์ (วิเคราะห์ข้อมูล แก้ปัญหา เปรียบเทียบ) พรอมต์จำแนกประเภท (จัดประเภท เรียงลำดับ ติดแท็ก) และพรอมต์แปลงรูป (แปลภาษา แปลงรูปแบบ ปรับสำนวน) เป็นต้น',
  'pages.angelInsider.learnMore.faq.effectivePrompts.question':
    'ฉันจะเขียนพรอมต์ที่มีประสิทธิภาพได้อย่างไร',
  'pages.angelInsider.learnMore.faq.effectivePrompts.answer':
    'พรอมต์ที่ได้ผลดีที่สุดมีสี่ส่วน: <strong>(ก) บทบาท</strong> — A&GEL ควรสวมบทบาทเป็นใคร; <strong>(ข) งาน</strong> — คำสั่งที่เฉพาะเจาะจง; <strong>(ค) บริบท</strong> — ข้อมูลพื้นฐานและเอกสารอ้างอิง; <strong>(ง) รูปแบบ</strong> — คุณต้องการให้ผลลัพธ์มีโครงสร้างอย่างไร',
  'pages.angelInsider.learnMore.faq.rag.question': 'RAG คืออะไร และ A&GEL ใช้เมื่อใด',
  'pages.angelInsider.learnMore.faq.rag.answer':
    'RAG (Retrieval-Augmented Generation) คือโหมดแชทเริ่มต้นของ A&GEL โดยจะดึงเอกสารอ้างอิงจากคลังจัดเก็บของคุณส่งให้โมเดลพร้อมกับพรอมต์ เพื่อเพิ่มความแม่นยำและความน่าเชื่อถือของผลลัพธ์',
  'pages.angelInsider.learnMore.faq.allMaterials.question':
    'เหตุใดจึงไม่ควรให้ A&GEL พิจารณาเอกสารที่อัปโหลดไว้ทั้งหมดในทุกพรอมต์',
  'pages.angelInsider.learnMore.faq.allMaterials.answer':
    'การให้บริบทที่ไม่เกี่ยวข้องจะลดทั้งความเร็ว ความถูกต้อง และความน่าเชื่อถือ A&GEL ทำงานเชิงความน่าจะเป็น จึงอาจดึงเอกสารที่ไม่เหมาะกับงานปัจจุบันมาใช้ ควรจำกัดบริบทให้เหลือเฉพาะเอกสารที่เกี่ยวข้องกับพรอมต์ของคุณ',
  'pages.angelInsider.learnMore.faq.selectMaterials.question':
    'ฉันจะเลือกเอกสารอ้างอิงที่เกี่ยวข้องสำหรับแต่ละพรอมต์ได้อย่างไร',
  'pages.angelInsider.learnMore.faq.selectMaterials.answer':
    'ในโหมดแชท ให้ไปที่ “บริบท” คลิกสัญลักษณ์การเลือก แล้วเลือกเฉพาะเอกสารหรือโฟลเดอร์ที่เกี่ยวข้อง',
  'pages.angelInsider.learnMore.faq.group4.kicker': 'การใช้ผลลัพธ์',
  'pages.angelInsider.learnMore.faq.outputAsIs.question':
    'ฉันใช้ผลลัพธ์ของ A&GEL ได้ทันทีเลยหรือไม่',
  'pages.angelInsider.learnMore.faq.outputAsIs.answer':
    'ไม่ได้ — ต้องตรวจสอบผลลัพธ์ของ A&GEL ก่อนใช้งานเสมอ ให้ถือเป็นจุดตั้งต้น และตรวจทานเทียบกับแหล่งความรู้ที่เชื่อถือได้ รวมถึงเอกสารอ้างอิงที่คุณอัปโหลดไว้',
  'pages.angelInsider.learnMore.faq.accuracy.question':
    'ฉันควรตรวจสอบความถูกต้องและความน่าเชื่อถือของผลลัพธ์อย่างไร',
  'pages.angelInsider.learnMore.faq.accuracy.answer':
    'ในโหมดแชท ผลลัพธ์จะมีลิงก์อ้างอิงไปยังเอกสารต้นทางที่ A&GEL ใช้ คลิกที่การอ้างอิงแต่ละรายการเพื่อตรวจสอบกับเอกสารต้นฉบับ A&GEL ควรเป็นประตูสู่องค์ความรู้ของคุณ ไม่ใช่ตัวแหล่งความรู้เอง ผลลัพธ์ที่ไม่มีการอ้างอิงมีแนวโน้มเกิดการกุข้อมูล และไม่ควรนำไปใช้ เว้นแต่พรอมต์นั้นเป็นการเขียน จัดรูปแบบ หรือแก้ไขข้อความล้วน ๆ โดยได้ให้บริบทไว้อย่างเพียงพอแล้ว',
  'pages.angelInsider.learnMore.faq.group5.kicker': 'อภิธานศัพท์',
  'pages.angelInsider.learnMore.glossary.favouriteFileWeight.term': 'น้ำหนักไฟล์รายการโปรด',
  'pages.angelInsider.learnMore.glossary.favouriteFileWeight.definition':
    'ปรับระดับที่ A&GEL ให้ความสำคัญกับเอกสารที่ทำเครื่องหมายเป็น “รายการโปรด” ในคลังจัดเก็บ เมื่อสร้างคำตอบ',
  'pages.angelInsider.learnMore.glossary.reRanking.term': 'การจัดอันดับใหม่',
  'pages.angelInsider.learnMore.glossary.reRanking.definition':
    'กระบวนการจัดเรียงขั้นที่สอง ซึ่งทบทวนผลการค้นหาเบื้องต้นเพื่อจัดลำดับข้อสัญญาและช่วงข้อความที่เกี่ยวข้องที่สุดไว้ก่อนสร้างคำตอบ',
  'pages.angelInsider.learnMore.glossary.searchRatio.term': 'อัตราส่วนการค้นหา',
  'pages.angelInsider.learnMore.glossary.searchRatio.definition':
    'ควบคุมความกว้างในการค้นหาคลังจัดเก็บของ A&GEL อัตราส่วนสูง = บริบทกว้างขึ้น อัตราส่วนต่ำ = เน้นการจับคู่ที่ตรงกันพอดี',
  'pages.angelInsider.learnMore.glossary.systemPrompt.term': 'พรอมต์ระบบ',
  'pages.angelInsider.learnMore.glossary.systemPrompt.definition':
    'คำสั่งพื้นฐานที่กำหนดบทบาท น้ำเสียง และขอบเขตของ A&GEL ในทุกเซสชัน',
  'pages.angelInsider.learnMore.glossary.thinking.term': '‘การคิด’ / ‘การให้เหตุผล’',
  'pages.angelInsider.learnMore.glossary.thinking.definition':
    'การไตร่ตรองทีละขั้นภายในของ A&GEL ก่อนสร้างคำตอบสุดท้าย เพื่อลดข้อผิดพลาดในการวิเคราะห์ที่ซับซ้อน',
  'pages.angelInsider.learnMore.issues.heading': 'หากคุณต้องการอ่านฉบับย้อนหลัง',
  'pages.angelInsider.learnMore.issues.issue1.title': 'บริบทคือ (แทบจะ) ทุกสิ่ง',
  'pages.angelInsider.learnMore.issues.issue1.description':
    'พื้นฐาน • สาระสำคัญของการเขียนพรอมต์ • 17 ก.พ. 2026',
  'pages.angelInsider.learnMore.issues.issue2.title': 'กรณีใช้งานด้านการระงับข้อพิพาท',
  'pages.angelInsider.learnMore.issues.issue2.description':
    'สรุปคดี • ตัวติดตามคำคู่ความ • เคล็ดลับการเขียนพรอมต์ • 19 มี.ค. 2026',
  'pages.angelInsider.learnMore.issues.issue3.title': 'แอปไทม์ไลน์และพรอมต์หลายขั้นตอนใหม่',
  'pages.angelInsider.learnMore.issues.issue3.description':
    'การอัปโหลดอีเมล • อัปเดตการบันทึกเสียง • ปรับโฉมไทม์ไลน์ • 19 มี.ค. 2026',
  'pages.angelInsider.learnMore.issues.issue4.title': 'การแปลสดในการบันทึกเสียงและ Workstudio',
  'pages.angelInsider.learnMore.issues.issue4.description':
    'การแปลสด • ฟีเจอร์ Workstudio ใหม่ • 1 เม.ย. 2026',
  'pages.angelInsider.learnMore.issues.issue5.title': 'การอ้างอิงในบรรทัด มินิแชท และอื่น ๆ',
  'pages.angelInsider.learnMore.issues.issue5.description':
    'การอ้างอิงแบบชี้จุด • มินิแชทที่เลื่อนย้ายได้ • ไทม์สแตมป์ในการบันทึกเสียง • 10 เม.ย. 2026',
  'pages.angelInsider.learnMore.issues.pill': 'ฉบับที่ {number}',
  'pages.angelInsider.whatsNew.heading': 'มีอะไรใหม่',
  'pages.angelInsider.whatsNew.cards.msgUpload.title': 'การอัปโหลดอีเมล .msg',
  'pages.angelInsider.whatsNew.cards.msgUpload.body':
    'อัปโหลดไฟล์อีเมล .msg ได้โดยตรง พร้อมอ่านเนื้อหาไฟล์แนบได้ครบถ้วน',
  'pages.angelInsider.whatsNew.cards.inlineReferencing.title': 'การอ้างอิงในบรรทัด',
  'pages.angelInsider.whatsNew.cards.inlineReferencing.body':
    'การวิจัยเชิงลึก ไทม์ไลน์ สรุปขอบเขตงาน และตรวจสอบ รองรับการอ้างอิงแบบชี้จุดที่คลิกได้แล้ว — ตรวจสอบผลลัพธ์ใด ๆ กับต้นทางได้โดยไม่ต้องออกจากหน้านี้',
  'pages.angelInsider.comingUp.heading': 'สิ่งที่กำลังจะมา',
  'pages.angelInsider.comingUp.intro':
    'ใน A&GEL Insider ฉบับหน้า เราจะเจาะลึก Workstudio มากขึ้น คุณจะได้เรียนรู้วิธีสร้างพรอมต์หลายขั้นตอนตั้งแต่เริ่มต้น และนำไปใช้สร้างร่างเอกสารพร้อมการติดตามการแก้ไขที่สะท้อนจุดยืนมาตรฐานของทีมคุณ โปรดติดตาม',
  'pages.angelInsider.comingUp.cards.workstudioV2.title': 'Workstudio V2',
  'pages.angelInsider.comingUp.cards.workstudioV2.body':
    'เครื่องมือเขียนงานใน Workstudio ที่ลึกขึ้น และผลลัพธ์แบบติดตามการแก้ไขที่ครอบคลุมกว่าเดิม รายละเอียดในฉบับที่ 5',
  'pages.angelInsider.comingUp.cards.workstudioV2.badge': 'เร็ว ๆ นี้',
  'pages.angelInsider.comingUp.cards.moreToCome.title': 'ยังมีอีกมากที่กำลังจะตามมา',
  'pages.angelInsider.comingUp.cards.moreToCome.body':
    'ทีม A&GEL ส่งมอบฟีเจอร์ใหม่อย่างต่อเนื่อง โปรดติดตาม Insider ฉบับถัดไป',
  'pages.angelInsider.comingUp.cards.moreToCome.badge': 'อยู่ระหว่างดำเนินการ',
  'pages.angelInsider.issues.basics-intro.title': 'ยินดีต้อนรับสู่ A&GEL',
  'pages.angelInsider.issues.basics-intro.subtitle':
    'ข้อคิดสองสามข้อเพื่อให้คุณเริ่มต้นได้อย่างมั่นคง',
  'pages.angelInsider.issues.basics-intro.glance.0':
    'การเรียนรู้เครื่องมือใหม่ต้องใช้เวลา — เราพร้อมสนับสนุนคุณในทุกขั้นตอน',
  'pages.angelInsider.issues.basics-intro.glance.1':
    'เครื่องมืออย่าง A&GEL <strong>ขยายศักยภาพของคุณ</strong> ได้ไกลเกินกว่าที่คุณทำได้เพียงลำพัง',
  'pages.angelInsider.issues.basics-intro.glance.2':
    'วิธีเรียนรู้ที่ดีที่สุดคือ<strong>ลงมือใช้ A&GEL</strong> — สำรวจได้อย่างอิสระ และผิดพลาดได้',
  'pages.angelInsider.issues.basics-intro.glance.3':
    'เมื่อทีมนำ A&GEL มาใช้ร่วมกัน ประโยชน์จะทวีคูณกับทุกคน',
  'pages.angelInsider.issues.basics-intro.sections.0.kicker': '01 — เริ่มต้นใช้งาน',
  'pages.angelInsider.issues.basics-intro.sections.0.heading':
    'การเรียนรู้เครื่องมือใหม่ต้องใช้เวลา – และนั่นเป็นเรื่องปกติ',
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.0.p':
    'เรายินดีอย่างยิ่งที่คุณมาร่วมกับเรา ในขณะที่คุณเริ่มสำรวจ A&GEL เราขอแบ่งปันข้อคิดสองสามข้อเพื่อให้คุณเริ่มต้นได้อย่างมั่นคง',
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.1.p':
    'เราเข้าใจดีว่าการทำความคุ้นเคยกับเทคโนโลยีใหม่อาจรู้สึกท้าทายในช่วงแรก โปรดจำไว้ว่าเราพร้อมสนับสนุนคุณในทุกขั้นตอน หากมีคำถาม ติดขัดตรงจุดใด หรือเพียงต้องการให้เราช่วยพาไปทีละขั้น อย่าลังเลที่จะติดต่อเรา',
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.3.p':
    'เครื่องมือ AI อย่าง A&GEL <strong>แตกต่าง</strong>จากเครื่องมือรุ่นก่อน ๆ — เพราะมัน<strong>เสริมพลังให้คุณโดยตรง</strong> ลองนึกภาพว่าคุณมีผู้ช่วยเป็นกองทัพอยู่ในมือ พวกเขาอาจไม่ได้มาแทนวิจารณญาณของมนุษย์ แต่ในหลายแง่มุมก็ขยายศักยภาพของคุณได้ไกลเกินกว่าที่เคยทำได้เพียงลำพัง',
  'pages.angelInsider.issues.basics-intro.sections.0.blocks.4.p':
    '<strong>วิธีเริ่มต้นเรียนรู้ที่ดีที่สุดคือเริ่มใช้ A&GEL —</strong> เราขอเชิญชวนให้คุณสำรวจได้อย่างอิสระ ลองทำสิ่งต่าง ๆ ผิดพลาดได้ (ในแบบที่ปลอดภัย) แล้วค้นพบว่าอะไรเหมาะกับคุณที่สุด',
  'pages.angelInsider.issues.basics-intro.sections.1.kicker': '02 — การสั่งสมทักษะ',
  'pages.angelInsider.issues.basics-intro.sections.1.heading': 'ก้าวหน้าตามจังหวะของคุณเอง',
  'pages.angelInsider.issues.basics-intro.sections.1.blocks.0.p':
    'ลองมองการสั่งสมทักษะเหมือนการเดินขึ้นบันได เริ่มจากพื้นฐาน แล้วเมื่อคุณมั่นใจมากขึ้น การก้าวสู่ระดับถัดไปจะรู้สึกเป็นธรรมชาติมากขึ้น ไม่ต้องรีบ — นี่ไม่ใช่การแข่งขัน ใช้เวลาเท่าที่ต้องการเพื่อวางรากฐานให้แน่น',
  'pages.angelInsider.issues.basics-intro.sections.2.kicker': '03 — ชุมชนผู้ใช้',
  'pages.angelInsider.issues.basics-intro.sections.2.heading': 'ร่วมมือกัน เราไปได้ไกลกว่าเดิม',
  'pages.angelInsider.issues.basics-intro.sections.2.blocks.0.p':
    'เมื่อทีมงานและองค์กรนำ A&GEL มาใช้ร่วมกัน ประโยชน์จะทวีคูณกับทุกคน การแบ่งปันความรู้และร่วมมือกันในชุมชนผู้ใช้จะสร้างแรงกระเพื่อมที่ยกระดับทุกคนไปพร้อมกัน',
  'pages.angelInsider.issues.basics-intro.signoff.line':
    'ยินดีต้อนรับสู่ทีม — เราตื่นเต้นที่จะได้เห็นว่าเราจะทำอะไรได้บ้างร่วมกับ A&GEL',
  'pages.angelInsider.issues.basics-intro.signoff.name': 'Kok Leong<br>ทีมพัฒนา A&GEL',
  'pages.angelInsider.issues.issue-1.title': 'บริบทคือ (แทบจะ) ทุกสิ่ง',
  'pages.angelInsider.issues.issue-1.subtitle':
    'สาระสำคัญของการเขียนพรอมต์ — การเลือกบริบทกำหนดทุกสิ่งที่ A&GEL ส่งกลับมาอย่างไร',
  'pages.angelInsider.issues.issue-1.date': '15 ม.ค. 2026',
  'pages.angelInsider.issues.issue-1.glance.0':
    'แชทมีปุ่ม<strong>บริบท</strong>โดยเฉพาะ และตัวบ่งชี้ <strong>“% บริบท”</strong> แล้ว',
  'pages.angelInsider.issues.issue-1.glance.1':
    'ค่าเริ่มต้นของพารามิเตอร์การค้นหาคือ<strong>ไม่ใช้บริบท</strong> — เร็วกว่า เหมาะกับการตรวจทานและแก้ไขเล็กน้อย',
  'pages.angelInsider.issues.issue-1.glance.2':
    'สร้าง<strong>ชุดบริบทเริ่มต้น</strong>จากคลังจัดเก็บของคุณไว้ใช้กับงานประจำวัน',
  'pages.angelInsider.issues.issue-1.glance.3':
    'พรอมต์ที่ไม่มีบริบทก็เป็นเพียงการเดา — ให้ข้อมูลพื้นฐานที่มีเพียงคุณเท่านั้นที่รู้เสมอ',
  'pages.angelInsider.issues.issue-1.sections.0.kicker': '01 — แชท',
  'pages.angelInsider.issues.issue-1.sections.0.heading':
    'บริบทในแชท: ปุ่มเฉพาะและตัวบ่งชี้ “% บริบท”',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.0.p':
    'ฟังก์ชันแชทของ A&GEL ใช้กระบวนการ <strong>Retrieval-Augmented Generation (RAG)</strong> ที่ปรับแต่งเป็นพิเศษ โดยจะดึงองค์ความรู้และเอกสารอ้างอิงในคลังจัดเก็บของคุณส่งให้โมเดลเพื่อสร้างผลลัพธ์ ปัจจัยสำคัญที่สุดต่อคุณภาพของ RAG คือ<em>การเลือกบริบท</em> — คือคำตอบถูกดึงมาจากคลังจัดเก็บของคุณมากน้อยเพียงใด',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.1.p':
    'เพื่อให้เห็นภาพชัดขึ้น เราจึงเพิ่มตัวบ่งชี้ <strong>“% บริบท”</strong> — เป็นตัวชี้วัดคร่าว ๆ แต่มีประโยชน์ ช่วยให้เห็นได้ทันทีว่าเซสชันแชทปัจจุบันครอบคลุมคลังจัดเก็บของคุณมากเพียงใด คลิกปุ่มบริบทเพื่อเลือกโฟลเดอร์หรือไฟล์ที่ต้องการสนทนาด้วยได้อย่างแม่นยำ',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.2.callout.title':
    'ค่าเริ่มต้นใหม่: ไม่ใช้บริบท',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.2.callout.body':
    'ค่าเริ่มต้นของพารามิเตอร์การค้นหาคือไม่ใช้บริบท (มุมขวาบนของหน้าต่างแชท) วิธีนี้แชทจะเร็วขึ้นเพราะสร้างคำตอบจากความรู้สาธารณะที่ผ่านการฝึกไว้ล่วงหน้าเท่านั้น — เหมาะกับคำถามง่าย ๆ เช่น การตรวจทานหรือแก้ไขถ้อยคำ ในการตั้งค่าแบบไม่ใช้บริบท A&GEL ควรตอบกลับได้ภายในไม่กี่วินาที',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.3.h':
    'ตั้งค่าบริบทเริ่มต้นสำหรับการใช้งานประจำวัน',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.4.p':
    'เนื่องจาก A&GEL ตอบจากองค์ความรู้<em>ของคุณ</em> คุณจึงสร้างชุดบริบทเริ่มต้นได้ โดยคลิกปุ่มบริบท เลือกโฟลเดอร์ของคุณ แล้วกดปุ่มบวก (+) ตั้งชื่อชุดบริบท เลือก <strong>“ตั้งเป็นค่าเริ่มต้น”</strong> หากต้องการ แล้วคลิกตกลง',
  'pages.angelInsider.issues.issue-1.sections.0.blocks.5.p':
    'การเลือก<strong>ทุก</strong>โฟลเดอร์ (บริบท 100%) จะทำให้ A&GEL ช้าลง เพราะต้องค้นทุกเอกสาร — ขอบเขตที่กว้างไม่ได้ดีที่สุดเสมอไป ควรปรับบริบทให้ตรงกับคำถามนั้น ๆ การตอบกลับอาจใช้เวลาถึงหนึ่งนาที ขึ้นอยู่กับจำนวนไฟล์ที่คุณเข้าถึงได้และความซับซ้อนของคำถาม',
  'pages.angelInsider.issues.issue-1.sections.1.kicker': '02 — พรอมต์',
  'pages.angelInsider.issues.issue-1.sections.1.heading': 'ใส่บริบทของคุณทุกครั้งเมื่อเขียนพรอมต์',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.0.quote':
    'พรอมต์ที่ไม่มีบริบทก็เป็นเพียงการเดา — เหมือน “การเสี่ยงดวงกับพรอมต์”',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.1.p':
    'พรอมต์จะได้ผลก็ต่อเมื่อได้รับข้อมูลที่ถูกต้อง — โดยเฉพาะในสาขาที่ต้องอาศัยความเชี่ยวชาญเฉพาะทางสูง ให้มอง A&GEL เป็นผู้ช่วยที่มีความสามารถแต่ต้องการเห็นภาพรวมทั้งหมด จงให้ข้อมูลพื้นฐานที่มีเพียงคุณเท่านั้นที่รู้ — เป้าหมายสำคัญ ตัวชี้วัดความสำเร็จ หรือแม้แต่ตัวอย่างของคำตอบที่ “ดี” และ “ไม่ดี”',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.2.h':
    'กรอบคิดง่าย ๆ สำหรับพรอมต์ที่มีเนื้อหาแน่นขึ้น',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.3.p':
    'หมั่นถามตัวเองว่าคุณให้บริบทเพียงพอแล้วหรือยัง นี่คือจุดที่คุณได้ใช้ความเชี่ยวชาญในสาขาของคุณอย่างเต็มที่ — และเป็นจุดที่คุณภาพของผลลัพธ์อาจต่างกันราวฟ้ากับเหวเมื่อเทียบกับการเขียนพรอมต์แบบพื้นฐาน',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.4.callout.title': 'ตัวอย่างงานคดีความ',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.4.callout.body':
    'ทนายความคดีความจะได้ผลลัพธ์ที่คมชัดขึ้นมากเพียงแค่คัดลอกพรอมต์แล้วแก้ส่วนที่อยู่ในวงเล็บเหลี่ยมให้ตรงกับคดีของตน ยิ่งคุณให้บริบททางกฎหมาย (สรุปย่อของกฎหมายที่ใช้บังคับ) และบริบททางธุรกิจ (ข้อเท็จจริงแวดล้อม) มากเท่าใด พรอมต์นั้นก็ยิ่งทำหน้าที่เป็นเครื่องมือวิเคราะห์ได้ดีขึ้นเท่านั้น',
  'pages.angelInsider.issues.issue-1.sections.1.blocks.5.p':
    'คุณคือผู้ที่รู้จักบริบทของตนเองดีที่สุด — ดังนั้นจงใส่บริบทเฉพาะแบบที่จะดึงประสิทธิภาพของพรอมต์ รายการคำถาม และคำสั่งที่กำหนดเองของคุณออกมาให้เต็มที่เสมอ',
  'pages.angelInsider.issues.issue-1.sections.2.kicker': '03 — เริ่มต้นใช้งาน',
  'pages.angelInsider.issues.issue-1.sections.2.heading': 'ต้องการความช่วยเหลือ?',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.title': 'พบปัญหา? บอกเราสามอย่าง',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.body':
    'ส่งข้อความหรืออีเมลถึงผู้พัฒนา A&GEL โดยระบุเพียงเท่านี้ก็เพียงพอ:',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.list.0':
    '<strong>เวลาที่เกิดเหตุ</strong> — เช่น “แชทที่ฉันเริ่มเมื่อ 16:31 น. วันนี้”',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.list.1':
    '<strong>ฟีเจอร์ที่มีปัญหา</strong> — เช่น “ลองอัปโหลดไฟล์ใน การวิเคราะห์ → การวิจัยเชิงลึก แล้วไฟล์ไม่โหลด”',
  'pages.angelInsider.issues.issue-1.sections.2.blocks.0.callout.list.2':
    '<strong>คำอธิบายโดยย่อ</strong> หรือภาพหน้าจอ',
  'pages.angelInsider.issues.issue-1.signoff.line': 'ด้วยความปรารถนาดี และอย่าลืม — บริบทมาก่อน',
  'pages.angelInsider.issues.issue-1.signoff.name': 'ทีมพัฒนา A&GEL',
  'pages.angelInsider.issues.issue-2.title': 'กรณีใช้งานด้านการระงับข้อพิพาท',
  'pages.angelInsider.issues.issue-2.subtitle':
    'สร้างบทสรุปและร่างฉบับแรก วิเคราะห์และติดตามคำคู่ความ — พร้อมเคล็ดลับการเขียนพรอมต์',
  'pages.angelInsider.issues.issue-2.date': '12 ก.พ. 2026',
  'pages.angelInsider.issues.issue-2.glance.0':
    'พรอมต์ <strong>สรุปคดี</strong> สองแบบ (แบบกระชับและแบบละเอียด) — แบบละเอียดโดดเด่นเป็นพิเศษกับคำพิพากษาที่ซับซ้อน',
  'pages.angelInsider.issues.issue-2.glance.1':
    'พรอมต์สำหรับร่าง<strong>คำให้การ</strong>และ<strong>ข่าวสารกฎหมาย</strong>สำหรับลูกความ',
  'pages.angelInsider.issues.issue-2.glance.2':
    'ชุดพรอมต์สำหรับ<strong>วิเคราะห์คำคู่ความ</strong> — คำฟ้อง คำให้การ และความครบถ้วนของข้ออ้าง',
  'pages.angelInsider.issues.issue-2.glance.3':
    'ใช้<strong>โหมดตรวจสอบ</strong>เป็นตัวติดตามคำคู่ความข้ามเอกสารหลายฉบับ',
  'pages.angelInsider.issues.issue-2.sections.0.kicker': '01 — บทสรุป',
  'pages.angelInsider.issues.issue-2.sections.0.heading': 'สร้างบทสรุปคดี',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.0.p':
    'เราได้พัฒนาพรอมต์สองแบบสำหรับสรุปคดี — แบบหนึ่งให้ภาพรวมกระชับ อีกแบบหนึ่งวิเคราะห์ละเอียดกว่า ทั้งสองดัดแปลงจากพรอมต์ที่ SAL เผยแพร่ และขัดเกลาด้วย AI เชิงสร้างสรรค์ (รวมถึงการให้ A&GEL วิจารณ์ผลงานของตัวเอง)',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.1.p':
    'จากประสบการณ์ของเรา สรุปคดี<strong>แบบละเอียด</strong>มักเหนือกว่า โดยเฉพาะกับคำพิพากษาที่ซับซ้อนขึ้น A&GEL ถูกกำหนดให้อ้างอิงจากคำพิพากษาต้นฉบับ<em>เท่านั้น</em> — แต่พึงทราบว่ามันอาจแยกแยะ<em>เหตุผลแห่งคำวินิจฉัย (ratio decidendi)</em> ออกจาก<em>ความเห็นประกอบ (obiter dicta)</em> ได้ยาก',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.2.callout.title': 'ไม่ใช่ยาวิเศษ',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.2.callout.body':
    'ผลลัพธ์ยังต้องผ่านการตรวจทานและตรวจสอบตามปกติ — ตรวจความถูกต้องและครบถ้วนอย่างละเอียด พรอมต์เหล่านี้ให้จุดตั้งต้นที่มีประสิทธิภาพ ไม่ใช่ผลงานที่เสร็จสมบูรณ์',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.3.p':
    'ใช้ควบคู่กับฟังก์ชัน<strong>สรุปแบบมีคำแนะนำ</strong> (อยู่ในโหมดแอป) ซึ่งสรุปเอกสารฉบับเดียวโดยมีพรอมต์เป็นตัวกำกับ อัปโหลดคำพิพากษาของศาลสิงคโปร์ เลือกพรอมต์สรุปคดี (แบบละเอียด) แล้วเพิ่มประเด็นเฉพาะที่คุณให้ความสำคัญ',
  'pages.angelInsider.issues.issue-2.sections.0.blocks.4.figure.caption':
    'สรุปคดี (แบบกระชับ) v1.1 และสรุปคดี (แบบละเอียด) v1.1 ในคลังพรอมต์',
  'pages.angelInsider.issues.issue-2.sections.1.kicker': '02 — การร่างเอกสาร',
  'pages.angelInsider.issues.issue-2.sections.1.heading': 'สร้างร่างฉบับแรก',
  'pages.angelInsider.issues.issue-2.sections.1.blocks.0.p':
    'มีพรอมต์หนึ่ง (อิงจากพรอมต์ที่ SAL เผยแพร่) ที่สร้างร่าง<strong>คำให้การ</strong>ฉบับแรกเพื่อตอบคำฟ้อง คัดลอกแล้วปรับให้เข้ากับคดีของคุณ และอย่าลืมใส่บริบทให้เพียงพอ',
  'pages.angelInsider.issues.issue-2.sections.1.blocks.1.p':
    'พรอมต์ที่สองสร้าง<strong>ข่าวสารกฎหมาย</strong>สำหรับลูกความจากบทสรุปคดี โดยมีบทความตัวอย่างด้านการจัดการองค์ความรู้สั้น ๆ เป็นตัวกำกับสำนวน โครงสร้าง และน้ำเสียง',
  'pages.angelInsider.issues.issue-2.sections.1.blocks.2.gallery.0.caption':
    'ร่างคำให้การเพื่อตอบคำฟ้อง',
  'pages.angelInsider.issues.issue-2.sections.1.blocks.2.gallery.1.caption':
    'ร่างตามสำนวนและน้ำเสียงของบทความอ้างอิง v1.2',
  'pages.angelInsider.issues.issue-2.sections.2.kicker': '03 — คำคู่ความ',
  'pages.angelInsider.issues.issue-2.sections.2.heading': 'วิเคราะห์คำคู่ความ',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.0.p':
    'เราได้เตรียมพรอมต์สำหรับวิเคราะห์คำคู่ความไว้หลายชุด ซึ่งผ่านการทดสอบมาเพียงเบื้องต้น — ลองใช้ คัดลอกไปปรับปรุง และแบ่งปันกับผู้ใช้ท่านอื่น',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.1.list.0':
    '<strong>วิเคราะห์คำฟ้อง</strong> — บทสรุปผู้บริหาร ลำดับเหตุการณ์ ความครบถ้วนตามระเบียบศาล ค.ศ. 2021 ประเด็นสำคัญและข้อคัดค้านเบื้องต้น รวมถึงสิ่งที่ต้องดำเนินการทันทีและขั้นตอนถัดไป',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.1.list.1':
    '<strong>วิเคราะห์คำให้การ</strong> — ดึงกลยุทธ์การต่อสู้คดีออกมา พร้อมชี้ช่องว่างที่ยังไม่ได้ตอบข้อกล่าวหาในคำฟ้องอย่างเฉพาะเจาะจง',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.1.list.2':
    '<strong>ความครบถ้วนของคำคู่ความ</strong> — เดิมสร้างขึ้นเพื่อประเมินคำให้การ ให้คัดลอกไปปรับใช้กับคำคู่ความที่คุณกำลังตรวจ',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.2.gallery.0.caption':
    'การวิเคราะห์คำฟ้องและลำดับเหตุการณ์ v1.5',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.2.gallery.1.caption':
    'วิเคราะห์คำให้การต่อคำฟ้อง v1.0',
  'pages.angelInsider.issues.issue-2.sections.2.blocks.2.gallery.2.caption':
    'ความครบถ้วนของคำคู่ความสำหรับคำให้การ v1.0',
  'pages.angelInsider.issues.issue-2.sections.3.kicker': '04 — โหมดตรวจสอบ',
  'pages.angelInsider.issues.issue-2.sections.3.heading': 'ใช้ตรวจสอบเป็นตัวติดตามคำคู่ความ',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.0.p':
    'เห็นจุดยืนของแต่ละฝ่ายตลอดอายุของข้อพิพาทได้ในพริบตา ใน<strong>โหมดตรวจสอบ</strong> ให้ถือว่าทุกมูลเหตุแห่งการฟ้องในคำฟ้องคือคำถามนำ เพื่อตรวจสอบและโต้แย้งจุดยืนที่ปรากฏในคำคู่ความและคำให้การเป็นหนังสือได้อย่างเป็นระบบ',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.1.h': 'ขั้นที่ 1 — สร้างรายการคำถามในแชท',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.2.p':
    'อัปโหลดคำฟ้องเข้าไฟล์ของคุณหรือใส่ในแชทโดยตรง แล้วรันพรอมต์เพื่อดึงมูลเหตุแห่งการฟ้องออกมา:',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.3.prompt.label': 'ตัวสร้างรายการคำถาม',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.3.prompt.text':
    'คุณคือทนายความคดีความที่มีประสบการณ์ 20 ปี สูดหายใจลึก ๆ แล้วตั้งสมาธิ\n\nเอกสารที่อัปโหลดคือคำฟ้อง ภารกิจของคุณคือจัดทำบทสรุปแบบหัวข้อย่อย แต่ละหัวข้อควรครอบคลุม (ก) มูลเหตุแห่งการฟ้องหนึ่งข้อ (ข) จำเลยที่ถูกฟ้องในข้อนั้น (ค) ข้ออ้างข้อเท็จจริงที่ใช้เป็นฐาน และ (ง) คำขอบังคับที่เรียกร้อง ให้นำเสนอทุกประเด็นย่อยไว้ในหัวข้อเดียวกัน — หลีกเลี่ยงหัวข้อย่อยซ้อนชั้น ให้ดึงเนื้อหาทั้งหมดจากเอกสาร หากมีจำเลยหลายราย ให้ครอบคลุมมูลเหตุแห่งการฟ้องต่อจำเลยที่ 1 ให้ครบก่อนจึงขึ้นจำเลยที่ 2 และต่อ ๆ ไป\n\nให้ครบถ้วนแต่กระชับ: สรุปและอ้างอิงเนื้อหาทั้งหมดที่เกี่ยวข้องโดยตรงกับแต่ละมูลเหตุแห่งการฟ้อง ให้แม่นยำ: เลี่ยงถ้อยคำคลุมเครือ และใช้ถ้อยคำตามเอกสาร',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.4.h':
    'ขั้นที่ 2 — รันรายการคำถามกับคำคู่ความในโหมดตรวจสอบ',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.5.p':
    'คัดลอกรายการที่สร้างได้ สลับไปที่<strong>ตรวจสอบ</strong> แล้วคลิก<strong>คำถามด่วน</strong> วางรายการลงใน<em>เพิ่มคำถาม</em> คลิก<em>เพิ่ม +</em> แนบคำฟ้องของคุณ แล้วกดส่ง',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.6.gallery.0.caption':
    'โหมดตรวจสอบ — เพิ่มรายการคำถามเป็นเมทริกซ์คำถามด่วน',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.7.callout.title': 'ไม่ได้จำกัดแค่คำคู่ความ',
  'pages.angelInsider.issues.issue-2.sections.3.blocks.7.callout.body':
    'ความสามารถของตรวจสอบในการตั้งคำถามจำนวนมากกับเอกสารจำนวนมาก ยังเหมาะกับงานที่มีเอกสารหนาแน่นแบบอื่นด้วย — การเปิดเผยพยานหลักฐาน การตรวจเอกสาร และการตรวจคำให้การเป็นหนังสือที่มีปริมาณมาก',
  'pages.angelInsider.issues.issue-2.sections.4.kicker': '05 — ฝีมือ',
  'pages.angelInsider.issues.issue-2.sections.4.heading':
    'เคล็ดลับการเขียนพรอมต์: ทดสอบและปรับปรุง',
  'pages.angelInsider.issues.issue-2.sections.4.blocks.0.p':
    '<strong>ทดสอบพรอมต์ของคุณ</strong> ประเมินพรอมต์โดยเทียบผลลัพธ์ของ A&GEL กับคำตอบต้นแบบที่คุณเตรียมไว้แล้ว หากใกล้เคียงกันมาก แสดงว่าพรอมต์ของคุณพัฒนามาดี หากไม่ ให้หาว่าขาดตรงไหนแล้วเติมบริบทเข้าไป',
  'pages.angelInsider.issues.issue-2.sections.4.blocks.1.p':
    '<strong>ปรับปรุงพรอมต์ของคุณ</strong> ใช้เครื่องมือ <em>Improve My Prompt v1.0</em> ในคลังพรอมต์เพื่อขัดเกลาให้ดียิ่งขึ้น',
  'pages.angelInsider.issues.issue-2.signoff.line': 'คัดลอก ปรับแต่ง และแบ่งปันสิ่งที่ได้ผล',
  'pages.angelInsider.issues.issue-2.signoff.name': 'ทีมพัฒนา A&GEL',
  'pages.angelInsider.issues.feature-scribe.title': 'การบันทึกเสียง',
  'pages.angelInsider.issues.feature-scribe.subtitle':
    'บันทึกเสียง ถอดความ แปลสด และแก้ไขบันทึกการประชุม — ครบในที่เดียว',
  'pages.angelInsider.issues.feature-scribe.glance.0':
    '<strong>แก้ไขได้ทันที</strong> — แก้ข้อความถอดความได้ขณะที่ระบบกำลังบันทึก ส่วนที่แก้ไขจะขีดเส้นใต้ไว้',
  'pages.angelInsider.issues.feature-scribe.glance.1':
    '<strong>เล่นเสียงย้อนกลับ</strong> — คลิกช่วงใดของข้อความถอดความ เพื่อเล่นเสียงจากจุดนั้น',
  'pages.angelInsider.issues.feature-scribe.glance.2':
    '<strong>การแปลสด</strong> — แปลแบบเรียลไทม์เป็นภาษาที่คุณเลือก',
  'pages.angelInsider.issues.feature-scribe.glance.3':
    '<strong>ดาวน์โหลดพร้อมไทม์สแตมป์</strong> — ไฟล์ Word ที่ส่งออกมีไทม์สแตมป์เพื่อให้ค้นหาจุดที่ต้องการได้ง่าย',
  'pages.angelInsider.issues.feature-scribe.sections.0.kicker': 'การบันทึกเสียง',
  'pages.angelInsider.issues.feature-scribe.sections.0.heading':
    'แก้ไขได้ทันทีและเล่นเสียงย้อนกลับ',
  'pages.angelInsider.issues.feature-scribe.sections.0.blocks.0.p':
    '<strong>แก้ไขได้ทันที</strong> — ระบบบันทึกเสียงที่ปรับปรุงใหม่ให้คุณแก้ข้อความถอดความได้ โดยส่วนที่แก้ไขจะขีดเส้นใต้ไว้เพื่อให้อ้างอิงง่าย <strong>เล่นเสียงย้อนกลับ</strong> — หลังบันทึกผลถอดความแล้ว ให้เปิดข้อความถอดความต้นฉบับและคลิกช่วงใดก็ได้ เพื่อเล่นเสียงจากจุดนั้น',
  'pages.angelInsider.issues.feature-scribe.sections.0.blocks.1.gallery.0.caption':
    'การบันทึกเสียงกำลังดำเนินอยู่ พร้อมถอดความแบบสด',
  'pages.angelInsider.issues.feature-scribe.sections.0.blocks.1.gallery.1.caption':
    'ข้อความถอดความต้นฉบับ — คลิกที่ช่วงใดเพื่อเล่นเสียงของช่วงนั้น',
  'pages.angelInsider.issues.feature-scribe.sections.1.kicker': 'การบันทึกเสียง',
  'pages.angelInsider.issues.feature-scribe.sections.1.heading':
    'การแปลสด มาอยู่ในการบันทึกเสียงแล้ว',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.0.p':
    'เข้าใจการสนทนาและการประชุมในภาษาที่คุณเลือก ติ๊กช่อง<strong>การแปลสด</strong>แล้วเลือกภาษา — A&GEL จะแสดงคำแปลใต้ข้อความถอดความต้นฉบับแบบทันที',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.1.figure.caption':
    'เปิดใช้การแปลสดและเลือกภาษาจากเมนูแบบเลื่อนลง',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.2.p':
    'ขณะที่ A&GEL ถอดความและแปล คุณสามารถพิมพ์บันทึกย่อหรือแก้ข้อความถอดความได้โดยตรง — สิ่งที่คุณแก้จะแสดงเป็น<strong>สีเหลือง</strong>เพื่อแยกจากข้อความของ A&GEL ข้อความถอดความที่บันทึกไว้จะเก็บทั้งคำแปลและสิ่งที่คุณแก้ไข',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.3.gallery.0.caption':
    'คำแปลสดอยู่ใต้ต้นฉบับ พร้อมบันทึกย่อที่แก้ไขได้แสดงเป็นสีเหลือง',
  'pages.angelInsider.issues.feature-scribe.sections.1.blocks.3.gallery.1.caption':
    'ไทม์สแตมป์เรียงลงมาทางซ้ายของข้อความถอดความต้นฉบับ',
  'pages.angelInsider.issues.feature-scribe.sections.2.kicker': 'การบันทึกเสียง',
  'pages.angelInsider.issues.feature-scribe.sections.2.heading':
    'ข้อความถอดความที่ดาวน์โหลดได้ พร้อมไทม์สแตมป์แล้ว',
  'pages.angelInsider.issues.feature-scribe.sections.2.blocks.0.p':
    'ข้อความถอดความจากการบันทึกเสียงมี<strong>ไทม์สแตมป์</strong>อยู่ในไฟล์ Word ที่ดาวน์โหลดแล้ว — เป็นเครื่องหมายที่ช่วยให้ไปยังช่วงเวลาที่ต้องการในบทสนทนาหรือการประชุมที่บันทึกไว้ได้ง่ายขึ้น',
  'pages.angelInsider.issues.feature-scribe.sections.2.blocks.1.figure.caption':
    'ไฟล์ถอดความที่ดาวน์โหลด โดยยังคงไทม์สแตมป์และคำแปลไว้',
  'pages.angelInsider.issues.feature-scribe.signoff.line': 'บันทึก ทบทวน เล่นซ้ำ',
  'pages.angelInsider.issues.feature-scribe.signoff.name': 'ทีมพัฒนา A&GEL',
  'pages.angelInsider.issues.feature-prompt-library.title': 'คลังพรอมต์',
  'pages.angelInsider.issues.feature-prompt-library.subtitle':
    'ค้นหา คัดลอก และปรับใช้พรอมต์ที่สร้างโดยชุมชนผู้ใช้ — พร้อมขัดเกลาด้วยเครื่องมือในตัว',
  'pages.angelInsider.issues.feature-prompt-library.glance.0':
    'เรียกดู คัดลอก และปรับพรอมต์ที่ชุมชนผู้ใช้สร้างไว้ในคลังพรอมต์ ให้เข้ากับงานเฉพาะของคุณ',
  'pages.angelInsider.issues.feature-prompt-library.glance.1':
    '<strong>ทดสอบพรอมต์ของคุณ</strong> — เทียบผลลัพธ์ของ A&GEL กับคำตอบต้นแบบที่คุณเตรียมไว้แล้ว',
  'pages.angelInsider.issues.feature-prompt-library.glance.2':
    'ใช้ <strong>Improve My Prompt v1.0</strong> ในคลังพรอมต์เพื่อขัดเกลาพรอมต์ที่ยังให้ผลไม่เป็นดังหวัง',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.kicker': 'ฝีมือ',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.heading':
    'เคล็ดลับการเขียนพรอมต์: ทดสอบและปรับปรุง',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.0.p':
    '<strong>ทดสอบพรอมต์ของคุณ</strong> วิธีที่ได้ผลในการวัดประสิทธิภาพของพรอมต์ คือเทียบผลลัพธ์ของ A&GEL กับ “คำตอบต้นแบบ” หรือผลลัพธ์อ้างอิงที่คุณเตรียมไว้แล้ว',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.1.p':
    'ตัวอย่างเช่น หากคุณกำลังพัฒนาพรอมต์สำหรับสรุปคดี ให้ใช้บทสรุปคดีที่คุณเคยจัดทำไว้และคุ้นเคยดีเป็นเกณฑ์เทียบ รันพรอมต์สรุปของคุณแล้วประเมินผลลัพธ์ของ A&GEL เทียบกับงานเดิมของคุณ หากผลลัพธ์ใกล้เคียงกับเกณฑ์มาก แสดงว่าพรอมต์ของคุณพัฒนามาดี หากไม่ ให้ระบุช่องว่างที่ชัดเจนแล้วปรับพรอมต์ให้สอดคล้อง — เช่น เพิ่มบริบทให้มากขึ้น',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.2.p':
    '<strong>ปรับปรุงพรอมต์ของคุณ</strong> ลองใช้เครื่องมือ <em>Improve My Prompt v1.0</em> ที่มีอยู่ในคลังพรอมต์ของคุณเพื่อขัดเกลาพรอมต์ให้ดียิ่งขึ้น',
  'pages.angelInsider.issues.feature-prompt-library.sections.0.blocks.3.figure.caption':
    'Improve My Prompt v1.0 — ขัดเกลาพรอมต์ที่มีอยู่แล้วในคลัง',
  'pages.angelInsider.issues.feature-prompt-library.signoff.line':
    'คัดลอก ปรับแต่ง และแบ่งปันสิ่งที่ได้ผล',
  'pages.angelInsider.issues.feature-prompt-library.signoff.name': 'ทีมพัฒนา A&GEL',
  'pages.angelInsider.issues.feature-prompting.title': 'การเขียนพรอมต์',
  'pages.angelInsider.issues.feature-prompting.subtitle':
    'พรอมต์ที่ไม่มีบริบทก็คือการเดา นี่คือกรอบคิดที่จะเปลี่ยนสิ่งนั้น',
  'pages.angelInsider.issues.feature-prompting.glance.0':
    'พรอมต์ที่ได้ผลทุกอันมีสี่ส่วน: <strong>บทบาท งาน บริบท และรูปแบบ</strong>',
  'pages.angelInsider.issues.feature-prompting.glance.1':
    'บริบทคือส่วนที่มีเพียง<em>คุณ</em>เท่านั้นที่ให้ได้ — เป็นจุดที่ความเชี่ยวชาญของคุณสร้างความแตกต่าง',
  'pages.angelInsider.issues.feature-prompting.glance.2':
    'พรอมต์ที่ไม่มีบริบทก็คือ “การเสี่ยงดวงกับพรอมต์” — ถูกต้องตามรูปแบบ แต่ยากจะได้ผลลัพธ์ที่ใช้ได้จริง',
  'pages.angelInsider.issues.feature-prompting.glance.3':
    'คัดลอกพรอมต์จากคลัง แล้วปรับด้วยข้อเท็จจริงและกรอบกฎหมายเฉพาะของงานคุณ',
  'pages.angelInsider.issues.feature-prompting.sections.0.kicker': '01 — กรอบคิด',
  'pages.angelInsider.issues.feature-prompting.sections.0.heading': 'บทบาท งาน บริบท รูปแบบ',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.0.p':
    'พรอมต์ที่ได้ผลทุกอันมีสี่ส่วน ลองมองเป็นรายการตรวจสอบ:',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.1.p':
    '<strong>บทบาท</strong> — บอก A&GEL ว่าให้สวมบทบาทเป็นใคร <em>“คุณคือทนายความคดีความที่มีประสบการณ์ 20 ปี”</em> สิ่งนี้กำหนดน้ำเสียง ความลึก และความเฉพาะเจาะจงของผลลัพธ์',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.2.p':
    '<strong>งาน</strong> — อธิบายสิ่งที่คุณต้องการให้ทำอย่างชัดเจนและเฉพาะเจาะจง',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.3.p':
    '<strong>บริบท</strong> — นี่คือส่วนที่มีเพียงคุณเท่านั้นที่ให้ได้ ไม่ว่าจะเป็นกรอบกฎหมายที่เฉพาะเจาะจง ข้อเท็จจริงทางธุรกิจ หรือสภาพแวดล้อมของเรื่องนั้น พรอมต์ที่ไม่มีบริบทก็เป็นเพียงการเดา — ที่ทีมงานเรียกว่า “การเสี่ยงดวงกับพรอมต์” คุณภาพผลลัพธ์ของ A&GEL แปรผันตรงกับคุณภาพของบริบทที่คุณให้',
  'pages.angelInsider.issues.feature-prompting.sections.0.blocks.4.p':
    '<strong>รูปแบบ</strong> — ระบุว่าต้องการให้ผลลัพธ์มีโครงสร้างอย่างไร รายการเรียงเลข? ตาราง? ร่างข้อสัญญา? หรือย่อหน้าสั้น ๆ? หากไม่ระบุ A&GEL จะใช้รูปแบบทั่วไปซึ่งอาจไม่เหมาะกับขั้นตอนการทำงานของคุณ',
  'pages.angelInsider.issues.feature-prompting.sections.1.kicker': '02 — บริบทในทางปฏิบัติ',
  'pages.angelInsider.issues.feature-prompting.sections.1.heading': 'ความแตกต่างที่บริบทสร้างขึ้น',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.0.p':
    'มอง A&GEL เป็นผู้ช่วยที่มีความสามารถแต่ต้องเห็นภาพรวมทั้งหมดจึงจะทำงานได้ดีที่สุด แทนที่จะถามคำถามกว้าง ๆ ให้ใส่รายละเอียดพื้นฐานที่มีเพียงคุณเท่านั้นที่รู้ — เป้าหมายสำคัญของคุณ ข้อเท็จจริงของเรื่อง และลักษณะของคำตอบที่ “ดี” หรือ “ไม่ดี”',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.1.p':
    'ยิ่งคุณให้เนื้อหาทางกฎหมาย (เช่น สรุปย่อของสาขากฎหมายที่ใช้บังคับ) และบริบททางธุรกิจ (เช่น ข้อเท็จจริงแวดล้อมของธุรกรรมหรือข้อพิพาท) มากเท่าใด ผลลัพธ์ก็ยิ่งมีประโยชน์มากขึ้นเท่านั้น เมื่อมีบริบทเช่นนี้ คุณภาพของผลลัพธ์อาจต่างกันราวฟ้ากับเหวเมื่อเทียบกับการเขียนพรอมต์แบบพื้นฐาน',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.2.callout.title':
    'ตัวอย่างการสรุปคดี',
  'pages.angelInsider.issues.feature-prompting.sections.1.blocks.2.callout.body':
    'เมื่อใช้พรอมต์สรุปคดี ให้เพิ่มรายละเอียดโดยย่อของประเด็นกฎหมายที่คุณสนใจ — เช่น ความแตกต่างระหว่างเหตุผลแห่งคำวินิจฉัย (ratio decidendi) กับความเห็นประกอบ (obiter dicta) คัดลอกพรอมต์จากคลัง แก้ให้สะท้อนจุดสนใจเฉพาะของคุณ แล้วคุณจะพบว่าผลลัพธ์ตรงเป้ากว่าการใช้พรอมต์ตามที่มีอยู่เดิมมาก',
  'pages.angelInsider.issues.feature-prompting.sections.2.kicker': '03 — ทดสอบและปรับปรุง',
  'pages.angelInsider.issues.feature-prompting.sections.2.heading':
    'ตั้งเกณฑ์เทียบ แล้วค่อยขัดเกลา',
  'pages.angelInsider.issues.feature-prompting.sections.2.blocks.0.p':
    'ทดสอบพรอมต์ใด ๆ เทียบกับ “คำตอบต้นแบบ” ที่คุณมีอยู่แล้ว — บทสรุปคดีที่คุณเคยจัดทำ หรือข้อสัญญาที่คุณเคยร่างไว้ รันพรอมต์แล้วเทียบผลลัพธ์กับเกณฑ์ของคุณ หากสอดคล้องกัน แสดงว่าพรอมต์พัฒนามาดี หากไม่ ให้ระบุช่องว่างที่ชัดเจนแล้วเติมบริบทให้สอดคล้อง',
  'pages.angelInsider.issues.feature-prompting.sections.2.blocks.1.p':
    'ใช้เครื่องมือ <strong>Improve My Prompt v1.0</strong> ในคลังพรอมต์เพื่อขัดเกลาพรอมต์ใด ๆ ที่ยังให้ผลไม่เป็นดังหวัง',
  'pages.angelInsider.issues.feature-prompting.signoff.line':
    'คุณรู้จักบริบทของตัวเองดีที่สุด — จงใส่มันลงไปในพรอมต์',
  'pages.angelInsider.issues.feature-prompting.signoff.name': 'ทีมพัฒนา A&GEL',
  'pages.angelInsider.issues.feature-prompting.altCta.label':
    'อ่านเพิ่มเติมเกี่ยวกับคลังพรอมต์ &rarr;',
  'pages.angelInsider.issues.feature-guided-summary.title': 'ข้อมูลด่วนและสรุปแบบมีคำแนะนำ',
  'pages.angelInsider.issues.feature-guided-summary.subtitle':
    'อ่านเอกสารฉบับเดียวได้อย่างรวดเร็วและตรวจสอบต้นทางได้ — จะเอาแบบภาพรวมหรือกำหนดทิศทางเองก็ได้',
  'pages.angelInsider.issues.feature-guided-summary.glance.0':
    'ใช้<strong>ข้อมูลด่วน</strong>เพื่อดูภาพรวมของเอกสารใด ๆ ได้ทันที',
  'pages.angelInsider.issues.feature-guided-summary.glance.1':
    '<strong>สรุปแบบมีคำแนะนำ</strong> (อยู่ในโหมดแอป) ให้คุณกำหนดจุดโฟกัสเองได้ — ใช้คู่กับพรอมต์จากคลัง',
  'pages.angelInsider.issues.feature-guided-summary.glance.2':
    'อัปโหลดเอกสาร เลือกพรอมต์ แล้วเพิ่มประเด็นเฉพาะที่คุณต้องการให้ครอบคลุม',
  'pages.angelInsider.issues.feature-guided-summary.glance.3':
    'เร็วขึ้นแล้ว — พร้อม<strong>การอัปเดตระหว่างทางและการอ้างอิงในบรรทัด</strong>ขณะกำลังสร้างผลลัพธ์',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.kicker': '01 — สรุปแบบมีคำแนะนำ',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.heading':
    'บทสรุปของเอกสารใด ๆ ที่ตรวจสอบต้นทางได้ โดยมีพรอมต์เป็นตัวกำกับ',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.0.p':
    'คลังพรอมต์มีพรอมต์สองแบบสำหรับสรุปเอกสาร — แบบหนึ่งให้ภาพรวมกระชับ อีกแบบหนึ่งวิเคราะห์ละเอียดกว่า ทั้งสองดัดแปลงจากพรอมต์ที่ SAL เผยแพร่และขัดเกลาด้วย AI เชิงสร้างสรรค์',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.1.p':
    'จากประสบการณ์ของเรา ตัวสรุป<strong>แบบละเอียด</strong>มักเหนือกว่า โดยเฉพาะกับเอกสารที่ซับซ้อนขึ้น A&GEL ถูกกำหนดให้อ้างอิงจากต้นฉบับ<em>เท่านั้น</em> — แม้ว่าในคดีตามคำพิพากษา มันอาจแยกแยะ<em>เหตุผลแห่งคำวินิจฉัย (ratio decidendi)</em> ออกจาก<em>ความเห็นประกอบ (obiter dicta)</em> ได้ยาก',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.2.callout.title':
    'ไม่ใช่ยาวิเศษ',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.2.callout.body':
    'ผลลัพธ์ยังต้องผ่านการตรวจทานและตรวจสอบตามปกติ — ตรวจความถูกต้องและครบถ้วนอย่างละเอียด พรอมต์เหล่านี้ให้จุดตั้งต้นที่มีประสิทธิภาพ ไม่ใช่ผลงานที่เสร็จสมบูรณ์',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.3.p':
    'ใช้ฟังก์ชัน<strong>สรุปแบบมีคำแนะนำ</strong> (อยู่ในโหมดแอป) เพื่อรันพรอมต์ใด ๆ กับเอกสารฉบับเดียว อัปโหลดไฟล์ เลือกพรอมต์จากคลัง แล้วเพิ่มประเด็นเฉพาะที่คุณให้ความสำคัญ',
  'pages.angelInsider.issues.feature-guided-summary.sections.0.blocks.4.figure.caption':
    'สรุปคดี (แบบกระชับ) v1.1 และสรุปคดี (แบบละเอียด) v1.1 ในคลังพรอมต์',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.kicker': '02 — ความเร็วและการอัปเดต',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.heading':
    'สร้างผลลัพธ์เร็วขึ้นพร้อมการอัปเดตระหว่างทาง',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.blocks.0.p':
    'สรุปแบบมีคำแนะนำมี<strong>การอัปเดตระหว่างทางพร้อมการอ้างอิงในบรรทัด</strong>ขณะกำลังสร้างผลลัพธ์แล้ว — คุณจะเห็นแต่ละส่วนทยอยปรากฏ และเริ่มตรวจสอบการอ้างอิงได้ก่อนที่ผลลัพธ์ทั้งหมดจะเสร็จ',
  'pages.angelInsider.issues.feature-guided-summary.sections.1.blocks.1.p':
    'ความเร็วของผลลัพธ์โดยรวมก็เพิ่มขึ้นด้วย หมายเหตุ: สำหรับเอกสารที่ไม่ซับซ้อน บทสรุปอาจโหลดเร็วจนข้ามการอัปเดตระหว่างทางไปเลย',
  'pages.angelInsider.issues.feature-guided-summary.signoff.line':
    'ข้อมูลด่วนไว้ดูภาพรวม สรุปแบบมีคำแนะนำไว้กำหนดจุดโฟกัสเอง',
  'pages.angelInsider.issues.feature-guided-summary.signoff.name': 'ทีมพัฒนา A&GEL',
  'pages.angelInsider.issues.feature-vault.title': 'คลังจัดเก็บของคุณ',
  'pages.angelInsider.issues.feature-vault.subtitle':
    'คลังจัดเก็บคือสมองของคุณบน A&GEL — จัดการให้ดี แล้วผลลัพธ์ของ AI ก็จะคมชัดตามไปด้วย',
  'pages.angelInsider.issues.feature-vault.glance.0':
    'A&GEL <strong>ไม่</strong>ค้นหาข้อมูลจากอินเทอร์เน็ต — แต่ทำงานเฉพาะภายในคลังจัดเก็บของคุณเท่านั้น',
  'pages.angelInsider.issues.feature-vault.glance.1':
    '<strong>บริบทคือทุกสิ่ง</strong>: การอัปโหลดอย่างแม่นยำและคัดสรร ย่อมให้ผลลัพธ์ที่แม่นยำและเชื่อถือได้',
  'pages.angelInsider.issues.feature-vault.glance.2':
    'โครงสร้างโฟลเดอร์ของคุณคือข้อมูลกำกับ — ที่นำทาง AI ไปสู่มุมมองที่ถูกต้อง',
  'pages.angelInsider.issues.feature-vault.glance.3':
    'ใช้<strong>น้ำหนักไฟล์ที่อ้างอิง</strong>และ<strong>น้ำหนักไฟล์ในเซสชัน</strong>เพื่อปรับละเอียดว่า A&GEL ควรให้ความสำคัญกับสิ่งใด',
  'pages.angelInsider.issues.feature-vault.sections.0.kicker': '01 — สมอง',
  'pages.angelInsider.issues.feature-vault.sections.0.heading': 'คลังจัดเก็บคือสมองของคุณบน A&GEL',
  'pages.angelInsider.issues.feature-vault.sections.0.blocks.0.p':
    'คลังจัดเก็บถูกออกแบบมาให้เป็นแหล่งบริบทหลักของ A&GEL โดยยึดโยงผลลัพธ์เชิงความน่าจะเป็นของ AI ไว้กับฐานความรู้ที่คุณคัดสรรและเชื่อถือได้',
  'pages.angelInsider.issues.feature-vault.sections.0.blocks.1.p':
    '<strong>A&GEL ค้นหาคำตอบจากอินเทอร์เน็ตหรือไม่</strong> ไม่ A&GEL ทำงานอยู่ภายในขอบเขตคลังจัดเก็บของคุณอย่างเคร่งครัด โดยอาศัยเฉพาะเอกสารที่คุณอัปโหลดและคัดสรรไว้ นี่เป็นทางเลือกการออกแบบโดยเจตนา เพื่อวัตถุประสงค์สามประการ คือ ความถูกต้องของผลลัพธ์ การรักษาความปลอดภัย และการรักษาความสมบูรณ์ของฐานความรู้เฉพาะขององค์กรคุณ',
  'pages.angelInsider.issues.feature-vault.sections.0.blocks.2.p':
    'แทนที่จะดึงข้อมูลที่ยังไม่ผ่านการตรวจสอบจากเว็บ A&GEL ยึดคลังจัดเก็บของคุณเป็นแหล่งความจริงเพียงแหล่งเดียวอย่างเคร่งครัด หากคลังจัดเก็บของคุณได้รับการคัดสรรอย่างดี ฟีเจอร์ต่าง ๆ ของ A&GEL ก็จะตั้งอยู่บนแบบอย่างที่คุณเชื่อถือ ข้อเท็จจริงที่คุณตรวจสอบแล้ว และกลยุทธ์ที่คุณเห็นชอบ เมื่อ A&GEL ตอบคำถาม มันไม่ได้เดาจากความรู้ทั่วไป — แต่กำลังสังเคราะห์ข้อมูลเชิงลึกจากแหล่งอ้างอิงที่เฉพาะเจาะจงและน่าเชื่อถือของคุณ',
  'pages.angelInsider.issues.feature-vault.sections.1.kicker': '02 — การอัปโหลด',
  'pages.angelInsider.issues.feature-vault.sections.1.heading': 'อัปโหลดอะไร และอัปโหลดอย่างไร',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.0.p':
    '<strong>อัปโหลดอะไรได้บ้าง</strong> เอกสาร Word, PDF หรืออีเมลใด ๆ ส่วนรูปแบบไฟล์อื่น ๆ อยู่ระหว่างดำเนินการ',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.1.p':
    '<strong>อย่างไร</strong> อัปโหลดไฟล์ได้โดยลากและวางไฟล์ทีละไฟล์หรือทั้งโฟลเดอร์ลงบนหน้าไฟล์ หรือคลิกปุ่มอัปโหลด',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.2.figure.caption':
    'ลากและวางไฟล์หรือโฟลเดอร์ลงบนหน้าไฟล์ได้โดยตรง',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.3.callout.title':
    'ใส่ขยะเข้าไป ก็ได้ขยะออกมา',
  'pages.angelInsider.issues.feature-vault.sections.1.blocks.3.callout.body':
    'อย่ามอง A&GEL เป็นคำพยากรณ์วิเศษ แต่ให้มองเป็นเพื่อนร่วมงานที่ไม่รู้จักเหน็ดเหนื่อยและได้อ่านทุกอย่างที่คุณอัปโหลดไว้ ถ้าคุณยื่นโต๊ะรกที่กองด้วยเอกสารไม่เกี่ยวข้องให้เขา งานที่ออกมาก็มักจะสับสน แต่ถ้าคุณยื่นแบบอย่างที่ตรงประเด็นเพียงชิ้นเดียว งานของเขาก็จะคมขึ้น นี่คือแก่นความจริงของการใช้ A&GEL: <strong>บริบทคือทุกสิ่ง</strong>',
  'pages.angelInsider.issues.feature-vault.sections.2.kicker': '03 — โครงสร้าง',
  'pages.angelInsider.issues.feature-vault.sections.2.heading': 'ควรมีโครงสร้างโฟลเดอร์บ้าง',
  'pages.angelInsider.issues.feature-vault.sections.2.blocks.0.p':
    'โครงสร้างโฟลเดอร์ไม่ได้มีไว้เพื่อความเป็นระเบียบเท่านั้น — แต่เป็นข้อมูลกำกับที่นำทาง AI การจัดไฟล์ลงโฟลเดอร์ย่อยอย่างมีเหตุผล เช่น แยกแบบอย่างฝั่ง “ผู้ขาย” ออกจากฝั่ง “ลูกค้า” ช่วยให้ A&GEL ดึงมุมมองที่ถูกต้องมาใช้ได้',
  'pages.angelInsider.issues.feature-vault.sections.2.blocks.1.figure.caption':
    'เจาะลงไปในโฟลเดอร์ย่อย — การแยกแบบอย่างฝั่ง “ผู้รับอนุญาต” ออกจากฝั่ง “ผู้ให้อนุญาต” ช่วยให้บริบทสะอาด',
  'pages.angelInsider.issues.feature-vault.sections.2.blocks.2.p':
    '<strong>เลี่ยงกับดัก “อัปโหลดทุกอย่าง”</strong> เป็นเรื่องน่าดึงดูดที่จะเทเอกสารทั้งคลังลงในโฟลเดอร์เดียวแล้วปล่อยให้ AI จัดการเอง อย่าทำเช่นนั้น A&GEL ใช้ Retrieval-Augmented Generation (RAG) หมายความว่ามันดึงคำตอบจากไฟล์ที่คุณอัปโหลด GenAI ไม่ได้ “เข้าใจ” ข้อเท็จจริง — แต่ทำนายความน่าจะเป็น เมื่อคุณป้อนสิ่งรบกวนที่ไม่เกี่ยวข้อง สัญญาณก็จะถูกเจือจาง ผลที่ได้คือผลลัพธ์ที่ถูกต้องน้อยลง แม่นยำน้อยลง และเชื่อถือได้น้อยลง ควรเลือกเอกสารหรือโฟลเดอร์ที่เกี่ยวข้องกับพรอมต์ด้วยตัวเองเสมอ',
  'pages.angelInsider.issues.feature-vault.sections.3.kicker': '04 — การปรับละเอียด',
  'pages.angelInsider.issues.feature-vault.sections.3.heading': 'ปรับละเอียดสัญญาณ',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.0.p':
    'A&GEL มีปุ่มปรับให้คุณควบคุมกระบวนการนี้ ใช้<strong>น้ำหนักไฟล์ที่อ้างอิง</strong>เพื่อบังคับให้ AI ให้ความสำคัญกับเอกสารที่คุณอ้างถึงเป็นพิเศษ และใช้<strong>น้ำหนักไฟล์ในเซสชัน</strong>เพื่อเพิ่มน้ำหนักให้ไฟล์ที่อัปโหลดเฉพาะสำหรับการสนทนานั้น',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.1.p':
    'ท้ายที่สุด โปรดจำไว้ว่า A&GEL คือจุดตั้งต้น — เป็นคู่คิดสำหรับระดมสมองหรือพื้นที่ทำงานร่วมกันเพื่อขัดเกลาความคิดเริ่มต้น ไม่ใช่เส้นชัย ตรวจสอบผลลัพธ์เทียบกับเอกสารต้นทางที่ลิงก์ไว้ในคำตอบเสมอ',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.2.callout.title': 'สรุปแล้ว',
  'pages.angelInsider.issues.feature-vault.sections.3.blocks.2.callout.body':
    'ดูแลคลังจัดเก็บของคุณเหมือนห้องสมุดที่คัดสรรมาอย่างดี ไม่ใช่กองขยะ รู้ว่าคุณเก็บเอกสารไว้ที่ใด เลือกบริบทอย่างพิถีพิถัน แล้ว A&GEL จะเปลี่ยนจากแชทบอทที่ส่งเสียงรบกวน เป็นผู้ช่วยที่แม่นยำสูง',
  'pages.angelInsider.issues.feature-vault.signoff.line': 'ดูแลคลังจัดเก็บของคุณ ควบคุมบริบทของคุณ',
  'pages.angelInsider.issues.feature-vault.signoff.name': 'ทีมพัฒนา A&GEL',
  'pages.angelInsider.issues.feature-vault.cta.label': 'กลับไปที่พื้นฐาน →',
  'pages.angelInsider.issues.issue-3.title': 'แอปไทม์ไลน์และพรอมต์หลายขั้นตอนใหม่',
  'pages.angelInsider.issues.issue-3.subtitle':
    'การอัปโหลด .msg, การบันทึกเสียงที่ฉลาดขึ้น, การเขียนพรอมต์หลายขั้นตอนอย่างมีโครงสร้าง และไทม์ไลน์ที่ปรับโฉมครั้งใหญ่',
  'pages.angelInsider.issues.issue-3.date': '18 มี.ค. 2026',
  'pages.angelInsider.issues.issue-3.glance.0':
    '<strong>ไฟล์อีเมล (.msg)</strong> อัปโหลดและอ่านได้ครบถ้วนแล้ว — รวมถึงไฟล์แนบ',
  'pages.angelInsider.issues.issue-3.glance.1':
    '<strong>การบันทึกเสียง</strong> รองรับการแก้ไขทันที การเล่นเสียงย้อนกลับ และการบันทึกอัตโนมัติทุกหนึ่งนาที',
  'pages.angelInsider.issues.issue-3.glance.2':
    'โหมด<strong>พรอมต์หลายขั้นตอน</strong>ใหม่ ช่วยแบ่งงานกฎหมายที่ซับซ้อนออกเป็นขั้นตอนที่ตรงเป้า',
  'pages.angelInsider.issues.issue-3.glance.3':
    '<strong>ไทม์ไลน์</strong>ปรับโฉมใหม่ให้รวมลำดับเหตุการณ์จากเอกสารหลายฉบับเข้าด้วยกัน',
  'pages.angelInsider.issues.issue-3.sections.0.kicker': '01 — ไฟล์',
  'pages.angelInsider.issues.issue-3.sections.0.heading': 'อัปโหลดไฟล์อีเมล (.msg)',
  'pages.angelInsider.issues.issue-3.sections.0.blocks.0.p':
    'ผู้ใช้ A&GEL สามารถอัปโหลดไฟล์อีเมล <strong>.msg</strong> ทั้งฉบับเข้าสู่ไฟล์ เพื่อใช้กับแชทหรือโหมดเฉพาะทางใด ๆ ได้แล้ว A&GEL จะอ่านเนื้อหาทั้งหมด — รวมถึงไฟล์แนบ — ยกเว้นไฟล์แนบที่มีป้ายกำกับความอ่อนไหว <em>เฉพาะภายใน</em> หรือที่ป้องกันด้วยรหัสผ่าน',
  'pages.angelInsider.issues.issue-3.sections.0.blocks.1.p':
    'เมื่ออัปโหลดแล้ว ให้ A&GEL สรุปอีเมล สรุปเอกสารที่แนบมา หรือรันพรอมต์ใด ๆ จากคลังกับไฟล์นั้นได้',
  'pages.angelInsider.issues.issue-3.sections.1.kicker': '02 — การบันทึกเสียง',
  'pages.angelInsider.issues.issue-3.sections.1.heading':
    'การบันทึกเสียง: แก้ไขทันทีและเล่นเสียงย้อนกลับ',
  'pages.angelInsider.issues.issue-3.sections.1.blocks.0.p':
    '<strong>แก้ไขได้ทันที</strong> — ระบบบันทึกเสียงที่ปรับปรุงใหม่ให้คุณแก้ข้อความถอดความได้ โดยส่วนที่แก้ไขจะขีดเส้นใต้ไว้เพื่อให้อ้างอิงง่าย <strong>เล่นเสียงย้อนกลับ</strong> — หลังบันทึกผลถอดความแล้ว ให้เปิดข้อความถอดความต้นฉบับและคลิกช่วงใดก็ได้ เพื่อเล่นเสียงจากจุดนั้น',
  'pages.angelInsider.issues.issue-3.sections.1.blocks.1.gallery.0.caption':
    'การบันทึกเสียงกำลังดำเนินอยู่ พร้อมถอดความแบบสด',
  'pages.angelInsider.issues.issue-3.sections.1.blocks.1.gallery.1.caption':
    'ข้อความถอดความต้นฉบับ — คลิกที่ช่วงใดเพื่อเล่นเสียงของช่วงนั้น',
  'pages.angelInsider.issues.issue-3.sections.2.kicker': '03 — โหมดใหม่',
  'pages.angelInsider.issues.issue-3.sections.2.heading': 'พรอมต์หลายขั้นตอน',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.0.p':
    'อยู่ภายใต้<strong>แอปเฉพาะทาง</strong> แม้พรอมต์ครั้งเดียวจบจะมีประสิทธิภาพกับคำถามง่าย ๆ แต่งานกฎหมายที่ซับซ้อนจะได้ประโยชน์จากแนวทางที่มีโครงสร้างและทำเป็นรอบ ๆ พรอมต์หลายขั้นตอนให้คุณแยกปัญหาออกเป็นชุดของการโต้ตอบที่ตรงเป้า — เป็นโหมดโปรดของเราสำหรับงานเอกสารระดับปานกลางถึงซับซ้อน',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.1.h':
    'แบ่งขั้นตอนการทำงานออกเป็นช่วงอย่างมีเหตุผล',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.0.n': 'งานบรรษัท · ขั้นที่ 1',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.0.text':
    'สรุปว่าคู่สัญญาแต่ละฝ่ายมีหน้าที่ต้องทำสิ่งใดบ้าง',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.1.n': 'ขั้นที่ 2',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.1.text':
    'โดยคำนึงถึงบทสรุปนั้น ให้ชี้ข้อสัญญาที่เอนเอียงไปข้างเดียวหรือผิดปกติ',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.2.n': 'ขั้นที่ 3',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.2.steps.2.text':
    'สำหรับข้อสัญญาที่ชี้ไว้ หากฉันเป็นตัวแทนของ [คู่สัญญา] ให้ทำการแก้ไขแบบติดตามการเปลี่ยนแปลง เสนอห้าประเด็นสำคัญที่ฉันควรผลักดัน',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.0.n': 'คดีความ · ขั้นที่ 1',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.0.text':
    'จากคำฟ้อง [ที่แนบมา] ให้ร่างชุดคำถามซักถามชุดแรก',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.1.n': 'ขั้นที่ 2',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.1.text':
    'เมื่อทำขั้นที่ 1 เสร็จแล้ว ให้ร่างคำขอให้ส่งเอกสารที่สอดคล้องกัน',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.2.n': 'ขั้นที่ 3',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.3.steps.2.text':
    'เป็นขั้นสุดท้าย ให้ระบุผู้ครอบครองเอกสารห้ารายแรกที่น่าจะมีเอกสารตรงตามคำขอ พร้อมอธิบายเหตุผล',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.4.callout.title':
    'มีพรอมต์เดียวหรือ? ก็ยังควรใช้',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.4.callout.body':
    'แม้จะมีเพียงขั้นตอนเดียว แอปนี้ก็ยอดเยี่ยมสำหรับพรอมต์เดี่ยวที่ซับซ้อนซึ่งคุณต้องใช้กับเอกสาร — บ่อยครั้งดีกว่าโหมดแชทเสียอีก',
  'pages.angelInsider.issues.issue-3.sections.2.blocks.5.figure.caption':
    'ผลลัพธ์จากพรอมต์หลายขั้นตอน — คลิกการอ้างอิงเพื่อเปิดตัวแสดงเอกสารในหน้าเดียวกันพร้อมไฮไลต์',
  'pages.angelInsider.issues.issue-3.sections.3.kicker': '04 — ไทม์ไลน์',
  'pages.angelInsider.issues.issue-3.sections.3.heading': 'ไทม์ไลน์ที่ปรับโฉมครั้งใหญ่',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.0.p':
    '<strong>รวมไทม์ไลน์ข้ามเอกสาร</strong> ไทม์ไลน์เวอร์ชันใหม่จะดึงลำดับเหตุการณ์จากเอกสารที่เลือกแต่ละฉบับ แล้วผสานเป็นเส้นเดียว — มีค่ามากเมื่อคุณมีคำให้การเป็นหนังสือ คำคู่ความ หรือคำแถลงขนาดใหญ่หลายฉบับ ซึ่งแต่ละฉบับมีไทม์ไลน์ของตัวเอง',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.1.gallery.0.caption':
    'ไทม์ไลน์คำฟ้องและคำให้การที่รวมจากไฟล์ห้าฉบับ',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.1.gallery.1.caption':
    'เจาะดูไทม์ไลน์ของเอกสารฉบับเดียวพร้อมการอ้างอิงต้นทาง',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.2.p':
    '<strong>ดูต้นทาง</strong> คลิกการอ้างอิงท้ายเหตุการณ์ใดก็ได้ เพื่อเปิดเอกสารต้นทางโดยไฮไลต์บรรทัดที่เป็นที่มา',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.3.h':
    'ไทม์ไลน์อัจฉริยะ ปรับให้เข้ากับงานของคุณ',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.4.p':
    'หลังเลือกเอกสารแล้ว ให้คลิก<strong>ขยายพรอมต์</strong>เพื่อให้การดึงข้อมูลโฟกัสไปที่หัวข้อที่คุณสนใจ การตั้งค่า <em>Basic Litigation (แบ่งปัน)</em> จะดึงคำอธิบายเหตุการณ์ เอกสารต้นทาง หน่วยงาน/บุคคล และย่อหน้าสนับสนุน — คุณเพิ่มฟิลด์ของคุณเองได้ด้วย',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.5.callout.title':
    'ใช้กับข้อความแชทได้เช่นกัน',
  'pages.angelInsider.issues.issue-3.sections.3.blocks.5.callout.body':
    'ชี้ไทม์ไลน์ไปที่บันทึกการแชทหรือภาพหน้าจอข้อความ (WhatsApp, WeChat) เพื่อสร้างลำดับเหตุการณ์',
  'pages.angelInsider.issues.issue-3.signoff.line': 'ขั้นตอนย่อยลง ลำดับเหตุการณ์คมชัดขึ้น',
  'pages.angelInsider.issues.issue-3.signoff.name': 'ทีมพัฒนา A&GEL',
  'pages.angelInsider.issues.feature-dispute.title': 'การระงับข้อพิพาท',
  'pages.angelInsider.issues.feature-dispute.subtitle':
    'สรุปคดี วิเคราะห์คำฟ้อง ร่างคำให้การ และติดตามคำคู่ความ — ครบถ้วนภายใน A&GEL',
  'pages.angelInsider.issues.feature-dispute.glance.0':
    '<strong>สรุปคดี</strong> — สำหรับคำพิพากษาที่ซับซ้อน แบบละเอียดมักให้ผลดีกว่าแบบกระชับ',
  'pages.angelInsider.issues.feature-dispute.glance.1':
    '<strong>การวิเคราะห์คำฟ้อง</strong> — อัปโหลดคำฟ้องแล้วรันพรอมต์วิเคราะห์ได้ทันที',
  'pages.angelInsider.issues.feature-dispute.glance.2':
    '<strong>การร่างคำให้การ</strong> — สร้างร่างคำให้การฉบับแรกจากคำฟ้อง',
  'pages.angelInsider.issues.feature-dispute.glance.3':
    '<strong>ตัวติดตามคำคู่ความ</strong> — โหมดตรวจสอบจะจับคู่แต่ละมูลเหตุแห่งการฟ้องกับจุดยืนของทุกฝ่ายตลอดชุดเอกสารทั้งหมด',
  'pages.angelInsider.issues.feature-dispute.sections.0.kicker': '01 — สรุปคดี',
  'pages.angelInsider.issues.feature-dispute.sections.0.heading': 'การสรุปคำพิพากษาและคำคู่ความ',
  'pages.angelInsider.issues.feature-dispute.sections.0.blocks.0.p':
    'คลังพรอมต์มีพรอมต์สรุปคดีสองแบบ — แบบกระชับและแบบละเอียด จากประสบการณ์ของเรา แบบ<strong>ละเอียด</strong>มักเหนือกว่า โดยเฉพาะกับคำพิพากษาที่ซับซ้อน A&GEL ถูกกำหนดให้อ้างอิงจากเอกสารต้นทางเท่านั้น',
  'pages.angelInsider.issues.feature-dispute.sections.0.blocks.1.figure.caption':
    'สรุปคดี (แบบกระชับ) v1.1 และสรุปคดี (แบบละเอียด) v1.1 ในคลังพรอมต์',
  'pages.angelInsider.issues.feature-dispute.sections.1.kicker': '02 — คำฟ้องและคำให้การ',
  'pages.angelInsider.issues.feature-dispute.sections.1.heading':
    'การวิเคราะห์คำฟ้องและการร่างคำให้การ',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.0.p':
    'ใช้พรอมต์<strong>การวิเคราะห์คำฟ้องและลำดับเหตุการณ์</strong>สำหรับการประเมินคดีในระยะแรก อัปโหลดคำฟ้องแล้วรันพรอมต์ — A&GEL จะดึงข้อเท็จจริงสำคัญ มูลเหตุแห่งการฟ้อง และลำดับเหตุการณ์ออกมา',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.1.p':
    'หากต้องการร่างคำให้การฉบับแรก ให้ใช้พรอมต์<strong>ร่างคำให้การเพื่อตอบคำฟ้อง</strong>จากคลัง คัดลอกแล้วปรับบริบทให้เข้ากับคดีของคุณ',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.2.callout.title':
    'แบบละเอียดดีกว่าแบบกระชับ',
  'pages.angelInsider.issues.feature-dispute.sections.1.blocks.2.callout.body':
    'สำหรับคำพิพากษาที่ซับซ้อนหรือคำฟ้องที่ยาว ตัวสรุปแบบละเอียดให้ผลลัพธ์ที่ถูกต้องและครบถ้วนกว่าอย่างสม่ำเสมอ',
  'pages.angelInsider.issues.feature-dispute.sections.2.kicker': '03 — ตัวติดตามคำคู่ความ',
  'pages.angelInsider.issues.feature-dispute.sections.2.heading':
    'ใช้โหมดตรวจสอบเป็นตัวติดตามคำคู่ความ',
  'pages.angelInsider.issues.feature-dispute.sections.2.blocks.0.p':
    'โหมดตรวจสอบจะรันรายการคำถามกับเอกสารหลายฉบับพร้อมกัน สำหรับงานระงับข้อพิพาท ให้โหลดคำฟ้อง คำให้การ และคำแก้ต่างเพิ่มเติม กำหนดคำถามของคุณ (ข้อละหนึ่งมูลเหตุแห่งการฟ้อง) แล้ว A&GEL จะจับคู่จุดยืนของแต่ละฝ่ายไว้ในตารางเดียว',
  'pages.angelInsider.issues.feature-dispute.sections.2.blocks.1.figure.caption':
    'คดี Lim Group: โหมดตรวจสอบติดตามข้อกล่าวหาเรื่องฉ้อฉลและการประพฤติมิชอบข้ามไฟล์ 5 ฉบับ',
  'pages.angelInsider.issues.feature-dispute.signoff.line': 'ประเมินคดีเร็วขึ้น เตรียมงานได้ดีขึ้น',
  'pages.angelInsider.issues.feature-dispute.signoff.name': 'ทีมพัฒนา A&GEL',
  'pages.angelInsider.issues.feature-sidebyside.title':
    'เปรียบเทียบแบบเคียงข้างกันและการเทียบความต่าง',
  'pages.angelInsider.issues.feature-sidebyside.subtitle':
    'โหมดตรวจทานที่ละเอียดที่สุด — ทีละข้อสัญญา พร้อมตรวจสอบย้อนกลับไปยังย่อหน้าต้นทางได้ครบถ้วน',
  'pages.angelInsider.issues.feature-sidebyside.glance.0':
    '<strong>เปรียบเทียบแบบเคียงข้างกัน</strong>ทำงานทีละข้อสัญญา พร้อมตรวจสอบย่อหน้าต้นทางได้ครบถ้วนสำหรับทุกข้อค้นพบ',
  'pages.angelInsider.issues.feature-sidebyside.glance.1':
    '<strong>การเทียบความต่าง</strong>สร้างการตรวจทานทางกฎหมายรอบแรกสำหรับการติดตามการแก้ไขหรือการแก้ไขเอกสาร',
  'pages.angelInsider.issues.feature-sidebyside.glance.2':
    'ทุกข้อค้นพบเชื่อมกลับไปยังข้อสัญญาต้นทางที่แน่นอน — ไม่ต้องไล่หาในเอกสาร',
  'pages.angelInsider.issues.feature-sidebyside.glance.3':
    '<strong>หน้าต่างมินิแชท</strong>เลื่อนย้ายและปรับขนาดได้แล้ว — ลากออกไปไม่ให้บังพื้นที่ทำงานของคุณ',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.kicker':
    '01 — เปรียบเทียบแบบเคียงข้างกัน',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.heading':
    'วิเคราะห์ทีละข้อสัญญาพร้อมตรวจสอบต้นทาง',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.blocks.0.p':
    'เปรียบเทียบแบบเคียงข้างกันคือโหมดตรวจทานที่ละเอียดที่สุดของ A&GEL มันจะไล่อ่านเอกสารทีละข้อสัญญา และสำหรับทุกข้อค้นพบ มันจะแสดงย่อหน้าต้นทางที่แน่นอนขึ้นมา — เพื่อให้คุณตรวจสอบผลลัพธ์เทียบกับต้นฉบับได้โดยตรง',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.blocks.1.figure.caption':
    'การวิเคราะห์แบบเคียงข้างกันของสัญญาซื้อขายหุ้น (SPA) — แต่ละข้อค้นพบเชื่อมกลับไปยังข้อสัญญาต้นทาง',
  'pages.angelInsider.issues.feature-sidebyside.sections.0.blocks.2.figure.caption':
    'แผงคำอธิบาย — เหตุผลของ A&GEL แสดงเคียงข้างต้นทางในหน้าเดียวกัน',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.kicker': '02 — การเทียบความต่าง',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.heading':
    'การตรวจทานรอบแรกของการติดตามการแก้ไข',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.blocks.0.p':
    '<strong>การเทียบความต่าง</strong>สร้างการตรวจทานทางกฎหมายรอบแรกสำหรับการติดตามการแก้ไขหรือการแก้ไขเอกสาร อัปโหลดเอกสารฉบับแก้ไข แล้ว A&GEL จะจัดทำการวิเคราะห์อย่างเป็นระบบว่ามีอะไรเปลี่ยนไปและมีนัยอย่างไร',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.blocks.1.callout.title':
    'เป็นจุดตั้งต้น ไม่ใช่ผลงานสำเร็จรูป',
  'pages.angelInsider.issues.feature-sidebyside.sections.1.blocks.1.callout.body':
    'ผลลัพธ์จากเปรียบเทียบแบบเคียงข้างกันและการเทียบความต่างเป็นจุดตั้งต้นที่มีประสิทธิภาพ — ตรวจสอบเทียบกับต้นทางเสมอก่อนสรุปขั้นสุดท้าย',
  'pages.angelInsider.issues.feature-sidebyside.sections.2.kicker': '03 — มินิแชท',
  'pages.angelInsider.issues.feature-sidebyside.sections.2.heading':
    'หน้าต่างมินิแชทที่เลื่อนย้ายได้',
  'pages.angelInsider.issues.feature-sidebyside.sections.2.blocks.0.p':
    'ตรวจสอบ การเทียบความต่าง และเปรียบเทียบแบบเคียงข้างกัน ล้วนมี<strong>หน้าต่างมินิแชท</strong>ที่ให้คุณถามเกี่ยวกับเอกสารและผลลัพธ์ของ A&GEL ไปพร้อมกัน ตอนนี้หน้าต่างนี้<strong>เลื่อนย้ายและปรับขนาดได้</strong> — ลากไปไว้ที่ใดก็ได้บนหน้าจอ เพื่อไม่ให้บังผลลัพธ์ที่คุณกำลังตรวจอยู่',
  'pages.angelInsider.issues.feature-sidebyside.signoff.line': 'ทีละข้อสัญญา ตรวจสอบต้นทางได้',
  'pages.angelInsider.issues.feature-sidebyside.signoff.name': 'ทีมพัฒนา A&GEL',
  'pages.angelInsider.issues.feature-multistep.title': 'พรอมต์หลายขั้นตอน',
  'pages.angelInsider.issues.feature-multistep.subtitle':
    'แบ่งงานกฎหมายที่ซับซ้อนออกเป็นขั้นตอนต่อเนื่อง — โดยแต่ละขั้นต่อยอดจากขั้นก่อนหน้า',
  'pages.angelInsider.issues.feature-multistep.glance.0': 'อยู่ภายใต้<strong>แอปเฉพาะทาง</strong>',
  'pages.angelInsider.issues.feature-multistep.glance.1':
    'แต่ละขั้นตอนต่อยอดจากผลลัพธ์ของขั้นก่อนหน้า — เหมาะอย่างยิ่งกับขั้นตอนการทำงานที่ซับซ้อน',
  'pages.angelInsider.issues.feature-multistep.glance.2':
    'ใช้ได้ทั้งกับขั้นตอนการทำงานหลายขั้น <em>และ</em> พรอมต์เดี่ยวที่ซับซ้อนซึ่งใช้กับเอกสาร',
  'pages.angelInsider.issues.feature-multistep.glance.3':
    'ผลลัพธ์มีการอ้างอิงต้นทางในบรรทัด — คลิกเพื่อเปิดต้นทางพร้อมไฮไลต์',
  'pages.angelInsider.issues.feature-multistep.sections.0.kicker': '01 — เริ่มต้นใช้งาน',
  'pages.angelInsider.issues.feature-multistep.sections.0.heading':
    'โหมดที่มีโครงสร้างสำหรับงานกฎหมายที่ซับซ้อน',
  'pages.angelInsider.issues.feature-multistep.sections.0.blocks.0.p':
    'อยู่ภายใต้<strong>แอปเฉพาะทาง</strong> พรอมต์หลายขั้นตอนให้คุณแยกปัญหากฎหมายออกเป็นลำดับขั้นที่ตรงเป้า — โดยแต่ละขั้นต่อยอดจากขั้นก่อนหน้า เหมาะทั้งกับขั้นตอนการทำงานหลายขั้น และพรอมต์เดี่ยวที่ซับซ้อนซึ่งต้องการความแม่นยำระดับเอกสาร',
  'pages.angelInsider.issues.feature-multistep.sections.0.blocks.1.figure.caption':
    'พรอมต์หลายขั้นตอนในตารางแอปเฉพาะทาง',
  'pages.angelInsider.issues.feature-multistep.sections.1.kicker': '02 — ตัวอย่าง',
  'pages.angelInsider.issues.feature-multistep.sections.1.heading':
    'การแบ่งขั้นตอนการทำงานออกเป็นช่วงอย่างมีเหตุผล',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.0.n':
    'งานบรรษัท · ขั้นที่ 1',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.0.text':
    'สรุปว่าคู่สัญญาแต่ละฝ่ายมีหน้าที่ต้องทำสิ่งใดบ้าง',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.1.n': 'ขั้นที่ 2',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.1.text':
    'โดยคำนึงถึงบทสรุปนั้น ให้ชี้ข้อสัญญาที่เอนเอียงไปข้างเดียวหรือผิดปกติ',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.2.n': 'ขั้นที่ 3',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.0.steps.2.text':
    'สำหรับข้อสัญญาที่ชี้ไว้ หากฉันเป็นตัวแทนของ [คู่สัญญา] ให้ทำการแก้ไขแบบติดตามการเปลี่ยนแปลง เสนอห้าประเด็นสำคัญที่ฉันควรผลักดัน',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.0.n':
    'คดีความ · ขั้นที่ 1',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.0.text':
    'จากคำฟ้อง [ที่แนบมา] ให้ร่างชุดคำถามซักถามชุดแรก',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.1.n': 'ขั้นที่ 2',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.1.text':
    'เมื่อทำขั้นที่ 1 เสร็จแล้ว ให้ร่างคำขอให้ส่งเอกสารที่สอดคล้องกัน',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.2.n': 'ขั้นที่ 3',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.1.steps.2.text':
    'ระบุผู้ครอบครองเอกสารห้ารายแรกที่น่าจะมีเอกสารตรงตามคำขอ พร้อมอธิบายเหตุผล',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.2.callout.title':
    'มีพรอมต์เดียวหรือ? ก็ยังควรใช้',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.2.callout.body':
    'แม้จะมีเพียงขั้นตอนเดียว แอปนี้ก็ยอดเยี่ยมสำหรับพรอมต์ที่ซับซ้อนซึ่งใช้กับเอกสาร — บ่อยครั้งดีกว่าโหมดแชทเสียอีก',
  'pages.angelInsider.issues.feature-multistep.sections.1.blocks.3.figure.caption':
    'ผลลัพธ์จากพรอมต์หลายขั้นตอน — คลิกการอ้างอิงเพื่อเปิดตัวแสดงเอกสารในหน้าเดียวกันพร้อมไฮไลต์',
  'pages.angelInsider.issues.feature-multistep.sections.2.kicker': '03 — ตัวอย่างการใช้งานจริง',
  'pages.angelInsider.issues.feature-multistep.sections.2.heading': 'การร่างรายงานจากเอกสารสองฉบับ',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.0.p':
    'ขั้นตอนการทำงานสามขั้นสำหรับดึงประเด็นห่วงกังวลจากเอกสารสองฉบับ แล้วรวมเข้าเป็นรายงานฉบับเดียวพร้อมบทสรุปผู้บริหาร — ซับซ้อนเกินกว่าจะทำได้อย่างน่าเชื่อถือด้วยพรอมต์แชทเพียงครั้งเดียว',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.1.callout.title':
    'ขั้นที่ 1 — การดึงข้อมูล',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.1.callout.body':
    '<strong>บริบทนำเข้า:</strong> [ใส่เนื้อความของเอกสาร 1 และเอกสาร 2]<br><strong>พรอมต์:</strong> “อ่านข้อความที่ให้มา ดึงรายการแบบหัวข้อย่อยที่ครอบคลุม ของประเด็นห่วงกังวล ปัญหา หรือความเสี่ยงทั้งหมดที่กล่าวถึงในเอกสารทั้งสองฉบับ”<br><em>ผลลัพธ์: รายการประเด็นห่วงกังวลที่สะอาดและรวมเป็นชุดเดียว</em>',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.2.callout.title':
    'ขั้นที่ 2 — ร่างรายงานฉบับเต็ม',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.2.callout.body':
    '<strong>บริบทนำเข้า:</strong> [ผลลัพธ์จากขั้นที่ 1]<br><strong>พรอมต์:</strong> “ใช้รายการประเด็นห่วงกังวลที่ให้มา เขียนรายงานอย่างเป็นทางการโดยละเอียด จัดกลุ่มประเด็นที่คล้ายกันไว้ใต้หัวข้อที่เหมาะสม ในขั้นนี้อย่าใส่บทนำหรือบทสรุปผู้บริหาร”<br><em>ผลลัพธ์: รายงานฉบับเต็มที่มีโครงสร้าง</em>',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.3.callout.title':
    'ขั้นที่ 3 — บทสรุปผู้บริหารและการรวมเป็นฉบับสุดท้าย',
  'pages.angelInsider.issues.feature-multistep.sections.2.blocks.3.callout.body':
    '<strong>บริบทนำเข้า:</strong> [ผลลัพธ์จากขั้นที่ 2]<br><strong>พรอมต์:</strong> “อ่านรายงานที่ให้มา ขั้นแรก เขียนบทสรุปผู้บริหารกระชับหนึ่งย่อหน้า จากนั้นแสดงบทสรุปผู้บริหาร เพิ่มเส้นคั่นเชิงภาพ แล้วแสดงรายงานฉบับเต็มตามเดิมไว้ด้านล่าง เพื่อสร้างเป็นเอกสารรวมฉบับเดียว”<br><em>ผลลัพธ์: เอกสารรวมฉบับสุดท้าย</em>',
  'pages.angelInsider.issues.feature-multistep.signoff.line': 'ขั้นตอนย่อยลง ผลลัพธ์คมชัดขึ้น',
  'pages.angelInsider.issues.feature-multistep.signoff.name': 'ทีมพัฒนา A&GEL',
  'pages.angelInsider.issues.feature-timeline.title': 'ไทม์ไลน์',
  'pages.angelInsider.issues.feature-timeline.subtitle':
    'รวมลำดับเหตุการณ์จากเอกสารได้สูงสุด 100 ฉบับให้เป็นไทม์ไลน์เดียวที่ตรวจสอบต้นทางได้',
  'pages.angelInsider.issues.feature-timeline.glance.0':
    'รวมลำดับเหตุการณ์จาก<strong>เอกสารได้สูงสุด 100 ฉบับ</strong>ให้เป็นไทม์ไลน์เดียว',
  'pages.angelInsider.issues.feature-timeline.glance.1':
    '<strong>การอ้างอิงในบรรทัดที่คลิกได้</strong> — คลิกการอ้างอิงใดก็ได้เพื่อเปิดต้นทางพร้อมไฮไลต์ข้อความ',
  'pages.angelInsider.issues.feature-timeline.glance.2':
    '<strong>ไทม์ไลน์อัจฉริยะ</strong>ให้คุณดึงฟิลด์ที่กำหนดเองได้ ทั้งหน่วยงาน ย่อหน้าสนับสนุน และอื่น ๆ',
  'pages.angelInsider.issues.feature-timeline.glance.3':
    'ใช้ได้กับบันทึกการแชทและภาพหน้าจอข้อความ (WhatsApp, WeChat) ด้วย',
  'pages.angelInsider.issues.feature-timeline.sections.0.kicker': '01 — ไทม์ไลน์รวม',
  'pages.angelInsider.issues.feature-timeline.sections.0.heading':
    'ลำดับเหตุการณ์ข้ามเอกสารหลายฉบับ',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.0.p':
    'ไทม์ไลน์เวอร์ชันใหม่จะดึงลำดับเหตุการณ์จากเอกสารที่เลือกแต่ละฉบับ แล้วผสานเป็นเส้นเดียว — มีค่ามากเมื่อคุณมีคำให้การเป็นหนังสือ คำคู่ความ หรือคำแถลงขนาดใหญ่หลายฉบับ ซึ่งแต่ละฉบับมีไทม์ไลน์ของตัวเอง',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.1.gallery.0.caption':
    'ไทม์ไลน์คำฟ้องและคำให้การที่รวมจากไฟล์ห้าฉบับ',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.1.gallery.1.caption':
    'เจาะดูเหตุการณ์เดียว — แสดงทั้งเอกสารต้นทาง หน่วยงาน และย่อหน้าสนับสนุน',
  'pages.angelInsider.issues.feature-timeline.sections.0.blocks.2.p':
    '<strong>ดูต้นทาง</strong> คลิกการอ้างอิงในบรรทัดท้ายเหตุการณ์ใดก็ได้ เพื่อเปิดเอกสารต้นทางโดยไฮไลต์บรรทัดที่เป็นที่มา',
  'pages.angelInsider.issues.feature-timeline.sections.1.kicker': '02 — ไทม์ไลน์อัจฉริยะ',
  'pages.angelInsider.issues.feature-timeline.sections.1.heading':
    'ดึงฟิลด์ที่กำหนดเองให้ตรงกับงานของคุณ',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.0.p':
    'คลิก<strong>ขยายพรอมต์</strong>เพื่อให้การดึงข้อมูลโฟกัสไปที่หัวข้อที่คุณสนใจ การตั้งค่า <em>Basic Litigation (แบ่งปัน)</em> จะดึงคำอธิบายเหตุการณ์ เอกสารต้นทาง หน่วยงาน/บุคคล และย่อหน้าสนับสนุน — คุณเพิ่มฟิลด์ของคุณเองได้ด้วย',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.1.figure.caption':
    'ไทม์ไลน์อัจฉริยะ: เพิ่มฟิลด์การดึงข้อมูลที่กำหนดเองได้ใต้ขยายพรอมต์',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.2.callout.title':
    'ใช้กับข้อความแชทได้เช่นกัน',
  'pages.angelInsider.issues.feature-timeline.sections.1.blocks.2.callout.body':
    'ชี้ไทม์ไลน์ไปที่บันทึกการแชทหรือภาพหน้าจอข้อความ (WhatsApp, WeChat) เพื่อสร้างลำดับเหตุการณ์',
  'pages.angelInsider.issues.feature-timeline.signoff.line': 'ไทม์ไลน์เดียว ครอบคลุมทุกเอกสาร',
  'pages.angelInsider.issues.feature-timeline.signoff.name': 'ทีมพัฒนา A&GEL',
  'pages.angelInsider.issues.feature-using-files.title': 'การใช้ไฟล์ของคุณบน A&GEL',
  'pages.angelInsider.issues.feature-using-files.subtitle':
    'A&GEL รองรับเอกสาร Word, PDF และอีเมลได้ในตัว (และจะเพิ่มรูปแบบอื่นในอนาคต) อย่างไรก็ตาม ไฟล์บางประเภทอาจอัปโหลดขึ้น A&GEL ไม่สำเร็จ เพราะไม่มีชั้นข้อความ ป้ายกำกับความอ่อนไหวไม่ถูกต้อง หรือรูปแบบไฟล์ไม่เหมาะสม ซึ่งแต่ละปัญหาล้วนมีวิธีแก้ที่ไม่ยุ่งยาก',
  'pages.angelInsider.issues.feature-using-files.intro':
    'คุณอาจพบว่าไฟล์บางไฟล์อัปโหลดขึ้น A&GEL ไม่สำเร็จ คู่มือนี้ครอบคลุมสาเหตุที่พบบ่อยที่สุด — ตั้งแต่เอกสารสแกนที่ไม่มีชั้นข้อความ ไปจนถึงป้ายกำกับความอ่อนไหวของเอกสาร — พร้อมวิธีแก้ไข',
  'pages.angelInsider.issues.feature-using-files.glance.0':
    'A&GEL อ่าน<strong>ชั้นข้อความ</strong>ใน PDF — เอกสารกระดาษที่สแกนมามักไม่มีชั้นข้อความ',
  'pages.angelInsider.issues.feature-using-files.glance.1':
    'พบบ่อยกับไฟล์เก่า ๆ และเอกสารกระดาษที่สแกนมาโดยไม่ได้ทำ OCR',
  'pages.angelInsider.issues.feature-using-files.glance.2':
    'วิธีแก้: ทำให้ PDF ค้นหาข้อความได้ แล้วอัปโหลดขึ้น A&GEL ใหม่',
  'pages.angelInsider.issues.feature-using-files.glance.3':
    'ต้องแปลง PDF จำนวนมากในคราวเดียวใช่ไหม ทีมพัฒนา A&GEL ช่วยได้',
  'pages.angelInsider.issues.feature-using-files.glance.4':
    'เอกสารภายในต้องเปลี่ยนป้ายกำกับเป็น <strong>External</strong> ก่อนอัปโหลด มิฉะนั้น A&GEL จะปฏิเสธ',
  'pages.angelInsider.issues.feature-using-files.glance.5':
    'เอกสาร Word รุ่นเก่า (ปี 1997–2004, .doc ก่อนยุค OOXML) รองรับอยู่แล้ว — ไม่ต้องแปลง',
  'pages.angelInsider.issues.feature-using-files.sections.0.kicker': '01 — ไม่มีชั้นข้อความ',
  'pages.angelInsider.issues.feature-using-files.sections.0.heading':
    'ปัญหาเกี่ยวกับเอกสารที่สแกนมา',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.0.p':
    'A&GEL อ่านเอกสารด้วยการดึงชั้นข้อความที่ฝังอยู่ใน PDF เมื่อเอกสารไม่มีชั้นข้อความ เช่น เอกสารกระดาษที่สแกนมา A&GEL จะเห็นเพียงภาพของหน้ากระดาษและไม่สามารถประมวลผลได้',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.1.p':
    'เอกสารที่สแกนมาส่วนใหญ่ โดยเฉพาะที่แปลงเป็นดิจิทัลด้วยเครื่องถ่ายเอกสาร จะถูกบันทึกเป็น PDF ที่เป็นภาพล้วน ซึ่งพบบ่อยกับไฟล์เก่า ๆ และเอกสารที่สแกนเป็นภาพ (และยังไม่ได้ทำ OCR)',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.2.p':
    'ก่อนอัปโหลด ให้เปิดไฟล์ของคุณในโปรแกรมอ่าน PDF ที่รองรับ OCR (การรู้จำอักขระด้วยแสง) — เช่น Kofax — เพื่อให้แน่ใจว่าจะประมวลผลได้สำเร็จ',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.0.n': 'ขั้นที่ 1',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.0.text':
    'เปิด PDF ที่สแกนมาในโปรแกรมอ่าน PDF ที่มีความสามารถ OCR เช่น Kofax',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.1.n': 'ขั้นที่ 2',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.1.text':
    'รัน OCR เพื่อให้ไฟล์ค้นหาข้อความได้ — ใน Kofax คือฟังก์ชัน <strong>“Make Searchable”</strong> หรือ <strong>“Searchable PDF”</strong> หากมีหลายไฟล์ที่ต้องแปลง ให้มองหาตัวเลือก OCR แบบเป็นชุดหรือหลายไฟล์ (ใน Kofax อยู่ใต้ Advanced Processing) แทนที่จะแปลงทีละไฟล์',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.2.n': 'ขั้นที่ 3',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.3.steps.2.text':
    'บันทึกไฟล์ที่แปลงแล้ว จากนั้นอัปโหลดขึ้น A&GEL',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.4.p':
    'เมื่อแปลงเสร็จ ไฟล์จะมีชั้นข้อความที่ค้นหาได้ และ A&GEL จะประมวลผลได้ตามปกติ อีกทางหนึ่ง คุณอาจสร้าง PDF ที่ค้นหาได้ตั้งแต่ตอนสแกน แทนที่จะมาแปลงภายหลัง — เครื่องพิมพ์และเครื่องสแกนหลายรุ่นสามารถสร้าง PDF ที่ค้นหาได้โดยตรงระหว่างการสแกน ลองหาตัวเลือกที่เทียบเท่ากับ “Searchable PDF” หรือ OCR บนอุปกรณ์ของคุณเอง เพราะชื่อเมนูและขั้นตอนแตกต่างกันไปตามรุ่น',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.5.figure.caption':
    'ตัวอย่าง: บนหน้าจอ “สแกนและส่ง” ของเครื่องสแกนนี้ การเลือก PDF เป็นรูปแบบไฟล์และเปิดใช้ OCR (เน้นความเร็ว หรือ เน้นความแม่นยำ) จะได้ PDF ที่ค้นหาได้พร้อมชั้นข้อความ',
  'pages.angelInsider.issues.feature-using-files.sections.0.blocks.6.p':
    'ต้องทำ OCR กับ PDF จำนวนมากในคราวเดียวใช่ไหม ติดต่อทีมพัฒนา A&GEL ได้เลย — พวกเขาช่วยดำเนินการแปลงแบบเป็นชุดให้คุณได้',
  'pages.angelInsider.issues.feature-using-files.sections.1.kicker': '02 — ป้ายกำกับความอ่อนไหว',
  'pages.angelInsider.issues.feature-using-files.sections.1.heading':
    'ปัญหาเกี่ยวกับป้ายกำกับความอ่อนไหว',
  'pages.angelInsider.issues.feature-using-files.sections.1.blocks.0.p':
    'เอกสารทุกฉบับมีป้ายกำกับความอ่อนไหว ซึ่งกำหนดตอนบันทึกใน Word หรือ Outlook และ A&GEL จะตรวจป้ายนี้ก่อนรับการอัปโหลด',
  'pages.angelInsider.issues.feature-using-files.sections.1.blocks.1.p':
    'A&GEL จะปฏิเสธไฟล์ที่บันทึกด้วยป้ายกำกับความอ่อนไหวแบบ Internal — ให้เปลี่ยนป้ายเอกสารเป็น External แล้วบันทึกก่อนอัปโหลด',
  'pages.angelInsider.issues.feature-using-files.sections.2.kicker': '03 — ไฟล์ Word รุ่นเก่า',
  'pages.angelInsider.issues.feature-using-files.sections.2.heading': 'รองรับเอกสาร Word รุ่นเก่า',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.0.p':
    'เอกสาร Word รุ่นเก่าก็รองรับเช่นกัน รูปแบบต่อไปนี้ไม่จำเป็นต้องแปลงหรือบันทึกใหม่ก่อนอัปโหลด:',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.left.label': 'PDF',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.topMiddle.label':
    'MS Word รุ่นปัจจุบัน (.docx)',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.bottomMiddle.label':
    'MS Word ปี 1997–2004 (.doc)',
  'pages.angelInsider.issues.feature-using-files.sections.2.blocks.1.formatsGrid.right.label':
    'อีเมล (.msg)',
  'pages.angelInsider.issues.feature-using-files.signoff.line':
    'ทำให้เอกสารที่สแกนมาค้นหาข้อความได้ด้วย Kofax หรือการตั้งค่า OCR ของเครื่องพิมพ์ บันทึกเอกสารภายในเป็น External ก่อนอัปโหลด และโปรดทราบว่ารูปแบบ Word ทั้งรุ่นเก่าและรุ่นปัจจุบันใช้งานได้เลยโดยไม่ต้องแปลง',
  'pages.angelInsider.issues.feature-using-files.signoff.name': 'ทีมพัฒนา A&GEL',
  'pages.angelInsider.issues.feature-work-studio.title': 'Workstudio',
  'pages.angelInsider.issues.feature-work-studio.subtitle':
    'แปลงจุดยืนมาตรฐานของทีมให้เป็นการตรวจทานที่เป็นมาตรฐานเดียวกัน — ส่งคืนเป็นเอกสาร Word พร้อมการติดตามการแก้ไข',
  'pages.angelInsider.issues.feature-work-studio.glance.0':
    'กำหนดจุดยืนในการเจรจาของทีมลงใน Workstudio เพียงครั้งเดียว — แล้วนำกลับมาใช้กับทุกสัญญา',
  'pages.angelInsider.issues.feature-work-studio.glance.1':
    'A&GEL จะใช้ Workstudio นั้นและส่งคืน<strong>เอกสาร Word พร้อมการติดตามการแก้ไข</strong>',
  'pages.angelInsider.issues.feature-work-studio.glance.2':
    'ตรวจทานการแก้ไขด้วยสถานะ ยอมรับ / ปฏิเสธ / รอดำเนินการ',
  'pages.angelInsider.issues.feature-work-studio.glance.3':
    'รายละเอียดเพิ่มเติมเกี่ยวกับการสร้างและใช้งาน Workstudio จะมาใน A&GEL Insider ฉบับหน้า',
  'pages.angelInsider.issues.feature-work-studio.sections.0.kicker': '01 — Workstudio',
  'pages.angelInsider.issues.feature-work-studio.sections.0.heading':
    'จุดยืนมาตรฐานของคุณ ทำงานอัตโนมัติ',
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.0.p':
    'Workstudio ให้คุณกำหนดจุดยืนในการเจรจาและจุดยืนมาตรฐานของทีมลงในเทมเพลตการตรวจทานที่นำกลับมาใช้ใหม่ได้ เมื่อสร้างเสร็จแล้ว อัปโหลดสัญญาฉบับใดก็ได้ A&GEL จะใช้ Workstudio นั้น — และส่งคืนเอกสาร Word ที่เสนอการเปลี่ยนแปลงในรูปแบบติดตามการแก้ไข พร้อมให้ตรวจทานและปรับแก้ต่อ',
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.1.figure.caption':
    'Workstudio ขณะใช้งานจริง — ตรวจทานการแก้ไขและความคิดเห็นด้วยสถานะ ยอมรับ/ปฏิเสธ/รอดำเนินการ',
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.2.callout.title':
    'คู่มือ Workstudio ฉบับเต็มกำลังจะมา',
  'pages.angelInsider.issues.feature-work-studio.sections.0.blocks.2.callout.body':
    'A&GEL Insider ฉบับหน้าจะอธิบายวิธีสร้าง Workstudio ตั้งแต่เริ่มต้น และวิธีนำไปใช้กับงานของทีมคุณ',
  'pages.angelInsider.issues.feature-work-studio.signoff.line':
    'จุดยืนของคุณ ถูกนำไปใช้โดยอัตโนมัติ',
  'pages.angelInsider.issues.feature-work-studio.signoff.name': 'ทีมพัฒนา A&GEL',
  'pages.angelInsider.issues.feature-deepresearch.title': 'การวิจัยเชิงลึก',
  'pages.angelInsider.issues.feature-deepresearch.subtitle':
    'การวิเคราะห์ข้ามเอกสารภายใต้พรอมต์การวิจัยที่มีโครงสร้าง — ทุกข้อค้นพบเชื่อมกลับไปยังย่อหน้าต้นทาง',
  'pages.angelInsider.issues.feature-deepresearch.glance.0':
    'รันพรอมต์การวิจัยที่มีโครงสร้างกับชุดเอกสารที่คุณเลือกไว้ทั้งหมด',
  'pages.angelInsider.issues.feature-deepresearch.glance.1':
    'ทุกข้อค้นพบมี<strong>การอ้างอิงในบรรทัดที่คลิกได้</strong> — เปิดต้นทางพร้อมไฮไลต์ข้อความ',
  'pages.angelInsider.issues.feature-deepresearch.glance.2':
    'อยู่ภายใต้<strong>แอปเฉพาะทาง</strong>',
  'pages.angelInsider.issues.feature-deepresearch.glance.3':
    'ใช้คู่กับคลังจัดเก็บที่คัดสรรเอกสารต้นทางชั้นต้นไว้อย่างดี เพื่อความแม่นยำสูงสุด',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.kicker': '01 — ทำอะไรได้บ้าง',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.heading':
    'วิเคราะห์ข้ามเอกสารภายใต้พรอมต์ที่มีโครงสร้าง',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.blocks.0.p':
    'การวิจัยเชิงลึกจะรันพรอมต์การวิจัยที่มีโครงสร้างกับเอกสารที่คุณเลือก แล้วส่งคืนบทวิเคราะห์อย่างละเอียดที่ระบุต้นทาง ออกแบบมาสำหรับงานที่ต้องสังเคราะห์ข้อมูลข้ามเอกสารหลายฉบับ — การวิเคราะห์คำพิพากษา การวิจัยตลาด การทำแผนที่กฎเกณฑ์ — มากกว่าการซักถามไฟล์เพียงฉบับเดียว',
  'pages.angelInsider.issues.feature-deepresearch.sections.0.blocks.1.figure.caption':
    'ผลลัพธ์จากการวิจัยเชิงลึก — แต่ละข้อค้นพบเชื่อมกลับไปยังเอกสารต้นทางผ่านการอ้างอิงในบรรทัดที่คลิกได้',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.kicker': '02 — การอ้างอิงในบรรทัด',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.heading':
    'ตรวจสอบทุกข้อค้นพบกับต้นทาง',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.blocks.0.p':
    'ทุกข้อค้นพบในผลลัพธ์ของการวิจัยเชิงลึกมี<strong>การอ้างอิงในบรรทัดพร้อมหมายเลข</strong> คลิกการอ้างอิงใดก็ได้เพื่อเปิดเอกสารต้นทางโดยไฮไลต์ข้อความที่เป็นที่มา — โดยไม่ต้องออกจากหน้านี้เลย',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.blocks.1.callout.title':
    'เลือกบริบทอย่างมีเป้าหมาย',
  'pages.angelInsider.issues.feature-deepresearch.sections.1.blocks.1.callout.body':
    'จำกัดบริบทให้เหลือเฉพาะเอกสารที่เกี่ยวข้องกับคำถามวิจัยของคุณมากที่สุด บริบทที่กว้างเกินไปจะเจือจางสัญญาณ — การวิจัยเชิงลึกทำงานได้ดีที่สุดกับเอกสารที่คัดสรรและตรงเป้า',
  'pages.angelInsider.issues.feature-deepresearch.sections.2.kicker': '03 — ควรใช้เมื่อใด',
  'pages.angelInsider.issues.feature-deepresearch.sections.2.heading':
    'เหมาะที่สุดกับงานสังเคราะห์ข้อมูล',
  'pages.angelInsider.issues.feature-deepresearch.sections.2.blocks.0.p':
    'ใช้การวิจัยเชิงลึกเมื่อคุณต้องสังเคราะห์ข้อมูลข้ามหลายแหล่ง — เช่น เปรียบเทียบจุดยืนในคำให้การเป็นหนังสือหลายฉบับ สรุปคำพิพากษาในประเด็นใดประเด็นหนึ่ง หรือทำแผนที่ข้อกำหนดกำกับดูแลข้ามเขตอำนาจ หากเป็นเอกสารฉบับเดียว ควรพิจารณาใช้สรุปแบบมีคำแนะนำหรือสรุปขอบเขตงานแทน',
  'pages.angelInsider.issues.feature-deepresearch.signoff.line': 'ทุกข้อค้นพบ ตรวจสอบต้นทางได้',
  'pages.angelInsider.issues.feature-deepresearch.signoff.name': 'ทีมพัฒนา A&GEL',
  'pages.angelInsider.issues.feature-scopesummary.title': 'สรุปขอบเขตงาน',
  'pages.angelInsider.issues.feature-scopesummary.subtitle':
    'บทสรุปที่มีโครงสร้างตามขอบเขตที่คุณกำหนด — ทุกประเด็นที่ดึงออกมามีการอ้างอิงในบรรทัดที่คลิกได้',
  'pages.angelInsider.issues.feature-scopesummary.glance.0':
    'สร้างบทสรุปที่โฟกัสเฉพาะขอบเขตที่คุณกำหนด — ไม่ใช่ทั้งเอกสาร',
  'pages.angelInsider.issues.feature-scopesummary.glance.1':
    'ทุกประเด็นที่ดึงออกมามี<strong>การอ้างอิงในบรรทัดที่คลิกได้</strong>เพื่อตรวจสอบกับต้นทาง',
  'pages.angelInsider.issues.feature-scopesummary.glance.2':
    'อยู่ภายใต้<strong>แอปเฉพาะทาง</strong>',
  'pages.angelInsider.issues.feature-scopesummary.glance.3':
    'ยิ่งกำหนดขอบเขตให้แคบ ผลลัพธ์ที่ดึงออกมาก็ยิ่งตรงเป้าและนำไปใช้ได้จริง',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.kicker': '01 — ทำอะไรได้บ้าง',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.heading':
    'การดึงข้อมูลแบบโฟกัสภายในขอบเขตที่กำหนด',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.blocks.0.p':
    'สรุปขอบเขตงานให้คุณกำหนดเรื่องที่ต้องการให้ A&GEL โฟกัส — หน้าที่ตามสัญญา การจัดสรรความเสี่ยง สิทธิบอกเลิก ข้อกำหนดด้านทรัพย์สินทางปัญญา — แล้วสร้างบทสรุปที่มีโครงสร้างจำกัดอยู่เฉพาะขอบเขตเหล่านั้น ผลลัพธ์จะตรงเป้ากว่าการสรุปทั้งเอกสาร และสอดคล้องโดยตรงกับลำดับความสำคัญในการตรวจทานของคุณ',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.blocks.1.callout.title':
    'กำหนดขอบเขตให้ชัดเจน',
  'pages.angelInsider.issues.feature-scopesummary.sections.0.blocks.1.callout.body':
    'ยิ่งขอบเขตแคบ ผลลัพธ์ก็ยิ่งแม่นยำ ขอบเขตที่กว้างจะให้ผลลัพธ์คล้ายกับการสรุปทั้งเอกสาร ส่วนขอบเขตที่ตรงเป้า — เช่น “หน้าที่ด้านการคุ้มครองข้อมูลและความมั่นคงปลอดภัย” — จะให้ผลลัพธ์ที่กระชับและนำไปใช้ได้ทันที',
  'pages.angelInsider.issues.feature-scopesummary.sections.1.kicker': '02 — การอ้างอิงในบรรทัด',
  'pages.angelInsider.issues.feature-scopesummary.sections.1.heading':
    'ทุกประเด็น ตรวจสอบต้นทางได้',
  'pages.angelInsider.issues.feature-scopesummary.sections.1.blocks.0.p':
    'ทุกประเด็นที่ดึงออกมาในสรุปขอบเขตงานมี<strong>การอ้างอิงในบรรทัดที่คลิกได้</strong> — คลิกเพื่อเปิดเอกสารต้นทางโดยไฮไลต์ข้อสัญญาหรือย่อหน้าที่เป็นที่มา ไม่ต้องสลับแท็บ การตรวจสอบทั้งหมดเกิดขึ้นในหน้าเดียว',
  'pages.angelInsider.issues.feature-scopesummary.signoff.line':
    'กำหนดขอบเขต ระบุต้นทาง ตรวจสอบได้',
  'pages.angelInsider.issues.feature-scopesummary.signoff.name': 'ทีมพัฒนา A&GEL',
  'pages.angelInsider.issues.feature-review.title': 'ตรวจสอบ',
  'pages.angelInsider.issues.feature-review.subtitle':
    'ตั้งคำถามหลายข้อกับเอกสารหลายฉบับพร้อมกัน — ผลลัพธ์แสดงเป็นตารางพร้อมการอ้างอิงในบรรทัด',
  'pages.angelInsider.issues.feature-review.glance.0':
    '<strong>รันรายการคำถามกับเอกสารหลายฉบับพร้อมกัน</strong> — ผลลัพธ์อยู่ในตารางเดียว',
  'pages.angelInsider.issues.feature-review.glance.1':
    'คลิกช่องใดก็ได้เพื่อขยาย<strong>แผงคำอธิบาย</strong>ที่มีการอ้างอิงในบรรทัดไปยังข้อสัญญาต้นทาง',
  'pages.angelInsider.issues.feature-review.glance.2':
    'ใช้<strong>มินิแชท</strong>เพื่อถามต่อโดยไม่ต้องออกจากหน้าตรวจสอบ',
  'pages.angelInsider.issues.feature-review.glance.3': 'อยู่ภายใต้<strong>แอปเฉพาะทาง</strong>',
  'pages.angelInsider.issues.feature-review.sections.0.kicker': '01 — ทำอะไรได้บ้าง',
  'pages.angelInsider.issues.feature-review.sections.0.heading':
    'ตรวจหลายเอกสารหลายคำถามในตารางเดียว',
  'pages.angelInsider.issues.feature-review.sections.0.blocks.0.p':
    'ตรวจสอบจะรันรายการคำถามกับเอกสารหลายฉบับพร้อมกัน แล้วส่งผลลัพธ์กลับมาเป็นตาราง — คำถามละหนึ่งแถว เอกสารละหนึ่งคอลัมน์ รูปแบบนี้เหมาะกับการเปรียบเทียบสัญญา การตรวจสอบสถานะข้ามชุดเอกสาร หรือการจับคู่จุดยืนในคำคู่ความ',
  'pages.angelInsider.issues.feature-review.sections.0.blocks.1.figure.caption':
    'การตรวจเทียบมาตรฐาน AI SaaS — ตรวจไฟล์ 20 ฉบับกับชุดคำถามที่กำหนดไว้ในตารางเดียว',
  'pages.angelInsider.issues.feature-review.sections.1.kicker': '02 — แผงคำอธิบาย',
  'pages.angelInsider.issues.feature-review.sections.1.heading':
    'คำอธิบายที่ตรวจสอบต้นทางได้สำหรับทุกข้อค้นพบ',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.0.p':
    'คลิกช่องใดก็ได้เพื่อขยาย<strong>แผงคำอธิบาย</strong> แต่ละข้อค้นพบจะถูกแยกย่อยพร้อมการอ้างอิงในบรรทัดอย่างเป็นระบบ — คลิกการอ้างอิงใดก็ได้เพื่อเปิดข้อสัญญาต้นทางโดยตรง',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.1.figure.caption':
    'แผงคำอธิบายในตรวจสอบ — แต่ละข้อค้นพบเชื่อมไปยังข้อสัญญาต้นทาง',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.2.callout.title':
    'สร้างรายการคำถามครั้งเดียว แล้วใช้ซ้ำ',
  'pages.angelInsider.issues.feature-review.sections.1.blocks.2.callout.body':
    'รายการคำถามที่วางโครงมาดีจะกลายเป็นเทมเพลตที่ใช้ซ้ำได้กับเอกสารประเภทนั้น บันทึกไว้แล้วนำไปใช้กับสัญญาชุดถัดไปในหมวดเดียวกัน',
  'pages.angelInsider.issues.feature-review.sections.2.kicker': '03 — มินิแชท',
  'pages.angelInsider.issues.feature-review.sections.2.heading': 'ถามต่อโดยไม่ต้องออกจากหน้านี้',
  'pages.angelInsider.issues.feature-review.sections.2.blocks.0.p':
    '<strong>หน้าต่างมินิแชท</strong>ให้คุณถามคำถามต่อเนื่องเกี่ยวกับเอกสารและผลลัพธ์จากตรวจสอบไปพร้อมกัน — โดยไม่ต้องเปลี่ยนหน้า หน้าต่างนี้เลื่อนย้ายและปรับขนาดได้ จึงไม่บังพื้นที่ทำงานของคุณ',
  'pages.angelInsider.issues.feature-review.signoff.line': 'ทุกเอกสาร ทุกคำถาม ในตารางเดียว',
  'pages.angelInsider.issues.feature-review.signoff.name': 'ทีมพัฒนา A&GEL',
  'pages.angelInsider.issues.feature-msg.title': 'การอัปโหลดอีเมล .msg',
  'pages.angelInsider.issues.feature-msg.subtitle':
    'อัปโหลดไฟล์อีเมลทั้งฉบับเข้า A&GEL — รวมถึงไฟล์แนบ — แล้วใช้งานได้เหมือนเอกสารอื่น ๆ',
  'pages.angelInsider.issues.feature-msg.glance.0':
    'อัปโหลดไฟล์อีเมล <strong>.msg</strong> เข้าไฟล์ได้โดยตรง',
  'pages.angelInsider.issues.feature-msg.glance.1': 'A&GEL อ่านเนื้อหาทั้งหมด — รวมถึงไฟล์แนบ',
  'pages.angelInsider.issues.feature-msg.glance.2':
    'ใช้ร่วมกับแชทหรือโหมดเฉพาะทางใด ๆ ได้ (สรุปแบบมีคำแนะนำ ไทม์ไลน์ ฯลฯ)',
  'pages.angelInsider.issues.feature-msg.glance.3':
    'ข้อยกเว้น: ไฟล์แนบที่มีป้ายกำกับ <em>เฉพาะภายใน</em> หรือที่ป้องกันด้วยรหัสผ่านจะถูกข้ามไป',
  'pages.angelInsider.issues.feature-msg.sections.0.kicker': 'การอัปโหลด .msg',
  'pages.angelInsider.issues.feature-msg.sections.0.heading': 'อัปโหลดไฟล์อีเมล (.msg)',
  'pages.angelInsider.issues.feature-msg.sections.0.blocks.0.p':
    'ผู้ใช้ A&GEL สามารถอัปโหลดไฟล์อีเมล <strong>.msg</strong> ทั้งฉบับเข้าสู่ไฟล์ เพื่อใช้กับแชทหรือโหมดเฉพาะทางใด ๆ ได้แล้ว A&GEL จะอ่านเนื้อหาทั้งหมด — รวมถึงไฟล์แนบ — ยกเว้นไฟล์แนบที่มีป้ายกำกับความอ่อนไหว <em>เฉพาะภายใน</em> หรือที่ป้องกันด้วยรหัสผ่าน',
  'pages.angelInsider.issues.feature-msg.sections.0.blocks.1.p':
    'เมื่ออัปโหลดแล้ว ให้ A&GEL สรุปอีเมล สรุปเอกสารที่แนบมา หรือรันพรอมต์ใด ๆ จากคลังกับไฟล์นั้นได้',
  'pages.angelInsider.issues.feature-msg.signoff.line': 'ทั้งอีเมลและไฟล์แนบ ครบถ้วน',
  'pages.angelInsider.issues.feature-msg.signoff.name': 'ทีมพัฒนา A&GEL',
  'pages.angelInsider.issues.feature-inline-ref.title': 'การอ้างอิงในบรรทัด',
  'pages.angelInsider.issues.feature-inline-ref.subtitle':
    'การอ้างอิงแบบชี้จุดที่คลิกได้ในการวิจัยเชิงลึก ไทม์ไลน์ สรุปขอบเขตงาน และตรวจสอบ — ตรวจสอบทุกผลลัพธ์กับต้นทางได้โดยไม่ต้องออกจากหน้านี้',
  'pages.angelInsider.issues.feature-inline-ref.glance.0':
    'ผลลัพธ์จากการวิจัยเชิงลึก ไทม์ไลน์ และสรุปขอบเขตงาน มี<strong>การอ้างอิงในบรรทัดที่คลิกได้</strong>แล้ว',
  'pages.angelInsider.issues.feature-inline-ref.glance.1':
    'คลิกการอ้างอิงใดก็ได้เพื่อเปิดเอกสารต้นทางโดยไฮไลต์ข้อความตรงจุดที่อ้างถึง',
  'pages.angelInsider.issues.feature-inline-ref.glance.2':
    '<strong>แผงคำอธิบาย</strong>ของตรวจสอบก็มีการอ้างอิงในบรรทัดอย่างเป็นระบบสำหรับทุกข้อค้นพบที่ AI สร้างขึ้น',
  'pages.angelInsider.issues.feature-inline-ref.glance.3':
    'ไม่ต้องสลับแท็บ — การตรวจสอบทั้งหมดเกิดขึ้นในหน้าเดียว',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.kicker': 'การอ้างอิงในบรรทัด',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.heading': 'ตรวจสอบทุกผลลัพธ์กับต้นทาง',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.blocks.0.p':
    'แอปผลลัพธ์หลักทั้งหมดของ A&GEL — <strong>การวิจัยเชิงลึก ไทม์ไลน์ สรุปขอบเขตงาน</strong> — มีการอ้างอิงในบรรทัดที่คลิกได้แล้ว การอ้างอิงแต่ละรายการมีหมายเลขและลิงก์กำกับ คลิกเพื่อเปิดเอกสารต้นทางโดยไฮไลต์ข้อความตรงจุดที่อ้างถึง',
  'pages.angelInsider.issues.feature-inline-ref.sections.0.blocks.1.p':
    'สิ่งนี้ทำให้ไม่ต้องสลับแท็บหรือค้นหาเอกสารต้นทางด้วยตนเองเพื่อตรวจสอบประเด็นใดประเด็นหนึ่ง การอ้างอิงไขว้ทำได้ในหน้าเดียว',
  'pages.angelInsider.issues.feature-inline-ref.sections.1.kicker': 'การอ้างอิงในบรรทัดในตรวจสอบ',
  'pages.angelInsider.issues.feature-inline-ref.sections.1.heading':
    'การอ้างอิงอย่างเป็นระบบในแผงคำอธิบาย',
  'pages.angelInsider.issues.feature-inline-ref.sections.1.blocks.0.p':
    'ส่วน<strong>คำอธิบาย</strong>ของหน้าตรวจสอบ — ซึ่งขยายได้โดยคลิกที่ช่องใดก็ได้ — มีการอ้างอิงในบรรทัดอย่างเป็นระบบแล้ว ทุกประเด็นอธิบายเชื่อมโยงไปยังข้อสัญญาหรือย่อหน้าต้นทาง ทำให้การตรวจสอบข้อค้นพบที่ AI สร้างขึ้นเทียบกับข้อเท็จจริงเป็นเรื่องง่าย',
  'pages.angelInsider.issues.feature-inline-ref.sections.1.blocks.1.figure.caption':
    'แผงคำอธิบายในตรวจสอบ พร้อมการอ้างอิงในบรรทัดอย่างเป็นระบบที่เชื่อมไปยังเอกสารต้นทาง',
  'pages.angelInsider.issues.feature-inline-ref.signoff.line': 'ทุกผลลัพธ์ ตรวจสอบต้นทางได้',
  'pages.angelInsider.issues.feature-inline-ref.signoff.name': 'ทีมพัฒนา A&GEL',
  'pages.angelInsider.issues.issue-5.title': 'การอ้างอิงในบรรทัด มินิแชท และอื่น ๆ',
  'pages.angelInsider.issues.issue-5.subtitle':
    'การอ้างอิงแบบชี้จุดครบทุกแอป มินิแชทที่เลื่อนย้ายได้ ไทม์สแตมป์ในการบันทึกเสียง และการปรับปรุงประสบการณ์ใช้งานอีกชุดใหญ่',
  'pages.angelInsider.issues.issue-5.date': '10 เม.ย. 2026',
  'pages.angelInsider.issues.issue-5.glance.0':
    'การวิจัยเชิงลึก ไทม์ไลน์ สรุปขอบเขตงาน และตรวจสอบ มี<strong>การอ้างอิงในบรรทัดที่คลิกได้</strong>แล้ว',
  'pages.angelInsider.issues.issue-5.glance.1':
    'หน้าต่างมินิแชทในตรวจสอบ การเทียบความต่าง และเปรียบเทียบแบบเคียงข้างกัน <strong>เลื่อนย้ายและปรับขนาดได้</strong>แล้ว',
  'pages.angelInsider.issues.issue-5.glance.2':
    'ข้อความถอดความจากการบันทึกเสียงมี<strong>ไทม์สแตมป์</strong>อยู่ในไฟล์ Word ที่ดาวน์โหลดแล้ว',
  'pages.angelInsider.issues.issue-5.glance.3':
    'นอกจากปุ่มหยุดแล้ว ยัง<strong>ยุติเซสชันผ่านแท็บประวัติ</strong>ได้ด้วย',
  'pages.angelInsider.issues.issue-5.glance.4':
    'การค้นหาดีขึ้น: จับคู่คำสำคัญได้แม่นขึ้น และค้นหาภายในเอกสารได้',
  'pages.angelInsider.issues.issue-5.sections.0.kicker': '01 — การอ้างอิงในบรรทัด',
  'pages.angelInsider.issues.issue-5.sections.0.heading': 'การอ้างอิงแบบชี้จุดครบทุกแอป',
  'pages.angelInsider.issues.issue-5.sections.0.blocks.0.p':
    'การวิจัยเชิงลึก ไทม์ไลน์ และสรุปขอบเขตงาน มี<strong>การอ้างอิงในบรรทัดที่คลิกได้</strong>แล้ว การอ้างอิงเหล่านี้ช่วยให้คุณตรวจทานผลลัพธ์เทียบกับเอกสารต้นทางได้ทันที — คลิกการอ้างอิงใดก็ได้เพื่อเปิดต้นทางโดยไฮไลต์ข้อความที่เกี่ยวข้อง ทั้งหมดนี้โดยไม่ต้องออกจากหน้านี้',
  'pages.angelInsider.issues.issue-5.sections.0.blocks.1.p':
    'ส่วน<strong>คำอธิบาย</strong>ที่ขยายได้ในหน้าตรวจสอบก็ได้รับการอ้างอิงในบรรทัดอย่างเป็นระบบซึ่งเชื่อมไปยังเอกสารต้นทางเช่นกัน ทำให้ตรวจสอบบทวิเคราะห์ที่ AI สร้างขึ้นเทียบกับข้อเท็จจริงได้ง่ายขึ้น',
  'pages.angelInsider.issues.issue-5.sections.0.blocks.2.figure.caption':
    'แผงคำอธิบายในตรวจสอบ — การอ้างอิงในบรรทัดอย่างเป็นระบบที่เชื่อมไปยังเอกสารต้นทาง',
  'pages.angelInsider.issues.issue-5.sections.1.kicker': '02 — มินิแชท',
  'pages.angelInsider.issues.issue-5.sections.1.heading': 'หน้าต่างมินิแชทที่เลื่อนย้ายได้',
  'pages.angelInsider.issues.issue-5.sections.1.blocks.0.p':
    'หน้าต่างมินิแชทที่มีอยู่ใน<strong>ตรวจสอบ การเทียบความต่าง และเปรียบเทียบแบบเคียงข้างกัน</strong> เลื่อนย้ายและปรับขนาดได้แล้ว ลากออกไปไว้ข้าง ๆ ระหว่างที่คุณไล่ดูผลลัพธ์ — มันจะไม่บังพื้นที่ทำงานหลักของคุณอีกต่อไป',
  'pages.angelInsider.issues.issue-5.sections.2.kicker': '03 — การบันทึกเสียง',
  'pages.angelInsider.issues.issue-5.sections.2.heading': 'ไทม์สแตมป์ในข้อความถอดความที่ดาวน์โหลด',
  'pages.angelInsider.issues.issue-5.sections.2.blocks.0.p':
    'ข้อความถอดความจากการบันทึกเสียงที่ดาวน์โหลด (ไฟล์ Word) มี<strong>ไทม์สแตมป์</strong>แล้ว — เป็นเครื่องหมายที่ให้คุณข้ามไปยังช่วงเวลาที่ต้องการในไฟล์เสียงได้จากตัวเอกสารโดยตรง',
  'pages.angelInsider.issues.issue-5.sections.2.blocks.1.figure.caption':
    'ไฟล์ถอดความจากการบันทึกเสียงที่ดาวน์โหลด แสดงไทม์สแตมป์เคียงกับคำแปล',
  'pages.angelInsider.issues.issue-5.sections.3.kicker': '04 — การอัปเดตอื่น ๆ',
  'pages.angelInsider.issues.issue-5.sections.3.heading': 'การปรับปรุงประสบการณ์ใช้งาน',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.0.h': 'ยุติเซสชันได้ง่ายขึ้น',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.1.p':
    'นอกจากปุ่มหยุดที่มีอยู่เดิม เซสชันที่กำลังดำเนินอยู่ยังยุติได้ด้วยการ<strong>ลบออกจากแท็บประวัติ</strong> — มีประโยชน์เมื่อคุณต้องแก้พรอมต์แล้วรันใหม่ หรือเมื่อเซสชันไม่ตอบสนอง',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.2.h': 'การค้นหาที่ดีขึ้น',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.3.p':
    'การค้นหาได้ประโยชน์จาก<strong>การอ้างอิงในบรรทัด</strong> การจับคู่คำสำคัญที่ดีขึ้น และการค้นหาภายในเอกสาร — ทำให้ค้นหาเนื้อหาที่ต้องการในคลังจัดเก็บของคุณได้ง่ายขึ้น',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.4.h': 'สรุปแบบมีคำแนะนำที่เร็วขึ้น',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.5.p':
    'สรุปแบบมีคำแนะนำมี<strong>การอัปเดตระหว่างทางพร้อมการอ้างอิงในบรรทัด</strong>ขณะสร้างผลลัพธ์แล้ว และความเร็วโดยรวมก็เพิ่มขึ้น สำหรับเอกสารที่ไม่ซับซ้อน บทสรุปอาจโหลดเร็วจนข้ามการอัปเดตระหว่างทางไป',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.6.h': 'หน้าไฟล์ที่ปรับให้ดีขึ้น',
  'pages.angelInsider.issues.issue-5.sections.3.blocks.7.p':
    'หน้าไฟล์มีการแบ่งหน้าที่ดีขึ้นแล้ว — คุณเห็นไฟล์และโฟลเดอร์ได้มากขึ้นในคราวเดียว โดยหน้าจะเติมเต็มพื้นที่หน้าจอของคุณแบบยืดหยุ่น',
  'pages.angelInsider.issues.issue-5.signoff.line': 'ตรวจสอบเร็วขึ้น พื้นที่ทำงานโล่งขึ้น',
  'pages.angelInsider.issues.issue-5.signoff.name': 'ทีมพัฒนา A&GEL',
  'pages.angelInsider.issues.feature-faq.title': 'คำถามที่พบบ่อย',
  'pages.angelInsider.issues.feature-faq.subtitle':
    'เริ่มต้นใช้งาน A&GEL — ตั้งแต่การจัดการไฟล์และการเขียนพรอมต์ ไปจนถึงการตรวจสอบผลลัพธ์ของคุณ',
  'pages.angelInsider.issues.feature-faq.date': '10 ก.พ. 2026',
  'pages.angelInsider.issues.feature-faq.glance.0':
    'A&GEL สนับสนุน — แต่ไม่แทนที่ — ความเชี่ยวชาญเฉพาะทางของคุณอย่างไร',
  'pages.angelInsider.issues.feature-faq.glance.1':
    'แนวปฏิบัติที่ดีในการจัดการไฟล์: ควรอัปโหลดอะไร และจัดระเบียบอย่างไร',
  'pages.angelInsider.issues.feature-faq.glance.2':
    'วิธีเขียนพรอมต์ที่ได้ผลด้วยกรอบคิด บทบาท–งาน–บริบท–รูปแบบ',
  'pages.angelInsider.issues.feature-faq.glance.3':
    'วิธีตรวจสอบความถูกต้องและความน่าเชื่อถือของผลลัพธ์จาก A&GEL',
  'pages.angelInsider.issues.feature-faq.glance.4': 'อภิธานศัพท์เทคนิคที่ใช้ใน A&GEL',
  'pages.angelInsider.issues.feature-faq.sections.0.kicker': '1 — หลักการทั่วไป',
  'pages.angelInsider.issues.feature-faq.sections.0.heading':
    'ให้ผู้เชี่ยวชาญได้ทำหน้าที่ผู้เชี่ยวชาญเสมอ',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.0.h':
    'ถาม: ส่วนหนึ่งของปรัชญาการออกแบบ A&GEL คือเราควร “ให้ผู้เชี่ยวชาญได้ทำหน้าที่ผู้เชี่ยวชาญเสมอ” หมายความว่าอย่างไร',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.1.p':
    '“ให้ผู้เชี่ยวชาญได้ทำหน้าที่ผู้เชี่ยวชาญเสมอ” หมายถึงการที่วิจารณญาณ ความเข้าใจเชิงลึก และความซื่อตรงของคุณในฐานะมืออาชีพ/ผู้เชี่ยวชาญในสาขาของคุณ ควรอยู่ที่ใจกลางของงานเสมอ',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.2.p':
    'A&GEL ไม่ได้มาแทนความเชี่ยวชาญนั้น และไม่ได้ทำตัวเป็นผู้เชี่ยวชาญเฉพาะทาง แต่ถูกออกแบบมาเพื่อช่วยให้คุณในฐานะผู้ทำงานด้านความรู้/นักกฎหมาย ทำได้มากขึ้นด้วยทรัพยากรที่มากขึ้น',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.3.h':
    'ถาม: หากฉันไม่คุ้นเคยกับเรื่องที่กำลังถาม A&GEL เลย เช่นนั้นฉันไม่ควรใช้ A&GEL ใช่หรือไม่',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.4.p':
    'หากคุณยังอยู่ระหว่างสั่งสมความเชี่ยวชาญ นั่นไม่ได้แปลว่าคุณควรเลี่ยงการใช้ A&GEL แต่แปลว่าคุณควรใส่ใจมากขึ้นกับวิธีที่คุณใช้ A&GEL คุณควรระมัดระวังเป็นพิเศษและตรวจสอบผลลัพธ์ของ A&GEL ให้มากขึ้น',
  'pages.angelInsider.issues.feature-faq.sections.0.blocks.5.p':
    'ยิ่งไปกว่านั้น ลองใช้ A&GEL เป็นประตูและเป็นผู้นำทางสู่องค์ความรู้ที่ทีมหรือบริษัทของคุณอัปโหลดไว้ เมื่อใช้เป็นช่องทางใหม่ในการเข้าถึงองค์ความรู้เหล่านั้นและรับข้อมูลเชิงลึกกับบทเรียนได้ทันที A&GEL ก็จะกลายเป็นเครื่องมือทรงพลังที่หนุนการเรียนรู้และพัฒนาของคุณ',
  'pages.angelInsider.issues.feature-faq.sections.1.kicker': '2 — การจัดการไฟล์',
  'pages.angelInsider.issues.feature-faq.sections.1.heading': 'ควรอัปโหลดอะไร และจัดระเบียบอย่างไร',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.0.h':
    'ถาม: ฉันควรอัปโหลดเอกสารอ้างอิงประเภทใดขึ้น A&GEL',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.1.p':
    'โดยหลักแล้ว ให้อัปโหลดเฉพาะเอกสารที่เชื่อถือได้และถูกต้องเท่านั้น ตัวอย่างเช่น แหล่งกฎหมายชั้นต้น (ตัวบทกฎหมาย คำพิพากษา ฯลฯ) และเอกสารภายในที่เชื่อถือได้ (เช่น องค์ความรู้ขององค์กร หรือเอกสารของคุณเองที่ผ่านการใช้งานและพิสูจน์แล้ว)',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.2.p':
    'เนื่องจากผลลัพธ์ของ A&GEL ขึ้นอยู่กับเอกสาร/โฟลเดอร์ที่คุณระบุเป็นอย่างมาก จึงต้องเลือกและอัปโหลดไฟล์ที่ถูกต้อง พร้อมทั้งตั้งชื่อเอกสารที่เชื่อถือได้เหล่านั้นตามแนวทางที่ชัดเจน',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.3.callout.title':
    'การตั้งค่าเอกสาร Word',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.3.callout.body':
    'ก่อนอัปโหลดขึ้น A&GEL เอกสาร Word ต้องตั้งค่าความปลอดภัยเป็น ‘External’ (หรือค่าที่เทียบเท่า)',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.4.h':
    'ถาม: แล้วเอกสารของบุคคลภายนอกล่ะ ฉันอัปโหลดขึ้น A&GEL ได้หรือไม่',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.5.p':
    'ได้แน่นอน! เราสนับสนุนให้คุณใช้ A&GEL วิเคราะห์ ซักไซ้ หรือตรวจทานเอกสารของบุคคลภายนอก — อันที่จริงนี่คือจุดแข็งหลักอย่างหนึ่งของโหมดเฉพาะทางหลายโหมดใน A&GEL (เช่น ตรวจสอบ) ซึ่งรวมถึงเอกสารจากทนายความฝ่ายตรงข้าม/คู่สัญญาอีกฝ่ายด้วย',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.6.p':
    'เพียงแต่ต้องอัปโหลดไว้ในโฟลเดอร์ที่ระบุชัดว่าเป็นเอกสารของบุคคลภายนอก เพื่อให้คุณดูจากเส้นทางไฟล์แล้วรู้ได้ทันทีว่านี่คือแบบอย่างที่เชื่อถือได้ หรือแท้จริงแล้วเป็นเอกสาร “จากภายนอก” ที่คุณกำลังทำงานด้วย',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.7.p':
    'โปรดคำนึงถึงนโยบายขององค์กร (เช่น นโยบายที่ครอบคลุมการใช้ AI เชิงสร้างสรรค์) และนโยบายการใช้งานที่ยอมรับได้ซึ่งเกี่ยวข้องกับการใช้ A&GEL ของคุณด้วย รวมถึงการใช้เนื้อหาของบุคคลภายนอกโดยได้รับอนุญาตอย่างเหมาะสมเมื่อจำเป็น',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.8.h':
    'ถาม: ทำไม A&GEL จึงใช้เวลานานในการ “ประมวลผล” ไฟล์ที่ฉันอัปโหลดในแท็บไฟล์หรือในแชท',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.9.p':
    'เอกสารต้องถูกแปลงเป็นรูปแบบที่ A&GEL ใช้งานได้ (เรียกว่า “เอ็มเบดดิง”) จึงอาจใช้เวลาสักครู่ตอนอัปโหลด — แต่จะเกิดขึ้นเพียงครั้งเดียวเมื่ออัปโหลดเข้าไฟล์ในคลังจัดเก็บของคุณ เอกสารที่อัปโหลดไว้ในแท็บไฟล์สามารถนำกลับมาใช้ในเซสชันใหม่ได้ โดยเลือกไฟล์นั้นเป็นบริบทในแชทหรือในโหมดเฉพาะทางใด ๆ',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.10.p':
    'ในแชท เมื่ออัปโหลดเอกสารแล้ว คุณสามารถสนทนากับเอกสารเดิมในเซสชันแชทใหม่ได้ โดยคลิกปุ่ม “บริบท” แล้วคลิกปุ่ม “แชทใหม่พร้อมเอกสาร”',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.11.h':
    'ถาม: ฉันควรอัปโหลดเอกสารจำนวนมากขึ้นแท็บไฟล์อย่างไร',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.12.p':
    'ในโหมดไฟล์ ให้คลิกปุ่มอัปโหลดที่มุมขวาบนของหน้าจอ เลือกไฟล์ที่ต้องการอัปโหลดได้ตามจำนวนที่ต้องการ แล้วกด “open” คุณสามารถใช้ฟังก์ชันอื่น ๆ ของ A&GEL ต่อได้ระหว่างที่เอกสารอ้างอิงกำลังอัปโหลด',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.13.h':
    'ถาม: ฉันควรจัดหมวดหมู่และดูแลเอกสารอ้างอิงที่อัปโหลดขึ้น A&GEL อย่างไร ทำไมจึงไม่ควรอัปโหลดทุกอย่างไว้ในโฟลเดอร์เดียว',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.14.p':
    '<strong>ทำไมการจัดการไฟล์จึงสำคัญ</strong> การจัดการไฟล์อย่างเหมาะสมเป็นสิ่งสำคัญอย่างยิ่งเพื่อให้คุณทำสองสิ่งนี้ได้อย่างมีประสิทธิภาพ: (ก) เลือกเอกสารอ้างอิงที่เกี่ยวข้องให้ A&GEL ใช้เป็นบริบทในการตอบ และ (ข) ตรวจสอบว่า A&GEL ใช้เอกสารอ้างอิงใดบ้าง เพื่อยืนยันความถูกต้องและความน่าเชื่อถือของผลลัพธ์ที่สร้างขึ้น',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.15.p':
    '<strong>ฉันควรจัดการเอกสารอ้างอิงที่อัปโหลดไว้อย่างไร</strong> เมื่ออัปโหลดเอกสารอ้างอิงขึ้น A&GEL เราแนะนำอย่างยิ่งว่าอย่าอัปโหลดทุกอย่างไว้ในโฟลเดอร์เดียว แต่ควรคัดสรรและจัดกลุ่มเอกสารตาม: (i) หัวข้อเรื่อง และ (ii) ขั้นตอนการทำงาน',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.16.p':
    'วิธีทำในแท็บไฟล์คือ ก่อนอัปโหลดเอกสาร ให้สร้างโฟลเดอร์ใหม่โดยคลิกปุ่ม “สร้างโฟลเดอร์” ที่มุมขวาบน แล้วตั้งชื่อตามหัวข้อเรื่องของคุณ จากนั้นในโฟลเดอร์ที่เพิ่งสร้าง ให้สร้างโฟลเดอร์ย่อยและตั้งชื่อตามขั้นตอนการทำงานของเอกสารที่คุณกำลังอัปโหลด',
  'pages.angelInsider.issues.feature-faq.sections.1.blocks.17.p':
    'เมื่ออัปโหลดเอกสาร ก็จะได้เส้นทางไฟล์ที่เหมาะสมซึ่งแสดงทั้งหัวข้อเรื่องและขั้นตอนการทำงานของเอกสาร ตัวอย่างเช่น: <code>Home / IP Licensing Agreements / Licensor</code>',
  'pages.angelInsider.issues.feature-faq.sections.2.kicker': '3 — การเขียนพรอมต์ให้ A&GEL',
  'pages.angelInsider.issues.feature-faq.sections.2.heading': 'การเขียนพรอมต์ที่ได้ผล',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.0.h': 'ถาม: ฉันใช้พรอมต์ประเภทใดได้บ้าง',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.1.p':
    'คุณเขียนพรอมต์ให้ A&GEL ได้หลายแบบ นี่คือข้อเสนอแนะของพรอมต์ประเภทต่าง ๆ (รวมถึงบางแบบที่คุณอาจนึกไม่ถึง):',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.2.h': 'การค้นหาและสืบค้นข้อมูล',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.3.list.0':
    '<strong>พรอมต์แบบตั้งคำถาม:</strong> คำถามตรง ๆ เพื่อขอข้อเท็จจริง คำอธิบาย หรือความกระจ่าง',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.3.list.1':
    '<strong>พรอมต์แบบขอคำอธิบาย:</strong> ขอคำอธิบายโดยละเอียดเกี่ยวกับแนวคิด กระบวนการ หรือปรากฏการณ์ มักใช้ถ้อยคำอย่าง “อธิบาย” “บรรยาย” หรือ “แจกแจง”',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.3.list.2':
    '<strong>พรอมต์แบบวิจัย:</strong> คำขอรวบรวมข้อมูลที่ซับซ้อนกว่า ซึ่งอาจต้องสังเคราะห์ข้อมูลจากหลายแหล่ง',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.4.h': 'เชิงงานและเชิงสั่งการ',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.5.list.0':
    '<strong>พรอมต์แบบสั่งการ:</strong> คำสั่งที่ชัดเจนและตรงไปตรงมา ใช้คำกริยาแสดงการกระทำ เช่น “เขียน” “สร้าง” “วิเคราะห์” หรือ “สรุป”',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.5.list.1':
    '<strong>พรอมต์งานหลายขั้นตอน:</strong> คำสั่งซับซ้อนที่แบ่งงานใหญ่ออกเป็นขั้นตอนต่อเนื่อง',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.5.list.2':
    '<strong>พรอมต์อิงเทมเพลต:</strong> พรอมต์ที่มีโครงสร้าง ซึ่งกำหนดรูปแบบหรือกรอบเฉพาะให้ AI ทำตาม',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.6.h': 'การวิเคราะห์และแก้ปัญหา',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.7.list.0':
    '<strong>พรอมต์วิเคราะห์ข้อมูล:</strong> คำสั่งให้วิเคราะห์ชุดข้อมูล ระบุรูปแบบ หรือดึงข้อมูลเชิงลึกออกมา',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.7.list.1':
    '<strong>พรอมต์แก้ปัญหา:</strong> คำขอที่เสนอโจทย์แล้วให้ AI เสนอทางออก กลยุทธ์ หรือข้อเสนอแนะ',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.7.list.2':
    '<strong>พรอมต์วิเคราะห์เชิงเปรียบเทียบ:</strong> คำสั่งให้เปรียบเทียบและชี้ความต่างของตัวเลือก ประเมินทางเลือก หรือชั่งข้อดีข้อเสีย',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.8.h': 'การจำแนกและการจัดระเบียบ',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.9.list.0':
    '<strong>พรอมต์จำแนกประเภท:</strong> คำสั่งให้จัดข้อความ ข้อมูล หรือสารสนเทศเข้าหมวดหรือป้ายกำกับที่กำหนดไว้ล่วงหน้า',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.9.list.1':
    '<strong>พรอมต์เรียงลำดับและจัดอันดับ:</strong> คำขอให้จัดระเบียบข้อมูลตามเกณฑ์เฉพาะ เช่น ความสำคัญ ลำดับความเร่งด่วน หรือความชอบ',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.9.list.2':
    '<strong>พรอมต์ติดแท็กและป้ายกำกับ:</strong> คำสั่งให้กำหนดแท็ก ป้ายกำกับ หรือข้อมูลกำกับให้เนื้อหา เพื่อการจัดระเบียบหรือการค้นหา',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.10.h': 'การแปลงรูปและการจัดรูปแบบ',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.11.list.0':
    '<strong>พรอมต์แปลภาษา:</strong> คำสั่งให้แปลงข้อความจากภาษาหนึ่งเป็นอีกภาษาหนึ่ง หรือปรับเนื้อหาให้เข้ากับบริบททางวัฒนธรรมที่ต่างออกไป',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.11.list.1':
    '<strong>พรอมต์แปลงรูปแบบ:</strong> คำขอให้เปลี่ยนโครงสร้างหรือวิธีนำเสนอข้อมูล เช่น เปลี่ยนความเรียงเป็นหัวข้อย่อย',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.11.list.2':
    '<strong>พรอมต์ปรับสำนวน:</strong> คำสั่งให้เขียนเนื้อหาใหม่ด้วยน้ำเสียง สำนวน หรือสำหรับผู้อ่านที่ต่างออกไป',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.12.h': 'พรอมต์ประเภทอื่น ๆ',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.0':
    'พรอมต์สวมบทบาทและกำหนดตัวตน',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.1': 'พรอมต์เชิงสนทนาและโต้ตอบ',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.2': 'พรอมต์กำหนดระบบและพฤติกรรม',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.3': 'พรอมต์เชิงเหตุผลและตรรกะ',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.4': 'พรอมต์ด้านโค้ดและเทคนิค',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.13.list.5':
    'พรอมต์เพื่อการเรียนรู้และฝึกอบรม',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.14.h':
    'ถาม: ฉันจะเขียนพรอมต์ที่ได้ผลได้อย่างไร',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.15.p':
    'โดยทั่วไป พรอมต์ที่ได้ผลที่สุดประกอบด้วย 4 ส่วน: <strong>(ก) บทบาท (ข) งาน (ค) บริบท และ (ง) รูปแบบ</strong>',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.16.h': '(ก) บทบาท',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.17.p':
    'บทบาทหมายถึงข้อมูลที่คุณให้เกี่ยวกับตัวคุณเอง หรือสิ่งที่ต้องการให้ A&GEL สวมบทบาทเป็น เมื่อเขียนพรอมต์ให้ AI สิ่งนี้ช่วยกำกับให้ A&GEL เขียนด้วยสำนวนและน้ำเสียงแบบหนึ่ง การใส่บทบาทจะช่วยให้คุณได้คำตอบที่เหมาะกับคุณมากขึ้น',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.18.prompt.label': 'ตัวอย่าง',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.18.prompt.text':
    'คุณคือทนายความผู้มากประสบการณ์ 30 ปี',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.19.h': '(ข) งาน',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.20.p':
    'นี่คือคำสั่งที่คุณให้แก่โมเดล คุณควรระบุคำสั่งงานให้เฉพาะเจาะจงเพื่อให้ได้ผลลัพธ์ที่ดีที่สุด อย่างไรก็ตาม การสั่งงาน AI ให้ชัดเจนและกระชับก็สำคัญไม่แพ้กัน',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.21.prompt.label': 'ตัวอย่าง',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.21.prompt.text':
    'สรุปเอกสารนี้โดยไม่เกิน 100 คำ',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.22.h': '(ค) บริบท',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.23.p':
    'บริบท (คือข้อมูล) ที่คุณป้อนให้ A&GEL สร้างความแตกต่างได้อย่างมหาศาล บริบทคือวิธีที่ดีที่สุดในการทำให้พรอมต์ของคุณได้ผลลัพธ์ที่ตรงเป้า บริบทเช่นนี้อาจระบุในรูปของ “องค์ความรู้” เฉพาะทางที่คุณต้องการให้ A&GEL นำมาพิจารณาเป็นพิเศษขณะสร้างผลลัพธ์ก็ได้',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.24.prompt.label': 'ตัวอย่าง',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.24.prompt.text':
    'บทสรุปนี้จัดทำให้ลูกความซึ่งเป็นผู้ซื้อในธุรกรรมนี้ ให้ใส่รายละเอียดของธุรกรรมจากมุมมองของผู้ซื้อไว้ในบทสรุปด้วย\n\nองค์ความรู้: ข้อสัญญาเรื่องการโอนสิทธิ การแปลงหนี้ใหม่ หรือการโอนย้าย ไม่ถือเป็นตัวอย่างของข้อกำหนดเรื่องการเปลี่ยนแปลงอำนาจควบคุม ความเป็นเจ้าของ หรือส่วนได้เสีย',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.25.h': '(ง) รูปแบบ',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.26.p':
    'นี่คือรูปแบบของผลลัพธ์ ตัวเลือกมีทั้งรายการ ตาราง และรูปแบบ Markdown',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.27.prompt.label': 'ตัวอย่าง',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.27.prompt.text':
    'นำเสนอบทสรุปในรูปของตาราง',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.28.callout.title': 'เริ่มจากคลังพรอมต์',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.28.callout.body':
    'วิธีหนึ่งในการเขียนพรอมต์ที่ได้ผล คือหยิบพรอมต์ที่มีอยู่แล้วและพิสูจน์ว่าใช้ได้ผล มาปรับให้เข้ากับวัตถุประสงค์ของคุณ ไปที่แท็บคลังพรอมต์ กด “คัดลอก” พรอมต์ที่เกี่ยวข้อง แล้วปรับให้เข้ากับงานของคุณ',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.29.h':
    'ตัวอย่างเต็ม — บทบาท + งาน + บริบท + รูปแบบ',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.30.prompt.label':
    'ตัวอย่างพรอมต์ฉบับเต็ม',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.30.prompt.text':
    'คุณคือทนายความผู้มากประสบการณ์ จงสร้างบทสรุปที่กระชับ (แต่ละส่วนไม่เกิน 100 คำ) ของเอกสารนี้ คำสั่ง: ให้เน้นชี้ (1) ประโยชน์สำคัญและแง่บวกที่เอกสารกล่าวถึง โดยแยกเป็นอีกหัวข้อย่อยหนึ่ง ให้ยกตัวอย่างข้อเท็จจริงที่อ้างถึงอย่างน้อยหนึ่งข้อเพื่อประกอบ และ (ข) ความเสี่ยงสำคัญและแง่ลบที่เอกสารกล่าวถึง โดยแยกเป็นอีกหัวข้อย่อยหนึ่ง ให้ยกตัวอย่างข้อเท็จจริงที่อ้างถึงอย่างน้อยหนึ่งข้อเพื่อประกอบ ให้บทสรุปมีความสอดคล้องและชัดเจน หากพบตัวอย่างหรือข้อสนับสนุนมากกว่าหนึ่ง ให้ระบุว่าข้อใดดีที่สุดหรือแย่ที่สุดตามที่บทความบรรยายไว้ ใช้ภาษาที่เป็นทางการและรักษาน้ำเสียงที่เป็นกลาง หลีกเลี่ยงการสอดแทรกความเห็นหรือการตีความส่วนตัว นำเสนอผลลัพธ์ทั้งหมดในรูปแบบ markdown โดยใช้หัวข้อย่อยสำหรับแต่ละประเด็นสำคัญ และใช้ตัวหนาสำหรับข้อค้นพบที่สำคัญเป็นพิเศษ งานของคุณต้องแม่นยำ ถูกต้อง และเป็นมืออาชีพ เพราะจะถูกตรวจทานโดยนักกฎหมายอาวุโสและนำไปใช้ในธุรกรรมทางการเงินที่มีเดิมพันสูง',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.31.h':
    'ถาม: RAG คืออะไร และ A&GEL ใช้เมื่อใด',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.32.p':
    'โดยค่าเริ่มต้น ฟังก์ชันแชทของ A&GEL ใช้ Retrieval-Augmented Generation (RAG) ซึ่งจะดึงข้อมูลจากเอกสารอ้างอิงที่คุณอัปโหลดไว้ในแท็บไฟล์ ก่อนส่งต่อไปยังส่วนที่ทำหน้าที่สร้างข้อความ (คือ LLM) พร้อมกับพรอมต์ที่คุณเขียนถึง A&GEL จากนั้น A&GEL จะสร้างผลลัพธ์จากข้อมูลที่มี — พร้อมบริบทเพิ่มเติมจาก RAG',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.33.p':
    'การผสาน RAG เข้ากับเทคโนโลยี LLM มอบบริบทและข้อมูลที่เกี่ยวข้องให้ A&GEL สร้าง “คำตอบที่ได้รับการเสริม” ซึ่งช่วยเพิ่มความแม่นยำของผลลัพธ์ และทำให้มีโอกาสสูงขึ้นที่คำตอบนั้นจะเชื่อถือได้',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.34.h':
    'ถาม: ทำไมฉันจึงไม่ควรปล่อยให้ A&GEL พิจารณาเอกสารที่ฉันอัปโหลดไว้ทั้งหมดในทุกพรอมต์',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.35.p':
    'เราแนะนำอย่างยิ่งว่าอย่าให้ A&GEL พิจารณาเอกสารที่อัปโหลดไว้ซึ่งไม่เกี่ยวข้องกับพรอมต์ของคุณ',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.36.p':
    'เครื่องมือ Gen AI อย่าง A&GEL ไม่ได้เข้าใจความหมายของคำ ข้อสัญญา หรือสัญญา ฯลฯ มันทำงานด้วยวิธีเชิงความน่าจะเป็น ไม่ใช่ความเข้าใจอย่างแท้จริง ในโหมดแชท หากเลือกไฟล์ทั้งหมดเป็นบริบท A&GEL จะดึงการอ้างอิงจากเอกสารทุกฉบับที่อัปโหลดไว้ในไฟล์ในคลังจัดเก็บของคุณ แต่เอกสารบริบทที่เกี่ยวข้องกับพรอมต์ของคุณจริง ๆ อาจมีเพียงเอกสารในหัวข้อเฉพาะเรื่องหนึ่ง หรือแม้กระทั่งขั้นตอนการทำงานหนึ่งเท่านั้น การให้บริบทเพิ่มเติมที่ไม่เกี่ยวข้องกับวัตถุประสงค์ของคุณ มีแนวโน้มจะลดทั้งความเร็ว ความถูกต้อง ความแม่นยำ และความน่าเชื่อถือของผลลัพธ์จาก A&GEL',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.37.h':
    'ถาม: ฉันจะเลือกเอกสารอ้างอิงที่เกี่ยวข้องสำหรับแต่ละพรอมต์ได้อย่างไร',
  'pages.angelInsider.issues.feature-faq.sections.2.blocks.38.p':
    'ในโหมดแชท หากต้องการจำกัดให้ A&GEL ใช้เฉพาะเอกสารอ้างอิงที่เกี่ยวข้องอย่างแท้จริงเป็นบริบทของพรอมต์ ให้ไปที่ “บริบท” คลิกสัญลักษณ์การเลือก แล้วเลือกเฉพาะเอกสาร/โฟลเดอร์ที่เกี่ยวข้อง',
  'pages.angelInsider.issues.feature-faq.sections.3.kicker': '4 — การใช้ผลลัพธ์',
  'pages.angelInsider.issues.feature-faq.sections.3.heading':
    'การตรวจสอบความถูกต้องและความน่าเชื่อถือ',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.0.h':
    'ถาม: ฉันเขียนพรอมต์ให้ A&GEL และได้ผลลัพธ์มาแล้ว ใช้ได้เลยหรือไม่',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.1.p':
    'โดยทั่วไป คุณควรตรวจสอบผลลัพธ์ของ A&GEL เสมอก่อนนำไปใช้ในงานของคุณ เราแนะนำให้ใช้ผลลัพธ์จาก A&GEL เป็นเพียงจุดตั้งต้นหรือจุดอ้างอิง และควรตรวจทานเทียบกับแหล่งความรู้ที่เชื่อถือได้เสมอ (เช่น เอกสารอ้างอิงที่คุณอัปโหลด หรือเอกสารกฎหมายที่ผ่านการตรวจสอบแล้ว)',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.2.h':
    'ถาม: ฉันควรตรวจสอบความถูกต้องและความน่าเชื่อถือของผลลัพธ์อย่างไร',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.3.p':
    'ในโหมดแชท ผลลัพธ์ของ A&GEL ได้รับการปรับให้แสดงการอ้างอิงทุกครั้งที่มี การอ้างอิงเหล่านี้คือลิงก์ไปยังข้อมูลที่เชื่อถือได้ (เช่น เอกสารที่คุณอัปโหลดไว้ในแท็บไฟล์)',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.4.p':
    '<strong>A&GEL ควรเป็นประตูสู่องค์ความรู้ของคุณ ไม่ใช่แหล่งกำเนิดขององค์ความรู้นั้น</strong> เมื่อคลิกลิงก์อ้างอิงแต่ละรายการ คุณจะเห็นเอกสารอ้างอิงที่ A&GEL ใช้เป็นบริบท คุณควรตรวจสอบผลลัพธ์ของ A&GEL เทียบกับเอกสารอ้างอิงเหล่านั้นเสมอ เพื่อยืนยันความถูกต้องและความน่าเชื่อถือ',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.5.p':
    'หากคุณจัดการไฟล์ใน A&GEL อย่างเหมาะสม ลิงก์อ้างอิง — ซึ่งแสดงเส้นทางไฟล์ของเอกสารที่ถูกอ้างถึง — ยังช่วยให้เห็นภาพคร่าว ๆ ได้ทันทีว่า A&GEL ใช้เอกสารที่ตรงหัวข้อเรื่อง (และขั้นตอนการทำงาน) ที่ถูกต้องมาเสริมผลลัพธ์หรือไม่ ตัวอย่างเช่น หากคุณเขียนพรอมต์จากมุมของ “ผู้โอนสิทธิการเช่า” แต่สังเกตว่า A&GEL อ้างอิงเอกสารที่อยู่ในโฟลเดอร์ “ผู้รับโอนสิทธิการเช่า” คุณย่อมรู้ได้ทันทีว่าผลลัพธ์นั้นยังไม่สอดรับกับวัตถุประสงค์ของคุณอย่างเต็มที่',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.6.callout.title':
    'จะทำอย่างไรหากผลลัพธ์ไม่มีการอ้างอิงเลย',
  'pages.angelInsider.issues.feature-faq.sections.3.blocks.6.callout.body':
    'ผลลัพธ์ที่ไม่มีการอ้างอิงมีแนวโน้มเกิดการกุข้อมูล เพราะไม่ได้ยึดโยงกับเอกสารอ้างอิงที่เชื่อถือได้ใด ๆ หากคุณไม่เห็นการอ้างอิงเลย แทบจะแน่ใจได้ว่าข้อมูลที่ปรากฏในผลลัพธ์มาจากการฝึกล่วงหน้าของโมเดลเพียงอย่างเดียว คุณไม่ควรใช้ผลลัพธ์นั้น เว้นแต่คุณมั่นใจว่ามันตอบสนองต่อพรอมต์ทั่วไปด้านการเขียนหรือการแก้ไขข้อความ (เช่น ทำเอกสารนี้ให้เข้าใจง่ายขึ้น หรือการตรวจทาน) หรือการสรุปความ ซึ่งโมเดลได้รับบริบทเพียงพอแล้ว',
  'pages.angelInsider.issues.feature-faq.sections.4.kicker': '5 — อภิธานศัพท์',
  'pages.angelInsider.issues.feature-faq.sections.4.heading': 'ศัพท์เทคนิคที่ใช้ใน A&GEL',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.0.p':
    '<strong>น้ำหนักไฟล์รายการโปรด:</strong> ปรับระดับที่ A&GEL ให้ความสำคัญกับเอกสารที่คุณทำเครื่องหมายเป็น “รายการโปรด” (ภายในคลังจัดเก็บ) เมื่อสร้างคำตอบ น้ำหนักที่สูงขึ้นทำให้แหล่งข้อมูลที่คุณเลือกไว้มีอิทธิพลต่อผลลัพธ์มากกว่าไฟล์ทั่วไปในคลังจัดเก็บ',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.1.p':
    '<strong>การจัดอันดับใหม่:</strong> กระบวนการจัดเรียงขั้นที่สอง ซึ่ง A&GEL จะทบทวนผลการค้นหาเบื้องต้นเพื่อจัดลำดับข้อสัญญาหรือช่วงข้อความที่เกี่ยวข้องที่สุดไว้ก่อน วิธีนี้ทำให้ข้อมูลที่ตรงประเด็นที่สุดปรากฏอยู่ด้านบนก่อนที่จะสร้างคำตอบ',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.2.p':
    '<strong>อัตราส่วนการค้นหา:</strong> ควบคุมปริมาณข้อมูลภายในที่ AI ดึงมาใช้ตอบคำถาม อัตราส่วนที่สูงขึ้นจะขยายการค้นหาเพื่อเก็บบริบทได้มากขึ้น (มีประโยชน์กับการสำรวจในวงกว้าง) ขณะที่อัตราส่วนต่ำจะเน้นเฉพาะสิ่งที่ตรงกันพอดี (คล้าย ๆ กับ CTRL+F)',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.3.p':
    '<strong>พรอมต์ระบบ:</strong> ชุดคำสั่งพื้นฐานที่กำหนดบทบาทเฉพาะ น้ำเสียง และขอบเขตการทำงานของ A&GEL (เช่น “คุณคือหุ้นส่วนอาวุโสที่มีประสบการณ์ 20 ปี”) การตั้งค่าเหล่านี้เป็นกรอบหลักที่กำกับวิธีที่ A&GEL จัดการทุกคำขอที่ตามมา',
  'pages.angelInsider.issues.feature-faq.sections.4.blocks.4.p':
    '<strong>‘การคิด’ หรือ ‘การให้เหตุผล’:</strong> กระบวนการที่ A&GEL แยกย่อยคำถามที่ซับซ้อนออกเป็นขั้น ๆ อย่างมีตรรกะก่อนสร้างคำตอบสุดท้าย การไตร่ตรองภายในนี้เลียนแบบการให้เหตุผลของมนุษย์ และมีเป้าหมายเพื่อช่วยลดข้อผิดพลาดในการวิเคราะห์ที่ซับซ้อน',
  'pages.angelInsider.issues.feature-faq.signoff.line':
    'เครื่องมือใหม่ทุกชิ้นย่อมต้องใช้เวลาปรับตัวสักหน่อย — A&GEL ก็เช่นกัน ยิ่งคุณใช้มากเท่าไร มันก็ยิ่งมีประโยชน์มากขึ้นเท่านั้น',
  'pages.angelInsider.issues.feature-faq.signoff.name': 'ทีมพัฒนา A&GEL',
  'pages.app.addCustomFieldsTitle': 'เพิ่มฟิลด์กำหนดเองเพื่อดึงข้อมูลสำหรับแต่ละเหตุการณ์',
  'pages.app.addCustomStepButton': 'ขั้นตอนกำหนดเอง',
  'pages.app.addFieldButton': 'เพิ่มฟิลด์',
  'pages.app.addFromLibraryButton': 'จากคลัง',
  'pages.app.addFromSavedButton': 'การตั้งค่าที่บันทึกไว้',
  'pages.app.addToMattersButton': 'เพิ่มไปยังเรื่อง',
  'pages.app.analysisType.agenticResearch.title': 'การวิจัยเชิงเอเจนต์',
  'pages.app.analysisType.comparison.title': 'การเปรียบเทียบ',
  'pages.app.analysisType.contractDeadlines.title': 'ดึงข้อมูลกำหนดเวลา',
  'pages.app.analysisType.executiveSummary.title': 'สรุปสำหรับผู้บริหาร',
  'pages.app.analysisType.gartnerReport.title': 'รายงานสไตล์ Gartner',
  'pages.app.analysisType.multiStepPrompt.title': 'พรอมต์หลายขั้นตอน',
  'pages.app.analysisType.scopeOfWork.title': 'สรุปขอบเขตงาน',
  'pages.app.analyzingFiles': 'กำลังวิเคราะห์ไฟล์...',
  'pages.app.applicablePartiesColumnTitle': 'คู่สัญญาที่เกี่ยวข้อง',
  'pages.app.appsTitle': 'แอป',
  'pages.app.backToSavedPromptsLabel': 'กลับไปยังพรอมต์ที่บันทึกไว้',
  'pages.app.backgroundColumnTitle': 'ความเป็นมา',
  'pages.app.buildMultiStepPromptTitle': 'สร้างพรอมต์แบบหลายขั้นตอน',
  'pages.app.buildNewButton': 'การตั้งค่าใหม่',
  'pages.app.clauseColumnTitle': 'ข้อสัญญา',
  'pages.app.clearStepsButton': 'ล้าง',
  'pages.app.clearStepsConfirm': 'ลบขั้นตอนทั้งหมดออกจากรายการหรือไม่?',
  'pages.app.clientDetailsPlaceholder': 'ชื่อและรายละเอียดโดยย่อของลูกค้า',
  'pages.app.clientInformationTitle': 'ข้อมูลลูกค้า',
  'pages.app.clientLabel': 'ลูกค้า',
  'pages.app.collapseAllPrompts': 'ย่อพรอมต์ทั้งหมด',
  'pages.app.collapsePrompt': 'ย่อพรอมต์',
  'pages.app.compilingFinalSummary': 'กำลังรวบรวมสรุปฉบับสมบูรณ์...',
  'pages.app.complexityLabel': 'ความซับซ้อน',
  'pages.app.configNameLabel': 'ชื่อการตั้งค่า',
  'pages.app.configTagsLabel': 'แท็ก',
  'pages.app.configurationDeletedSuccess': 'ลบการตั้งค่าเรียบร้อยแล้ว',
  'pages.app.configurationSavedSuccess': 'บันทึกการตั้งค่าเรียบร้อยแล้ว',
  'pages.app.configurationUpdatedSuccess': 'อัปเดตการตั้งค่าเรียบร้อยแล้ว',
  'pages.app.contactLabel': 'ผู้ติดต่อ',
  'pages.app.counterpartyLabel': 'คู่สัญญา',
  'pages.app.dateReferenceColumnTitle': 'วันที่/เอกสารอ้างอิง',
  'pages.app.deadlinesSectionTitle': 'กำหนดเวลา',
  'pages.app.deleteConfigConfirmTitle': 'คุณต้องการลบการตั้งค่านี้ใช่หรือไม่',
  'pages.app.deleteStepTooltip': 'ลบขั้นตอน',
  'pages.app.detailsColumnTitle': 'รายละเอียด',
  'pages.app.doneCount': 'เสร็จสิ้น ({completed}/{total})',
  'pages.app.dragHereToUpload': 'ลากมาวางที่นี่เพื่ออัปโหลด',
  'pages.app.dragStepTooltip': 'ลากขั้นตอน',
  'pages.app.dropZoneForNamedStep': 'พื้นที่วางสำหรับ {stepName}',
  'pages.app.dropZoneForStepNumber': 'พื้นที่วางสำหรับขั้นตอนที่ {stepNumber}',
  'pages.app.durationColumnTitle': 'ระยะเวลา',
  'pages.app.enterConfigNamePlaceholder': 'ระบุชื่อการตั้งค่า',
  'pages.app.enterDescriptionPlaceholder': 'ระบุคำอธิบาย',
  'pages.app.enterTagsPlaceholder': 'พิมพ์แท็กแล้วกด Enter',
  'pages.app.entitiesColumnTitle': 'หน่วยงาน/บุคคลที่เกี่ยวข้อง',
  'pages.app.expandAllPrompts': 'ขยายพรอมต์ทั้งหมด',
  'pages.app.expandPrompt': 'ขยายพรอมต์',
  'pages.app.extendPromptTabLabel': 'ขยายพรอมต์',
  'pages.app.extraFieldDescriptionPlaceholder': 'คำอธิบาย (เช่น ดึงข้อมูลมูลค่าเงินที่ระบุไว้)',
  'pages.app.extraFieldKeyPlaceholder': 'คีย์ (เช่น งบประมาณ)',
  'pages.app.extractColumnTitle': 'การดึงข้อมูล',
  'pages.app.fileCountLabel': '{count} ไฟล์',
  'pages.app.filesCompleteCount': 'เสร็จสิ้น {completed}/{total} ไฟล์',
  'pages.app.hardDeadlineColumnTitle': 'กำหนดเวลาตายตัว',
  'pages.app.inProgressSuffix': ' (กำลังดำเนินการ)',
  'pages.app.keyDatesDeadlinesTitle': 'วันที่และกำหนดเวลาสำคัญ',
  'pages.app.libraryPanelTitle': 'คลังพรอมต์',
  'pages.app.loadSavedConfigPlaceholder': 'โหลดการตั้งค่าที่บันทึกไว้',
  'pages.app.loadingDocumentTip': 'กำลังโหลดเอกสาร...',
  'pages.app.mattersUpdatedSuccess': 'อัปเดตงาน (Matters) เรียบร้อยแล้ว',
  'pages.app.moveStepDownTooltip': 'เลื่อนลง',
  'pages.app.moveStepUpTooltip': 'เลื่อนขึ้น',
  'pages.app.newAnalysisModesTitle': 'โหมดวิเคราะห์ใหม่',
  'pages.app.newFieldDefaultKey': 'ฟิลด์ {number}',
  'pages.app.newSessionLabel': 'เซสชันใหม่',
  'pages.app.newStepDefaultName': 'ขั้นตอนใหม่',
  'pages.app.noSourceDocumentsDescription': 'ไม่มีเอกสารต้นฉบับ',
  'pages.app.noTimelineItemsExtracted': 'ไม่พบรายการไทม์ไลน์ที่ดึงข้อมูลได้',
  'pages.app.overallTabLabel': 'ภาพรวม',
  'pages.app.overviewSectionTitle': 'ภาพรวม',
  'pages.app.partiesSectionTitle': 'คู่สัญญา',
  'pages.app.peopleEntitiesInvolvedLabel': 'บุคคล/หน่วยงานที่เกี่ยวข้อง',
  'pages.app.periodsDurationsTitle': 'ช่วงเวลาและระยะเวลา',
  'pages.app.pleaseEnterPlaceholder': 'กรุณาระบุ',
  'pages.app.processingNextStep': 'กำลังประมวลผลขั้นตอนถัดไป...',
  'pages.app.promptForStepPlaceholder': 'พรอมต์สำหรับขั้นตอนนี้',
  'pages.app.promptLabelWithValue': 'พรอมต์: {prompt}',
  'pages.app.provideDetailsTabLabel': 'ระบุรายละเอียด',
  'pages.app.provideDocumentsTabLabel': 'ระบุเอกสาร',
  'pages.app.providePromptsTabLabel': 'ระบุพรอมต์',
  'pages.app.provisionColumnTitle': 'บทบัญญัติ',
  'pages.app.publishAudienceGroupsLabel': 'กลุ่ม',
  'pages.app.publishAudienceLabel': 'กลุ่มเป้าหมาย',
  'pages.app.publishAudienceOptionFirmWide': 'ทั้งองค์กร',
  'pages.app.publishAudienceOptionGroup': 'กลุ่ม',
  'pages.app.publishAudienceOptionPublic': 'สาธารณะ',
  'pages.app.publishButton': 'เผยแพร่',
  'pages.app.publishConfigTitle': 'เผยแพร่การตั้งค่า',
  'pages.app.publishRequestSubmitted': 'ส่งคำขอเผยแพร่แล้ว — กำลังรอการอนุมัติจากผู้ดูแลระบบ',
  'pages.app.publishedToGroup': 'เผยแพร่ไปยังกลุ่มแล้ว',
  'pages.app.readingDocumentName': 'กำลังอ่าน {name}',
  'pages.app.restrictionColumnTitle': 'ข้อจำกัด',
  'pages.app.restrictiveCovenantsTitle': 'ข้อตกลงจำกัดสิทธิ',
  'pages.app.reuseButton': 'ใช้ซ้ำ',
  'pages.app.runAppButton': 'เรียกใช้แอป',
  'pages.app.sanitizedCheckingDocuments': 'กำลังตรวจสอบเอกสาร…',
  'pages.app.sanitizedSearchingDocuments': 'กำลังค้นหาเอกสาร…',
  'pages.app.sanitizedWorkingThroughDocuments': 'กำลังดำเนินการกับเอกสาร…',
  'pages.app.saveAsConfigButton': 'บันทึกเป็น',
  'pages.app.saveConfigButton': 'บันทึกการตั้งค่า',
  'pages.app.saveConfigurationTitle': 'บันทึกการตั้งค่า',
  'pages.app.savedPromptStepCount': '{count, plural, other {# ขั้นตอน}}',
  'pages.app.savedPromptsEmpty': 'ไม่พบพรอมต์หลายขั้นตอนที่บันทึกไว้',
  'pages.app.savedPromptsPanelTitle': 'เลือกการตั้งค่าที่บันทึกไว้',
  'pages.app.savedPromptsSearchPlaceholder': 'ค้นหาพรอมต์ที่บันทึกไว้...',
  'pages.app.savedPromptsTagFilterPlaceholder': 'กรองตามแท็ก',
  'pages.app.searchMattersPlaceholder': 'ค้นหางาน (Matters)...',
  'pages.app.searchPromptsPlaceholder': 'ค้นหาพรอมต์...',
  'pages.app.selectAtLeastOneGroupError': 'กรุณาเลือกอย่างน้อยหนึ่งกลุ่ม',
  'pages.app.selectDocumentsStepTitle': '1. เลือกเอกสารที่คุณต้องการวิเคราะห์',
  'pages.app.selectMattersLabel': 'เลือกงาน (Matters):',
  'pages.app.sharedConfigLabel': '{name} (แชร์แล้ว)',
  'pages.app.sourcesColumnTitle': 'แหล่งที่มา',
  'pages.app.specialRequestsSectionTitle': 'คำขอพิเศษ',
  'pages.app.specificInformationStepTitle': '2. ข้อมูลเฉพาะเจาะจง (ไม่บังคับ)',
  'pages.app.stepNamePlaceholder': 'ชื่อขั้นตอน (เช่น ดึงข้อมูลหน่วยงาน/บุคคล)',
  'pages.app.stepNumberLabel': 'ขั้นตอนที่ {number}',
  'pages.app.stepsAddedFromConfig': '{count, plural, other {เพิ่มแล้ว # ขั้นตอน}}',
  'pages.app.subagentLabel': 'ซับเอเจนต์ {number}',
  'pages.app.subjectLabel': 'เรื่อง',
  'pages.app.summaryLabel': 'สรุป',
  'pages.app.tool.checkingDocuments': 'กำลังตรวจสอบเอกสาร',
  'pages.app.tool.readingDocument': 'กำลังอ่านเอกสาร',
  'pages.app.tool.searchingDocuments': 'กำลังค้นหาเอกสาร',
  'pages.app.tool.workingWithName': 'กำลังดำเนินการ ({name})',
  'pages.app.tool.writingReport': 'กำลังเขียนรายงาน',
  'pages.app.untitledSession': '(ไม่มีชื่อ)',
  'pages.app.updateConfigButton': 'อัปเดต',
  'pages.app.updateConfigurationTitle': 'อัปเดตการตั้งค่า',
  'pages.app.updateMattersFailed': 'อัปเดตงาน (Matters) ไม่สำเร็จ',
  'pages.app.uploadOrSelectFilesError': 'กรุณาอัปโหลดไฟล์หรือเลือกไฟล์ที่มีอยู่',
  'pages.app.urgencyColumnTitle': 'ความเร่งด่วน',
  'pages.app.useAnotherAppButton': 'ใช้แอปอื่น',
  'pages.app.whatsNew': 'มีอะไรใหม่',
  'pages.app.workingEllipsis': 'กำลังดำเนินการ…',
  'pages.app.workingThroughDocumentsCount': 'กำลังดำเนินการกับเอกสาร ({completed}/{total})',
  'pages.chat.addToMatters': 'เพิ่มไปยังงาน (Matters)',
  'pages.chat.agentQuestion.answersSent': 'ส่งคำตอบไปยังเอเจนต์แล้ว',
  'pages.chat.agentQuestion.customAnswerPlaceholder': 'หรือพิมพ์คำตอบของคุณเอง...',
  'pages.chat.agentQuestion.dismissQuestion': 'ปิดคำถาม',
  'pages.chat.agentQuestion.noAnswer': '(ไม่มีคำตอบ)',
  'pages.chat.agentQuestion.question': 'คำถาม',
  'pages.chat.agentQuestion.questionOfTotal': 'คำถามที่ {current} จาก {total}',
  'pages.chat.agentQuestion.questionProgress': '{current} / {total}',
  'pages.chat.agentQuestion.reviewAnswers': 'ตรวจสอบคำตอบ',
  'pages.chat.agentQuestion.reviewYourAnswers': 'ตรวจสอบคำตอบของคุณก่อนส่ง',
  'pages.chat.agentQuestion.seeLess': 'ดูน้อยลง',
  'pages.chat.agentQuestion.seeMore': 'ดูเพิ่มเติม',
  'pages.chat.agentQuestion.sendAnswers': 'ส่งคำตอบ',
  'pages.chat.agentQuestion.submitted': 'ส่งแล้ว',
  'pages.chat.agentQuestion.summary': 'สรุป',
  'pages.chat.agenticRag': 'Agentic RAG',
  'pages.chat.agenticRag.description': 'เอเจนต์จะตัดสินใจว่าจะค้นหาไฟล์บริบทของคุณเมื่อใด',
  'pages.chat.allowSelfPrompting': 'อนุญาตให้สร้างพรอมต์ด้วยตนเอง',
  'pages.chat.allowSelfPrompting.description': 'เอเจนต์จะใช้พรอมต์ที่ตรงกันจากคลังของคุณ',
  'pages.chat.attachedDocument': 'เอกสารแนบ',
  'pages.chat.auth.contentOpenedInNewTab': 'เปิดเนื้อหาในแท็บใหม่แล้ว',
  'pages.chat.auth.dataOpenedInNewTab': 'เปิดข้อมูลในแท็บใหม่แล้ว',
  'pages.chat.auth.failedToFetchUrl': 'ไม่สามารถดึงข้อมูล URL ได้: {error}',
  'pages.chat.auth.failedToOpenNewTab': 'ไม่สามารถเปิดแท็บใหม่ได้',
  'pages.chat.auth.fileOpenedInNewTab': 'เปิดไฟล์ในแท็บใหม่แล้ว',
  'pages.chat.auth.jsonResponseTitle': 'การตอบกลับ JSON',
  'pages.chat.auth.textResponseTitle': 'การตอบกลับข้อความ',
  'pages.chat.cannotCopyNonTextContent': 'ไม่สามารถคัดลอกเนื้อหาที่ไม่ใช่ข้อความได้',
  'pages.chat.chatTitle': 'แชท',
  'pages.chat.clickOrDragToUpload': 'คลิกหรือลากมาวางเพื่ออัปโหลด',
  'pages.chat.connectionInterrupted': 'การเชื่อมต่อของคุณถูกขัดจังหวะ โปรดแตะ {retry}',
  'pages.chat.context.custom': 'กำหนดเอง {suffix}',
  'pages.chat.context.defaultWithName': 'ค่าเริ่มต้น ({name})',
  'pages.chat.context.fullContext': 'บริบททั้งหมด',
  'pages.chat.context.label': 'บริบท',
  'pages.chat.context.selectedLabel': 'เลือกแล้ว',
  'pages.chat.customisation': 'การปรับแต่ง',
  'pages.chat.dragHereToUpload': 'ลากไฟล์มาที่นี่เพื่ออัปโหลด',
  'pages.chat.emptyState.desktopTitle': 'วันนี้ A&GEL ช่วยอะไรคุณได้บ้าง',
  'pages.chat.emptyState.mobileTitle': 'A&GEL ช่วยอะไรคุณได้บ้าง',
  'pages.chat.failedToCopyMessage': 'คัดลอกข้อความไม่สำเร็จ',
  'pages.chat.failedToDownloadFile': 'ดาวน์โหลดไฟล์ไม่สำเร็จ: {error}',
  'pages.chat.fileDownloadedSuccessfully': 'ดาวน์โหลดไฟล์สำเร็จ',
  'pages.chat.filesInVault': 'ไฟล์ใน Vault',
  'pages.chat.home': 'หน้าแรก',
  'pages.chat.htmlContentIframeTitle': 'เนื้อหา HTML',
  'pages.chat.messageCopied': 'คัดลอกข้อความแล้ว!',
  'pages.chat.newChatConfirm.okText': 'ใช่, เริ่มแชทใหม่',
  'pages.chat.newChatConfirm.title': 'เริ่มแชทใหม่หรือไม่',
  'pages.chat.nextStep.button': 'ขั้นตอนถัดไป',
  'pages.chat.nextStep.review': 'ตรวจสอบ',
  'pages.chat.nextStep.workstudio': 'Workstudio',
  'pages.chat.referenceDocument': 'เอกสารอ้างอิง',
  'pages.chat.referenceTitle': 'อ้างอิง: {title}',
  'pages.chat.referencesCount': 'การอ้างอิง {count} รายการ',
  'pages.chat.selectedContext': 'บริบทที่เลือก',
  'pages.chat.selfPromptedUsing': 'สร้างพรอมต์อัตโนมัติโดยใช้ {name}',
  'pages.chat.showMoreLines': 'แสดงเพิ่มเติม ({count} บรรทัด)',
  'pages.chat.sourcesCount': 'แหล่งที่มา ({count})',
  'pages.chat.startNewChat': 'เริ่มแชทใหม่',
  'pages.chat.starterPrompt.caseSummariser.name': 'สรุปคดีความ',
  'pages.chat.starterPrompt.draftChecklist.name': 'ร่างเช็กลิสต์',
  'pages.chat.starterPrompt.summariseArticle.name': 'สรุปบทความนี้',
  'pages.chat.status.completed': 'เสร็จสมบูรณ์',
  'pages.chat.status.working': 'กำลังดำเนินการ',
  'pages.chat.toolCategory.compare': 'กำลังเปรียบเทียบข้อความ',
  'pages.chat.toolCategory.generate': 'กำลังสร้างเอกสาร',
  'pages.chat.toolCategory.read': 'กำลังอ่านเอกสาร',
  'pages.chat.toolCategory.searchDoc': 'กำลังค้นหาในเอกสาร',
  'pages.chat.toolCategory.searchFiles': 'กำลังค้นหาไฟล์',
  'pages.chat.toolCategory.selfInstruction': 'กำลังดำเนินการตามคำสั่ง',
  'pages.chat.transientFiles': 'ไฟล์ชั่วคราว',
  'pages.chat.unknownFileName': 'ไม่ทราบ',
  'pages.chat.unknownFileNameLong': 'ไม่ทราบชื่อไฟล์',
  'pages.chat.untitledSession': '(ไม่มีชื่อ)',
  'pages.chat.upload.failedToUploadFile': 'อัปโหลด {fileName} ไม่สำเร็จ',
  'pages.chat.uploadedImageAlt': 'อัปโหลดแล้ว',
  'pages.chat.waiting.almostThere': 'ใกล้เสร็จแล้ว...',
  'pages.chat.waiting.fetchingThatForYou': 'กำลังดึงข้อมูลให้คุณ...',
  'pages.chat.waiting.hangTight': 'รอสักครู่ กำลังดำเนินการอยู่...',
  'pages.chat.waiting.holdOnRetrieving': 'รอสักครู่ กำลังดึงข้อมูล...',
  'pages.chat.waiting.justAMoment': 'สักครู่...',
  'pages.chat.waiting.letMeCheck': 'ขอตรวจสอบสักครู่...',
  'pages.chat.waiting.lookingThatUp': 'กำลังค้นหาข้อมูลให้คุณ...',
  'pages.chat.waiting.oneSecPlease': 'รอสักครู่...',
  'pages.chat.waiting.workingOnIt': 'กำลังดำเนินการ...',
  'pages.chat.webSearch.confidentialityNotice':
    'เปิดใช้งานการค้นหาเว็บแล้ว โปรดอย่าใส่ข้อมูลที่เป็นความลับของลูกค้าหรือข้อมูลที่ได้รับเอกสิทธิ์ทางกฎหมายในคำสั่งของคุณ',
  'pages.chat.webSearch.permission.title': 'สิทธิ์การค้นหา',
  'pages.chat.webSearch.permission.manual': 'ด้วยตนเอง',
  'pages.chat.webSearch.permission.manualDescription': 'ตรวจสอบคำค้นหาแต่ละรายการก่อนส่ง',
  'pages.chat.webSearch.permission.auto': 'อัตโนมัติ',
  'pages.chat.webSearch.permission.autoDescription':
    'ทำงานโดยไม่ต้องตรวจสอบ คำค้นหาจะออกจากสำนักงาน',
  'pages.comparison.analysisFallbackTitle': 'การวิเคราะห์',
  'pages.comparison.outcomeUnverified': 'ยังไม่ได้ตรวจสอบ',
  'pages.comparison.commentTags': 'แท็กความคิดเห็น',
  'pages.comparison.allCommentTags': 'แท็กความคิดเห็นทั้งหมด',
  'pages.comparison.noMatchingComments': 'ไม่มีความคิดเห็นที่ตรงกับแท็กที่เลือก',
  'pages.comparison.downloadExcel': 'ดาวน์โหลด Excel',
  'pages.comparison.stopSuccess': 'หยุดการเปรียบเทียบสำเร็จ คุณสามารถดูผลลัพธ์บางส่วนได้',
  'pages.comparison.stopFailed': 'หยุดการเปรียบเทียบไม่สำเร็จ',
  'pages.comparison.uploadSuccess': 'อัปโหลด {fileName} สำเร็จ',
  'pages.comparison.uploadFailed': 'อัปโหลด {fileName} ไม่สำเร็จ',
  'pages.comparison.uploadLimitExceeded': 'คุณสามารถอัปโหลดได้สูงสุด {max} ไฟล์สำหรับงานประเภทนี้',
  'pages.comparison.pollingTimeout': 'หมดเวลาการตรวจสอบสถานะ งานอาจยังคงดำเนินการอยู่',
  'pages.comparison.taskStarted': 'เริ่มงานเปรียบเทียบแล้ว',
  'pages.comparison.startFailed': 'เริ่มการเปรียบเทียบไม่สำเร็จ',
  'pages.comparison.previousAnalysisTitle': 'การวิเคราะห์ก่อนหน้า',
  'pages.comparison.analysisPositionCounter': '{current} / {total}',
  'pages.comparison.analysisFoundCounter': 'พบ {total} รายการ',
  'pages.comparison.nextAnalysisTitle': 'การวิเคราะห์ถัดไป',
  'pages.comparison.messageHeading': 'ข้อความ',
  'pages.comparison.noResultsYet': 'ยังไม่มีผลลัพธ์',
  'pages.comparison.startComparisonButton': 'เริ่มการเปรียบเทียบ',
  'pages.comparison.newComparisonButton': 'เริ่มการเปรียบเทียบใหม่',
  'pages.comparison.searchComparisonsPlaceholder': 'ค้นหาการเปรียบเทียบ',
  'pages.comparison.reuseButton': 'ใช้ซ้ำ',
  'pages.comparison.selectMattersLabel': 'เลือกเรื่อง (Matter):',
  'pages.comparison.searchMattersPlaceholder': 'ค้นหาเรื่อง (Matter)...',
  'pages.comparison.mattersUpdated': 'อัปเดตเรื่อง (Matter) สำเร็จ',
  'pages.comparison.mattersUpdateFailed': 'อัปเดตเรื่อง (Matter) ไม่สำเร็จ',
  'pages.comparison.addToMattersButton': 'เพิ่มไปยังเรื่อง (Matter)',
  'pages.comparison.untitled': '(ไม่มีชื่อ)',
  'pages.comparison.processingMoreResults': 'กำลังประมวลผลผลลัพธ์เพิ่มเติม...',
  'pages.comparison.processingComparison': 'กำลังประมวลผลการเปรียบเทียบ...',
  'pages.comparison.taskType.strikethroughUnderline.label': 'ขีดฆ่าและขีดเส้นใต้',
  'pages.comparison.taskType.trackedChanges.label': 'การติดตามการเปลี่ยนแปลง',
  'pages.comparison.taskType.twoVersions.label': 'สองเวอร์ชัน',
  'pages.comparison.taskType.referenceDocument.label': 'เอกสารเป้าหมายเทียบกับเอกสารอ้างอิง',
  'pages.comparison.requirement.singleDocument': 'เอกสารเดียว',
  'pages.comparison.requirement.twoDocuments': 'สองเอกสาร',
  'pages.comparison.startHereTab': 'เริ่มที่นี่',
  'pages.comparison.selectDocumentsPrompt': 'เลือกเอกสารที่คุณต้องการใช้ในการเปรียบเทียบ',
  'pages.comparison.dragUploadText': 'คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด',
  'pages.comparison.swapOrderButton': 'สลับลำดับ',
  'pages.comparison.fileLabel.old': '(เดิม) ',
  'pages.comparison.fileLabel.new': '(ใหม่) ',
  'pages.comparison.fileLabel.reference': '(อ้างอิง) ',
  'pages.comparison.fileLabel.target': '(เป้าหมาย) ',
  'pages.comparison.customInstructionTab': 'คำสั่งที่กำหนดเอง (ไม่บังคับ)',
  'pages.comparison.modifyPromptTitle': 'แก้ไขพรอมต์',
  'pages.comparison.pageTitle': 'การเปรียบเทียบ',
  'pages.comparison.similarDocumentComparisonTitle': 'การเปรียบเทียบเอกสารที่คล้ายกัน',
  'pages.comparison.referenceDocumentComparisonTitle': 'การเปรียบเทียบเอกสารอ้างอิง',
  'pages.comparison.dragHereToUpload': 'ลากไฟล์มาที่นี่เพื่ออัปโหลด',
  'pages.comparison.documentCount.unknownFile': 'ไม่ทราบชื่อไฟล์',
  'pages.comparison.documentCount.fileCount': '{count} ไฟล์',
  'pages.comparison.reviewDirection.reviewedOnBehalfOf': 'ตรวจสอบในนามของ ',
  'pages.comparison.reviewDirection.swapButton': 'สลับทิศทางการตรวจสอบ',
  'pages.comparison.invalidFileDocxOrPdf': '{fileName} ไม่ใช่ไฟล์ .docx หรือ .pdf ที่ถูกต้อง',
  'pages.comparison.invalidFileDocx': '{fileName} ไม่ใช่ไฟล์ .docx ที่ถูกต้อง',
  'pages.comparison.singleFileCountError': 'กรุณาอัปโหลดเอกสารจำนวน 1 ไฟล์สำหรับงานนี้',
  'pages.composer.changeAction.accept': 'ยอมรับ',
  'pages.composer.changeAction.reject': 'ปฏิเสธ',
  'pages.composer.changeAction.reset': 'รีเซ็ต',
  'pages.composer.documentView.foundCount': 'พบ {count} รายการ',
  'pages.composer.documentView.nextChangeArrow': 'ถัดไป ↓',
  'pages.composer.documentView.nextChangeTitle': 'การเปลี่ยนแปลงถัดไป',
  'pages.composer.documentView.positionCount': '{current} / {total}',
  'pages.composer.documentView.previousChangeTitle': 'การเปลี่ยนแปลงก่อนหน้า',
  'pages.composer.documentView.stepNumber': 'ขั้นตอนที่ {number}',
  'pages.composer.documentView.turnNumber': 'รอบที่ {number}',
  'pages.composer.playbook.askAgel': 'ถาม A&GEL',
  'pages.composer.playbook.chooseDocumentTitle': 'เลือกเอกสารเพื่อเริ่มต้น',
  'pages.composer.playbook.createSessionFailed': 'สร้างเซสชัน Workstudio ไม่สำเร็จ',
  'pages.composer.playbook.documentCanvas': 'แคนวาสเอกสาร',
  'pages.composer.playbook.docxOnlyAllowedError': 'โหมด Workstudio รองรับเฉพาะไฟล์ .docx เท่านั้น',
  'pages.composer.playbook.downloadGenerating': 'กำลังสร้าง…',
  'pages.composer.playbook.dragToUpload': 'ลากไฟล์มาที่นี่เพื่ออัปโหลด',
  'pages.composer.playbook.fileUploadFailed': 'อัปโหลด {fileName} ไม่สำเร็จ',
  'pages.composer.playbook.fileUploadedSuccess': 'อัปโหลด {fileName} สำเร็จแล้ว',
  'pages.composer.playbook.newButtonText': 'Workstudio ใหม่',
  'pages.composer.playbook.openFailed': 'ไม่สามารถเปิด Workstudio ได้',
  'pages.composer.playbook.reuseButton': 'ใช้ซ้ำ',
  'pages.composer.playbook.resizeChatPane': 'ปรับขนาดพื้นที่แชท',
  'pages.composer.playbook.searchPlaceholder': 'ค้นหา Workstudio',
  'pages.composer.playbook.title': 'Workstudio',
  'pages.composer.playbookReview.acceptAllButton': 'ยอมรับทั้งหมด',
  'pages.composer.playbookReview.addCommentButton': 'แสดงความคิดเห็น',
  'pages.composer.playbookReview.addCommentPlaceholder': 'เพิ่มความคิดเห็น...',
  'pages.composer.playbookReview.addCommentTooltip': 'เพิ่มความคิดเห็น',
  'pages.composer.playbookReview.allAcceptedSuccess': 'ยอมรับการเปลี่ยนแปลงทั้งหมดแล้ว',
  'pages.composer.playbookReview.allRejectedSuccess': 'ปฏิเสธการเปลี่ยนแปลงทั้งหมดแล้ว',
  'pages.composer.playbookReview.backToWorkstudio': 'กลับไปที่ Workstudio',
  'pages.composer.playbookReview.changeOfTotal': 'การเปลี่ยนแปลง {index} จาก {total}',
  'pages.composer.playbookReview.commentSavedSuccess': 'บันทึกความคิดเห็นแล้ว',
  'pages.composer.playbookReview.documentViewAriaLabel': 'มุมมองเอกสาร',
  'pages.composer.playbookReview.doneEditingButton': 'เสร็จสิ้น',
  'pages.composer.playbookReview.downloadGenericError': 'ไม่สามารถสร้างไฟล์ดาวน์โหลดได้',
  'pages.composer.playbookReview.downloadSuccess': 'ดาวน์โหลดเอกสารสำเร็จแล้ว!',
  'pages.composer.playbookReview.downloadTimeoutError': 'การสร้างไฟล์ดาวน์โหลดหมดเวลา',
  'pages.composer.playbookReview.editCommentButton': 'แก้ไขความคิดเห็น',
  'pages.composer.playbookReview.editCommentTooltip': 'แก้ไขความคิดเห็น',
  'pages.composer.playbookReview.editDocumentButton': 'แก้ไข',
  'pages.composer.playbookReview.groupAcceptAllCount': 'ยอมรับทั้งหมด ({count})',
  'pages.composer.playbookReview.groupRejectAllCount': 'ปฏิเสธทั้งหมด ({count})',
  'pages.composer.playbookReview.groupResetAllCount': 'รีเซ็ตทั้งหมด ({count})',
  'pages.composer.playbookReview.hidePromptButton': 'ซ่อนพรอมต์',
  'pages.composer.playbookReview.layerChangeCount': '{count, plural, other {# การเปลี่ยนแปลง}}',
  'pages.composer.playbookReview.loadingDocument': 'กำลังโหลดเอกสาร...',
  'pages.composer.playbookReview.localDraftTag': 'ฉบับร่างในเครื่อง',
  'pages.composer.playbookReview.localDraftTooltip':
    'ฉบับร่างที่ยังไม่ได้บันทึก ใช้บันทึกการแก้ไขเพื่อบันทึกการเปลี่ยนแปลงข้อความเป็นการเปลี่ยนแปลงที่ติดตาม',
  'pages.composer.playbookReview.noChangesFromStep': 'ไม่มีการเปลี่ยนแปลงจากขั้นตอนนี้',
  'pages.composer.playbookReview.noChangesTitle': 'ไม่พบการเปลี่ยนแปลง',
  'pages.composer.playbookReview.previousChangesFallback': 'การเปลี่ยนแปลงก่อนหน้า',
  'pages.composer.playbookReview.regenerateLabel': 'สร้างใหม่',
  'pages.composer.playbookReview.rejectAllButton': 'ปฏิเสธทั้งหมด',
  'pages.composer.playbookReview.resetAllButton': 'รีเซ็ตทั้งหมด',
  'pages.composer.playbookReview.reviewViewAriaLabel': 'มุมมองตรวจสอบ',
  'pages.composer.playbookReview.saveEditsButton': 'บันทึกการแก้ไข',
  'pages.composer.playbookReview.saveEditsError':
    'บันทึกการแก้ไขไม่สำเร็จ ฉบับร่างของคุณยังอยู่ — โปรดลองอีกครั้ง',
  'pages.composer.playbookReview.saveEditsNoChanges': 'ไม่มีการเปลี่ยนแปลงข้อความที่จะบันทึก',
  'pages.composer.playbookReview.saveEditsSuccess': 'บันทึกการแก้ไขเป็นการเปลี่ยนแปลงที่ติดตามแล้ว',
  'pages.composer.playbookReview.saveEditsTooltip':
    'บันทึกการเปลี่ยนแปลงข้อความเป็นการเปลี่ยนแปลงที่ติดตาม การเปลี่ยนแปลงเฉพาะรูปแบบจะไม่ถูกบันทึก',
  'pages.composer.playbookReview.saveEditsUnavailableTooltip':
    'ไม่สามารถบันทึกได้เนื่องจากเค้าโครงเอกสารนี้ไม่สามารถแมปกลับไปยังข้อความของเอกสารได้ การแก้ไขจะยังคงเป็นฉบับร่างในเครื่อง',
  'pages.composer.playbookReview.selfPromptedUsing': 'สั่งงานอัตโนมัติโดยใช้ {promptName}',
  'pages.composer.playbookReview.showFullPromptButton': 'แสดงพรอมต์แบบเต็ม',
  'pages.composer.playbookReview.showingDocumentView': 'กำลังแสดงมุมมองเอกสาร',
  'pages.composer.playbookReview.showingStepView': 'กำลังแสดงมุมมองทีละขั้นตอน',
  'pages.composer.playbookReview.status.accepted': 'ยอมรับแล้ว',
  'pages.composer.playbookReview.status.pending': 'รอดำเนินการ',
  'pages.composer.playbookReview.status.rejected': 'ปฏิเสธแล้ว',
  'pages.composer.playbookReview.statusDistributionAriaLabel': 'การกระจายสถานะการตรวจสอบ',
  'pages.composer.playbookReview.stepChangeCount': '{count, plural, other {# การเปลี่ยนแปลง}}',
  'pages.composer.playbookReview.stepTag': 'ขั้นตอนที่ {number}',
  'pages.composer.playbookReview.stepViewAriaLabel': 'มุมมองทีละขั้นตอน',
  'pages.composer.playbookReview.turnNeedsRegeneration': 'รอบนี้จำเป็นต้องสร้างใหม่',
  'pages.composer.playbookReview.turnHasConflicts': 'รอบนี้มีการเปลี่ยนแปลงที่ขัดแย้งกัน',
  'pages.composer.playbookReview.turnConflictReason':
    'การเปลี่ยนแปลงที่เสนอมีบางส่วนทับซ้อนกัน โปรดสร้างรอบนี้ใหม่เพื่อปรับใช้ซ้ำ',
  'pages.composer.playbookReview.turnHasUnlocatableChanges':
    'รอบนี้มีการเปลี่ยนแปลงที่ไม่พบตำแหน่ง',
  'pages.composer.playbookReview.turnUnlocatableReason':
    'ไม่พบตำแหน่งของการเปลี่ยนแปลงที่เสนอบางรายการในเอกสาร โปรดสร้างรอบนี้ใหม่เพื่อปรับใช้ซ้ำ',
  'pages.composer.playbookReview.turnTitle': 'รอบที่ {order}: {prompt}',
  'pages.composer.playbookReview.undoChangeError': 'ไม่สามารถย้อนกลับได้ กรุณาลองใหม่อีกครั้ง',
  'pages.composer.playbookReview.updatingCanvas': 'กำลังอัปเดตพื้นที่ตรวจสอบ...',
  'pages.composer.playbookReview.viewChangeTooltip': 'ดูการเปลี่ยนแปลงในเอกสารต้นฉบับ',
  'pages.composer.playbookReview.viewContextButton': 'ดูบริบท',
  'pages.dashboard.allChannelsOption': 'ทุกช่องทาง',
  'pages.dashboard.presetPast30Days': '30 วันที่ผ่านมา',
  'pages.dashboard.presetToday': 'วันนี้',
  'pages.dashboard.presetWtd': 'WTD',
  'pages.dashboard.presetMtd': 'MTD',
  'pages.dashboard.presetYtd': 'YTD',
  'pages.dashboard.exportLoading': 'ส่งออกแดชบอร์ด',
  'pages.dashboard.downloaded': 'ดาวน์โหลดแล้ว',
  'pages.dashboard.downloadingName': 'กำลังดาวน์โหลด {name}',
  'pages.dashboard.chatGptMessageSeries': 'ข้อความ ChatGPT',
  'pages.dashboard.storyboardMessageSeries': 'ข้อความ Storyboard',
  'pages.dashboard.broadcastMessageSeries': 'ข้อความออกอากาศ',
  'pages.dashboard.messageTrendDataTitle': 'ข้อมูลแนวโน้มข้อความ',
  'pages.dashboard.messageTrendDataTooltip': 'แนวโน้มย้อนหลังของสถิติข้อความในช่วงเวลาที่เลือก',
  'pages.dashboard.newUsersSeries': 'ผู้ใช้ใหม่',
  'pages.dashboard.activeUsersSeries': 'ผู้ใช้ที่ใช้งานอยู่',
  'pages.dashboard.userTrendDataTitle': 'ข้อมูลแนวโน้มผู้ใช้',
  'pages.dashboard.userTrendDataTooltip': 'แนวโน้มย้อนหลังของสถิติผู้ใช้ในช่วงเวลาที่เลือก',
  'pages.dashboard.userActivityHeatmapTitle': 'แผนที่ความหนาแน่นกิจกรรมผู้ใช้',
  'pages.dashboard.wordCloudTitle': 'เวิร์ดคลาวด์',
  'pages.dashboard.realTimeUsersTitle': 'ผู้ใช้แบบเรียลไทม์',
  'pages.dashboard.activeUsersTitle': 'ผู้ใช้ที่ใช้งานอยู่',
  'pages.dashboard.newUsersTitle': 'ผู้ใช้ใหม่',
  'pages.dashboard.promptTokensTitle': 'โทเคนพรอมต์',
  'pages.dashboard.completionTokensTitle': 'โทเคนการตอบกลับ',
  'pages.dashboard.userMessagesTitle': 'ข้อความของผู้ใช้',
  'pages.dashboard.chatGptTitle': 'ChatGPT',
  'pages.dashboard.storyboardsTitle': 'Storyboards',
  'pages.dashboard.botMessagesTitle': 'ข้อความของบอท',
  'pages.dashboard.broadcastsTitle': 'การออกอากาศ',
  'pages.dashboard.repliesTitle': 'การตอบกลับ',
  'pages.dashboard.messageExchangesTitle': 'การแลกเปลี่ยนข้อความ',
  'pages.dashboard.broadcastTitle': '#ออกอากาศ',
  'pages.dashboard.outreachTitle': 'การเข้าถึงกลุ่มเป้าหมาย',
  'pages.dashboard.totalUsersTitle': 'ผู้ใช้ทั้งหมด',
  'pages.dashboard.totalUserMessagesTitle': 'ข้อความผู้ใช้ทั้งหมด',
  'pages.dashboard.totalBotMessagesTitle': 'ข้อความบอททั้งหมด',
  'pages.dashboard.totalMessageExchangesTitle': 'การแลกเปลี่ยนข้อความทั้งหมด',
  'pages.diagnostics.usersFilter.label': 'ผู้ใช้:',
  'pages.diagnostics.usersFilter.placeholder': 'ผู้ใช้',
  'pages.diagnostics.typesFilter.label': 'ประเภท:',
  'pages.diagnostics.typesFilter.placeholder': 'ประเภท',
  'pages.diagnostics.dateFilter.label': 'วันที่:',
  'pages.diagnostics.datePreset.past30Days': '30 วันที่ผ่านมา',
  'pages.diagnostics.datePreset.today': 'วันนี้',
  'pages.diagnostics.datePreset.wtd': 'WTD',
  'pages.diagnostics.datePreset.mtd': 'MTD',
  'pages.diagnostics.datePreset.ytd': 'YTD',
  'pages.diagnostics.errorItem.description': ' {username} · เวลาที่สร้าง: {createdTime}',
  'pages.files.you': 'คุณ',
  'pages.files.assignAnotherOwnerFirst': 'กรุณากำหนดเจ้าของรายอื่นก่อน',
  'pages.files.keepAtLeastOneMember': 'กรุณาเก็บสมาชิกไว้อย่างน้อยหนึ่งคน',
  'pages.files.keepAtLeastOneOwner': 'กรุณาเก็บเจ้าของไว้อย่างน้อยหนึ่งคน',
  'pages.files.deletingEllipsis': 'กำลังลบ...',
  'pages.files.failedToDelete': 'ไม่สามารถลบได้',
  'pages.files.dropToUploadCurrentFolder': 'วางไฟล์เพื่ออัปโหลดไปยังโฟลเดอร์ปัจจุบัน',
  'pages.files.deleteConfirm.title': 'ลบไฟล์ {count} รายการ?',
  'pages.files.fromPath': 'จาก: {path}',
  'pages.files.createdAtColumn': 'สร้างเมื่อ',
  'pages.files.favoritesTitle': 'รายการโปรด',
  'pages.files.searchFavoritesPlaceholder': 'ค้นหารายการโปรด...',
  'pages.files.chatTooltip': 'แชท',
  'pages.files.uploadingEllipsis': 'กำลังอัปโหลด...',
  'pages.files.paginationRangeOfTotal': '{start}-{end} จาก {total}',
  'pages.files.enterNamePlaceholder': 'ป้อนชื่อ',
  'pages.files.deleteConfirm.itemContent': 'คุณแน่ใจหรือไม่ว่าต้องการลบ “{name}”?',
  'pages.files.chatWithFolderTooltip': 'แชทกับโฟลเดอร์นี้',
  'pages.files.chatWithFileTooltip': 'แชทกับไฟล์นี้',
  'pages.files.filePreviewAlt': 'ตัวอย่างไฟล์',
  'pages.files.fileTypeCannotBePreviewed': 'ไฟล์ประเภทนี้ไม่สามารถแสดงตัวอย่างได้',
  'pages.files.uploadFilesMenuItem': 'อัปโหลดไฟล์',
  'pages.files.uploadFolderMenuItem': 'อัปโหลดโฟลเดอร์',
  'pages.files.newFolderButton': 'โฟลเดอร์ใหม่',
  'pages.files.sortOption.newestFirst': 'ใหม่ล่าสุดก่อน',
  'pages.files.sortOption.oldestFirst': 'เก่าที่สุดก่อน',
  'pages.files.sortOption.nameAZ': 'ชื่อ A–Z',
  'pages.files.sortOption.nameZA': 'ชื่อ Z–A',
  'pages.files.cleanupButton': 'ล้างข้อมูล',
  'pages.files.selectButton': 'เลือก',
  'pages.files.addGroupTitle': 'เพิ่มกลุ่ม',
  'pages.files.editGroupTitle': 'แก้ไขกลุ่ม',
  'pages.files.groupType.privateGroup': 'กลุ่มส่วนตัว',
  'pages.files.groupType.firmWide': 'ทั่วทั้งบริษัท',
  'pages.files.groupType.public': 'สาธารณะ',
  'pages.files.selectGroupTypeRequired': 'กรุณาเลือกประเภทกลุ่ม',
  'pages.files.groupNameRequired': 'กรุณาระบุชื่อกลุ่ม',
  'pages.files.groupNameTaken': 'มีกลุ่มที่ใช้ชื่อนี้อยู่แล้ว',
  'pages.files.addPersonPlaceholder': 'เพิ่มบุคคล',
  'pages.files.noMembersYet': 'ยังไม่มีสมาชิก',
  'pages.files.memberColumn': 'สมาชิก',
  'pages.files.roleColumn': 'บทบาท',
  'pages.files.roleOwner': 'เจ้าของ',
  'pages.files.roleMember': 'สมาชิก',
  'pages.files.revisionHistoryTitle': 'ประวัติการแก้ไข',
  'pages.files.renamedTo': ' เป็น ',
  'pages.files.noFieldValue': 'ไม่มี {field}',
  'pages.files.chatWithGroupTooltip': 'แชทกับกลุ่มนี้',
  'pages.files.searchFilesPlaceholder': 'ค้นหาไฟล์...',
  'pages.files.historyTitle': 'ประวัติ',
  'pages.files.addNewButton': 'เพิ่มใหม่',
  'pages.files.homeButton': 'หน้าแรก',
  'pages.files.selectFolderPlaceholder': 'เลือกโฟลเดอร์',
  'pages.files.moveMultipleFilesTitle': 'ย้าย {count} ไฟล์',
  'pages.files.moveSingleFileTitle': 'ย้าย "{name}"',
  'pages.files.addAtLeastOneMember': 'กรุณาเพิ่มสมาชิกอย่างน้อยหนึ่งคน',
  'pages.files.selectAtLeastOneOwner': 'กรุณาเลือกเจ้าของอย่างน้อยหนึ่งคน',
  'pages.files.folderWarning.privateGroup': 'ปลอดภัยน้อยลง: มองเห็นได้โดยกลุ่มของคุณ',
  'pages.files.folderWarning.firmWide': 'ไม่ปลอดภัยอย่างมาก: มองเห็นได้โดยทั้งบริษัทของคุณ',
  'pages.files.folderWarning.public': 'ไม่ปลอดภัยอย่างมาก: มองเห็นได้โดยทุกคน',
  'pages.files.duplicateFileNameError': 'ชื่อไฟล์ซ้ำ กรุณาเปลี่ยนชื่อไฟล์',
  'pages.files.failedToUpdate': 'อัปเดตไม่สำเร็จ',
  'pages.files.filesDeletedCount': 'ลบไฟล์แล้ว {count} ไฟล์',
  'pages.files.filesMovedCount': 'ย้ายไฟล์แล้ว {count} ไฟล์',
  'pages.files.failedToDeleteCount': 'ลบไฟล์ไม่สำเร็จ {count} ไฟล์',
  'pages.files.failedToMoveCount': 'ย้ายไฟล์ไม่สำเร็จ {count} ไฟล์',
  'pages.files.failedToDeleteFiles': 'ลบไฟล์ไม่สำเร็จ',
  'pages.files.failedToMoveFiles': 'ย้ายไฟล์ไม่สำเร็จ',
  'pages.files.unnamedFile': 'ไม่มีชื่อ',
  'pages.files.failedToUploadFile': 'อัปโหลด {fileName} ไม่สำเร็จ',
  'pages.files.failedToCreateFolder': 'สร้างโฟลเดอร์ไม่สำเร็จ: {folderName}',
  'pages.files.uploadingFolderEllipsis': 'กำลังอัปโหลดโฟลเดอร์...',
  'pages.files.folderUploadFailed': 'อัปโหลดโฟลเดอร์ไม่สำเร็จ',
  'pages.library.functionOption.summarise': 'สรุป',
  'pages.library.functionOption.review': 'ตรวจสอบ',
  'pages.library.functionOption.amend': 'แก้ไขเพิ่มเติม',
  'pages.library.functionOption.redFlagging': 'การระบุจุดเสี่ยง',
  'pages.library.functionOption.promptlet': 'Promptlet',
  'pages.library.visibilityOption.personal': 'ส่วนตัว',
  'pages.library.visibilityOption.group': 'กลุ่ม',
  'pages.library.visibilityOption.firmWide': 'ทั่วทั้งบริษัท',
  'pages.library.visibilityOption.public': 'สาธารณะ',
  'pages.library.updateSuccess': 'อัปเดตสำเร็จ',
  'pages.library.updateFailed': 'อัปเดตไม่สำเร็จ',
  'pages.library.copySuccess': 'คัดลอกพรอมต์ไปยังคลิปบอร์ดแล้ว!',
  'pages.library.copyFailed': 'คัดลอกพรอมต์ไม่สำเร็จ',
  'pages.library.selfInstruction': 'การกำหนดคำสั่งเอง',
  'pages.library.pendingApproval': 'รอการอนุมัติ',
  'pages.library.publishPromptModalTitle': 'เผยแพร่พรอมต์',
  'pages.library.publishButton': 'เผยแพร่',
  'pages.library.publishSuccess': 'เผยแพร่พรอมต์สำเร็จ',
  'pages.library.publishFailedDefault': 'ส่งคำขอเผยแพร่ไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
  'pages.library.field.visibility': 'การมองเห็น',
  'pages.library.cloneButton': 'โคลน',
  'pages.library.chatWithPromptButton': 'แชทกับพรอมต์นี้',
  'pages.library.enterPromptNamePlaceholder': 'กรอกชื่อพรอมต์',
  'pages.library.field.purpose': 'วัตถุประสงค์',
  'pages.library.enterPurposePlaceholder': 'กรอกวัตถุประสงค์',
  'pages.library.field.notes': 'หมายเหตุ',
  'pages.library.enterNotesPlaceholder': 'กรอกหมายเหตุ',
  'pages.library.field.author': 'ผู้เขียน',
  'pages.library.allowSelfInstruction': 'อนุญาตให้กำหนดคำสั่งเอง',
  'pages.library.attachedDocuments': 'เอกสารที่แนบ',
  'pages.library.documentsCount': '{count} เอกสาร',
  'pages.library.field.prompt': 'พรอมต์',
  'pages.library.enterPromptContentPlaceholder': 'กรอกเนื้อหาพรอมต์',
  'pages.library.noPromptsSelected': 'ไม่ได้เลือกพรอมต์',
  'pages.library.promptClonedSuccess': 'โคลนพรอมต์สำเร็จ',
  'pages.library.cloneAuthorLabel': 'ผู้เขียน: {author}',
  'pages.library.cloneAudienceLabel': 'กลุ่มเป้าหมาย: {visibility}',
  'pages.library.undoChangesButton': 'ยกเลิกการเปลี่ยนแปลง',
  'pages.library.saveChangesButton': 'บันทึกการเปลี่ยนแปลง',
  'pages.library.unsavedChangesTitle': 'การเปลี่ยนแปลงที่ยังไม่ได้บันทึก',
  'pages.library.exitModifyButton': 'ออกจากการแก้ไข',
  'pages.library.field.tags': 'แท็ก',
  'pages.library.title': 'คลังพรอมต์',
  'pages.library.exitCompareButton': 'ออกจากการเปรียบเทียบ',
  'pages.library.compareButton': 'เปรียบเทียบ',
  'pages.library.addPromptModalTitle': 'เพิ่มพรอมต์',
  'pages.library.addButton': 'เพิ่ม +',
  'pages.library.tagsPlaceholder': 'รายการแท็ก',
  'pages.library.filterByFunctionPlaceholder': 'กรองตามฟังก์ชัน',
  'pages.library.filterByAudiencePlaceholder': 'กรองตามกลุ่มเป้าหมาย',
  'pages.library.searchPlaceholder': 'ค้นหาพรอมต์และแท็ก',
  'pages.library.favoriteOnly': 'รายการโปรดเท่านั้น',
  'pages.library.filterByLabel': 'กรองตาม:',
  'pages.library.compareSelectHint': 'เลือกพรอมต์สองหรือสามรายการที่ต้องการเปรียบเทียบ',
  'pages.library.untitledPrompt': 'พรอมต์ไม่มีชื่อ',
  'pages.library.compareLimitWarning': 'คุณสามารถเปรียบเทียบได้สูงสุด 3 พรอมต์',
  'pages.library.copyPromptButton': 'คัดลอกพรอมต์',
  'pages.organisation.idColumnTitle': 'รหัส',
  'pages.organisation.untitledOrganisationFallback': 'องค์กรไม่มีชื่อ',
  'pages.organisation.userLimitLabel': 'ขีดจำกัดผู้ใช้',
  'pages.organisation.userLimitUnlimitedCount': '{count} / ไม่จำกัด',
  'pages.organisation.userLimitUnlimited': 'ไม่จำกัด',
  'pages.organisation.userLimitOnly': 'ขีดจำกัด: {limit}',
  'pages.organisation.msTenantIdsLabel': 'รหัส MS Tenant',
  'pages.organisation.organisationsTableHeaderTitle': 'องค์กร',
  'pages.organisation.createOrganisationLabel': 'สร้างองค์กร',
  'pages.organisation.usersTableHeaderTitle': 'ผู้ใช้ของ {orgName}',
  'pages.organisation.defaultOrganisationName': 'องค์กร',
  'pages.organisation.userLimitReachedTooltip': 'ถึงขีดจำกัดผู้ใช้แล้ว',
  'pages.organisation.addUserButtonLabel': 'เพิ่มผู้ใช้',
  'pages.organisation.usernameColumnTitle': 'ชื่อผู้ใช้',
  'pages.organisation.emailColumnTitle': 'อีเมล',
  'pages.organisation.roleLabel': 'บทบาท',
  'pages.organisation.defaultUserRoleLabel': 'ผู้ใช้',
  'pages.organisation.changeRoleButtonLabel': 'เปลี่ยนบทบาท',
  'pages.organisation.removeUserConfirmTitle': 'ต้องการลบผู้ใช้ออกจากองค์กรใช่หรือไม่',
  'pages.organisation.userRemovedSuccessMessage': 'ลบผู้ใช้แล้ว',
  'pages.organisation.unableToRemoveUserErrorMessage': 'ไม่สามารถลบผู้ใช้ได้',
  'pages.organisation.editOrganisationModalTitle': 'แก้ไของค์กร',
  'pages.organisation.organisationUpdatedSuccessMessage': 'อัปเดตองค์กรสำเร็จ',
  'pages.organisation.organisationCreatedSuccessMessage': 'สร้างองค์กรสำเร็จ',
  'pages.organisation.organisationNameRequiredMessage': 'กรุณากรอกชื่อองค์กร',
  'pages.organisation.organisationNameLabel': 'ชื่อองค์กร',
  'pages.organisation.userLimitTooltip': 'จำนวนผู้ใช้สูงสุดที่อนุญาต เว้นว่างไว้เพื่อไม่จำกัดจำนวน',
  'pages.organisation.userEmailLabel': 'อีเมลผู้ใช้',
  'pages.organisation.userEmailPlaceholder': 'user@company.com',
  'pages.organisation.emailRequiredMessage': 'กรุณากรอกอีเมล',
  'pages.organisation.roleRequiredMessage': 'กรุณาเลือกบทบาท',
  'pages.organisation.userAddedSuccessMessage': 'เพิ่มผู้ใช้แล้ว',
  'pages.organisation.unableToAddUserErrorMessage': 'ไม่สามารถเพิ่มผู้ใช้ได้',
  'pages.organisation.roleUpdatedSuccessMessage': 'อัปเดตบทบาทแล้ว',
  'pages.organisation.unableToUpdateRoleErrorMessage': 'ไม่สามารถอัปเดตบทบาทได้',
  'pages.organisation.unableToLoadRolesErrorMessage': 'ไม่สามารถโหลดบทบาทได้',
  'pages.playbook.header.title': 'Workstudio',
  'pages.playbook.emptyState.title': 'พร้อมเมื่อคุณพร้อมแล้ว',
  'pages.playbook.checkingDocument': 'กำลังตรวจสอบเอกสาร...',
  'pages.playbook.updatingReviewCanvas': 'กำลังอัปเดตพื้นที่ตรวจสอบ...',
  'pages.playbook.inputPlaceholder': 'บอก A&GEL ว่าต้องการแก้ไขอะไร...',
  'pages.playbook.inputAriaLabel': 'คำสั่ง Workstudio',
  'pages.playbook.contextButton': 'บริบท',
  'pages.playbook.sendButtonAriaLabel': 'ส่งคำสั่ง Workstudio',
  'pages.playbook.sendInstructionError': 'ส่งคำสั่ง Workstudio ไม่สำเร็จ',
  'pages.projectsHub.func.chat': 'แชท',
  'pages.projectsHub.func.scribe': 'จดบันทึก',
  'pages.projectsHub.func.apps': 'แอป',
  'pages.projectsHub.func.review': 'ตรวจสอบ',
  'pages.projectsHub.func.sideBySide': 'เปรียบเทียบแบบเคียงข้าง',
  'pages.projectsHub.func.comparison': 'การเปรียบเทียบ',
  'pages.projectsHub.func.translation': 'การแปล',
  'pages.projectsHub.func.template': 'ผลลัพธ์ที่กำหนดเอง',
  'pages.projectsHub.func.quote': 'ใบเสนอราคา',
  'pages.projectsHub.untitledSession': 'ไม่มีชื่อ',
  'pages.projectsHub.untitledFileLabel': '(ไม่มีชื่อ)',
  'pages.projectsHub.errors.loadDataFailed': 'โหลดข้อมูลไม่สำเร็จ',
  'pages.projectsHub.subfolderCreated': 'สร้างโฟลเดอร์ย่อยแล้ว',
  'pages.projectsHub.collectionCreated': 'สร้างคอลเลกชันแล้ว',
  'pages.projectsHub.errors.createFailed': 'สร้างไม่สำเร็จ',
  'pages.projectsHub.errors.updateFailed': 'อัปเดตไม่สำเร็จ',
  'pages.projectsHub.deleteCollectionConfirm.title': 'ลบคอลเลกชัน',
  'pages.projectsHub.deleteCollectionConfirm.content': 'ลบ "{name}" ใช่หรือไม่',
  'pages.projectsHub.collectionDeleted': 'ลบแล้ว',
  'pages.projectsHub.errors.deleteFailed': 'ไม่สำเร็จ',
  'pages.projectsHub.sessionsAdded': 'เพิ่ม {count} เซสชันแล้ว',
  'pages.projectsHub.errors.addSessionsFailed': 'เพิ่มไม่สำเร็จ',
  'pages.projectsHub.sessionRemoved': 'นำเซสชันออกแล้ว',
  'pages.projectsHub.errors.removeSessionFailed': 'นำเซสชันออกไม่สำเร็จ',
  'pages.projectsHub.sessionsRemoved': 'นำ {count} เซสชันออกแล้ว',
  'pages.projectsHub.errors.removeSessionsFailed': 'นำเซสชันออกไม่สำเร็จ',
  'pages.projectsHub.fieldSaved': 'บันทึกแล้ว',
  'pages.projectsHub.errors.saveFieldFailed': 'บันทึกไม่สำเร็จ',
  'pages.projectsHub.folderDeleted': 'ลบโฟลเดอร์แล้ว',
  'pages.projectsHub.errors.deleteFolderFailed': 'ลบโฟลเดอร์ไม่สำเร็จ',
  'pages.projectsHub.folderCreated': 'สร้างโฟลเดอร์แล้ว',
  'pages.projectsHub.errors.createFolderFailed': 'สร้างโฟลเดอร์ไม่สำเร็จ',
  'pages.projectsHub.deleteFolderConfirm.description': 'ลบ "{name}" พร้อมเนื้อหาทั้งหมดใช่หรือไม่',
  'pages.projectsHub.deleteSessionsConfirm.title': 'ลบเซสชัน',
  'pages.projectsHub.removeSessionConfirm.title': 'นำเซสชันออก',
  'pages.projectsHub.removeSessionConfirm.description': 'นำ "{name}" ออกจากคอลเลกชันนี้ใช่หรือไม่',
  'pages.projectsHub.sort.newestFirst': 'ใหม่สุดก่อน',
  'pages.projectsHub.sort.oldestFirst': 'เก่าสุดก่อน',
  'pages.projectsHub.sort.nameAsc': 'ชื่อ (A-Z)',
  'pages.projectsHub.sort.nameDesc': 'ชื่อ (Z-A)',
  'pages.projectsHub.doubleClickToOpen': 'ดับเบิลคลิกเพื่อเปิด',
  'pages.projectsHub.tidyUp': 'จัดระเบียบ',
  'pages.projectsHub.exit': 'ออก',
  'pages.projectsHub.manage': 'จัดการ',
  'pages.projectsHub.deleteSessionsButton': 'ลบ ({count})',
  'pages.projectsHub.searchSessionsPlaceholder': 'ค้นหาเซสชัน',
  'pages.projectsHub.emptyState.noFiles': 'ไม่มีไฟล์',
  'pages.projectsHub.newFolderButton': 'โฟลเดอร์ใหม่',
  'pages.projectsHub.addSessionsButton': 'เพิ่มเซสชัน',
  'pages.projectsHub.folderInfoLabel': 'ข้อมูลโฟลเดอร์',
  'pages.projectsHub.mattersHeading': 'เรื่อง',
  'pages.projectsHub.hubBreadcrumbLabel': 'ฮับ',
  'pages.projectsHub.deleteFolderButton': 'ลบโฟลเดอร์',
  'pages.projectsHub.itemsLabel': 'รายการ',
  'pages.projectsHub.selectSubfolderEmptyState': 'เลือกโฟลเดอร์ย่อยเพื่อดูรายละเอียด',
  'pages.projectsHub.selectFolderEmptyState': 'เลือกโฟลเดอร์เพื่อดูรายละเอียด',
  'pages.projectsHub.noCollectionsMatch': 'ไม่มีคอลเลกชันที่ตรงกับตัวกรองปัจจุบัน',
  'pages.projectsHub.noSessionsFoundForFunction': 'ไม่พบเซสชัน {func}',
  'pages.projectsHub.step1ChooseFunctionType': 'ขั้นตอนที่ 1 — เลือกประเภทฟังก์ชัน',
  'pages.projectsHub.selectFunctionPlaceholder': 'เลือกฟังก์ชัน',
  'pages.projectsHub.step2SelectSessions': 'ขั้นตอนที่ 2 — เลือกเซสชันที่จะเพิ่ม',
  'pages.projectsHub.createFolderButton': 'สร้างโฟลเดอร์',
  'pages.projectsHub.folderNameLabel': 'ชื่อโฟลเดอร์',
  'pages.projectsHub.subfolderNamePlaceholder': 'เช่น Due Diligence',
  'pages.projectsHub.collectionNamePlaceholder': 'เช่น M&A Due Diligence',
  'pages.projectsHub.optionalDescriptionPlaceholder': 'คำอธิบาย (ไม่บังคับ)',
  'pages.projectsHub.optionalNotesPlaceholder': 'หมายเหตุ (ไม่บังคับ)',
  'pages.projectsHub.createCollectionModalTitle': 'สร้างคอลเลกชัน',
  'pages.projectsHub.collectionNameLabel': 'ชื่อคอลเลกชัน',
  'pages.projectsHub.editCollectionModalTitle': 'แก้ไข • {name}',
  'pages.projectsHub.itemCountLabel': '{count, plural, one {# รายการ} other {# รายการ}}',
  'pages.projectsHub.fileCountLabel': '{count, plural, one {# ไฟล์} other {# ไฟล์}}',
  'pages.quote.historyTooltip': 'ประวัติ (Tab+H)',
  'pages.quote.hideTooltip': 'ซ่อน (Tab+H)',
  'pages.quote.newQuoteTooltip': 'ใบเสนอราคาใหม่ (Tab+N)',
  'pages.quote.untitled': '(ไม่มีชื่อ)',
  'pages.quote.newQuote': 'ใบเสนอราคาใหม่',
  'pages.quote.deletedExample': 'ลบตัวอย่างแล้ว',
  'pages.quote.generateDescription': 'สร้างใบเสนอราคาโดยอิงจากเทมเพลตและข้อเท็จจริงของคุณ',
  'pages.quote.sizeLabel': 'ขนาด',
  'pages.quote.sizeShort': 'สั้น',
  'pages.quote.sizeMedium': 'ปานกลาง',
  'pages.quote.sizeLong': 'ยาว',
  'pages.quote.examplesLabel': 'ตัวอย่าง',
  'pages.quote.promptLabel': 'พรอมต์',
  'pages.quote.examplesTitle': 'ตัวอย่าง',
  'pages.quote.quoteTitle': 'ใบเสนอราคา',
  'pages.quote.uploadManageExamples': 'อัปโหลด / จัดการตัวอย่าง',
  'pages.quote.generateQuoteSubtitle': 'สร้างใบเสนอราคา',
  'pages.quote.fileLabel': 'ไฟล์',
  'pages.quote.deleteConfirmTitle': 'ยืนยันการลบตัวอย่างต่อไปนี้ใช่หรือไม่',
  'pages.review.addAtLeastOneQuestion': 'กรุณาเพิ่มคำถามอย่างน้อยหนึ่งข้อก่อนส่ง',
  'pages.review.addAtLeastOneQuestionFirst': 'กรุณาเพิ่มคำถามอย่างน้อยหนึ่งข้อก่อน',
  'pages.review.addAtLeastOneQuestionRule': 'กรุณาเพิ่มคำถามอย่างน้อยหนึ่งข้อ',
  'pages.review.addQuestionButton': 'คำถาม',
  'pages.review.addSectionButton': 'ส่วน',
  'pages.review.addToMatters': 'เพิ่มไปยังเรื่อง',
  'pages.review.adhocModifyMode': 'แก้ไขเฉพาะกิจ',
  'pages.review.audiencePlaceholder': 'ชื่อลูกค้าหรือกลุ่มเป้าหมาย',
  'pages.review.authorLabel': 'ผู้เขียน',
  'pages.review.categoryLabel': 'หมวดหมู่',
  'pages.review.cellDetailsDrawer.addCommentPlaceholder': 'เพิ่มความคิดเห็น...',
  'pages.review.cellDetailsDrawer.answer': 'คำตอบ',
  'pages.review.cellDetailsDrawer.comments': 'ความคิดเห็น',
  'pages.review.cellDetailsDrawer.commentsWithCount': 'ความคิดเห็น ({count})',
  'pages.review.cellDetailsDrawer.exactMatch': 'พบข้อความที่ตรงกันทุกประการในเอกสารต้นฉบับ',
  'pages.review.cellDetailsDrawer.explanation': 'คำอธิบาย',
  'pages.review.cellDetailsDrawer.fullReference': 'ข้อมูลอ้างอิงแบบเต็ม',
  'pages.review.cellDetailsDrawer.fuzzyMatch': 'พบข้อความที่ใกล้เคียงกันในเอกสารต้นฉบับ',
  'pages.review.cellDetailsDrawer.openDocument': 'เปิดเอกสาร',
  'pages.review.cellDetailsDrawer.openInSearch': 'เปิดในการค้นหา',
  'pages.review.cellDetailsDrawer.verified': 'ตรวจสอบแล้ว',
  'pages.review.cellDetailsDrawer.verify': 'ตรวจสอบ',
  'pages.review.cellMarkedUnverified': 'ทำเครื่องหมายเซลล์เป็นยังไม่ได้ตรวจสอบ',
  'pages.review.cellMarkedVerified': 'ทำเครื่องหมายเซลล์เป็นตรวจสอบแล้ว',
  'pages.review.cellUpdateFailed': 'อัปเดตเซลล์ไม่สำเร็จ',
  'pages.review.cellUpdatedSuccessfully': 'อัปเดตเซลล์สำเร็จ',
  'pages.review.cellVerificationUpdateFailed': 'อัปเดตสถานะการตรวจสอบเซลล์ไม่สำเร็จ',
  'pages.review.changesUndone': 'เลิกทำการเปลี่ยนแปลงแล้ว',
  'pages.review.chatWithEntireOutput': 'แชทกับผลลัพธ์ทั้งหมด',
  'pages.review.cloneButton': 'ทำสำเนา',
  'pages.review.clonedNamePrefix': 'สำเนา - {name}',
  'pages.review.columnEditModal.addTitle': 'เพิ่มเอกสารใหม่ (คอลัมน์)',
  'pages.review.columnEditModal.columnUpdated': 'เริ่มการอัปเดตคอลัมน์แล้ว คอลัมน์จะรีเฟรชในไม่ช้า',
  'pages.review.columnEditModal.columnsAdded': 'เพิ่มคอลัมน์ใหม่แล้ว เมทริกซ์จะรีเฟรชในไม่ช้า',
  'pages.review.columnEditModal.dropToUpload': 'วางไฟล์ที่นี่เพื่ออัปโหลด',
  'pages.review.columnEditModal.fileRequired': 'กรุณาอัปโหลดหรือเลือกไฟล์สำหรับคอลัมน์นี้',
  'pages.review.columnEditModal.filesRequiredValidation': 'กรุณาอัปโหลดไฟล์หรือเลือกไฟล์ที่มีอยู่',
  'pages.review.columnEditModal.updateFailed': 'อัปเดตคอลัมน์ไม่สำเร็จ',
  'pages.review.columnEditModal.updateTitle': 'เอกสารใหม่สำหรับคอลัมน์นี้',
  'pages.review.createQuestionListButton': 'สร้างรายการคำถาม',
  'pages.review.createdByYou': 'คุณ',
  'pages.review.customInstruction': 'คำสั่งที่กำหนดเอง',
  'pages.review.customInstructionOptional': 'คำสั่งที่กำหนดเอง (ไม่บังคับ)',
  'pages.review.deleteQuestionListConfirm': 'ยืนยันการลบรายการคำถามนี้ใช่หรือไม่',
  'pages.review.downloadExcel': 'Excel (.xlsx)',
  'pages.review.downloadWord': 'Word (.docx)',
  'pages.review.dragHereToUpload': 'ลากไฟล์มาวางที่นี่เพื่ออัปโหลด',
  'pages.review.exitButton': 'ออก',
  'pages.review.exitClone': 'ออกจากการโคลน',
  'pages.review.exitCreate': 'ออกจากการสร้าง',
  'pages.review.exitModify': 'ออกจากการแก้ไข',
  'pages.review.fileCount': '{count} ไฟล์',
  'pages.review.mattersUpdateFailed': 'ไม่สามารถอัปเดตเรื่องได้',
  'pages.review.mattersUpdated': 'อัปเดตเรื่องสำเร็จ',
  'pages.review.modifyButton': 'แก้ไข',
  'pages.review.newCategoryPlaceholder': 'หมวดหมู่ใหม่',
  'pages.review.newQuestionListDefaultName': 'รายการคำถามตรวจสอบใหม่',
  'pages.review.noEmailOnFile': 'ไม่มีอีเมลในระบบ',
  'pages.review.noNotesAvailable': 'ไม่มีบันทึกย่อ',
  'pages.review.noPrivateGroupsFound': 'ไม่พบกลุ่มส่วนตัว',
  'pages.review.noPurposeAvailable': 'ไม่มีวัตถุประสงค์',
  'pages.review.noQuestionsYet': 'ยังไม่มีคำถาม',
  'pages.review.notesLabel': 'บันทึกย่อ',
  'pages.review.pendingApproval': 'รอการอนุมัติ',
  'pages.review.pollingTimeout': 'หมดเวลาการตรวจสอบสถานะ การตรวจสอบอาจยังคงดำเนินการอยู่',
  'pages.review.publishButton': 'เผยแพร่',
  'pages.review.publishFailed': 'ไม่สามารถเผยแพร่รายการคำถามได้',
  'pages.review.publishTargetFirm': 'ทั้งสำนักงาน',
  'pages.review.publishToLabel': 'เผยแพร่ไปยัง:',
  'pages.review.publishedAccess.firm': 'สำนักงาน',
  'pages.review.publishedAccess.privateGroup': 'กลุ่มส่วนตัว',
  'pages.review.publishedAccess.public': 'สาธารณะ',
  'pages.review.publishedToLabel': 'เผยแพร่ไปยัง {access}',
  'pages.review.publishedToPrivateGroup': 'เผยแพร่รายการคำถามไปยังกลุ่มส่วนตัวแล้ว',
  'pages.review.publishedToPrivateGroups': 'เผยแพร่รายการคำถามไปยังกลุ่มส่วนตัวแล้ว',
  'pages.review.purposeLabel': 'วัตถุประสงค์',
  'pages.review.questionListCloned': 'โคลนรายการคำถามสำเร็จ',
  'pages.review.questionListCreated': 'สร้างรายการคำถามสำเร็จ',
  'pages.review.questionListDeleted': 'ลบรายการคำถามสำเร็จ',
  'pages.review.questionListImporter.allColumns': 'ทุกคอลัมน์ (รวมทุกเซลล์เข้าด้วยกัน)',
  'pages.review.questionListImporter.checklistText': 'ข้อความรายการตรวจสอบ',
  'pages.review.questionListImporter.columnOption': 'คอลัมน์ {index} - {label}',
  'pages.review.questionListImporter.couldNotParse': 'ไม่สามารถแยกวิเคราะห์รายการตรวจสอบได้',
  'pages.review.questionListImporter.couldNotReadFile': 'ไม่สามารถอ่านไฟล์ {fileName} ได้',
  'pages.review.questionListImporter.docxColumn': 'คอลัมน์ DOCX',
  'pages.review.questionListImporter.dropZoneText': 'คลิกหรือลากรายการตรวจสอบมาที่บริเวณนี้',
  'pages.review.questionListImporter.granularityEveryLine': 'ทุกบรรทัดเป็นหนึ่งคำถาม',
  'pages.review.questionListImporter.granularityLevel2': 'ลงถึงระดับ 2',
  'pages.review.questionListImporter.granularityLevel3': 'ลงถึงระดับ 3',
  'pages.review.questionListImporter.granularityLevel4': 'ลงถึงระดับ 4',
  'pages.review.questionListImporter.granularityLevel5': 'ลงถึงระดับ 5',
  'pages.review.questionListImporter.granularityTopLevel': 'ระดับบนสุดเท่านั้น',
  'pages.review.questionListImporter.groupByLevel': 'จัดกลุ่มคำถามตามระดับ',
  'pages.review.questionListImporter.importQuestions': 'นำเข้าคำถาม',
  'pages.review.questionListImporter.importQuestionsAction': 'นำเข้าคำถาม',
  'pages.review.questionListImporter.loadedFile': 'โหลดไฟล์ {fileName} แล้ว',
  'pages.review.questionListImporter.noQuestionsDetected': 'ไม่พบคำถามในรายการตรวจสอบ',
  'pages.review.questionListImporter.noQuestionsSelected': 'ไม่ได้เลือกคำถามสำหรับนำเข้า',
  'pages.review.questionListImporter.previewQuestions': 'ดูตัวอย่างคำถาม',
  'pages.review.questionListImporter.questionGranularity': 'ระดับความละเอียดของคำถาม',
  'pages.review.questionListImporter.questionsReadyCount': 'พร้อม {count} คำถาม',
  'pages.review.questionListImporter.readingChecklist': 'กำลังอ่านรายการตรวจสอบ...',
  'pages.review.questionListImporter.removeFile': 'ลบไฟล์',
  'pages.review.questionListImporter.removeQuestion': 'ลบคำถามที่ {number}',
  'pages.review.questionListImporter.removeQuestionsHint': 'ลบคำถามใด ๆ ที่คุณไม่ต้องการนำเข้า',
  'pages.review.questionListImporter.reviewQuestions': 'ตรวจสอบคำถาม',
  'pages.review.questionListNamePlaceholder': 'ชื่อรายการคำถามตรวจสอบ',
  'pages.review.questionListUpdated': 'อัปเดตรายการคำถามสำเร็จ',
  'pages.review.questionNamePlaceholder': 'คำถาม',
  'pages.review.questionRow.dragToReorder': 'ลากเพื่อจัดลำดับใหม่',
  'pages.review.questionRow.moveDown': 'เลื่อนลง',
  'pages.review.questionRow.moveUp': 'เลื่อนขึ้น',
  'pages.review.questionRow.rowType': 'ประเภทแถว',
  'pages.review.questionsList': 'รายการคำถาม',
  'pages.review.quickQuestionsHeading': 'คำถามด่วน',
  'pages.review.rejected': 'ปฏิเสธแล้ว',
  'pages.review.resizeHint': 'ลากขอบเพื่อปรับขนาด',
  'pages.review.restoreConfigFailed': 'ไม่สามารถกู้คืนการตั้งค่าได้ กรุณาลองใหม่อีกครั้ง',
  'pages.review.resultPanel.processing': 'กำลังประมวลผล',
  'pages.review.resultPanel.stopped': 'หยุดการประมวลผลแล้ว',
  'pages.review.reuseButton': 'ใช้ซ้ำ',
  'pages.review.rowEditModal.addTitle': 'เพิ่มคำถามใหม่ (แถว)',
  'pages.review.rowEditModal.promptLabel': 'พรอมป์',
  'pages.review.rowEditModal.promptRequired': 'กรุณากรอกพรอมป์',
  'pages.review.rowEditModal.rowAdded': 'เพิ่มแถวใหม่แล้ว เมทริกซ์จะรีเฟรชในอีกสักครู่',
  'pages.review.rowEditModal.rowUpdated': 'เริ่มอัปเดตแถวแล้ว แถวจะรีเฟรชในอีกสักครู่',
  'pages.review.rowEditModal.updateFailed': 'ไม่สามารถอัปเดตแถวได้',
  'pages.review.rowEditModal.updateTitle': 'อัปเดตพรอมป์คำถาม',
  'pages.review.saveAsButton': 'บันทึกเป็น',
  'pages.review.saveChangesButton': 'บันทึกการเปลี่ยนแปลง',
  'pages.review.searchMattersPlaceholder': 'ค้นหาเรื่อง...',
  'pages.review.sectionNamePlaceholder': 'หัวข้อส่วน',
  'pages.review.selectCellHint': 'คลิกเซลล์ แถว หรือคอลัมน์เพื่อเลือก',
  'pages.review.selectDocumentsToReview': 'เลือกเอกสารที่คุณต้องการตรวจสอบ',
  'pages.review.selectDocumentsToReviewNumbered': '2. เลือกเอกสารที่คุณต้องการตรวจสอบ',
  'pages.review.selectMatters': 'เลือกเรื่อง:',
  'pages.review.selectPrivateGroupsHint': 'เลือกกลุ่มส่วนตัวหนึ่งกลุ่มหรือมากกว่าเพื่อแชร์ด้วย:',
  'pages.review.selectPrivateGroupsPlaceholder': 'เลือกกลุ่มส่วนตัว',
  'pages.review.sentForApproval': 'ส่งรายการคำถามเพื่อขออนุมัติแล้ว',
  'pages.review.sentimentLegendPrefix': 'คำอธิบาย: ความรู้สึกของ AI:',
  'pages.review.sentimentNegative': 'เชิงลบ',
  'pages.review.sentimentPositive': 'เชิงบวก',
  'pages.review.showAll': 'แสดงทั้งหมด',
  'pages.review.startNewReview': 'เริ่มการตรวจสอบใหม่',
  'pages.review.stayButton': 'อยู่ต่อ',
  'pages.review.submitReviewFailed': 'ไม่สามารถส่งการตรวจสอบได้',
  'pages.review.systemPromptLabel': 'พรอมป์ระบบ',
  'pages.review.tabs.customiseOptional': 'ปรับแต่ง (ไม่บังคับ)',
  'pages.review.tabs.prompts': 'พรอมป์',
  'pages.review.tabs.selectDocuments': 'เลือกเอกสาร',
  'pages.review.tabs.startHere': 'เริ่มที่นี่',
  'pages.review.typeHerePlaceholder': 'พิมพ์ที่นี่...',
  'pages.review.undoChangesButton': 'เลิกทำการเปลี่ยนแปลง',
  'pages.review.unsavedChangesWillBeLost': 'การเปลี่ยนแปลงที่ยังไม่ได้บันทึกจะสูญหาย',
  'pages.review.untitledSession': '(ไม่มีชื่อ)',
  'pages.review.updateFailed': 'ไม่สามารถอัปเดตได้',
  'pages.review.viewMode': 'ดู',
  'pages.review.whoIsItFor': 'เหมาะสำหรับใคร?',
  'pages.review.whoIsItForNumbered': '1. เหมาะสำหรับใคร?',
  'pages.scribe.addToMatters': 'เพิ่มไปยังเรื่อง',
  'pages.scribe.aiWorking': 'AI กำลังทำงาน...',
  'pages.scribe.appDescription': 'ถอดเสียงไฟล์เสียงหรือการบันทึกเป็นข้อความที่มีโครงสร้าง',
  'pages.scribe.audioUploadSuccess': 'อัปโหลดไฟล์เสียงสำเร็จ',
  'pages.scribe.autoDetect': 'ตรวจจับอัตโนมัติ',
  'pages.scribe.autoGenerateFailed': 'ไม่สามารถสร้างผลลัพธ์ที่เลือกโดยอัตโนมัติได้',
  'pages.scribe.autoRecordingName': 'การบันทึก {timestamp}',
  'pages.scribe.autoSavedNote': 'บันทึกอัตโนมัติเมื่อ {relative} ({time})',
  'pages.scribe.convertingEllipsis': 'กำลังแปลง...',
  'pages.scribe.customLanguageFallback': 'กำหนดเอง',
  'pages.scribe.deleteConfirm.content': 'คุณแน่ใจหรือไม่ว่าต้องการลบข้อความถอดเสียงนี้?',
  'pages.scribe.deleteConfirm.title': 'ลบข้อความถอดเสียง',
  'pages.scribe.deleteTranscriptFailed': 'ไม่สามารถลบข้อความถอดเสียงได้',
  'pages.scribe.discardChangesConfirm.cancelText': 'แก้ไขต่อ',
  'pages.scribe.discardChangesConfirm.okText': 'ยกเลิกการแก้ไข',
  'pages.scribe.discardChangesConfirm.title': 'ยกเลิกการเปลี่ยนแปลงหรือไม่?',
  'pages.scribe.downloadAudio': 'ดาวน์โหลดไฟล์เสียง',
  'pages.scribe.downloadFailed': 'ดาวน์โหลดไม่สำเร็จ',
  'pages.scribe.downloadScript': 'ดาวน์โหลดข้อความถอดเสียง',
  'pages.scribe.downloadStarted': 'เริ่มการดาวน์โหลดแล้ว',
  'pages.scribe.downloadingAudio': 'กำลังดาวน์โหลดไฟล์เสียง...',
  'pages.scribe.enterTranscriptNamePlaceholder': 'กรอกชื่อข้อความถอดเสียง',
  'pages.scribe.errors.authTokenFailed': 'ไม่สามารถรับโทเคนยืนยันตัวตนได้',
  'pages.scribe.errors.startRecordingFailed': 'ไม่สามารถเริ่มการบันทึกได้',
  'pages.scribe.exitRecordingConfirm.cancelText': 'บันทึกต่อ',
  'pages.scribe.exitRecordingConfirm.content': 'ข้อความถอดเสียงจะไม่ถูกบันทึก',
  'pages.scribe.exitRecordingConfirm.okText': 'ออกจากการบันทึก',
  'pages.scribe.exitRecordingConfirm.title': 'ออกจากการบันทึกหรือไม่?',
  'pages.scribe.fastForward10': 'กรอไปข้างหน้า 10 วินาที',
  'pages.scribe.fileUploadFailed': 'อัปโหลดไฟล์ {fileName} ไม่สำเร็จ',
  'pages.scribe.fileUploadSuccess': 'อัปโหลดไฟล์สำเร็จ เริ่มการประมวลผลแล้ว',
  'pages.scribe.generateButton': 'สร้าง',
  'pages.scribe.generationFailedRetryText': 'การสร้างล้มเหลว กรุณาลองสร้างใหม่อีกครั้ง',
  'pages.scribe.generationStarted': 'เริ่มการสร้างแล้ว',
  'pages.scribe.historyButton': 'ประวัติ',
  'pages.scribe.homeButton': 'หน้าหลัก',
  'pages.scribe.initializingTranscription': 'กำลังเริ่มต้นการถอดเสียง...',
  'pages.scribe.interruptedModal.okText': 'ดูข้อความถอดเสียง',
  'pages.scribe.interruptedModal.title': 'การบันทึกเสียงถูกขัดจังหวะ',
  'pages.scribe.langGroup.custom': 'กำหนดเอง',
  'pages.scribe.langGroup.everythingElse': 'อื่นๆ ทั้งหมด',
  'pages.scribe.langGroup.otherOption': 'อื่นๆ…',
  'pages.scribe.langGroup.preferred': 'ที่ต้องการ',
  'pages.scribe.langGroup.seaEastAsian': 'เอเชียตะวันออกเฉียงใต้ + เอเชียตะวันออก',
  'pages.scribe.languageSelector.addLanguageButton': 'เพิ่มภาษา',
  'pages.scribe.languageSelector.customPlaceholder': 'พิมพ์ชื่อภาษา (เช่น มาเลย์)',
  'pages.scribe.liveTranslationLabel': 'การแปลแบบเรียลไทม์',
  'pages.scribe.loadingAudio': 'กำลังโหลดไฟล์เสียง...',
  'pages.scribe.mattersUpdatedSuccess': 'อัปเดตเรื่องสำเร็จ',
  'pages.scribe.modeNotGenerated': '{modeLabel} ยังไม่ได้ถูกสร้าง',
  'pages.scribe.nameYourTranscriptPlaceholder': 'ตั้งชื่อข้อความถอดเสียงของคุณ',
  'pages.scribe.newRecordingTitle': 'การบันทึกเสียงใหม่',
  'pages.scribe.newTranscript': 'ข้อความถอดเสียงใหม่',
  'pages.scribe.newTranscriptName': 'ข้อความถอดเสียงใหม่ {timestamp}',
  'pages.scribe.noAudioFileAvailable': 'ไม่มีไฟล์เสียง',
  'pages.scribe.noAudioForDownload': 'ไม่มีไฟล์เสียงให้ดาวน์โหลด',
  'pages.scribe.noContentAvailable': 'ไม่มีเนื้อหา กรุณาสร้างใหม่อีกครั้ง',
  'pages.scribe.noOutputsGenerated': 'ไม่มีผลลัพธ์ที่ถูกสร้างขึ้น',
  'pages.scribe.noRecentRecordings': 'ยังไม่มีการบันทึกเสียงล่าสุด',
  'pages.scribe.noSegmentsToEdit': 'ไม่มีส่วนของข้อความให้แก้ไข',
  'pages.scribe.noTimestampedSegments': 'ไม่มีส่วนของข้อความถอดเสียงที่มีการประทับเวลา',
  'pages.scribe.notAvailable': 'N/A',
  'pages.scribe.optionEmailDrafts': 'ร่างอีเมล',
  'pages.scribe.outputNotGeneratedYet': 'ผลลัพธ์นี้ยังไม่ได้ถูกสร้าง',
  'pages.scribe.outputViewer.actionItemsLabel': 'รายการดำเนินการ',
  'pages.scribe.outputViewer.addActionItemButton': 'เพิ่มรายการดำเนินการ',
  'pages.scribe.outputViewer.columnAction': 'การดำเนินการ',
  'pages.scribe.outputViewer.columnAssignee': 'ผู้รับผิดชอบ',
  'pages.scribe.outputViewer.columnDueDate': 'วันครบกำหนด',
  'pages.scribe.outputViewer.columnTask': 'งาน',
  'pages.scribe.outputViewer.commaSeparatedNamesPlaceholder': 'ชื่อคั่นด้วยจุลภาค',
  'pages.scribe.outputViewer.fieldBody': 'เนื้อหา',
  'pages.scribe.outputViewer.fieldCategory': 'หมวดหมู่',
  'pages.scribe.outputViewer.fieldCleanedTranscript': 'ข้อความถอดเสียงที่ปรับปรุงแล้ว',
  'pages.scribe.outputViewer.fieldExecutiveSummary': 'สรุปสำหรับผู้บริหาร',
  'pages.scribe.outputViewer.fieldGeneratedTitle': 'ชื่อเรื่องที่สร้างขึ้น',
  'pages.scribe.outputViewer.fieldKeyDecisions': 'การตัดสินใจสำคัญ',
  'pages.scribe.outputViewer.fieldNextMeeting': 'การประชุมครั้งถัดไป',
  'pages.scribe.outputViewer.fieldParticipants': 'ผู้เข้าร่วม',
  'pages.scribe.outputViewer.fieldRecipients': 'ผู้รับ',
  'pages.scribe.outputViewer.fieldSignatureBlock': 'ส่วนลายเซ็น',
  'pages.scribe.outputViewer.fieldSubject': 'หัวเรื่อง',
  'pages.scribe.outputViewer.fieldTopic': 'หัวข้อ',
  'pages.scribe.outputViewer.generatingContent': 'กำลังสร้างเนื้อหา...',
  'pages.scribe.outputViewer.generationFailed': 'การสร้างล้มเหลว',
  'pages.scribe.outputViewer.onePerLinePlaceholder': 'หนึ่งรายการต่อบรรทัด',
  'pages.scribe.outputViewer.pleaseCheckFields': 'กรุณาตรวจสอบข้อมูลในช่องกรอก',
  'pages.scribe.outputViewer.titleDefault': 'ผลลัพธ์',
  'pages.scribe.outputViewer.titleEmailDraft': 'ร่างอีเมล',
  'pages.scribe.outputViewer.titleMeetingNotes': 'บันทึกการประชุม',
  'pages.scribe.outputViewer.titleVoiceMemo': 'บันทึกเสียง',
  'pages.scribe.outputViewer.unknownOutputType': 'ไม่ทราบประเภทผลลัพธ์',
  'pages.scribe.pauseRecordingTitle': 'หยุดบันทึกชั่วคราว',
  'pages.scribe.recentRecordingsTitle': 'การบันทึกเสียงล่าสุด',
  'pages.scribe.recentlyTranscribed': 'ถอดเสียงล่าสุด',
  'pages.scribe.recordingPaused': 'หยุดบันทึกชั่วคราวแล้ว',
  'pages.scribe.recordingPausedInline': 'หยุดบันทึกชั่วคราว',
  'pages.scribe.regenerateButton': 'สร้างใหม่',
  'pages.scribe.resumeRecordingTitle': 'บันทึกต่อ',
  'pages.scribe.retranslatingSegments': 'กำลังแปลส่วนที่แก้ไขใหม่อีกครั้ง...',
  'pages.scribe.fillingMissingTranslations': 'กำลังแปลส่วนที่ขาดหายไป...',
  'pages.scribe.rewind10': 'ย้อนกลับ 10 วินาที',
  'pages.scribe.saveEditsFailed': 'บันทึกการแก้ไขข้อความถอดเสียงไม่สำเร็จ',
  'pages.scribe.saveFailed': 'บันทึกไม่สำเร็จ',
  'pages.scribe.saveTranscriptFailed': 'บันทึกข้อความถอดเสียงไม่สำเร็จ',
  'pages.scribe.saveTranscriptModalTitle': 'บันทึกข้อความถอดเสียง',
  'pages.scribe.saveTranscriptTitle': 'บันทึกข้อความถอดเสียง',
  'pages.scribe.savedSuccessfully': 'บันทึกสำเร็จ',
  'pages.scribe.savingTranscript': 'กำลังบันทึกข้อความถอดเสียง...',
  'pages.scribe.scribeTitle': 'บันทึกเสียง',
  'pages.scribe.scrollToBottom': 'เลื่อนไปด้านล่างสุด',
  'pages.scribe.searchMattersPlaceholder': 'ค้นหาเรื่อง...',
  'pages.scribe.searchTranscriptsPlaceholder': 'ค้นหาข้อความถอดเสียง',
  'pages.scribe.segmentTranslationFailed': 'การแปลส่วนของข้อความล้มเหลว',
  'pages.scribe.selectMattersLabel': 'เลือกเรื่อง:',
  'pages.scribe.startGenerationFailed': 'เริ่มการสร้างไม่สำเร็จ',
  'pages.scribe.startTranscriptionFailed': 'เริ่มกระบวนการถอดเสียงไม่สำเร็จ',
  'pages.scribe.status.clickMicToStart': 'คลิกไมโครโฟนเพื่อเริ่มบันทึกเสียง',
  'pages.scribe.status.processingFile': 'กำลังประมวลผลไฟล์... {stage}',
  'pages.scribe.status.queued': 'อยู่ในคิว',
  'pages.scribe.status.transcriptionCancelled': 'ยกเลิกการถอดเสียงแล้ว',
  'pages.scribe.status.transcriptionCompleted': 'ถอดเสียงเสร็จสมบูรณ์',
  'pages.scribe.status.transcriptionFailed': 'การถอดเสียงล้มเหลว',
  'pages.scribe.stopRecordingConfirm.cancelText': 'อยู่ต่อ',
  'pages.scribe.stopRecordingConfirm.okText': 'ออกจากหน้านี้',
  'pages.scribe.stopRecordingConfirm.title': 'หยุดการบันทึกเสียง?',
  'pages.scribe.stopRecordingSaveTitle': 'หยุดบันทึกเสียงและจัดเก็บข้อมูล',
  'pages.scribe.tabs.emailDraft': 'ร่างอีเมล',
  'pages.scribe.tabs.meetingNotes': 'บันทึกการประชุม',
  'pages.scribe.tabs.rawTranscript': 'ข้อความถอดเสียงต้นฉบับ',
  'pages.scribe.tabs.voiceMemo': 'บันทึกเสียง',
  'pages.scribe.transcriptDeleted': 'ลบข้อความถอดเสียงแล้ว',
  'pages.scribe.transcriptEmpty': 'ข้อความถอดเสียงว่างเปล่า',
  'pages.scribe.transcriptNameUpdated': 'อัปเดตชื่อข้อความถอดเสียงแล้ว',
  'pages.scribe.transcriptSavedSuccess': 'บันทึกข้อความถอดเสียงสำเร็จ',
  'pages.scribe.transcriptUpdated': 'อัปเดตข้อความถอดเสียงแล้ว',
  'pages.scribe.transcriptionFailedTitle': 'การถอดเสียงล้มเหลว',
  'pages.scribe.transcriptionLanguageQuestion': 'ต้องการใช้ภาษาใดในการถอดเสียง',
  'pages.scribe.transcriptionPurposeQuestion': 'การถอดเสียงนี้มีวัตถุประสงค์เพื่อใช้งานอะไร',
  'pages.scribe.translatingEllipsis': 'กำลังแปล...',
  'pages.scribe.increaseTranslationSize': 'เพิ่มขนาดข้อความที่แปล',
  'pages.scribe.decreaseTranslationSize': 'ลดขนาดข้อความที่แปล',
  'pages.scribe.translationTextSize': 'ขนาดข้อความแปล',
  'pages.scribe.unassigned': 'ยังไม่ได้มอบหมาย',
  'pages.scribe.unnamedTranscript': 'ข้อความถอดเสียงที่ไม่มีชื่อ',
  'pages.scribe.untitled': 'ไม่มีชื่อ',
  'pages.scribe.untitledParens': '(ไม่มีชื่อ)',
  'pages.scribe.untitledTranscript': 'ข้อความถอดเสียงที่ไม่มีชื่อ',
  'pages.scribe.updateMattersFailed': 'อัปเดตเรื่องไม่สำเร็จ',
  'pages.scribe.updateNameFailed': 'อัปเดตชื่อข้อความถอดเสียงไม่สำเร็จ',
  'pages.scribe.updateTranscriptNameTitle': 'อัปเดตชื่อข้อความถอดเสียง',
  'pages.scribe.uploadRecordingButton': 'อัปโหลดการบันทึกเสียง',
  'pages.scribe.uploadingAudioFile': 'กำลังอัปโหลดไฟล์เสียง...',
  'pages.scribe.waitingEllipsis': 'กำลังรอ...',
  'pages.scribe.waitingForTranslations': 'กำลังรอการแปลให้เสร็จสมบูรณ์...',
  'pages.scribe.whatsNew': 'มีอะไรใหม่',
  'pages.scribe.whatsNew.filteringSortingLabel': 'การกรองและการเรียงลำดับ:',
  'pages.scribe.whatsNew.guidanceTabsLabel': 'แท็บคำแนะนำ:',
  'pages.scribe.whatsNew.upcomingFeaturesTitle': 'ฟีเจอร์ที่กำลังจะมาถึง',
  'pages.search.chunkCopiedSuccess': 'คัดลอกส่วนข้อมูลแล้ว!',
  'pages.search.chunkCopyFailed': 'ไม่สามารถคัดลอกส่วนข้อมูลได้',
  'pages.search.searchRatioLabel': 'อัตราส่วนการค้นหา',
  'pages.search.favouriteFileWeightLabel': 'น้ำหนักไฟล์โปรด',
  'pages.search.rerankLabel': 'จัดอันดับใหม่',
  'pages.search.filePreviewAlt': 'ตัวอย่างไฟล์',
  'pages.search.previewNotSupported': 'ไม่สามารถแสดงตัวอย่างไฟล์ประเภทนี้ได้',
  'pages.search.chunkPageLabel': 'หน้า: {pageNumber}',
  'pages.search.matchPercentage': 'ตรงกัน {score}%',
  'pages.search.openChunkAriaLabel': 'เปิดส่วนข้อมูล {index}',
  'pages.search.navigateResultsTitle': 'นำทางผลลัพธ์',
  'pages.search.loadingChunkResults': 'กำลังโหลดผลลัพธ์ส่วนข้อมูล...',
  'pages.search.previousResultTitle': 'ผลลัพธ์ก่อนหน้า',
  'pages.search.nextResultTitle': 'ผลลัพธ์ถัดไป',
  'pages.search.chatWithDocumentButton': 'แชทกับเอกสารนี้',
  'pages.search.searchWithinDocumentPlaceholder': 'ค้นหาภายในเอกสาร...',
  'pages.search.filterDownLabel': 'กรองผลลัพธ์',
  'pages.search.documentPreviewTitle': 'ตัวอย่างเอกสาร',
  'pages.search.askAgelPlaceholder': 'ถาม A&GEL',
  'pages.search.searchAllButton': 'ค้นหาทั้งหมด',
  'pages.search.advancedSettingsButton': 'การตั้งค่าขั้นสูง',
  'pages.search.allTagsOption': ' แท็กทั้งหมด',
  'pages.sideBySide.addAtLeastOneQuestion': 'กรุณาเพิ่มคำถามอย่างน้อยหนึ่งข้อ',
  'pages.sideBySide.addNewQuestionsPlaceholder': 'เพิ่มคำถามใหม่ (บรรทัดละหนึ่งข้อ)',
  'pages.sideBySide.addPlusButton': 'เพิ่ม +',
  'pages.sideBySide.addQuestionsLabel': 'เพิ่มคำถาม',
  'pages.sideBySide.addToMattersButton': 'เพิ่มไปยัง Matters',
  'pages.sideBySide.authorFieldLabel': 'ผู้เขียน',
  'pages.sideBySide.authorLabel': 'ผู้เขียน: ',
  'pages.sideBySide.categoryLabel': 'หมวดหมู่',
  'pages.sideBySide.cellDetails.answer': 'คำตอบ',
  'pages.sideBySide.cellDetails.verified': 'ตรวจสอบแล้ว',
  'pages.sideBySide.cellDetails.verify': 'ตรวจสอบ',
  'pages.sideBySide.cellMarkedUnverified': 'ทำเครื่องหมายเซลล์ว่ายังไม่ได้ตรวจสอบ',
  'pages.sideBySide.cellMarkedVerified': 'ทำเครื่องหมายเซลล์ว่าตรวจสอบแล้ว',
  'pages.sideBySide.cellUpdatedSuccess': 'อัปเดตเซลล์สำเร็จ',
  'pages.sideBySide.changesUndone': 'เลิกทำการเปลี่ยนแปลงแล้ว',
  'pages.sideBySide.clickOrDragToUpload': 'คลิกหรือลากไฟล์เพื่ออัปโหลด',
  'pages.sideBySide.cloneButton': 'โคลน',
  'pages.sideBySide.cloneModeLabel': 'โคลน',
  'pages.sideBySide.clonedNamePrefix': 'โคลน - {name}',
  'pages.sideBySide.columnEditModal.enterPromptWarning': 'กรุณากรอกพรอมต์',
  'pages.sideBySide.columnEditModal.promptLabel': 'พรอมต์',
  'pages.sideBySide.columnEditModal.promptPlaceholder': 'อธิบายพรอมต์/คำสั่งระบบสำหรับคอลัมน์นี้',
  'pages.sideBySide.columnEditModal.title': 'แก้ไขคอลัมน์',
  'pages.sideBySide.columnEditModal.updateColumnFailed': 'ไม่สามารถอัปเดตคอลัมน์ได้',
  'pages.sideBySide.createModeLabel': 'สร้าง',
  'pages.sideBySide.createQuestionListButton': 'สร้างรายการคำถาม',
  'pages.sideBySide.createdByLabel': 'สร้างโดย: ',
  'pages.sideBySide.createdByYou': 'คุณ',
  'pages.sideBySide.customInstructionOptional': '2. คำสั่งกำหนดเอง (ไม่บังคับ)',
  'pages.sideBySide.deleteQuestionListConfirm': 'คุณแน่ใจหรือไม่ว่าต้องการลบรายการคำถามนี้',
  'pages.sideBySide.dragHereToUpload': 'ลากไฟล์มาที่นี่เพื่ออัปโหลด',
  'pages.sideBySide.emailButton': 'อีเมล',
  'pages.sideBySide.exitButton': 'ออก',
  'pages.sideBySide.exitModeButton': 'ออกจาก {mode}',
  'pages.sideBySide.fileCount': '{count} ไฟล์',
  'pages.sideBySide.firmOption': 'สำนักงาน',
  'pages.sideBySide.firmWideOption': 'ทั้งสำนักงาน',
  'pages.sideBySide.fromDocumentOption': 'จากเอกสาร',
  'pages.sideBySide.groupOption': 'กลุ่ม',
  'pages.sideBySide.leadRowHeader': 'ย่อหน้าของเอกสารต้นฉบับ',
  'pages.sideBySide.manualCraftOption': 'สร้างด้วยตนเอง',
  'pages.sideBySide.modifyButton': 'แก้ไข',
  'pages.sideBySide.modifyModeLabel': 'แก้ไข',
  'pages.sideBySide.newCategoryPlaceholder': 'หมวดหมู่ใหม่',
  'pages.sideBySide.newQuestionListButtonLabel': 'รายการคำถาม Side by Side ใหม่',
  'pages.sideBySide.newQuestionListDefaultName': 'รายการคำถาม Side by Side ใหม่',
  'pages.sideBySide.noNotesAvailable': 'ไม่มีบันทึกย่อ',
  'pages.sideBySide.noPurposeAvailable': 'ไม่มีวัตถุประสงค์',
  'pages.sideBySide.noSystemPromptConfigured': 'ยังไม่ได้ตั้งค่าพรอมต์ระบบ',
  'pages.sideBySide.notesFieldLabel': 'บันทึกย่อ',
  'pages.sideBySide.notesLabel': 'บันทึกย่อ: ',
  'pages.sideBySide.pendingApprovalTag': 'รอการอนุมัติ',
  'pages.sideBySide.processing': 'กำลังประมวลผล',
  'pages.sideBySide.processingStopped': 'หยุดการประมวลผลแล้ว',
  'pages.sideBySide.publicOption': 'สาธารณะ',
  'pages.sideBySide.publishButton': 'เผยแพร่',
  'pages.sideBySide.publishQuestionListFailed': 'ไม่สามารถเผยแพร่รายการคำถามได้',
  'pages.sideBySide.publishStatusLabel': 'สถานะการเผยแพร่',
  'pages.sideBySide.publishToLabel': 'เผยแพร่ไปยัง:',
  'pages.sideBySide.publishedToAccess': 'เผยแพร่ไปยัง {access} แล้ว',
  'pages.sideBySide.publishedToGroupSuccess': 'เผยแพร่รายการคำถามไปยังกลุ่มแล้ว',
  'pages.sideBySide.publishedToPrivateGroups': 'เผยแพร่รายการคำถามไปยังกลุ่มส่วนตัวแล้ว',
  'pages.sideBySide.publisherLabel': 'ผู้เผยแพร่: ',
  'pages.sideBySide.purposeFieldLabel': 'วัตถุประสงค์',
  'pages.sideBySide.purposeLabel': 'วัตถุประสงค์: ',
  'pages.sideBySide.questionListClonedSuccess': 'โคลนรายการคำถามสำเร็จ',
  'pages.sideBySide.questionListCreatedSuccess': 'สร้างรายการคำถามสำเร็จ',
  'pages.sideBySide.questionListDeletedSuccess': 'ลบรายการคำถามสำเร็จ',
  'pages.sideBySide.questionListNamePlaceholder': 'ชื่อรายการคำถาม Side-by-side',
  'pages.sideBySide.questionListUpdatedSuccess': 'อัปเดตรายการคำถามสำเร็จ',
  'pages.sideBySide.questionsListLabel': 'รายการคำถาม',
  'pages.sideBySide.quickQuestionsTitle': 'คำถามด่วน',
  'pages.sideBySide.rejectedTag': 'ถูกปฏิเสธ',
  'pages.sideBySide.reuseButton': 'ใช้ซ้ำ',
  'pages.sideBySide.reviewTemplateQuestionsDescription': 'ตรวจสอบคำถามสำหรับเทมเพลตนี้',
  'pages.sideBySide.saveChangesButton': 'บันทึกการเปลี่ยนแปลง',
  'pages.sideBySide.selectDocumentDescription': 'เลือกเอกสารที่คุณต้องการทำ Side by Side',
  'pages.sideBySide.selectGroupsPlaceholder': 'เลือกกลุ่ม',
  'pages.sideBySide.selectGroupsToShareDescription': 'เลือกกลุ่มหนึ่งกลุ่มขึ้นไปเพื่อแชร์ด้วย:',
  'pages.sideBySide.selectionFeatureName': 'side by side',
  'pages.sideBySide.selectionTitle': 'Side-by-side',
  'pages.sideBySide.sentForApprovalSuccess': 'ส่งรายการคำถามเพื่อขออนุมัติแล้ว',
  'pages.sideBySide.showQuestionsButton': 'แสดงคำถาม',
  'pages.sideBySide.startGenerateReview': 'เริ่มสร้างการตรวจทาน',
  'pages.sideBySide.startNewSideBySideButton': 'เริ่ม Side-by-Side ใหม่',
  'pages.sideBySide.stayButton': 'อยู่ต่อ',
  'pages.sideBySide.submitFailed': 'ไม่สามารถส่ง side-by-side ได้',
  'pages.sideBySide.systemPromptLabel': 'พรอมต์ระบบ',
  'pages.sideBySide.tabs.prompts': 'พรอมต์',
  'pages.sideBySide.tabs.questionList': 'รายการคำถาม',
  'pages.sideBySide.tabs.selectDocuments': 'เลือกเอกสาร',
  'pages.sideBySide.targetAudiencePlaceholder': 'ชื่อลูกค้าหรือกลุ่มเป้าหมาย',
  'pages.sideBySide.teamsButton': 'ทีม',
  'pages.sideBySide.templateSystemPromptLabel': 'พรอมต์ระบบของเทมเพลต',
  'pages.sideBySide.tour.step1.title': 'เลือกรายการคำถาม',
  'pages.sideBySide.tour.step2.title': 'กรอกกลุ่มเป้าหมายและเลือกไฟล์',
  'pages.sideBySide.tour.step3.title': 'ดูพรอมต์ระบบและคำถาม',
  'pages.sideBySide.tour.step4.title': 'ดูผลลัพธ์ Side-by-Side',
  'pages.sideBySide.typeHerePlaceholder': 'พิมพ์ที่นี่...',
  'pages.sideBySide.undoChangesButton': 'เลิกทำการเปลี่ยนแปลง',
  'pages.sideBySide.unsavedChangesWillBeLost': 'การเปลี่ยนแปลงที่ยังไม่ได้บันทึกจะสูญหาย',
  'pages.sideBySide.untitled': '(ไม่มีชื่อ)',
  'pages.sideBySide.updateCellFailed': 'ไม่สามารถอัปเดตเซลล์ได้',
  'pages.sideBySide.updateCellVerificationFailed': 'ไม่สามารถอัปเดตการตรวจสอบเซลล์ได้',
  'pages.sideBySide.updateFailed': 'ไม่สามารถอัปเดตได้',
  'pages.sideBySide.uploadDocumentFailed': 'ไม่สามารถอัปโหลดเอกสารได้',
  'pages.sideBySide.whoIsItForQuestion': '1. เอกสารนี้จัดทำเพื่อใคร?',
  'pages.template.waitingMessage.justAMoment': 'กรุณารอสักครู่...',
  'pages.template.waitingMessage.fetchingThatForYou': 'กำลังดึงข้อมูลให้คุณ...',
  'pages.template.waitingMessage.hangTight': 'รอสักครู่ กำลังดำเนินการ...',
  'pages.template.waitingMessage.letMeCheck': 'ขอตรวจสอบสักครู่...',
  'pages.template.waitingMessage.oneSecPlease': 'รอแป๊บเดียว...',
  'pages.template.waitingMessage.lookingThatUp': 'กำลังค้นหาข้อมูลให้คุณ...',
  'pages.template.waitingMessage.almostThere': 'ใกล้เสร็จแล้ว...',
  'pages.template.waitingMessage.holdOnRetrieving': 'รอสักครู่ กำลังดึงข้อมูล...',
  'pages.template.waitingMessage.workingOnIt': 'กำลังดำเนินการ...',
  'pages.template.dragDropUpload': 'ลากไฟล์มาวางที่นี่เพื่ออัปโหลด',
  'pages.template.fileUploadedSuccess': 'อัปโหลด {fileName} สำเร็จแล้ว',
  'pages.template.fileUploadFailed': 'ไม่สามารถอัปโหลด {fileName} ได้',
  'pages.template.loadTemplateDetailsFailed': 'ไม่สามารถโหลดรายละเอียดเทมเพลตได้',
  'pages.template.viewLess': 'ดูน้อยลง',
  'pages.template.viewAll': 'ดูทั้งหมด',
  'pages.template.tour.step1Title': 'เลือกเทมเพลตผลลัพธ์ที่กำหนดเอง',
  'pages.template.tour.step1Description': 'เริ่มต้นด้วยการเลือกเทมเพลตสำเร็จรูปจากหมวดหมู่ที่มีให้',
  'pages.template.tour.step2Title': 'เลือกไฟล์สำหรับการวิเคราะห์',
  'pages.template.tour.step3Title': 'ตรวจสอบพรอมต์และคำสั่ง',
  'pages.template.tour.step4Title': 'ดูผลลัพธ์',
  'pages.template.noSessionsFound': 'ไม่พบเซสชันเทมเพลต กรุณาเริ่มใช้งานเพื่อดูผลลัพธ์',
  'pages.template.startNewCustomOutput': 'เริ่มสร้างผลลัพธ์ที่กำหนดเองใหม่',
  'pages.template.untitled': '(ไม่มีชื่อ)',
  'pages.template.newSession': 'เซสชันใหม่',
  'pages.template.fileCount': '{count} ไฟล์',
  'pages.template.reuseButton': 'ใช้ซ้ำ',
  'pages.template.addToMattersButton': 'เพิ่มลงในคดีความ',
  'pages.template.startFillingTemplates': 'เริ่มกรอกเทมเพลต',
  'pages.template.unsavedChangesWarning': 'การเปลี่ยนแปลงที่ยังไม่ได้บันทึกจะสูญหาย',
  'pages.template.stayButton': 'อยู่ต่อ',
  'pages.template.exitButton': 'ออก',
  'pages.template.undoChangesButton': 'เลิกทำการเปลี่ยนแปลง',
  'pages.template.changesUndoneMessage': 'เลิกทำการเปลี่ยนแปลงแล้ว',
  'pages.template.templateCreatedSuccess': 'สร้างเทมเพลตสำเร็จแล้ว',
  'pages.template.templateUpdatedSuccess': 'อัปเดตเทมเพลตสำเร็จแล้ว',
  'pages.template.fillRequiredFields': 'กรุณากรอกข้อมูลในช่องที่จำเป็นให้ครบถ้วน',
  'pages.template.saveTemplateFailed': 'ไม่สามารถบันทึกเทมเพลตได้',
  'pages.template.createTemplateButton': 'สร้างเทมเพลต',
  'pages.template.saveTemplateButton': 'บันทึกเทมเพลต',
  'pages.template.presetNamePlaceholder': 'ชื่อเทมเพลตสำเร็จรูปที่กำหนดเอง',
  'pages.template.categoryLabel': 'หมวดหมู่',
  'pages.template.newCategoryPlaceholder': 'หมวดหมู่ใหม่',
  'pages.template.addCategoryButton': 'เพิ่มหมวดหมู่',
  'pages.template.purposeLabel': 'วัตถุประสงค์',
  'pages.template.notesLabel': 'หมายเหตุ',
  'pages.template.systemPromptLabel': 'พรอมต์ระบบ',
  'pages.template.typeProse': 'ร้อยแก้ว',
  'pages.template.typeTable': 'ตาราง',
  'pages.template.tableTypeLabel': 'ประเภทตาราง',
  'pages.template.tableTypeStandard': 'มาตรฐาน',
  'pages.template.tableTypeDocument': 'รายเอกสาร',
  'pages.template.tableTypeClause': 'รายข้อ',
  'pages.template.columnsLabel': 'คอลัมน์',
  'pages.template.newColumnButton': 'คอลัมน์ใหม่',
  'pages.template.exampleLabel': 'ตัวอย่าง',
  'pages.template.userDefinedLabel': 'กำหนดเองโดยผู้ใช้',
  'pages.template.userDefinedColumnTooltip': 'คอลัมน์ที่กำหนดเองโดยผู้ใช้',
  'pages.template.columnTypeString': 'ข้อความ',
  'pages.template.columnTypeNumber': 'ตัวเลข',
  'pages.template.columnTypeDatetime': 'วันที่และเวลา',
  'pages.template.sectionsLabel': 'ส่วน',
  'pages.template.newSectionButton': 'ส่วนใหม่',
  'pages.template.headingColumnHeader': 'หัวข้อ',
  'pages.template.promptColumnHeader': 'พรอมต์',
  'pages.template.modifyButton': 'แก้ไข',
  'pages.template.publishToLabel': 'เผยแพร่ไปยัง:',
  'pages.template.publishFirmWide': 'ทั้งสำนักงาน',
  'pages.template.publicAccessLabel': 'สาธารณะ',
  'pages.template.firmAccessLabel': 'สำนักงาน',
  'pages.template.publishButton': 'เผยแพร่',
  'pages.template.publishSentForApproval': 'ส่งเทมเพลตสำเร็จรูปเพื่อขออนุมัติแล้ว',
  'pages.template.publishTemplateFailed': 'ไม่สามารถเผยแพร่เทมเพลตได้',
  'pages.template.deleteConfirmQuestion': 'คุณแน่ใจหรือไม่ว่าต้องการลบเทมเพลตนี้?',
  'pages.template.templateDeletedSuccess': 'ลบเทมเพลตสำเร็จแล้ว',
  'pages.template.deleteTemplateFailed': 'ไม่สามารถลบเทมเพลตได้',
  'pages.template.publishStatusLabel': 'สถานะการเผยแพร่',
  'pages.template.pendingApprovalStatus': 'รอการอนุมัติ',
  'pages.template.rejectedStatus': 'ถูกปฏิเสธ',
  'pages.template.publishedToStatus': 'เผยแพร่ไปยัง {target} แล้ว',
  'pages.template.authorLabel': 'ผู้จัดทำ',
  'pages.template.emailButton': 'อีเมล',
  'pages.template.noPurposeAvailable': 'ไม่มีข้อมูลวัตถุประสงค์',
  'pages.template.noNotesAvailable': 'ไม่มีหมายเหตุ',
  'pages.template.startHereTab': 'เริ่มต้นที่นี่',
  'pages.template.whoIsItForQuestion': '1. เอกสารนี้จัดทำเพื่อใคร?',
  'pages.template.clientAudiencePlaceholder': 'ชื่อลูกค้าหรือกลุ่มเป้าหมาย',
  'pages.template.selectDocumentsQuestion': '2. เลือกเอกสารที่คุณต้องการตรวจสอบ',
  'pages.template.customInstructionTab': 'คำสั่งที่กำหนดเอง (ไม่บังคับ)',
  'pages.template.modifyPromptLabel': 'แก้ไขพรอมต์',
  'pages.template.typeHerePlaceholder': 'พิมพ์ที่นี่...',
  'pages.template.noSystemPromptConfigured': 'ยังไม่ได้กำหนดค่าพรอมต์ระบบ',
  'pages.template.exampleValuePrefix': 'เช่น {example}',
  'pages.template.customOutputTitle': 'ผลลัพธ์ที่กำหนดเอง',
  'pages.template.whatsNewButton': 'มีอะไรใหม่',
  'pages.template.tourButton': 'ทัวร์แนะนำ',
  'pages.template.addNewCustomTemplateButton': 'เพิ่มเทมเพลตที่กำหนดเองใหม่',
  'pages.template.whatsNewModal.improvedFilteringTitle': 'ปรับปรุงการกรองข้อมูล: ',
  'pages.template.whatsNewModal.adhocQuestionsTitle': 'คำถามเฉพาะกิจ: ',
  'pages.template.whatsNewModal.adhocQuestionsBody': 'เพิ่มคำถามได้อย่างยืดหยุ่นมากขึ้นแบบทันที',
  'pages.template.whatsNewModal.uiEnhancementsTitle': 'การปรับปรุงอินเทอร์เฟซ: ',
  'pages.template.upcomingFeaturesTitle': 'ฟีเจอร์ที่กำลังจะมาถึง',
  'pages.template.tourIndicator': '{current} / {total}',
  'pages.translation.addToMattersButton': 'เพิ่มลงในคดีความ',
  'pages.translation.batchFileCountLabel': '{count} ไฟล์',
  'pages.translation.batchTranslationStarted': 'เริ่มการแปลแบบกลุ่มแล้ว',
  'pages.translation.copiedSuccess': 'คัดลอกแล้ว!',
  'pages.translation.customInstructionTab': 'คำสั่งที่กำหนดเอง (ไม่บังคับ)',
  'pages.translation.docxOrPdfOnly': 'กรุณาเลือกเฉพาะไฟล์ DOCX หรือ PDF เท่านั้น',
  'pages.translation.downloadFailed': 'ดาวน์โหลดล้มเหลว ({status})',
  'pages.translation.dragHereToUpload': 'ลากไฟล์มาวางที่นี่เพื่ออัปโหลด',
  'pages.translation.enterLanguageRequired': 'กรุณาระบุภาษา',
  'pages.translation.failedRenderOriginalPreview': 'ไม่สามารถแสดงตัวอย่างต้นฉบับได้',
  'pages.translation.failedRenderTranslatedPreview': 'ไม่สามารถแสดงตัวอย่างฉบับแปลได้',
  'pages.translation.failedToFetchDocx': 'ไม่สามารถดึงไฟล์ DOCX ได้ ({status})',
  'pages.translation.failedToStartTranslation': 'ไม่สามารถเริ่มการแปลได้',
  'pages.translation.failedToStartTranslationMissingId': 'ไม่สามารถเริ่มการแปลได้ (ไม่มี id)',
  'pages.translation.fileCountLabel': '{count} ไฟล์',
  'pages.translation.filterFilesPlaceholder': 'กรองไฟล์',
  'pages.translation.liveTranslationHint': 'พิมพ์ทางด้านซ้าย แล้วดูคำแปลทางด้านขวาได้ทันที',
  'pages.translation.liveTranslationTitle': 'แปลภาษาแบบเรียลไทม์',
  'pages.translation.modifyPromptLabel': 'แก้ไขพรอมต์',
  'pages.translation.failed': 'การแปลล้มเหลว',
  'pages.translation.noPreviewAvailable': 'ไม่มีตัวอย่างให้แสดง',
  'pages.translation.noFilesMatch': 'ไม่พบไฟล์ที่ตรงกับ "{query}"',
  'pages.translation.noTranslatedDocumentYet': 'ยังไม่มีเอกสารที่แปลแล้ว',
  'pages.translation.originalLabel': 'ต้นฉบับ',
  'pages.translation.originalPdfTitle': 'PDF ต้นฉบับ',
  'pages.translation.otherLanguagePlaceholder': 'เช่น ทมิฬ',
  'pages.translation.outputLanguageStep': '2. ภาษาผลลัพธ์',
  'pages.translation.processingTitle': 'กำลังประมวลผล…',
  'pages.translation.processingTranslation': 'กำลังประมวลผลการแปล…',
  'pages.translation.promptOptionalLabel': 'พรอมต์ (ไม่บังคับ)',
  'pages.translation.recentlyTranslatedLabel': 'แปลล่าสุด',
  'pages.translation.renderingOriginal': 'กำลังแสดงผลต้นฉบับ…',
  'pages.translation.renderingTranslation': 'กำลังแสดงผลคำแปล…',
  'pages.translation.reuseButton': 'ใช้ซ้ำ',
  'pages.translation.searchTranslationsPlaceholder': 'ค้นหาคำแปล',
  'pages.translation.selectAtMostDocuments': 'กรุณาเลือกเอกสารไม่เกิน {max} ฉบับเพื่อแปล',
  'pages.translation.selectDocumentStep': '1. เลือกเอกสารที่ต้องการแปล',
  'pages.translation.selectLanguagePlaceholder': 'เลือกภาษา',
  'pages.translation.selectLanguageRequired': 'กรุณาเลือกภาษา',
  'pages.translation.selectOutputLanguagePlaceholder': 'เลือกภาษาปลายทางหนึ่งภาษา',
  'pages.translation.selectOutputLanguageRequired': 'กรุณาเลือกภาษาปลายทาง',
  'pages.translation.startHereTab': 'เริ่มต้นที่นี่',
  'pages.translation.startLiveTranslationButton': 'เริ่มการแปลสด',
  'pages.translation.startNewTranslationButton': 'เริ่มการแปลใหม่',
  'pages.translation.startTranslationButton': 'เริ่มการแปล',
  'pages.translation.stopTranslationFailed': 'หยุดการแปลไม่สำเร็จ',
  'pages.translation.swapLanguagesTooltip': 'สลับภาษา',
  'pages.translation.title': 'การแปล',
  'pages.translation.translateButton': 'แปล',
  'pages.translation.translatedLabel': 'แปลแล้ว',
  'pages.translation.translatedPdfTitle': 'ไฟล์ PDF ที่แปลแล้ว',
  'pages.translation.translationFailedError': 'การแปลล้มเหลว',
  'pages.translation.translationStoppedSuccess': 'หยุดการแปลแล้ว',
  'pages.translation.translationTaskStarted': 'เริ่มงานแปลแล้ว',
  'pages.translation.typeTextToTranslatePlaceholder': 'พิมพ์ข้อความที่ต้องการแปล',
  'pages.translation.unknownLanguage': 'ไม่ทราบ',
  'pages.translation.untitledFallback': '(ไม่มีชื่อ)',
  'pages.translation.untitledTranslationFallback': 'การแปลที่ไม่มีชื่อ',
  'pages.user.passwordConfirmationPlaceholder': 'ยืนยันรหัสผ่าน',
  'pages.user.logoAlt': 'โลโก้',
  'pages.user.emailPlaceholder': 'อีเมล',
  'pages.user.passwordPlaceholder': 'รหัสผ่าน',
  'pages.user.newPasswordPlaceholder': 'รหัสผ่านใหม่',
  'pages.user.forgotPassword.submitButton': 'ส่งลิงก์รีเซ็ตรหัสผ่าน',
  'pages.user.resetPassword.successMessage': 'อัปเดตรหัสผ่านของคุณเรียบร้อยแล้ว',
  'pages.user.resetPassword.submitButton': 'รีเซ็ตรหัสผ่าน',
  'pages.user.resetPassword.passwordRequired': 'กรุณากรอกรหัสผ่าน',
  'pages.user.resetPassword.passwordMinLength': 'ต้องมีความยาวอย่างน้อย 8 ตัวอักษร',
  'pages.user.resetPassword.passwordNeedsAlpha': 'ต้องมีตัวอักษรอย่างน้อย 1 ตัว',
  'pages.user.resetPassword.passwordNeedsNumber': 'ต้องมีตัวเลขอย่างน้อย 1 ตัว',
  'pages.user.resetPassword.passwordNeedsSpecial': 'ต้องมีอักขระพิเศษอย่างน้อย 1 ตัว',
  'pages.user.resetPassword.confirmPasswordRequired': 'กรุณายืนยันรหัสผ่านใหม่ของคุณ!',
  'pages.user.resetPassword.passwordMismatch': 'รหัสผ่านทั้งสองที่คุณกรอกไม่ตรงกัน!',
  'pages.user.login.ssoNotConfigured': 'Microsoft SSO ยังไม่ได้รับการตั้งค่าอย่างถูกต้อง',
  'pages.user.login.ssoAccountNotFound': 'ไม่พบบัญชี Microsoft SSO',
  'pages.user.login.emailPasswordWrong': 'อีเมลหรือรหัสผ่านไม่ถูกต้อง',
  'pages.user.login.contactAdminContent': 'กรุณาติดต่อผู้ดูแลระบบของคุณเพื่อรีเซ็ตรหัสผ่าน',
  'pages.user.management.pageTitle': 'จัดการ',
  'pages.user.rolesLoadingPlaceholder': 'กำลังโหลดบทบาท...',
  'pages.user.selectRolePlaceholder': 'เลือกบทบาท',
  'pages.user.billing.seatsMinimumError': 'จำนวนที่นั่งต้องเป็นจำนวนเต็มอย่างน้อย 1',
  'pages.user.billing.contactRequiredError': 'กรุณากรอกชื่อและอีเมลผู้ติดต่อสำหรับการเรียกเก็บเงิน',
  'pages.user.billing.renewOrChoosePlan': 'ต่ออายุ / เลือกแพ็กเกจ',
  'pages.user.billing.switchPlanAction': 'เปลี่ยนแพ็กเกจ',
  'pages.user.billing.subscribeAction': 'สมัครสมาชิก',
  'pages.user.billing.renewPlanAction': 'ต่ออายุแพ็กเกจ',
  'pages.user.billing.switchPlanModalTitle': 'เปลี่ยนแพ็กเกจ',
  'pages.user.billing.renewThisPlanButton': 'ต่ออายุแพ็กเกจนี้',
  'pages.user.billing.currentPlanButton': 'แพ็กเกจปัจจุบัน',
  'pages.user.billing.switchToThisPlanButton': 'เปลี่ยนเป็นแพ็กเกจนี้',
  'pages.user.billing.subscribeToThisPlanButton': 'สมัครแพ็กเกจนี้',
  'pages.user.billing.planText': 'แพ็กเกจ',
  'pages.user.billing.selectedTag': 'เลือกแล้ว',
  'pages.user.billing.totalLabel': 'ยอดรวม:',
  'pages.user.billing.billingContactTitle': 'ผู้ติดต่อสำหรับการเรียกเก็บเงิน',
  'pages.user.billing.billingContactHint': 'จำเป็นสำหรับการชำระเงินและใบแจ้งหนี้',
  'pages.user.billing.fullNameLabel': 'ชื่อ-นามสกุล',
  'pages.user.billing.billingEmailLabel': 'อีเมลสำหรับการเรียกเก็บเงิน',
  'pages.user.billing.seatsLabel': 'ที่นั่ง',
  'pages.user.billing.registeringTenantTitle': 'กำลังลงทะเบียน Microsoft tenant',
  'pages.user.billing.tenantStep1': 'ขั้นตอนที่ 1/4: กำลังโหลดการตั้งค่า Microsoft SSO...',
  'pages.user.billing.tenantRegistrationCompleteTitle': 'ลงทะเบียน Microsoft tenant สำเร็จ',
  'pages.user.billing.tenantRegistrationFailedTitle': 'ลงทะเบียน Microsoft tenant ไม่สำเร็จ',
  'pages.user.billing.tenantRegistrationIncompleteMessage': 'การลงทะเบียนไม่เสร็จสมบูรณ์ {detail}',
  'pages.user.billing.loadInvoicesError': 'ไม่สามารถโหลดใบแจ้งหนี้ได้',
  'pages.user.billing.loadBillingDetailsError': 'ไม่สามารถโหลดรายละเอียดการเรียกเก็บเงินได้',
  'pages.user.billing.openCheckoutError': 'ไม่สามารถเปิดหน้าชำระเงินได้',
  'pages.user.billing.seatsUpdatedMessage': 'อัปเดตจำนวนที่นั่งแล้ว',
  'pages.user.billing.editSeatsModalTitle': 'แก้ไขจำนวนที่นั่ง',
  'pages.user.billing.saveSeatsButton': 'บันทึกจำนวนที่นั่ง',
  'pages.user.billing.currentTotalLabel': 'ยอดรวมปัจจุบัน',
  'pages.user.billing.previewTotalLabel': 'ยอดรวมโดยประมาณ',
  'pages.user.billing.differenceLabel': 'ส่วนต่างจากการต่ออายุครั้งถัดไป',
  'pages.user.billing.invoices': 'ใบแจ้งหนี้',
  'pages.user.billing.nextInvoiceDateLabel': 'วันที่ออกใบแจ้งหนี้ถัดไป:',
  'pages.user.billing.invoiceColumn': 'ใบแจ้งหนี้',
  'pages.user.billing.dueColumn': 'ครบกำหนด',
  'pages.user.billing.amountColumn': 'จำนวนเงิน',
  'pages.user.billing.downloadInvoiceError': 'ไม่สามารถดาวน์โหลดไฟล์ PDF ใบแจ้งหนี้ได้',
  'pages.user.billing.membersSeatsLabel': 'สมาชิก / ที่นั่ง',
  'pages.user.billing.scheduledTag': 'กำหนดการแล้ว',
  'pages.user.billing.pendingSeatsNotice': '→ {seats} ที่นั่ง เริ่มจากการต่ออายุครั้งถัดไป',
  'pages.user.billing.editSeatsButton': 'แก้ไขที่นั่ง',
  'pages.user.billing.currentPlanCardLabel': 'แพ็กเกจปัจจุบัน',
  'pages.user.billing.priceLabel': 'ราคา:',
  'pages.user.billing.billingCardTitle': 'การเรียกเก็บเงิน',
  'pages.user.billing.nextInvoiceLabel': 'ใบแจ้งหนี้ถัดไป',
  'pages.user.billing.registerMicrosoftTenantButton': 'ลงทะเบียน Microsoft Tenant',
  'pages.user.billing.contactOrgAdmin': 'กรุณาติดต่อผู้ดูแลระบบองค์กรของคุณ',
  'pages.user.billing.graceDeadlineFallback': 'วันสิ้นสุดระยะผ่อนผัน',
  'pages.user.billing.paymentIssueTitle': 'ปัญหาการชำระเงิน',
  'pages.user.billing.subscriptionCancelledTitle': 'การสมัครสมาชิกถูกยกเลิกแล้ว',
  'pages.user.billing.subscriptionInactiveTitle': 'การสมัครสมาชิกไม่ได้ใช้งาน',
  'pages.angelInsider.landing.tiles.basics.subtitle':
    'เริ่มต้นที่นี่ ทุกสิ่งที่คุณต้องรู้ตั้งแต่วันแรก',
  'pages.angelInsider.landing.tiles.learnMore.subtitle':
    'ฟีเจอร์ขั้นสูงสำหรับผู้ที่ต้องการก้าวไปอีกขั้น',
  'pages.angelInsider.basics.habits.habit1.intro':
    'ข้อผิดพลาดที่พบบ่อยที่สุดของผู้ใช้ใหม่คือการประเมินความสำคัญของการให้ข้อมูลที่เพียงพอแก่เครื่องมือ AI เพื่อใช้เป็นจุดเริ่มต้นในการทำงานต่ำเกินไป',
  'pages.angelInsider.basics.habits.habit2.title':
    'ใช้ LLM เป็น "ตัวประมวลผลข้อความ" ไม่ใช่เครื่องมือแหล่งความรู้',
  'pages.angelInsider.basics.habits.habit2.intro':
    'สิ่งสำคัญคือต้องเข้าใจว่า Large Language Model (LLM) คืออะไรกันแน่ โมเดลเหล่านี้ไม่ใช่ฐานข้อมูลความจริง และไม่สามารถใช้แทนการตัดสินใจของมนุษย์ได้ แต่ควรมองว่า LLM เป็นเสมือน CPU หรือตัวประมวลผลความเร็วสูงสำหรับงานด้านภาษาและงานด้านความคิดพื้นฐาน',
  'pages.angelInsider.basics.welcome.intro':
    'เรารู้สึกยินดีเป็นอย่างยิ่งที่คุณมาร่วมงานกับเรา ในขณะที่คุณเริ่มสำรวจ A&GEL เราขอแบ่งปันข้อคิดบางประการเพื่อช่วยให้คุณเริ่มต้นได้อย่างมั่นคง',
  'pages.angelInsider.basics.welcome.timeHeading':
    'การเรียนรู้เครื่องมือใหม่ต้องใช้เวลา – และนั่นเป็นเรื่องปกติ',
  'pages.angelInsider.basics.welcome.supportParagraph':
    'เราเข้าใจดีว่าการทำความคุ้นเคยกับเทคโนโลยีใหม่อาจเป็นเรื่องท้าทายในช่วงแรก โปรดจำไว้ว่าเราพร้อมสนับสนุนคุณในทุกขั้นตอน อย่าลังเลที่จะติดต่อเราหากมีคำถาม ติดขัดตรงไหน หรือเพียงต้องการให้เราช่วยแนะนำในเรื่องใดก็ตาม',
  'pages.angelInsider.basics.welcome.differentParagraph':
    'เครื่องมือ AI อย่าง A&GEL <strong>แตกต่าง</strong> จากเครื่องมือรุ่นก่อนหน้า เพราะช่วยเสริมศักยภาพให้ <strong>คุณโดยตรง</strong> ลองนึกภาพว่าคุณมีทีมผู้ช่วยมากมายพร้อมใช้งานอยู่ในมือ แม้จะไม่สามารถแทนที่การตัดสินใจของมนุษย์ได้ แต่ในหลายแง่มุมก็ช่วยขยายศักยภาพของคุณได้ไกลเกินกว่าที่จะทำได้เพียงลำพัง',
  'pages.angelInsider.basics.welcome.bestWayParagraph':
    '<strong>วิธีที่ดีที่สุดในการเริ่มเรียนรู้คือการเริ่มใช้งาน A&GEL —</strong> เราขอสนับสนุนให้คุณสำรวจได้อย่างอิสระ ลองผิดลองถูก (ในแบบที่ปลอดภัย) และค้นหาวิธีที่เหมาะกับคุณที่สุด',
  'pages.angelInsider.basics.welcome.staircaseParagraph':
    'ลองนึกภาพการพัฒนาทักษะเหมือนการเดินขึ้นบันได เริ่มต้นจากพื้นฐาน และเมื่อคุณมั่นใจมากขึ้น การก้าวไปสู่ระดับถัดไปก็จะเป็นไปอย่างเป็นธรรมชาติมากขึ้น ไม่ต้องเร่งรีบ — นี่ไม่ใช่การแข่งขัน ใช้เวลาที่คุณต้องการเพื่อสร้างพื้นฐานที่แข็งแกร่ง',
  'pages.angelInsider.basics.welcome.togetherParagraph':
    'เมื่อทีมและองค์กรร่วมกันใช้ A&GEL ประโยชน์ที่ได้จะทวีคูณสำหรับทุกคน การแบ่งปันความรู้และร่วมมือกันในกลุ่มผู้ใช้จะสร้างผลกระทบที่ส่งต่อและยกระดับทุกคนไปด้วยกัน',
  'pages.angelInsider.basics.welcome.welcomeAboardParagraph':
    'ขอต้อนรับสู่ทีม — เรารู้สึกตื่นเต้นที่จะได้เห็นสิ่งที่เราจะสามารถบรรลุร่วมกันด้วย A&GEL',
  'pages.angelInsider.basics.habitsSection.intro':
    'การเริ่มต้นใช้งาน A&GEL ไม่ใช่แค่การพิมพ์คำถามแล้วกด Enter ในหน้าแชท หากต้องการใช้ประโยชน์จากเครื่องมือ AI อย่าง A&GEL ได้อย่างเต็มที่ คุณจำเป็นต้องปรับเปลี่ยนวิธีคิดในการโต้ตอบกับ AI',
  'pages.angelInsider.basics.habitsSection.lockHint':
    'คลิกที่แผงเพื่อล็อกพื้นที่การแสดงผลให้กว้างขึ้น คลิกอีกครั้งเพื่อปลดล็อก',
  'pages.app.analysisType.agenticResearch.description':
    'สำรวจเอกสารที่เลือกและไฟล์ที่อัปโหลด จากนั้นสังเคราะห์คำตอบที่ครอบคลุมพร้อมการอ้างอิง',
  'pages.app.analysisType.comparison.description':
    'เปรียบเทียบเอกสารสองฉบับและให้รายงานที่อธิบายความแตกต่าง คุณสามารถระบุพรอมต์เพื่อกำหนดจุดที่ต้องการเปรียบเทียบได้',
  'pages.app.analysisType.contractDeadlines.description':
    "แสดงรายการกำหนดเวลา วันที่สำคัญ และระยะเวลาทั้งหมดที่พบในสัญญา/เอกสาร การให้รายละเอียดเกี่ยวกับลูกค้าจะเป็นประโยชน์ (เช่น 'ลูกค้าเป็นธนาคารในสิงคโปร์ที่เชี่ยวชาญด้านบริการธนาคารอิเล็กทรอนิกส์')",
  'pages.app.analysisType.executiveSummary.description':
    'ให้สรุปสำหรับผู้บริหารอย่างกระชับเกี่ยวกับคำแนะนำสำคัญ ประเด็นปัญหา ความเสี่ยง และแนวทางดำเนินการ',
  'pages.app.analysisType.gartnerReport.description':
    'ให้รายงานเชิงลึกด้านอุตสาหกรรมพร้อมการคาดการณ์และข้อเสนอแนะ',
  'pages.app.analysisType.guidedSummary.description':
    'ให้สรุปโดยละเอียดของเอกสารฉบับเดียวตามแนวทางที่กำหนดในพรอมต์',
  'pages.app.analysisType.multiStepPrompt.description':
    'ดำเนินการพรอมต์หลายรายการตามลำดับ โดยต่อยอดจากผลลัพธ์ของแต่ละขั้นตอน',
  'pages.app.analysisType.scopeOfWork.description':
    'อัปโหลดหรือเลือกอีเมล จดหมาย หรือ RFP จากลูกค้าที่มีการร้องขอความช่วยเหลือหรือบริการ ใน "พรอมต์" การให้รายละเอียดเกี่ยวกับลูกค้าจะเป็นประโยชน์ (เช่น \'ลูกค้าเป็นธนาคารในสิงคโปร์ที่เชี่ยวชาญด้านบริการธนาคารอิเล็กทรอนิกส์\')',
  'pages.app.analysisType.standardInfo.description':
    'ให้สรุปอย่างกระชับ รายชื่อบุคคลและองค์กรที่เกี่ยวข้อง และไทม์ไลน์เหตุการณ์โดยย่อ คุณสามารถระบุเอกสารได้สูงสุด 100 ฉบับ',
  'pages.app.analysisType.timeline.description':
    'ให้ไทม์ไลน์เหตุการณ์โดยละเอียดจากเอกสารสูงสุด 100 ฉบับ',
  'pages.app.appsInstructions':
    'เลือกไฟล์หลายไฟล์ที่ต้องการใช้งาน จากนั้นเลือกประเภทการวิเคราะห์จากรายการด้านล่าง คำขอจะใช้เวลาประมวลผลประมาณ 1-5 นาที',
  'pages.app.appsList.agenticResearch.description':
    'สำรวจเอกสารที่เลือกและไฟล์ที่อัปโหลด จากนั้นสังเคราะห์คำตอบที่ครอบคลุมพร้อมการอ้างอิง',
  'pages.app.appsList.contractDeadlines.description':
    'แสดงรายการกำหนดเวลา วันที่สำคัญ และระยะเวลาทั้งหมดที่พบในสัญญา/เอกสาร',
  'pages.app.appsList.executiveSummary.description':
    'ภาพรวมระดับสูงของประเด็นสำคัญ ผลการวิเคราะห์ และข้อเสนอแนะสำหรับผู้บริหาร',
  'pages.app.appsList.gartnerReport.description':
    'การวิเคราะห์อุตสาหกรรมเชิงลึกโดยใช้วิธีวิจัยที่น่าเชื่อถือและเป็นกลาง',
  'pages.app.appsList.guidedSummary.description':
    'ให้สรุปโดยละเอียดของเอกสารฉบับเดียวตามแนวทางที่กำหนดในพรอมต์',
  'pages.app.appsList.multiStepPrompt.description':
    'ดำเนินการพรอมต์หลายรายการตามลำดับ โดยต่อยอดจากผลลัพธ์ของแต่ละขั้นตอน',
  'pages.app.appsList.scopeOfWork.description':
    'อัปโหลดหรือเลือกอีเมล จดหมาย หรือ RFP จากลูกค้าที่มีการร้องขอความช่วยเหลือหรือบริการ',
  'pages.app.appsList.standardInfo.description':
    'ให้สรุปอย่างกระชับ รายชื่อบุคคลและองค์กร และไทม์ไลน์โดยย่อ',
  'pages.app.appsList.timeline.description':
    'ให้ไทม์ไลน์เหตุการณ์โดยละเอียดจากเอกสารสูงสุด 100 ฉบับ',
  'pages.app.extractDeadlinesModalDescription':
    "ระบุกำหนดเวลา วันที่สำคัญ และระยะเวลาทั้งหมดที่พบในสัญญา/เอกสาร การให้รายละเอียดของลูกค้าจะช่วยได้ (เช่น 'ลูกค้าเป็นธนาคารในสิงคโปร์ที่เชี่ยวชาญด้านบริการ e-banking')",
  'pages.app.newAnalysisModesDescription':
    'เราได้เปิดตัวโหมดวิเคราะห์ใหม่ที่ทรงประสิทธิภาพ 2 โหมด เพื่อช่วยให้คุณได้รับประโยชน์จากสัญญาของคุณมากยิ่งขึ้น',
  'pages.app.publishFirmWideNotice':
    'การตั้งค่านี้จะถูกแชร์กับทุกคนในองค์กรของคุณ ระบบจะส่งคำขอไปยังผู้ดูแลระบบขององค์กรเพื่อขออนุมัติ',
  'pages.app.publishPublicNotice':
    'การตั้งค่านี้จะปรากฏต่อผู้ใช้งานทุกคน ระบบจะส่งคำขอไปยังผู้ดูแลระบบสูงสุดเพื่อขออนุมัติ',
  'pages.app.scopeOfWorkModalDescription':
    'อัปโหลดหรือเลือกอีเมล จดหมาย หรือ RFP ของลูกค้าที่มีคำขอความช่วยเหลือหรือบริการ ใน "พรอมต์" การให้รายละเอียดของลูกค้าจะช่วยได้ (เช่น \'ลูกค้าเป็นธนาคารในสิงคโปร์ที่เชี่ยวชาญด้านบริการ e-banking\')',
  'pages.app.timelineFieldsDescription':
    'กำหนดคอลัมน์เพิ่มเติมที่คุณต้องการแสดงในไทม์ไลน์ สำหรับแต่ละฟิลด์ ให้ระบุคีย์ (หัวคอลัมน์) และคำอธิบายข้อมูลที่ต้องการดึง',
  'pages.chat.agenticRag.tooltip':
    'เปิดใช้งานการค้นคืนข้อมูลแบบเอเจนต์พร้อมอ้างอิงแหล่งที่มา ต้องมีเอกสารอยู่ในบริบทของแชท',
  'pages.chat.allowSelfPrompting.tooltip':
    'เมื่อเปิดใช้งาน ผู้ช่วยอาจแนะนำและนำพรอมต์จากคลังมาใช้เพื่อปรับปรุงคำตอบ',
  'pages.chat.emptyState.subtitle':
    'เลือกพรอมต์ด้านล่างเพื่อเริ่มใช้งานได้ทันที หรือพิมพ์ข้อความเพื่อสนทนากับ A&GEL โดยตรง',
  'pages.chat.newChatConfirm.content':
    'คุณแน่ใจหรือไม่ว่าต้องการล้างประวัติการสนทนาปัจจุบันและเริ่มเซสชันใหม่',
  'pages.chat.starterPrompt.caseSummariser.description':
    'พรอมต์แบบละเอียดพร้อมบริบททางกฎหมายสำหรับสรุปคดีของสิงคโปร์',
  'pages.chat.starterPrompt.draftChecklist.description':
    'พรอมต์ให้ Angel สร้างเช็กลิสต์จากเอกสารใดก็ได้',
  'pages.chat.starterPrompt.summariseArticle.description':
    'เครื่องมือสรุปบทความสำหรับการใช้งานทั่วไป',
  'pages.chat.upload.fileTypeNotAllowed':
    'ไม่รองรับประเภทไฟล์นี้ อนุญาตเฉพาะไฟล์ PDF, DOC, DOCX, MSG, EML, TXT, MD, XLS, XLSX, PPT และ PPTX เท่านั้น',
  'pages.chat.upload.onlyAllowedTypes':
    'กรุณาอัปโหลดเฉพาะไฟล์ PDF, DOC, DOCX, MSG, EML, TXT, MD, XLS, XLSX, PPT หรือ PPTX เท่านั้น',
  'pages.chat.upload.someFilesSkipped':
    'ไฟล์บางไฟล์ถูกข้ามไป อนุญาตเฉพาะไฟล์ PDF, DOC, DOCX, MSG, EML, TXT, MD, XLS, XLSX, PPT หรือ PPTX เท่านั้น',
  'pages.comparison.taskType.strikethroughUnderline.description':
    'วิเคราะห์การเปลี่ยนแปลงที่ทำเครื่องหมายด้วยรูปแบบขีดฆ่าและขีดเส้นใต้มาตรฐาน',
  'pages.comparison.taskType.trackedChanges.description':
    'ตรวจสอบการแก้ไขและความคิดเห็นที่ทำโดยใช้ฟีเจอร์ Track Changes',
  'pages.comparison.taskType.twoVersions.description':
    'เปรียบเทียบเอกสารสองเวอร์ชันที่แยกกันเพื่อระบุความแตกต่าง',
  'pages.comparison.taskType.referenceDocument.description':
    'เปรียบเทียบเอกสารเป้าหมายกับเอกสารอ้างอิง (เช่น termsheet)',
  'pages.comparison.customInstructionPlaceholder':
    'ป้อนคำสั่งเฉพาะของคุณสำหรับ A&GEL (เช่น "ลูกค้าของฉันคือ XYZ กรุณาเน้นที่การแก้ไขที่ส่งผลกระทบต่อลูกค้าของฉัน" หรือ "แสดงความคิดเห็นเป็นภาษามาเลย์")',
  'pages.comparison.legalReviewDescription':
    'ฟีเจอร์เปรียบเทียบได้รับการปรับให้เหมาะสมสำหรับการทำ "การตรวจสอบทางกฎหมาย" ของการแก้ไข (กล่าวคือ ตามค่าเริ่มต้นระบบจะแสดงความคิดเห็นเกี่ยวกับผลทางกฎหมายที่เกิดจากการแก้ไข)',
  'pages.comparison.twoVersionsFileCountError':
    'กรุณาอัปโหลดเอกสารจำนวน 2 ไฟล์สำหรับการเปรียบเทียบแบบสองเวอร์ชัน',
  'pages.composer.playbook.chooseDocumentDescription':
    'เลือกไฟล์ .docx เพื่อเปิดแคนวาสและเริ่มสนทนา',
  'pages.composer.playbook.docxOnlySkippedWarning':
    'ไฟล์บางไฟล์ถูกข้ามไป อนุญาตเฉพาะไฟล์ .docx เท่านั้น',
  'pages.composer.playbook.docxOnlySupportedError':
    'โหมด Workstudio รองรับเฉพาะไฟล์ .docx เท่านั้น',
  'pages.composer.playbookReview.acceptChangeError':
    'ไม่สามารถยอมรับการเปลี่ยนแปลงได้ กรุณาลองใหม่อีกครั้ง',
  'pages.composer.playbookReview.allAcceptError':
    'ไม่สามารถยอมรับการเปลี่ยนแปลงทั้งหมดได้ กรุณาลองใหม่อีกครั้ง',
  'pages.composer.playbookReview.allRejectError':
    'ไม่สามารถปฏิเสธการเปลี่ยนแปลงทั้งหมดได้ กรุณาลองใหม่อีกครั้ง',
  'pages.composer.playbookReview.allResetError':
    'ไม่สามารถรีเซ็ตการเปลี่ยนแปลงทั้งหมดได้ กรุณาลองใหม่อีกครั้ง',
  'pages.composer.playbookReview.allResetSuccess':
    'รีเซ็ตการเปลี่ยนแปลงทั้งหมดเป็นสถานะรอดำเนินการแล้ว',
  'pages.composer.playbookReview.commentSaveError':
    'ไม่สามารถบันทึกความคิดเห็นได้ กรุณาลองใหม่อีกครั้ง',
  'pages.composer.playbookReview.discardDraftButton': 'ละทิ้งฉบับร่าง',
  'pages.composer.playbookReview.documentLoadFailedError':
    'ไม่สามารถโหลดเอกสารนี้ได้ กรุณารีเฟรชเพื่อลองใหม่อีกครั้ง',
  'pages.composer.playbookReview.downloadInfoTooltip':
    'แต่ละรอบยังคงสามารถตรวจสอบได้ การดาวน์โหลดจะสร้างเอกสารฉบับปัจจุบันที่รวมทุกเลเยอร์ หลังจากใช้การเปลี่ยนแปลงที่ยอมรับแล้วและที่รอดำเนินการ',
  'pages.composer.playbookReview.groupAcceptedError':
    'ไม่สามารถยอมรับการเปลี่ยนแปลงได้ กรุณาลองใหม่อีกครั้ง',
  'pages.composer.playbookReview.groupAcceptedSuccess':
    'ยอมรับการเปลี่ยนแปลงที่เหมือนกัน {count} รายการแล้ว',
  'pages.composer.playbookReview.groupRejectedError':
    'ไม่สามารถปฏิเสธการเปลี่ยนแปลงได้ กรุณาลองใหม่อีกครั้ง',
  'pages.composer.playbookReview.groupRejectedSuccess':
    'ปฏิเสธการเปลี่ยนแปลงที่เหมือนกัน {count} รายการแล้ว',
  'pages.composer.playbookReview.groupResetError':
    'ไม่สามารถรีเซ็ตการเปลี่ยนแปลงได้ กรุณาลองใหม่อีกครั้ง',
  'pages.composer.playbookReview.groupResetSuccess':
    'รีเซ็ตการเปลี่ยนแปลงที่เหมือนกัน {count} รายการแล้ว',
  'pages.composer.playbookReview.noChangesDescription':
    'AI ไม่ได้เสนอการเปลี่ยนแปลงใดๆ สำหรับคำสั่งที่ระบุ',
  'pages.composer.playbookReview.processingTimeoutError':
    'การประมวลผลใช้เวลานานกว่าที่คาดไว้ กรุณารีเฟรชเพื่อตรวจสอบสถานะ',
  'pages.composer.playbookReview.rejectChangeError':
    'ไม่สามารถปฏิเสธการเปลี่ยนแปลงได้ กรุณาลองใหม่อีกครั้ง',
  'pages.composer.playbookReview.showMoreIdentical':
    '{action, select, hide {ซ่อน} other {แสดง}} การเปลี่ยนแปลงที่เหมือนกันเพิ่มเติมอีก {count} รายการ',
  'pages.composer.playbookReview.turnRegenerationReason':
    'การตัดสินใจในรอบก่อนหน้าได้เปลี่ยนแปลงเอกสารที่ใช้อ้างอิง',
  'pages.composer.playbookReview.waitForUpdateWarning':
    'กรุณารอให้การอัปเดตปัจจุบันเสร็จสิ้นก่อนดาวน์โหลด',
  'pages.dashboard.userActivityHeatmapTooltip':
    'จำนวนข้อความเฉลี่ยของผู้ใช้ต่อชั่วโมงต่อวันในสัปดาห์ สำหรับช่วงเวลาที่เลือก',
  'pages.dashboard.wordCloudTooltip':
    'การแสดงผลแบบกราฟิกของคำที่ถูกค้นหาบ่อยในข้อความของผู้ใช้ภายในช่วงเวลาที่เลือก',
  'pages.files.deleteAllFailedFilesConfirm':
    '{count, plural, one {ลบไฟล์อัปโหลดไม่สำเร็จทั้งหมด {count} ไฟล์ใช่หรือไม่?} other {ลบไฟล์อัปโหลดไม่สำเร็จทั้งหมด {count} ไฟล์ใช่หรือไม่?}}',
  'pages.files.filesDeletedCountWithFailures':
    'ลบไฟล์แล้ว {count} ไฟล์ ไม่สำเร็จ {failedCount} ไฟล์',
  'pages.files.filesMovedCountWithFailures':
    'ย้ายไฟล์แล้ว {count} ไฟล์ ไม่สำเร็จ {failedCount} ไฟล์',
  'pages.files.someFilesSkippedUnsupportedTypes':
    'ข้ามไฟล์บางไฟล์เนื่องจากไม่รองรับประเภทไฟล์ดังกล่าว',
  'pages.files.allowedFileTypesMessage':
    'รองรับเฉพาะไฟล์ PDF, DOC, DOCX, MSG, EML, TXT, MD, PPT, PPTX, XLS, XLSX เท่านั้น',
  'pages.library.attachedDocsAccessNote':
    'สิทธิ์การเข้าถึงเอกสารที่แนบกับพรอมต์จะเป็นไปตามสิทธิ์การเข้าถึงพรอมต์นั้น',
  'pages.library.publishRequestSentToAdmin':
    'คำขอเผยแพร่พรอมต์นี้ถูกส่งไปยังผู้ดูแลระบบเพื่อขออนุมัติแล้ว',
  'pages.library.firmWideVisibilityNote':
    'พรอมต์นี้จะมองเห็นได้โดยทุกคนในองค์กรของคุณ ระบบจะส่งคำขอไปยังผู้ดูแลองค์กรเพื่อขออนุมัติ',
  'pages.library.publicVisibilityNote':
    'พรอมต์นี้จะมองเห็นได้โดยผู้ใช้ทุกคน ระบบจะส่งคำขอไปยังผู้ดูแลระบบสูงสุดเพื่อขออนุมัติ',
  'pages.library.pendingApprovalNote':
    'คำขอเผยแพร่กำลังรอการอนุมัติ ตัวเลือกทั่วทั้งบริษัทและสาธารณะจะไม่สามารถใช้งานได้จนกว่าคำขอจะได้รับการอนุมัติหรือปฏิเสธ',
  'pages.library.unsavedChangesContent':
    'คุณมีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก ต้องการออกจากหน้านี้ใช่หรือไม่',
  'pages.library.description':
    'คลังพรอมต์ที่ออกแบบไว้ล่วงหน้าอย่างเป็นระบบ ใช้เพื่อเป็นแนวทางหรือเพิ่มประสิทธิภาพในการโต้ตอบกับโมเดลภาษา AI โดยทำหน้าที่เป็นแหล่งรวมศูนย์กลางที่จัดหมวดหมู่พรอมต์ตามวัตถุประสงค์ งาน หรือขอบเขต เช่น การเขียน การเขียนโค้ด การวิเคราะห์ข้อมูล หรือการสร้างสรรค์เนื้อหา',
  'pages.organisation.msTenantIdsTooltip':
    'ผู้ใช้จากรหัส Microsoft Tenant เหล่านี้สามารถเข้าสู่ระบบผ่าน SSO ได้',
  'pages.playbook.emptyState.description':
    'ขอให้เขียนใหม่ ตรวจสอบข้อสัญญา สรุปเนื้อหา หรือแก้ไขในจุดที่ต้องการได้',
  'pages.projectsHub.deleteSessionsConfirm.description':
    'นำ {count} เซสชันออกจากคอลเลกชันนี้ใช่หรือไม่',
  'pages.projectsHub.mattersSubtitle':
    'สร้างคอลเลกชันและจัดระเบียบเซสชันจากฟังก์ชันต่าง ๆ ไว้ในพื้นที่ทำงานเดียว',
  'pages.projectsHub.addSelectedSessionsButton':
    'เพิ่ม {count, plural, =0 {ที่เลือก} other {# เซสชัน}}',
  'pages.review.questionListImporter.checklistTextPlaceholder':
    'วางรายการตรวจสอบที่นี่ โดยแยกแต่ละข้อกำหนดเป็นหนึ่งบรรทัด',
  'pages.review.questionListImporter.dropZoneHint':
    'DOCX, PDF, EML, MSG, TXT หรือ MD ไฟล์จะถูกเก็บไว้ในเครื่องเท่านั้น',
  'pages.review.questionListImporter.pasteOrSelectRequired':
    'กรุณาวางหรือเลือกรายการตรวจสอบก่อนดูตัวอย่าง',
  'pages.review.quickQuestionsDescription':
    'สร้างการตรวจสอบเอกสารอย่างเป็นระบบสำหรับเอกสารหนึ่งฉบับหรือมากกว่า โดยอิงจากชุดคำถามเฉพาะกิจ',
  'pages.review.whatsNewDescription':
    'เพิ่มฟีเจอร์ใหม่หลายรายการเพื่อยกระดับกระบวนการตรวจสอบเอกสารของคุณ',
  'pages.scribe.audioUploadFailedSavingOnly':
    'ไม่สามารถอัปโหลดไฟล์เสียงได้ บันทึกเฉพาะข้อความถอดเสียงเท่านั้น',
  'pages.scribe.discardChangesConfirm.content':
    'คุณมีการแก้ไขที่ยังไม่ได้บันทึก ต้องการยกเลิกหรือไม่?',
  'pages.scribe.exitRecordingPopconfirm.description':
    'ออกจากการบันทึกหรือไม่? ข้อความถอดเสียงจะไม่ถูกบันทึก',
  'pages.scribe.interruptedModal.content':
    'การบันทึกเสียงของคุณถูกขัดจังหวะเนื่องจากการเชื่อมต่อหลุด (เช่น อุปกรณ์เข้าสู่โหมดสลีป) คลิก "ดูข้อความถอดเสียง" เพื่อบันทึกข้อมูลที่บันทึกไว้',
  'pages.scribe.recordingInProgressWarning':
    'คุณกำลังบันทึกเสียงอยู่ กรุณาหยุดบันทึกก่อนเปลี่ยนเซสชัน',
  'pages.scribe.recordingMicOnlyNote':
    'การบันทึกจะจับเสียงจากไมโครโฟนของคุณเท่านั้น ไม่รวมเสียงจากลำโพง หากต้องการถอดเสียงที่เล่นจากคอมพิวเตอร์ของคุณ ให้ใช้อุปกรณ์แยกต่างหากหรืออัปโหลดไฟล์บันทึกเสียง',
  'pages.scribe.status.defaultDescription':
    'ถอดเสียงไฟล์เสียงหรือการบันทึกเป็นข้อความที่มีโครงสร้าง',
  'pages.scribe.stopRecordingConfirm.content':
    'คุณมีการบันทึกเสียงที่กำลังทำงานอยู่ การออกจากหน้านี้จะหยุดการบันทึกเสียง คุณต้องการดำเนินการต่อหรือไม่',
  'pages.scribe.transcriptionFailedDesc':
    'Scribe ไม่สามารถถอดเสียงไฟล์นี้ได้ ลองดาวน์โหลดไฟล์เสียงแล้วอัปโหลดใหม่อีกครั้ง',
  'pages.scribe.whatsNew.filteringSortingDesc':
    'ปรับปรุงอินเทอร์เฟซให้จัดการและค้นหาข้อความถอดเสียงของคุณได้ง่ายขึ้น',
  'pages.scribe.whatsNew.guidanceTabsDesc':
    'ค้นหาคำแนะนำเกี่ยวกับวิธีเริ่มต้นใช้งานหรือค้นพบฟีเจอร์ใหม่ๆ ได้อย่างง่ายดาย',
  'pages.scribe.whatsNew.intro':
    'เราได้ปรับปรุง Scribe เพื่อมอบประสบการณ์การถอดเสียงที่ราบรื่นยิ่งขึ้น:',
  'pages.scribe.whatsNew.upcomingFeaturesDesc':
    'โปรดติดตามการควบคุมหลายภาษาที่ครอบคลุมยิ่งขึ้นและรูปแบบผลลัพธ์แบบมีโครงสร้างขั้นสูง',
  'pages.search.chunkResultCount':
    '{count, plural, one {ผลลัพธ์ส่วนข้อมูล} other {ผลลัพธ์ส่วนข้อมูล}}',
  'pages.sideBySide.addAtLeastOneQuestionBeforeSubmitting':
    'กรุณาเพิ่มคำถามอย่างน้อยหนึ่งข้อก่อนส่ง',
  'pages.sideBySide.columnEditModal.columnAddedSuccess':
    'เพิ่มคอลัมน์ใหม่แล้ว ตารางจะรีเฟรชในอีกสักครู่',
  'pages.sideBySide.columnEditModal.columnUpdateStartedSuccess':
    'เริ่มอัปเดตคอลัมน์แล้ว คอลัมน์จะรีเฟรชในอีกสักครู่',
  'pages.sideBySide.createCustomQuestionListDescription':
    'สร้างรายการคำถาม Side by Side แบบกำหนดเองสำหรับเซสชันนี้',
  'pages.sideBySide.pollingTimeoutWarning':
    'หมดเวลาการตรวจสอบสถานะ Side by Side อาจยังอยู่ระหว่างการประมวลผล',
  'pages.sideBySide.quickQuestionsDescription':
    'สร้าง Side by Side แบบมีโครงสร้างของเอกสารหนึ่งฉบับขึ้นไปโดยอิงจากชุดคำถามเฉพาะกิจ',
  'pages.sideBySide.restoreConfigurationFailed':
    'ไม่สามารถกู้คืนการตั้งค่าได้ กรุณาลองใหม่อีกครั้ง',
  'pages.sideBySide.selectionDescription':
    'สร้าง Side by Side แบบมีโครงสร้างของเอกสารหนึ่งฉบับขึ้นไปโดยอิงจากรายการคำถามของคุณ',
  'pages.sideBySide.tour.noHistorySessions':
    'ไม่มีเซสชัน side-by-side ในประวัติ กรุณาสร้างเซสชันก่อนเพื่อดูขั้นตอนนี้',
  'pages.sideBySide.tour.step1.description':
    'เริ่มต้นด้วยการเลือกรายการคำถามจากหมวดหมู่ที่มีอยู่ คลิกที่การ์ดรายการคำถามใดก็ได้เพื่อดำเนินการต่อ',
  'pages.sideBySide.tour.step2.description':
    'กรอกกลุ่มเป้าหมายหรือชื่อลูกค้า จากนั้นเลือกเอกสารที่คุณต้องการเปรียบเทียบแบบ side by side',
  'pages.sideBySide.tour.step3.description':
    'ตรวจสอบพรอมต์ระบบและรายการคำถามที่นี่ สลับไปที่แผงประวัติเพื่อดูเซสชันก่อนหน้า',
  'pages.sideBySide.tour.step4.description':
    'เมื่อคุณส่งแล้ว ผลลัพธ์ side-by-side จะปรากฏในตาราง คลิกที่เซลล์เพื่อดูรายละเอียด',
  'pages.sideBySide.whatsNewDescription':
    'เราได้เพิ่มฟีเจอร์ใหม่หลายรายการเพื่อยกระดับกระบวนการเปรียบเทียบเอกสารแบบเคียงข้างกันของคุณ',
  'pages.template.uploadInvalidFileTypes':
    'กรุณาอัปโหลดเฉพาะไฟล์ PDF, DOC, DOCX, MSG, EML, TXT หรือ MD เท่านั้น',
  'pages.template.someFilesSkipped':
    'ไฟล์บางไฟล์ถูกข้ามไป รองรับเฉพาะไฟล์ PDF, DOC, DOCX, MSG, EML, TXT หรือ MD เท่านั้น',
  'pages.template.tour.step2Description':
    'อัปโหลดหรือเลือกเอกสารที่คุณต้องการใช้สร้างผลลัพธ์ที่กำหนดเอง',
  'pages.template.tour.step3Description':
    'ระบุรายละเอียดกลุ่มเป้าหมายและคำสั่งที่กำหนดเองเพิ่มเติม (ถ้ามี) ที่นี่',
  'pages.template.tour.step4Description':
    'หลังจากส่งคำขอแล้ว ผลลัพธ์ที่สร้างขึ้นจะปรากฏในพื้นที่นี้',
  'pages.template.tableTypeTooltip':
    "คอลัมน์ที่กำหนดเองไม่สามารถใช้ได้กับตารางแบบ 'รายข้อ (Clause by clause)' และ 'รายเอกสาร (Document by document)'",
  'pages.template.customTemplateCreatedForSession':
    'สร้างเทมเพลตที่กำหนดเองสำหรับเซสชันนี้สำเร็จแล้ว',
  'pages.template.customOutputDescription':
    'สร้างและใช้พรอมต์ที่กำหนดเอง (เรียกว่า "ผลลัพธ์ที่กำหนดเอง" หรือ "Custom Outputs" บน A&GEL) เพื่อวิเคราะห์เอกสารได้ตรงตามความต้องการมากขึ้น ในกรณีที่คุณต้องการดึงข้อมูลประเภทเฉพาะ หรือต้องการการวิเคราะห์ในระดับที่ละเอียดมากขึ้น',
  'pages.template.whatsNewModal.intro':
    'เราได้เพิ่มฟีเจอร์ใหม่หลายรายการเพื่อยกระดับกระบวนการตรวจสอบเอกสารของคุณ:',
  'pages.template.whatsNewModal.improvedFilteringBody':
    'ตัวกรองกลุ่มเป้าหมายและผู้จัดทำใหม่ ช่วยให้คุณค้นหารายการคำถามได้รวดเร็วยิ่งขึ้น',
  'pages.template.whatsNewModal.uiEnhancementsBody':
    'อินเทอร์เฟซที่สะอาดตาและใช้งานง่ายขึ้นสำหรับการจัดการเทมเพลตของคุณ',
  'pages.template.upcomingFeaturesBody':
    'ติดตามอัปเดตเพิ่มเติมได้เร็วๆ นี้ รวมถึงการตรวจสอบร่วมกันและการวิเคราะห์ด้วย AI ขั้นสูง',
  'pages.translation.couldNotResolveFile':
    'ไม่สามารถระบุไฟล์ที่เลือกได้ กรุณาอัปโหลดหรือเลือกไฟล์ใหม่อีกครั้ง',
  'pages.translation.previewNotSupported':
    'ขณะนี้รองรับการแสดงตัวอย่างเฉพาะไฟล์ DOCX และ PDF เท่านั้น',
  'pages.translation.selectAtLeastOneDocument':
    'กรุณาอัปโหลดหรือเลือกเอกสารอย่างน้อย 1 ฉบับเพื่อแปล',
  'pages.translation.translationHint':
    'แปลเอกสารของคุณเป็นภาษาปลายทางหนึ่งภาษาหรือมากกว่า ผลลัพธ์จะแสดงเทียบเคียงกับข้อความต้นฉบับ',
  'pages.user.forgotPassword.emailSentMessage':
    'ระบบจะส่งอีเมลให้ในไม่ช้า หากอีเมลนี้ลงทะเบียนไว้ในระบบ',
  'pages.user.login.tenantNotRegistered':
    'Microsoft tenant ของคุณยังไม่ได้ลงทะเบียนสำหรับแอปนี้ กรุณาติดต่อผู้ดูแลระบบไอทีของคุณ',
  'pages.user.billing.contactNameInvalidError':
    "ชื่อผู้ติดต่อสำหรับการเรียกเก็บเงินสามารถประกอบด้วยตัวอักษร ช่องว่าง ยัติภังค์ (-) และเครื่องหมายอะพอสทรอฟี (') เท่านั้น",
  'pages.user.billing.switchPlanConfirmContent':
    'คุณจะถูกนำไปยังหน้าชำระเงินและเรียกเก็บเงิน {total} สำหรับ {seats} ที่นั่ง แพ็กเกจ {planName} ({interval}ly)',
  'pages.user.billing.switchPlanConfirmContentRenewal':
    'คุณจะถูกนำไปยังหน้าชำระเงินและเรียกเก็บเงิน {total} สำหรับ {seats} ที่นั่ง แพ็กเกจ {planName} ({interval}ly) เพื่อต่ออายุการสมัครสมาชิกที่ถูกยกเลิกของคุณ',
  'pages.user.billing.switchPlanConfirmContentReplace':
    'คุณจะถูกนำไปยังหน้าชำระเงินและเรียกเก็บเงิน {total} สำหรับ {seats} ที่นั่ง แพ็กเกจ {planName} ({interval}ly) แพ็กเกจปัจจุบันของคุณจะถูกเปลี่ยน',
  'pages.user.billing.ssoNotEnabledError':
    'Microsoft SSO ยังไม่ได้เปิดใช้งาน กรุณาติดต่อผู้ดูแลระบบของคุณ',
  'pages.user.billing.tenantStep2':
    'ขั้นตอนที่ 2/4: กำลังเปิดหน้าต่างเข้าสู่ระบบของ Microsoft กรุณาเข้าสู่ระบบและอนุญาตสิทธิ์สำหรับ tenant ของคุณ',
  'pages.user.billing.tenantStep3':
    'ขั้นตอนที่ 3/4: กำลังตรวจสอบ token ของ tenant กับเซิร์ฟเวอร์...',
  'pages.user.billing.tenantStep4':
    'ขั้นตอนที่ 4/4: กำลังบันทึกการลงทะเบียน tenant ให้กับองค์กรปัจจุบันของคุณ...',
  'pages.user.billing.tenantAddedMessage':
    'สำเร็จ Tenant ID {tenantId} ถูกเพิ่มเข้าสู่องค์กรของคุณแล้ว',
  'pages.user.billing.tenantAlreadyRegisteredMessage':
    'Tenant ID {tenantId} ได้ลงทะเบียนไว้กับองค์กรของคุณแล้ว ไม่ต้องดำเนินการเพิ่มเติม',
  'pages.user.billing.tenantRegisterGenericError':
    'ไม่สามารถลงทะเบียน Microsoft tenant ได้ กรุณาลองใหม่อีกครั้ง',
  'pages.user.billing.seatChangeScheduledMessage':
    'กำหนดการเปลี่ยนแปลงที่นั่งแล้ว — จะมีผลในการต่ออายุครั้งถัดไป',
  'pages.user.billing.tenantPopupNotice':
    'กรุณาเปิดหน้าต่างนี้ค้างไว้ ต้องใช้หน้าต่างป๊อปอัปของ Microsoft กรุณาเข้าสู่ระบบและให้ความยินยอมเพื่อดำเนินการต่อ',
  'pages.user.billing.seatChangeRenewalNotice':
    'การเปลี่ยนแปลงที่นั่งจะมีผลในการต่ออายุครั้งถัดไปของคุณในวันที่ {nextInvoiceDisplay}',
  'pages.user.billing.pastDueDescription':
    'การสมัครสมาชิกของคุณเลยกำหนดชำระเงิน คุณยังสามารถใช้งานได้ถึง {graceDate} กรุณาต่ออายุทันทีเพื่อไม่ให้การใช้งานหยุดชะงัก',
  'pages.user.billing.orgAccessRestrictedDescription':
    'การเข้าถึงขององค์กรถูกจำกัดจนกว่าจะแก้ไขปัญหาการเรียกเก็บเงิน',
  'pages.welcomeDashboard.jsonResponseTitle': 'การตอบสนอง JSON',
  'pages.welcomeDashboard.textResponseTitle': 'การตอบสนองข้อความ',
  'pages.welcomeDashboard.visibility.public': 'สาธารณะ',
  'pages.welcomeDashboard.visibility.firm': 'บริษัท',
  'pages.welcomeDashboard.visibility.unknown': 'ไม่ทราบ',
  'pages.welcomeDashboard.rejectButton': 'ปฏิเสธ',
  'pages.welcomeDashboard.approveButton': 'อนุมัติ',
  'pages.welcomeDashboard.metrics.wordsGeneratedToday.title': 'คำที่สร้างวันนี้',
  'pages.welcomeDashboard.metrics.wordsGenerated.chartLabel': 'คำที่สร้าง',
  'pages.welcomeDashboard.metrics.wordsGeneratedToday.description':
    'การร่างด้วยความช่วยเหลือของ AI',
  'pages.welcomeDashboard.metrics.pagesProcessed.title': 'หน้า A4 ที่ประมวลผล',
  'pages.welcomeDashboard.metrics.pagesProcessed.chartLabel': 'หน้าที่ประมวลผล',
  'pages.welcomeDashboard.metrics.pagesProcessed.description': 'ในเรื่องที่ดำเนินการอยู่วันนี้',
  'pages.welcomeDashboard.metrics.documentsDownloaded.title': 'เอกสารที่ดาวน์โหลด',
  'pages.welcomeDashboard.metrics.documentsDownloaded.chartLabel': 'เอกสารที่ดาวน์โหลด',
  'pages.welcomeDashboard.metrics.documentsDownloaded.description': 'ไฟล์ที่ส่งออกวันนี้',
  'pages.welcomeDashboard.metrics.questionsAnswered.title': 'คำถามที่ตอบแล้ว',
  'pages.welcomeDashboard.metrics.questionsAnswered.chartLabel': 'คำถามที่ตอบแล้ว',
  'pages.welcomeDashboard.metrics.questionsAnswered.description': 'พรอมต์ AI ที่ให้บริการวันนี้',
  'pages.welcomeDashboard.features.apps.name': 'แอป',
  'pages.welcomeDashboard.features.apps.description': 'วิเคราะห์และสรุปเนื้อหา',
  'pages.welcomeDashboard.features.scribe.name': 'บันทึกเสียง',
  'pages.welcomeDashboard.features.scribe.description': 'การถอดเสียงเอกสาร',
  'pages.welcomeDashboard.features.comparison.name': 'เปรียบเทียบ',
  'pages.welcomeDashboard.features.comparison.description': 'เปรียบเทียบเอกสารแบบเคียงข้าง',
  'pages.welcomeDashboard.features.review.name': 'ตรวจสอบ',
  'pages.welcomeDashboard.features.review.description': 'ตรวจสอบเอกสารด้วยคำถาม',
  'pages.welcomeDashboard.features.translation.name': 'การแปล',
  'pages.welcomeDashboard.features.translation.description': 'แปลเอกสาร',
  'pages.welcomeDashboard.features.chat.name': 'แชท',
  'pages.welcomeDashboard.features.chat.description': 'แชทกับผู้ช่วย AI',
  'pages.welcomeDashboard.features.templates.name': 'เทมเพลต',
  'pages.welcomeDashboard.features.templates.description': 'จัดการเทมเพลต',
  'pages.welcomeDashboard.features.quote.name': 'ใบเสนอราคา',
  'pages.welcomeDashboard.features.quote.description': 'สร้างใบเสนอราคา',
  'pages.welcomeDashboard.features.files.name': 'ไฟล์',
  'pages.welcomeDashboard.features.files.description': 'จัดการไฟล์ของคุณ',
  'pages.welcomeDashboard.features.library.name': 'คลังพรอมต์',
  'pages.welcomeDashboard.features.library.description': 'เข้าถึงคลังพรอมต์ของคุณ',
  'pages.welcomeDashboard.features.sideBySide.name': 'เปรียบเทียบแบบเคียงข้าง',
  'pages.welcomeDashboard.features.sideBySide.description': 'การเปรียบเทียบแบบเคียงข้าง',
  'pages.welcomeDashboard.features.playbook.name': 'Workstudio',
  'pages.welcomeDashboard.features.playbook.description': 'สร้างและจัดการเซสชัน Workstudio',
  'pages.welcomeDashboard.features.fallback.description': 'ฟีเจอร์',
  'pages.welcomeDashboard.features.search.name': 'ค้นหา',
  'pages.welcomeDashboard.greeting': 'สวัสดี {username}',
  'pages.welcomeDashboard.useCasesButton': 'กรณีการใช้งาน',
  'pages.welcomeDashboard.faqsButton': 'คำถามที่พบบ่อย',
  'pages.welcomeDashboard.publishingApprovalsButton': 'การอนุมัติการเผยแพร่ ({count})',
  'pages.welcomeDashboard.jumpBackInTitle': 'กลับมาทำต่อ',
  'pages.welcomeDashboard.untitledSession': 'เซสชันที่ไม่มีชื่อ',
  'pages.welcomeDashboard.viewAllButton': 'ดูทั้งหมด',
  'pages.welcomeDashboard.noRecentSessions': 'ไม่มีเซสชันล่าสุด',
  'pages.welcomeDashboard.statsTitle': 'สถิติ',
  'pages.welcomeDashboard.usefulFeaturesTitle': 'ฟีเจอร์ที่เป็นประโยชน์',
  'pages.welcomeDashboard.sessionsCount': '{count, plural, other {# เซสชัน}}',
  'pages.welcomeDashboard.foundUsefulThisWeek': 'ผู้ใช้ {count} คนพบว่ามีประโยชน์ในสัปดาห์นี้',
  'pages.welcomeDashboard.noRecentActivity': 'ไม่มีกิจกรรมล่าสุด',
  'pages.welcomeDashboard.publishingApprovalsModalTitle': 'การอนุมัติการเผยแพร่',
  'pages.welcomeDashboard.approvalTag.template': 'เทมเพลต',
  'pages.welcomeDashboard.approvalTag.review': 'ตรวจสอบ',
  'pages.welcomeDashboard.approvalTag.sideBySide': 'เคียงข้างกัน',
  'pages.welcomeDashboard.approvalTag.prompt': 'พรอมต์',
  'pages.welcomeDashboard.approvalTag.multiStep': 'หลายขั้นตอน',
  'pages.welcomeDashboard.recentSessionsModalTitle': '{pageName} — เซสชันล่าสุด',
  'pages.welcomeDashboard.detail.publishTarget': 'เป้าหมายการเผยแพร่',
  'pages.welcomeDashboard.detail.author': 'ผู้เขียน',
  'pages.welcomeDashboard.detail.unknown': 'ไม่ทราบ',
  'pages.welcomeDashboard.detail.category': 'หมวดหมู่',
  'pages.welcomeDashboard.detail.purpose': 'วัตถุประสงค์',
  'pages.welcomeDashboard.detail.notes': 'บันทึกย่อ',
  'pages.welcomeDashboard.systemPromptLabel': 'พรอมต์ระบบ',
  'pages.welcomeDashboard.noSystemPromptProvided': 'ไม่มีพรอมต์ระบบที่ระบุ',
  'pages.welcomeDashboard.promptContentLabel': 'เนื้อหาพรอมต์',
  'pages.welcomeDashboard.noPromptContentAvailable': 'ไม่มีเนื้อหาพรอมต์ที่ใช้ได้',
  'pages.welcomeDashboard.multiStepConfigFallback': 'การกำหนดค่าหลายขั้นตอน',
  'pages.welcomeDashboard.detail.description': 'คำอธิบาย',
  'pages.welcomeDashboard.stepsLabel': 'ขั้นตอน',
  'pages.welcomeDashboard.stepFallback': 'ขั้นตอนที่ {number}',
  'pages.welcomeDashboard.templateFallback': 'เทมเพลต',
  'pages.welcomeDashboard.detail.target': 'เป้าหมาย',
  'pages.welcomeDashboard.miscFallback': 'อื่นๆ',
  'pages.welcomeDashboard.detail.type': 'ประเภท',
  'pages.welcomeDashboard.templateType.prose': 'ร้อยแก้ว',
  'pages.welcomeDashboard.templateType.table': 'ตาราง',
  'pages.welcomeDashboard.tableTypeLabel': 'ประเภทตาราง',
  'pages.welcomeDashboard.tableType.standard': 'มาตรฐาน',
  'pages.welcomeDashboard.tableType.documentByDocument': 'ทีละเอกสาร',
  'pages.welcomeDashboard.tableType.clauseByClause': 'ทีละข้อ',
  'pages.welcomeDashboard.columnsLabel': 'คอลัมน์',
  'pages.welcomeDashboard.sectionsLabel': 'ส่วน',
  'pages.welcomeDashboard.userDefinedTag': 'กำหนดโดยผู้ใช้',
  'pages.welcomeDashboard.noTemplateStructureAvailable': 'ไม่มีโครงสร้างเทมเพลตที่ใช้ได้',
  'pages.welcomeDashboard.questionListFallback': 'รายการคำถาม',
  'pages.welcomeDashboard.noQuestionsAvailable': 'ไม่มีคำถามที่ใช้ได้',
};
